export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BlockAttributesArray: { input: any; output: any; }
  BlockAttributesObject: { input: any; output: any; }
};

/** The &quot;Accordion&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type Accordion = Accordion_Fields & AcfFieldGroup & AcfFieldGroupFields & {
  __typename?: 'Accordion';
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;Accordion&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Accordion&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;select&quot; Field Type added to the schema as part of the &quot;Accordion&quot; Field Group */
  iconType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;Accordion&quot; Field Group */
  items?: Maybe<Array<Maybe<AccordionItems>>>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Accordion&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;Accordion&quot; Field Group */
  withAbbreviations?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;Accordion&quot; Field Group */
  withLargeItemTitle?: Maybe<Scalars['Boolean']['output']>;
};

/** The &quot;AccordionItems&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type AccordionItems = AccordionItems_Fields & AcfFieldGroup & AcfFieldGroupFields & {
  __typename?: 'AccordionItems';
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;AccordionItems&quot; Field Group */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;AccordionItems&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;AccordionItems&quot; Field Group */
export type AccordionItems_Fields = {
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;AccordionItems&quot; Field Group */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;AccordionItems&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;Accordion&quot; Field Group */
export type Accordion_Fields = {
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;Accordion&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Accordion&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;select&quot; Field Type added to the schema as part of the &quot;Accordion&quot; Field Group */
  iconType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;Accordion&quot; Field Group */
  items?: Maybe<Array<Maybe<AccordionItems>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Accordion&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;Accordion&quot; Field Group */
  withAbbreviations?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;Accordion&quot; Field Group */
  withLargeItemTitle?: Maybe<Scalars['Boolean']['output']>;
};

/** A block used for editing the site */
export type AcfAccordion = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfAccordion & {
  __typename?: 'AcfAccordion';
  /** Fields of the Accordion ACF Field Group */
  accordion?: Maybe<Accordion>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfAccordion Block Type */
  attributes?: Maybe<AcfAccordionAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfAccordion Block Type */
export type AcfAccordionAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfAccordionAttributes';
  /** The &quot;align&quot; field on the &quot;AcfAccordionAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfAccordionAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfAccordionAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfAccordionAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfAccordionAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfAccordionAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfAccordionAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfArticlecards = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'AcfArticlecards';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfArticlecards Block Type */
  attributes?: Maybe<AcfArticlecardsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfArticlecards Block Type */
export type AcfArticlecardsAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfArticlecardsAttributes';
  /** The &quot;align&quot; field on the &quot;AcfArticlecardsAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfArticlecardsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfArticlecardsAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfArticlecardsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfArticlecardsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfArticlecardsAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfArticlecardsAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfBenefits = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfBenefits & {
  __typename?: 'AcfBenefits';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfBenefits Block Type */
  attributes?: Maybe<AcfBenefitsAttributes>;
  /** Fields of the Benefits ACF Field Group */
  benefits?: Maybe<Benefits>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfBenefits Block Type */
export type AcfBenefitsAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfBenefitsAttributes';
  /** The &quot;align&quot; field on the &quot;AcfBenefitsAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfBenefitsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfBenefitsAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfBenefitsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfBenefitsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfBenefitsAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfBenefitsAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfBenefitsaccordion = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfBenefitsAccordion & {
  __typename?: 'AcfBenefitsaccordion';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfBenefitsaccordion Block Type */
  attributes?: Maybe<AcfBenefitsaccordionAttributes>;
  /** Fields of the BenefitsAccordion ACF Field Group */
  benefitsAccordion?: Maybe<BenefitsAccordion>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfBenefitsaccordion Block Type */
export type AcfBenefitsaccordionAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfBenefitsaccordionAttributes';
  /** The &quot;align&quot; field on the &quot;AcfBenefitsaccordionAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfBenefitsaccordionAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfBenefitsaccordionAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfBenefitsaccordionAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfBenefitsaccordionAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfBenefitsaccordionAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfBenefitsaccordionAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfBenefitscontent = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfBenefitscontent & {
  __typename?: 'AcfBenefitscontent';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfBenefitscontent Block Type */
  attributes?: Maybe<AcfBenefitscontentAttributes>;
  /** Fields of the Benefitscontent ACF Field Group */
  benefitscontent?: Maybe<Benefitscontent>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfBenefitscontent Block Type */
export type AcfBenefitscontentAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfBenefitscontentAttributes';
  /** The &quot;align&quot; field on the &quot;AcfBenefitscontentAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfBenefitscontentAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfBenefitscontentAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfBenefitscontentAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfBenefitscontentAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfBenefitscontentAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfBenefitscontentAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfBenefitslist = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfBenefitsList & {
  __typename?: 'AcfBenefitslist';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfBenefitslist Block Type */
  attributes?: Maybe<AcfBenefitslistAttributes>;
  /** Fields of the BenefitsList ACF Field Group */
  benefitsList?: Maybe<BenefitsList>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfBenefitslist Block Type */
export type AcfBenefitslistAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfBenefitslistAttributes';
  /** The &quot;align&quot; field on the &quot;AcfBenefitslistAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfBenefitslistAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfBenefitslistAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfBenefitslistAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfBenefitslistAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfBenefitslistAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfBenefitslistAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfBlogarticles = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfBlogArticles & {
  __typename?: 'AcfBlogarticles';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfBlogarticles Block Type */
  attributes?: Maybe<AcfBlogarticlesAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** Fields of the BlogArticles ACF Field Group */
  blogArticles?: Maybe<BlogArticles>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfBlogarticles Block Type */
export type AcfBlogarticlesAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfBlogarticlesAttributes';
  /** The &quot;align&quot; field on the &quot;AcfBlogarticlesAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfBlogarticlesAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfBlogarticlesAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfBlogarticlesAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfBlogarticlesAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfBlogarticlesAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfBlogarticlesAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfBlogctacard = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfBlogCtaCard & {
  __typename?: 'AcfBlogctacard';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfBlogctacard Block Type */
  attributes?: Maybe<AcfBlogctacardAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** Fields of the BlogCtaCard ACF Field Group */
  blogCtaCard?: Maybe<BlogCtaCard>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfBlogctacard Block Type */
export type AcfBlogctacardAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfBlogctacardAttributes';
  /** The &quot;align&quot; field on the &quot;AcfBlogctacardAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfBlogctacardAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfBlogctacardAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfBlogctacardAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfBlogctacardAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfBlogctacardAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfBlogctacardAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfCallouttext = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfCalloutText & {
  __typename?: 'AcfCallouttext';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfCallouttext Block Type */
  attributes?: Maybe<AcfCallouttextAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** Fields of the CalloutText ACF Field Group */
  calloutText?: Maybe<CalloutText>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfCallouttext Block Type */
export type AcfCallouttextAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfCallouttextAttributes';
  /** The &quot;align&quot; field on the &quot;AcfCallouttextAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfCallouttextAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfCallouttextAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfCallouttextAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfCallouttextAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfCallouttextAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfCallouttextAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfCardgrid = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfCardGrid & {
  __typename?: 'AcfCardgrid';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfCardgrid Block Type */
  attributes?: Maybe<AcfCardgridAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** Fields of the CardGrid ACF Field Group */
  cardGrid?: Maybe<CardGrid>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfCardgrid Block Type */
export type AcfCardgridAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfCardgridAttributes';
  /** The &quot;align&quot; field on the &quot;AcfCardgridAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfCardgridAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfCardgridAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfCardgridAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfCardgridAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfCardgridAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfCardgridAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfCasestudies = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfCaseStudies & {
  __typename?: 'AcfCasestudies';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfCasestudies Block Type */
  attributes?: Maybe<AcfCasestudiesAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** Fields of the CaseStudies ACF Field Group */
  caseStudies?: Maybe<CaseStudies>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfCasestudies Block Type */
export type AcfCasestudiesAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfCasestudiesAttributes';
  /** The &quot;align&quot; field on the &quot;AcfCasestudiesAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfCasestudiesAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfCasestudiesAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfCasestudiesAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfCasestudiesAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfCasestudiesAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfCasestudiesAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfCompanylist = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfCompanyList & {
  __typename?: 'AcfCompanylist';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfCompanylist Block Type */
  attributes?: Maybe<AcfCompanylistAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** Fields of the CompanyList ACF Field Group */
  companyList?: Maybe<CompanyList>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfCompanylist Block Type */
export type AcfCompanylistAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfCompanylistAttributes';
  /** The &quot;align&quot; field on the &quot;AcfCompanylistAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfCompanylistAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfCompanylistAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfCompanylistAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfCompanylistAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfCompanylistAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfCompanylistAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** Connection between the BlogArticlesFeaturedArticlesArticles_Fields type and the ContentNode type */
export type AcfContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'AcfContentNodeConnection';
  /** Edges for the AcfContentNodeConnection connection */
  edges: Array<AcfContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: AcfContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type AcfContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'AcfContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Pagination metadata specific to &quot;AcfContentNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of AcfContentNodeConnection Nodes. */
export type AcfContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'AcfContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** A block used for editing the site */
export type AcfCorevalues = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'AcfCorevalues';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfCorevalues Block Type */
  attributes?: Maybe<AcfCorevaluesAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfCorevalues Block Type */
export type AcfCorevaluesAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfCorevaluesAttributes';
  /** The &quot;align&quot; field on the &quot;AcfCorevaluesAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfCorevaluesAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfCorevaluesAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfCorevaluesAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfCorevaluesAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfCorevaluesAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfCorevaluesAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfCtacard = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfCtaCard & {
  __typename?: 'AcfCtacard';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfCtacard Block Type */
  attributes?: Maybe<AcfCtacardAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fields of the CtaCard ACF Field Group */
  ctaCard?: Maybe<CtaCard>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfCtacard Block Type */
export type AcfCtacardAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfCtacardAttributes';
  /** The &quot;align&quot; field on the &quot;AcfCtacardAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfCtacardAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfCtacardAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfCtacardAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfCtacardAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfCtacardAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfCtacardAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfDivider = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfDivider & {
  __typename?: 'AcfDivider';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfDivider Block Type */
  attributes?: Maybe<AcfDividerAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fields of the Divider ACF Field Group */
  divider?: Maybe<Divider>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfDivider Block Type */
export type AcfDividerAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfDividerAttributes';
  /** The &quot;align&quot; field on the &quot;AcfDividerAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfDividerAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfDividerAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfDividerAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfDividerAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfDividerAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfDividerAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfFactoringinfographic = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfFactoringInfoGraphic & {
  __typename?: 'AcfFactoringinfographic';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfFactoringinfographic Block Type */
  attributes?: Maybe<AcfFactoringinfographicAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fields of the FactoringInfoGraphic ACF Field Group */
  factoringInfoGraphic?: Maybe<FactoringInfoGraphic>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfFactoringinfographic Block Type */
export type AcfFactoringinfographicAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfFactoringinfographicAttributes';
  /** The &quot;align&quot; field on the &quot;AcfFactoringinfographicAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfFactoringinfographicAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfFactoringinfographicAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfFactoringinfographicAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfFactoringinfographicAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfFactoringinfographicAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfFactoringinfographicAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A Field Group managed by ACF */
export type AcfFieldGroup = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** Fields associated with an ACF Field Group */
export type AcfFieldGroupFields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type AcfFinancingcta = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfFinancingCta & {
  __typename?: 'AcfFinancingcta';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfFinancingcta Block Type */
  attributes?: Maybe<AcfFinancingctaAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fields of the FinancingCta ACF Field Group */
  financingCta?: Maybe<FinancingCta>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfFinancingcta Block Type */
export type AcfFinancingctaAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfFinancingctaAttributes';
  /** The &quot;align&quot; field on the &quot;AcfFinancingctaAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfFinancingctaAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfFinancingctaAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfFinancingctaAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfFinancingctaAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfFinancingctaAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfFinancingctaAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfForm = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfFormContentBlock & {
  __typename?: 'AcfForm';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfForm Block Type */
  attributes?: Maybe<AcfFormAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fields of the FormContentBlock ACF Field Group */
  formContentBlock?: Maybe<FormContentBlock>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfForm Block Type */
export type AcfFormAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfFormAttributes';
  /** The &quot;align&quot; field on the &quot;AcfFormAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfFormAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfFormAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfFormAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfFormAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfFormAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfFormAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfFuelsavingscalculator = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfFuelSavingsCalculator & {
  __typename?: 'AcfFuelsavingscalculator';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfFuelsavingscalculator Block Type */
  attributes?: Maybe<AcfFuelsavingscalculatorAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fields of the FuelSavingsCalculator ACF Field Group */
  fuelSavingsCalculator?: Maybe<FuelSavingsCalculator>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfFuelsavingscalculator Block Type */
export type AcfFuelsavingscalculatorAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfFuelsavingscalculatorAttributes';
  /** The &quot;align&quot; field on the &quot;AcfFuelsavingscalculatorAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfFuelsavingscalculatorAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfFuelsavingscalculatorAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfFuelsavingscalculatorAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfFuelsavingscalculatorAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfFuelsavingscalculatorAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfFuelsavingscalculatorAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfHerobanner = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfHeroBanner & {
  __typename?: 'AcfHerobanner';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfHerobanner Block Type */
  attributes?: Maybe<AcfHerobannerAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fields of the HeroBanner ACF Field Group */
  heroBanner?: Maybe<HeroBanner>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfHerobanner Block Type */
export type AcfHerobannerAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfHerobannerAttributes';
  /** The &quot;align&quot; field on the &quot;AcfHerobannerAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfHerobannerAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfHerobannerAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfHerobannerAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfHerobannerAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfHerobannerAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfHerobannerAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfHerobannerwithform = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfHeroBannerWithForm & {
  __typename?: 'AcfHerobannerwithform';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfHerobannerwithform Block Type */
  attributes?: Maybe<AcfHerobannerwithformAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fields of the HeroBannerWithForm ACF Field Group */
  heroBannerWithForm?: Maybe<HeroBannerWithForm>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfHerobannerwithform Block Type */
export type AcfHerobannerwithformAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfHerobannerwithformAttributes';
  /** The &quot;align&quot; field on the &quot;AcfHerobannerwithformAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfHerobannerwithformAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfHerobannerwithformAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfHerobannerwithformAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfHerobannerwithformAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfHerobannerwithformAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfHerobannerwithformAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfHighlight = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfHighlight & {
  __typename?: 'AcfHighlight';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfHighlight Block Type */
  attributes?: Maybe<AcfHighlightAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fields of the Highlight ACF Field Group */
  highlight?: Maybe<Highlight>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfHighlight Block Type */
export type AcfHighlightAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfHighlightAttributes';
  /** The &quot;align&quot; field on the &quot;AcfHighlightAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfHighlightAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfHighlightAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfHighlightAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfHighlightAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfHighlightAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfHighlightAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** ACF Link field */
export type AcfLink = {
  __typename?: 'AcfLink';
  /** The target of the link (_blank, etc) */
  target?: Maybe<Scalars['String']['output']>;
  /** The title of the link */
  title?: Maybe<Scalars['String']['output']>;
  /** The url of the link */
  url?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type AcfLogorows = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfLogoRows & {
  __typename?: 'AcfLogorows';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfLogorows Block Type */
  attributes?: Maybe<AcfLogorowsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** Fields of the LogoRows ACF Field Group */
  logoRows?: Maybe<LogoRows>;
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfLogorows Block Type */
export type AcfLogorowsAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfLogorowsAttributes';
  /** The &quot;align&quot; field on the &quot;AcfLogorowsAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfLogorowsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfLogorowsAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfLogorowsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfLogorowsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfLogorowsAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfLogorowsAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfLogoscroll = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfLogoScroll & {
  __typename?: 'AcfLogoscroll';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfLogoscroll Block Type */
  attributes?: Maybe<AcfLogoscrollAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** Fields of the LogoScroll ACF Field Group */
  logoScroll?: Maybe<LogoScroll>;
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfLogoscroll Block Type */
export type AcfLogoscrollAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfLogoscrollAttributes';
  /** The &quot;align&quot; field on the &quot;AcfLogoscrollAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfLogoscrollAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfLogoscrollAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfLogoscrollAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfLogoscrollAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfLogoscrollAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfLogoscrollAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfMainhero = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfMainHero & {
  __typename?: 'AcfMainhero';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfMainhero Block Type */
  attributes?: Maybe<AcfMainheroAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** Fields of the MainHero ACF Field Group */
  mainHero?: Maybe<MainHero>;
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfMainhero Block Type */
export type AcfMainheroAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfMainheroAttributes';
  /** The &quot;align&quot; field on the &quot;AcfMainheroAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfMainheroAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfMainheroAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfMainheroAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfMainheroAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfMainheroAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfMainheroAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** Connection between the BenefitsBenefitCards_Fields type and the MediaItem type */
export type AcfMediaItemConnectionEdge = Edge & MediaItemConnectionEdge & OneToOneConnection & {
  __typename?: 'AcfMediaItemConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: MediaItem;
};

/** A block used for editing the site */
export type AcfModal = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfBlockModal & {
  __typename?: 'AcfModal';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfModal Block Type */
  attributes?: Maybe<AcfModalAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** Fields of the BlockModal ACF Field Group */
  blockModal?: Maybe<BlockModal>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfModal Block Type */
export type AcfModalAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfModalAttributes';
  /** The &quot;align&quot; field on the &quot;AcfModalAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfModalAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfModalAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfModalAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfModalAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfModalAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfModalAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfNewsandinsights = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfNewsAndInsights & {
  __typename?: 'AcfNewsandinsights';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfNewsandinsights Block Type */
  attributes?: Maybe<AcfNewsandinsightsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** Fields of the NewsAndInsights ACF Field Group */
  newsAndInsights?: Maybe<NewsAndInsights>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfNewsandinsights Block Type */
export type AcfNewsandinsightsAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfNewsandinsightsAttributes';
  /** The &quot;align&quot; field on the &quot;AcfNewsandinsightsAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfNewsandinsightsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfNewsandinsightsAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfNewsandinsightsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfNewsandinsightsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfNewsandinsightsAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfNewsandinsightsAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfNewslettersignup = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfNewsletterSignup & {
  __typename?: 'AcfNewslettersignup';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfNewslettersignup Block Type */
  attributes?: Maybe<AcfNewslettersignupAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** Fields of the NewsletterSignup ACF Field Group */
  newsletterSignup?: Maybe<NewsletterSignup>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfNewslettersignup Block Type */
export type AcfNewslettersignupAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfNewslettersignupAttributes';
  /** The &quot;align&quot; field on the &quot;AcfNewslettersignupAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfNewslettersignupAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfNewslettersignupAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfNewslettersignupAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfNewslettersignupAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfNewslettersignupAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfNewslettersignupAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** Options Page registered by ACF */
export type AcfOptionsPage = {
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  menuTitle?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type AcfOurhistory = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfOurHistory & {
  __typename?: 'AcfOurhistory';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfOurhistory Block Type */
  attributes?: Maybe<AcfOurhistoryAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** Fields of the OurHistory ACF Field Group */
  ourHistory?: Maybe<OurHistory>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfOurhistory Block Type */
export type AcfOurhistoryAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfOurhistoryAttributes';
  /** The &quot;align&quot; field on the &quot;AcfOurhistoryAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfOurhistoryAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfOurhistoryAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfOurhistoryAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfOurhistoryAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfOurhistoryAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfOurhistoryAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfPartners = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfPartners & {
  __typename?: 'AcfPartners';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfPartners Block Type */
  attributes?: Maybe<AcfPartnersAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** Fields of the Partners ACF Field Group */
  partners?: Maybe<Partners>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfPartners Block Type */
export type AcfPartnersAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfPartnersAttributes';
  /** The &quot;align&quot; field on the &quot;AcfPartnersAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfPartnersAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfPartnersAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfPartnersAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfPartnersAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfPartnersAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfPartnersAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfSolutions = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfSolutions & {
  __typename?: 'AcfSolutions';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfSolutions Block Type */
  attributes?: Maybe<AcfSolutionsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** Fields of the Solutions ACF Field Group */
  solutions?: Maybe<Solutions>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfSolutions Block Type */
export type AcfSolutionsAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfSolutionsAttributes';
  /** The &quot;align&quot; field on the &quot;AcfSolutionsAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfSolutionsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfSolutionsAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfSolutionsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfSolutionsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfSolutionsAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfSolutionsAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfSolutionscards = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfSolutionsCards & {
  __typename?: 'AcfSolutionscards';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfSolutionscards Block Type */
  attributes?: Maybe<AcfSolutionscardsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** Fields of the SolutionsCards ACF Field Group */
  solutionsCards?: Maybe<SolutionsCards>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfSolutionscards Block Type */
export type AcfSolutionscardsAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfSolutionscardsAttributes';
  /** The &quot;align&quot; field on the &quot;AcfSolutionscardsAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfSolutionscardsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfSolutionscardsAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfSolutionscardsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfSolutionscardsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfSolutionscardsAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfSolutionscardsAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfTeammembers = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfTeamMembers & {
  __typename?: 'AcfTeammembers';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfTeammembers Block Type */
  attributes?: Maybe<AcfTeammembersAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** Fields of the TeamMembers ACF Field Group */
  teamMembers?: Maybe<TeamMembers>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfTeammembers Block Type */
export type AcfTeammembersAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfTeammembersAttributes';
  /** The &quot;align&quot; field on the &quot;AcfTeammembersAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfTeammembersAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfTeammembersAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfTeammembersAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfTeammembersAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfTeammembersAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfTeammembersAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** Connection between the BlogArticlesFeaturedArticles_Fields type and the TermNode type */
export type AcfTermNodeConnection = Connection & TermNodeConnection & {
  __typename?: 'AcfTermNodeConnection';
  /** Edges for the AcfTermNodeConnection connection */
  edges: Array<AcfTermNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<TermNode>;
  /** Information about pagination in a connection. */
  pageInfo: AcfTermNodeConnectionPageInfo;
};

/** An edge in a connection */
export type AcfTermNodeConnectionEdge = Edge & TermNodeConnectionEdge & {
  __typename?: 'AcfTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: TermNode;
};

/** Pagination metadata specific to &quot;AcfTermNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of AcfTermNodeConnection Nodes. */
export type AcfTermNodeConnectionPageInfo = PageInfo & TermNodeConnectionPageInfo & WpPageInfo & {
  __typename?: 'AcfTermNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** A block used for editing the site */
export type AcfTestimonials = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfTestimonials & {
  __typename?: 'AcfTestimonials';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfTestimonials Block Type */
  attributes?: Maybe<AcfTestimonialsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** Fields of the Testimonials ACF Field Group */
  testimonials?: Maybe<Testimonials>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfTestimonials Block Type */
export type AcfTestimonialsAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfTestimonialsAttributes';
  /** The &quot;align&quot; field on the &quot;AcfTestimonialsAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfTestimonialsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfTestimonialsAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfTestimonialsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfTestimonialsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfTestimonialsAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfTestimonialsAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfTextcontent = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfWsywig & {
  __typename?: 'AcfTextcontent';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfTextcontent Block Type */
  attributes?: Maybe<AcfTextcontentAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
  /** Fields of the Wsywig ACF Field Group */
  wsywig?: Maybe<Wsywig>;
};

/** Attributes of the AcfTextcontent Block Type */
export type AcfTextcontentAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfTextcontentAttributes';
  /** The &quot;align&quot; field on the &quot;AcfTextcontentAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfTextcontentAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfTextcontentAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfTextcontentAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfTextcontentAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfTextcontentAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfTextcontentAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfTextheader = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfTextHeader & {
  __typename?: 'AcfTextheader';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfTextheader Block Type */
  attributes?: Maybe<AcfTextheaderAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** Fields of the TextHeader ACF Field Group */
  textHeader?: Maybe<TextHeader>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfTextheader Block Type */
export type AcfTextheaderAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfTextheaderAttributes';
  /** The &quot;align&quot; field on the &quot;AcfTextheaderAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfTextheaderAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfTextheaderAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfTextheaderAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfTextheaderAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfTextheaderAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfTextheaderAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfThrive = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfThrive & {
  __typename?: 'AcfThrive';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfThrive Block Type */
  attributes?: Maybe<AcfThriveAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** Fields of the Thrive ACF Field Group */
  thrive?: Maybe<Thrive>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfThrive Block Type */
export type AcfThriveAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfThriveAttributes';
  /** The &quot;align&quot; field on the &quot;AcfThriveAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfThriveAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfThriveAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfThriveAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfThriveAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfThriveAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfThriveAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfTwocolumncta = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfTwoColumnCta & {
  __typename?: 'AcfTwocolumncta';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfTwocolumncta Block Type */
  attributes?: Maybe<AcfTwocolumnctaAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** Fields of the TwoColumnCta ACF Field Group */
  twoColumnCta?: Maybe<TwoColumnCta>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfTwocolumncta Block Type */
export type AcfTwocolumnctaAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfTwocolumnctaAttributes';
  /** The &quot;align&quot; field on the &quot;AcfTwocolumnctaAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfTwocolumnctaAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfTwocolumnctaAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfTwocolumnctaAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfTwocolumnctaAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfTwocolumnctaAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfTwocolumnctaAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfTwocolumnpromo = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfTwoColumnPromo & {
  __typename?: 'AcfTwocolumnpromo';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfTwocolumnpromo Block Type */
  attributes?: Maybe<AcfTwocolumnpromoAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** Fields of the TwoColumnPromo ACF Field Group */
  twoColumnPromo?: Maybe<TwoColumnPromo>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the AcfTwocolumnpromo Block Type */
export type AcfTwocolumnpromoAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfTwocolumnpromoAttributes';
  /** The &quot;align&quot; field on the &quot;AcfTwocolumnpromoAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfTwocolumnpromoAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfTwocolumnpromoAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfTwocolumnpromoAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfTwocolumnpromoAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfTwocolumnpromoAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfTwocolumnpromoAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A block used for editing the site */
export type AcfVideo = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & WithAcfBlockVideo & WithAcfVideo & {
  __typename?: 'AcfVideo';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the AcfVideo Block Type */
  attributes?: Maybe<AcfVideoAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** Fields of the BlockVideo ACF Field Group */
  blockVideo?: Maybe<BlockVideo>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
  /** Fields of the Video ACF Field Group */
  video?: Maybe<Video>;
};

/** Attributes of the AcfVideo Block Type */
export type AcfVideoAttributes = BlockWithSupportsAnchor & {
  __typename?: 'AcfVideoAttributes';
  /** The &quot;align&quot; field on the &quot;AcfVideoAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;AcfVideoAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;data&quot; field on the &quot;AcfVideoAttributes&quot; block or block attributes */
  data: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;AcfVideoAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;AcfVideoAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mode&quot; field on the &quot;AcfVideoAttributes&quot; block or block attributes */
  mode: Scalars['String']['output'];
  /** The &quot;name&quot; field on the &quot;AcfVideoAttributes&quot; block or block attributes */
  name: Scalars['String']['output'];
};

/** A Gravity Forms address field. */
export type AddressField = FormField & GfFieldWithAddressSetting & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCopyValuesOptionSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSubLabelPlacementSetting & Node & {
  __typename?: 'AddressField';
  /** Determines the type of address to be displayed. */
  addressType?: Maybe<AddressFieldTypeEnum>;
  /** Address field value. */
  addressValues?: Maybe<AddressFieldValue>;
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** The field id of the field being used as the copy source. */
  copyValuesOptionFieldId?: Maybe<Scalars['Int']['output']>;
  /** The label that appears next to the copy values option when the form is displayed. The default value is \“Same as previous\”. */
  copyValuesOptionLabel?: Maybe<Scalars['String']['output']>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the country that will be selected by default. Only applicable when &quot;addressType&quot; is set to &quot;INTERATIONAL&quot;. */
  defaultCountry?: Maybe<AddressFieldCountryEnum>;
  /** Contains the province that will be selected by default. Only applicable when &quot;addressType&quot; is set to &quot;CANADA&quot;. */
  defaultProvince?: Maybe<AddressFieldProvinceEnum>;
  /** Contains the state that will be selected by default. Only applicable when &quot;addressType&quot; is set to &quot;US&quot;. */
  defaultState?: Maybe<AddressFieldProvinceEnum>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<AddressInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Indicates whether the copy values option can be used. This option allows users to skip filling out the field and use the same values as another. For example, if the mailing and billing address are the same. */
  shouldCopyValuesOption?: Maybe<Scalars['Boolean']['output']>;
  /** The placement of the labels for the subfields within the group. This setting controls all of the subfields, they cannot be set individually. They may be aligned above or below the inputs. If this property is not set, the “Sub-Label Placement” setting on the Form Settings-&gt;Form Layout page is used. If no setting is specified, the default is above inputs. */
  subLabelPlacement?: Maybe<FormFieldSubLabelPlacementEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** Countries supported by Gravity Forms Address Field. */
export enum AddressFieldCountryEnum {
  /** Andorra . */
  Ad = 'AD',
  /** United Arab Emirates . */
  Ae = 'AE',
  /** Afghanistan . */
  Af = 'AF',
  /** Antigua and Barbuda . */
  Ag = 'AG',
  /** Anguilla . */
  Ai = 'AI',
  /** Albania . */
  Al = 'AL',
  /** Armenia . */
  Am = 'AM',
  /** Angola . */
  Ao = 'AO',
  /** Antarctica . */
  Aq = 'AQ',
  /** Argentina . */
  Ar = 'AR',
  /** American Samoa . */
  As = 'AS',
  /** Austria . */
  At = 'AT',
  /** Australia . */
  Au = 'AU',
  /** Aruba . */
  Aw = 'AW',
  /** Åland Islands . */
  Ax = 'AX',
  /** Azerbaijan . */
  Az = 'AZ',
  /** Bosnia and Herzegovina . */
  Ba = 'BA',
  /** Barbados . */
  Bb = 'BB',
  /** Bangladesh . */
  Bd = 'BD',
  /** Belgium . */
  Be = 'BE',
  /** Burkina Faso . */
  Bf = 'BF',
  /** Bulgaria . */
  Bg = 'BG',
  /** Bahrain . */
  Bh = 'BH',
  /** Burundi . */
  Bi = 'BI',
  /** Benin . */
  Bj = 'BJ',
  /** Saint Barthélemy . */
  Bl = 'BL',
  /** Bermuda . */
  Bm = 'BM',
  /** Brunei Darussalam . */
  Bn = 'BN',
  /** Bolivia . */
  Bo = 'BO',
  /** Bonaire, Sint Eustatius and Saba . */
  Bq = 'BQ',
  /** Brazil . */
  Br = 'BR',
  /** Bahamas . */
  Bs = 'BS',
  /** Bhutan . */
  Bt = 'BT',
  /** Bouvet Island . */
  Bv = 'BV',
  /** Botswana . */
  Bw = 'BW',
  /** Belarus . */
  By = 'BY',
  /** Belize . */
  Bz = 'BZ',
  /** Canada . */
  Ca = 'CA',
  /** Cocos Islands . */
  Cc = 'CC',
  /** Congo, Democratic Republic of the . */
  Cd = 'CD',
  /** Central African Republic . */
  Cf = 'CF',
  /** Congo . */
  Cg = 'CG',
  /** Switzerland . */
  Ch = 'CH',
  /** Côte d'Ivoire . */
  Ci = 'CI',
  /** Cook Islands . */
  Ck = 'CK',
  /** Chile . */
  Cl = 'CL',
  /** Cameroon . */
  Cm = 'CM',
  /** China . */
  Cn = 'CN',
  /** Colombia . */
  Co = 'CO',
  /** Costa Rica . */
  Cr = 'CR',
  /** Cuba . */
  Cu = 'CU',
  /** Cabo Verde . */
  Cv = 'CV',
  /** Curaçao . */
  Cw = 'CW',
  /** Christmas Island . */
  Cx = 'CX',
  /** Cyprus . */
  Cy = 'CY',
  /** Czechia . */
  Cz = 'CZ',
  /** Germany . */
  De = 'DE',
  /** Djibouti . */
  Dj = 'DJ',
  /** Denmark . */
  Dk = 'DK',
  /** Dominica . */
  Dm = 'DM',
  /** Dominican Republic . */
  Do = 'DO',
  /** Algeria . */
  Dz = 'DZ',
  /** Ecuador . */
  Ec = 'EC',
  /** Estonia . */
  Ee = 'EE',
  /** Egypt . */
  Eg = 'EG',
  /** Western Sahara . */
  Eh = 'EH',
  /** Eritrea . */
  Er = 'ER',
  /** Spain . */
  Es = 'ES',
  /** Ethiopia . */
  Et = 'ET',
  /** Finland . */
  Fi = 'FI',
  /** Fiji . */
  Fj = 'FJ',
  /** Falkland Islands . */
  Fk = 'FK',
  /** Micronesia . */
  Fm = 'FM',
  /** Faroe Islands . */
  Fo = 'FO',
  /** France . */
  Fr = 'FR',
  /** Gabon . */
  Ga = 'GA',
  /** United Kingdom . */
  Gb = 'GB',
  /** Grenada . */
  Gd = 'GD',
  /** Georgia . */
  Ge = 'GE',
  /** French Guiana . */
  Gf = 'GF',
  /** Guernsey . */
  Gg = 'GG',
  /** Ghana . */
  Gh = 'GH',
  /** Gibraltar . */
  Gi = 'GI',
  /** Greenland . */
  Gl = 'GL',
  /** Gambia . */
  Gm = 'GM',
  /** Guinea . */
  Gn = 'GN',
  /** Guadeloupe . */
  Gp = 'GP',
  /** Equatorial Guinea . */
  Gq = 'GQ',
  /** Greece . */
  Gr = 'GR',
  /** South Georgia and the South Sandwich Islands . */
  Gs = 'GS',
  /** Guatemala . */
  Gt = 'GT',
  /** Guam . */
  Gu = 'GU',
  /** Guinea-Bissau . */
  Gw = 'GW',
  /** Guyana . */
  Gy = 'GY',
  /** Hong Kong . */
  Hk = 'HK',
  /** Heard Island and McDonald Islands . */
  Hm = 'HM',
  /** Honduras . */
  Hn = 'HN',
  /** Croatia . */
  Hr = 'HR',
  /** Haiti . */
  Ht = 'HT',
  /** Hungary . */
  Hu = 'HU',
  /** Indonesia . */
  Id = 'ID',
  /** Ireland . */
  Ie = 'IE',
  /** Israel . */
  Il = 'IL',
  /** Isle of Man . */
  Im = 'IM',
  /** India . */
  In = 'IN',
  /** British Indian Ocean Territory . */
  Io = 'IO',
  /** Iraq . */
  Iq = 'IQ',
  /** Iran . */
  Ir = 'IR',
  /** Iceland . */
  Is = 'IS',
  /** Italy . */
  It = 'IT',
  /** Jersey . */
  Je = 'JE',
  /** Jamaica . */
  Jm = 'JM',
  /** Jordan . */
  Jo = 'JO',
  /** Japan . */
  Jp = 'JP',
  /** Kenya . */
  Ke = 'KE',
  /** Kyrgyzstan . */
  Kg = 'KG',
  /** Cambodia . */
  Kh = 'KH',
  /** Kiribati . */
  Ki = 'KI',
  /** Comoros . */
  Km = 'KM',
  /** Saint Kitts and Nevis . */
  Kn = 'KN',
  /** Korea, Democratic People's Republic of . */
  Kp = 'KP',
  /** Korea, Republic of . */
  Kr = 'KR',
  /** Kuwait . */
  Kw = 'KW',
  /** Cayman Islands . */
  Ky = 'KY',
  /** Kazakhstan . */
  Kz = 'KZ',
  /** Lao People's Democratic Republic . */
  La = 'LA',
  /** Lebanon . */
  Lb = 'LB',
  /** Saint Lucia . */
  Lc = 'LC',
  /** Liechtenstein . */
  Li = 'LI',
  /** Sri Lanka . */
  Lk = 'LK',
  /** Liberia . */
  Lr = 'LR',
  /** Lesotho . */
  Ls = 'LS',
  /** Lithuania . */
  Lt = 'LT',
  /** Luxembourg . */
  Lu = 'LU',
  /** Latvia . */
  Lv = 'LV',
  /** Libya . */
  Ly = 'LY',
  /** Morocco . */
  Ma = 'MA',
  /** Monaco . */
  Mc = 'MC',
  /** Moldova . */
  Md = 'MD',
  /** Montenegro . */
  Me = 'ME',
  /** Saint Martin . */
  Mf = 'MF',
  /** Madagascar . */
  Mg = 'MG',
  /** Marshall Islands . */
  Mh = 'MH',
  /** North Macedonia . */
  Mk = 'MK',
  /** Mali . */
  Ml = 'ML',
  /** Myanmar . */
  Mm = 'MM',
  /** Mongolia . */
  Mn = 'MN',
  /** Macao . */
  Mo = 'MO',
  /** Northern Mariana Islands . */
  Mp = 'MP',
  /** Martinique . */
  Mq = 'MQ',
  /** Mauritania . */
  Mr = 'MR',
  /** Montserrat . */
  Ms = 'MS',
  /** Malta . */
  Mt = 'MT',
  /** Mauritius . */
  Mu = 'MU',
  /** Maldives . */
  Mv = 'MV',
  /** Malawi . */
  Mw = 'MW',
  /** Mexico . */
  Mx = 'MX',
  /** Malaysia . */
  My = 'MY',
  /** Mozambique . */
  Mz = 'MZ',
  /** Namibia . */
  Na = 'NA',
  /** New Caledonia . */
  Nc = 'NC',
  /** Niger . */
  Ne = 'NE',
  /** Norfolk Island . */
  Nf = 'NF',
  /** Nigeria . */
  Ng = 'NG',
  /** Nicaragua . */
  Ni = 'NI',
  /** Netherlands . */
  Nl = 'NL',
  /** Norway . */
  No = 'NO',
  /** Nepal . */
  Np = 'NP',
  /** Nauru . */
  Nr = 'NR',
  /** Niue . */
  Nu = 'NU',
  /** New Zealand . */
  Nz = 'NZ',
  /** Oman . */
  Om = 'OM',
  /** Panama . */
  Pa = 'PA',
  /** Peru . */
  Pe = 'PE',
  /** French Polynesia . */
  Pf = 'PF',
  /** Papua New Guinea . */
  Pg = 'PG',
  /** Philippines . */
  Ph = 'PH',
  /** Pakistan . */
  Pk = 'PK',
  /** Poland . */
  Pl = 'PL',
  /** Saint Pierre and Miquelon . */
  Pm = 'PM',
  /** Pitcairn . */
  Pn = 'PN',
  /** Puerto Rico . */
  Pr = 'PR',
  /** Palestine, State of . */
  Ps = 'PS',
  /** Portugal . */
  Pt = 'PT',
  /** Palau . */
  Pw = 'PW',
  /** Paraguay . */
  Py = 'PY',
  /** Qatar . */
  Qa = 'QA',
  /** Réunion . */
  Re = 'RE',
  /** Romania . */
  Ro = 'RO',
  /** Serbia . */
  Rs = 'RS',
  /** Russian Federation . */
  Ru = 'RU',
  /** Rwanda . */
  Rw = 'RW',
  /** Saudi Arabia . */
  Sa = 'SA',
  /** Solomon Islands . */
  Sb = 'SB',
  /** Seychelles . */
  Sc = 'SC',
  /** Sudan . */
  Sd = 'SD',
  /** Sweden . */
  Se = 'SE',
  /** Singapore . */
  Sg = 'SG',
  /** Saint Helena, Ascension and Tristan da Cunha . */
  Sh = 'SH',
  /** Slovenia . */
  Si = 'SI',
  /** Svalbard and Jan Mayen . */
  Sj = 'SJ',
  /** Slovakia . */
  Sk = 'SK',
  /** Sierra Leone . */
  Sl = 'SL',
  /** San Marino . */
  Sm = 'SM',
  /** Senegal . */
  Sn = 'SN',
  /** Somalia . */
  So = 'SO',
  /** Suriname . */
  Sr = 'SR',
  /** South Sudan . */
  Ss = 'SS',
  /** Sao Tome and Principe . */
  St = 'ST',
  /** El Salvador . */
  Sv = 'SV',
  /** Sint Maarten . */
  Sx = 'SX',
  /** Syria Arab Republic . */
  Sy = 'SY',
  /** Eswatini . */
  Sz = 'SZ',
  /** Turks and Caicos Islands . */
  Tc = 'TC',
  /** Chad . */
  Td = 'TD',
  /** French Southern Territories . */
  Tf = 'TF',
  /** Togo . */
  Tg = 'TG',
  /** Thailand . */
  Th = 'TH',
  /** Tajikistan . */
  Tj = 'TJ',
  /** Tokelau . */
  Tk = 'TK',
  /** Timor-Leste . */
  Tl = 'TL',
  /** Turkmenistan . */
  Tm = 'TM',
  /** Tunisia . */
  Tn = 'TN',
  /** Tonga . */
  To = 'TO',
  /** Türkiye . */
  Tr = 'TR',
  /** Trinidad and Tobago . */
  Tt = 'TT',
  /** Tuvalu . */
  Tv = 'TV',
  /** Taiwan . */
  Tw = 'TW',
  /** Tanzania, the United Republic of . */
  Tz = 'TZ',
  /** Ukraine . */
  Ua = 'UA',
  /** Uganda . */
  Ug = 'UG',
  /** US Minor Outlying Islands . */
  Um = 'UM',
  /** United States . */
  Us = 'US',
  /** Uruguay . */
  Uy = 'UY',
  /** Uzbekistan . */
  Uz = 'UZ',
  /** Holy See . */
  Va = 'VA',
  /** Saint Vincent and the Grenadines . */
  Vc = 'VC',
  /** Venezuela . */
  Ve = 'VE',
  /** Virgin Islands, British . */
  Vg = 'VG',
  /** Virgin Islands, U.S. . */
  Vi = 'VI',
  /** Viet Nam . */
  Vn = 'VN',
  /** Vanuatu . */
  Vu = 'VU',
  /** Wallis and Futuna . */
  Wf = 'WF',
  /** Samoa . */
  Ws = 'WS',
  /** Yemen . */
  Ye = 'YE',
  /** Mayotte . */
  Yt = 'YT',
  /** South Africa . */
  Za = 'ZA',
  /** Zambia . */
  Zm = 'ZM',
  /** Zimbabwe . */
  Zw = 'ZW'
}

/** Input fields for Address FormField. */
export type AddressFieldInput = {
  /** Address city. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Address country. */
  country?: InputMaybe<AddressFieldCountryEnum>;
  /** Address line two. */
  lineTwo?: InputMaybe<Scalars['String']['input']>;
  /** Address state/region/province name. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Street address. */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Address zip code. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Canadian Provinces supported by Gravity Forms Address Field. */
export enum AddressFieldProvinceEnum {
  /** Alberta . */
  Alberta = 'ALBERTA',
  /** British Columbia . */
  BritishColumbia = 'BRITISH_COLUMBIA',
  /** Manitoba . */
  Manitoba = 'MANITOBA',
  /** Newfoundland and Labrador . */
  NewfoundlandAndLabrador = 'NEWFOUNDLAND_AND_LABRADOR',
  /** New Brunswick . */
  NewBrunswick = 'NEW_BRUNSWICK',
  /** Northwest Territories . */
  NorthwestTerritories = 'NORTHWEST_TERRITORIES',
  /** Nova Scotia . */
  NovaScotia = 'NOVA_SCOTIA',
  /** Nunavut . */
  Nunavut = 'NUNAVUT',
  /** Ontario . */
  Ontario = 'ONTARIO',
  /** Prince Edward Island . */
  PrinceEdwardIsland = 'PRINCE_EDWARD_ISLAND',
  /** Quebec . */
  Quebec = 'QUEBEC',
  /** Saskatchewan . */
  Saskatchewan = 'SASKATCHEWAN',
  /** Yukon . */
  Yukon = 'YUKON'
}

/** Determines the type of address to be displayed. */
export enum AddressFieldTypeEnum {
  /** Canada address type. */
  Canada = 'CANADA',
  /** International address type. */
  International = 'INTERNATIONAL',
  /** United States address type. */
  Us = 'US'
}

/** The individual properties for each element of the address value field. */
export type AddressFieldValue = {
  __typename?: 'AddressFieldValue';
  /** Address city. */
  city?: Maybe<Scalars['String']['output']>;
  /** Address country. */
  country?: Maybe<AddressFieldCountryEnum>;
  /** Address line two. */
  lineTwo?: Maybe<Scalars['String']['output']>;
  /** Address state/region/province name. */
  state?: Maybe<Scalars['String']['output']>;
  /** Street address. */
  street?: Maybe<Scalars['String']['output']>;
  /** Address zip code. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** AddressInputProperty input values. */
export type AddressInputProperty = GfFieldInput & GfFieldInputWithAddressSetting & {
  __typename?: 'AddressInputProperty';
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** Whether or not this field should be hidden. */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Key used to identify this input. */
  key?: Maybe<Scalars['String']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** The AM or PM cycle in a 12-hour clock. */
export enum AmPmEnum {
  /** AM. The first 12-hour cycle of the day. */
  Am = 'AM',
  /** PM. The second 12-hour cycle of the day. */
  Pm = 'PM'
}

/** Avatars are profile images for users. WordPress by default uses the Gravatar service to host and fetch avatars from. */
export type Avatar = {
  __typename?: 'Avatar';
  /** TEST: URL for the default image or a default type. Accepts &#039;404&#039; (return a 404 instead of a default image), &#039;retro&#039; (8bit), &#039;monsterid&#039; (monster), &#039;wavatar&#039; (cartoon face), &#039;indenticon&#039; (the &#039;quilt&#039;), &#039;mystery&#039;, &#039;mm&#039;, or &#039;mysteryman&#039; (The Oyster Man), &#039;blank&#039; (transparent GIF), or &#039;gravatar_default&#039; (the Gravatar logo). */
  default?: Maybe<Scalars['String']['output']>;
  /** HTML attributes to insert in the IMG element. Is not sanitized. */
  extraAttr?: Maybe<Scalars['String']['output']>;
  /** Whether to always show the default image, never the Gravatar. */
  forceDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the avatar was successfully found. */
  foundAvatar?: Maybe<Scalars['Boolean']['output']>;
  /** Height of the avatar image. */
  height?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** What rating to display avatars up to. Accepts &#039;G&#039;, &#039;PG&#039;, &#039;R&#039;, &#039;X&#039;, and are judged in that order. */
  rating?: Maybe<Scalars['String']['output']>;
  /** Type of url scheme to use. Typically HTTP vs. HTTPS. */
  scheme?: Maybe<Scalars['String']['output']>;
  /** The size of the avatar in pixels. A value of 96 will match a 96px x 96px gravatar image. */
  size?: Maybe<Scalars['Int']['output']>;
  /** URL for the gravatar image source. */
  url?: Maybe<Scalars['String']['output']>;
  /** Width of the avatar image. */
  width?: Maybe<Scalars['Int']['output']>;
};

/** Content rating filter for user avatars. Determines the maximum maturity level of avatars to display, following standard content rating classifications (G, PG, R, X). */
export enum AvatarRatingEnum {
  /** Indicates a G level avatar rating level. */
  G = 'G',
  /** Indicates a PG level avatar rating level. */
  Pg = 'PG',
  /** Indicates an R level avatar rating level. */
  R = 'R',
  /** Indicates an X level avatar rating level. */
  X = 'X'
}

/** The &quot;Benefits&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type Benefits = AcfFieldGroup & AcfFieldGroupFields & Benefits_Fields & {
  __typename?: 'Benefits';
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;Benefits&quot; Field Group */
  benefitCards?: Maybe<Array<Maybe<BenefitsBenefitCards>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Benefits&quot; Field Group */
  sectionDescription?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** The &quot;BenefitsAccordion&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BenefitsAccordion = AcfFieldGroup & AcfFieldGroupFields & BenefitsAccordion_Fields & {
  __typename?: 'BenefitsAccordion';
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;BenefitsAccordion&quot; Field Group */
  accordionItems?: Maybe<Array<Maybe<BenefitsAccordionAccordionItems>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsAccordion&quot; Field Group */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsAccordion&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;BenefitsAccordionAccordionItems&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BenefitsAccordionAccordionItems = AcfFieldGroup & AcfFieldGroupFields & BenefitsAccordionAccordionItems_Fields & {
  __typename?: 'BenefitsAccordionAccordionItems';
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;BenefitsAccordionAccordionItems&quot; Field Group */
  accordionImage?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsAccordionAccordionItems&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;BenefitsAccordionAccordionItems&quot; Field Group */
  links?: Maybe<Array<Maybe<BenefitsAccordionAccordionItemsLinks>>>;
};

/** The &quot;BenefitsAccordionAccordionItemsLinks&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BenefitsAccordionAccordionItemsLinks = AcfFieldGroup & AcfFieldGroupFields & BenefitsAccordionAccordionItemsLinks_Fields & {
  __typename?: 'BenefitsAccordionAccordionItemsLinks';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;BenefitsAccordionAccordionItemsLinks&quot; Field Group */
  link?: Maybe<AcfLink>;
  /** This is the id that will be passed to the link element. It should be unique. */
  linkId?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;BenefitsAccordionAccordionItemsLinks&quot; Field Group */
export type BenefitsAccordionAccordionItemsLinks_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;BenefitsAccordionAccordionItemsLinks&quot; Field Group */
  link?: Maybe<AcfLink>;
  /** This is the id that will be passed to the link element. It should be unique. */
  linkId?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;BenefitsAccordionAccordionItems&quot; Field Group */
export type BenefitsAccordionAccordionItems_Fields = {
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;BenefitsAccordionAccordionItems&quot; Field Group */
  accordionImage?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsAccordionAccordionItems&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;BenefitsAccordionAccordionItems&quot; Field Group */
  links?: Maybe<Array<Maybe<BenefitsAccordionAccordionItemsLinks>>>;
};

/** Interface representing fields of the ACF &quot;BenefitsAccordion&quot; Field Group */
export type BenefitsAccordion_Fields = {
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;BenefitsAccordion&quot; Field Group */
  accordionItems?: Maybe<Array<Maybe<BenefitsAccordionAccordionItems>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsAccordion&quot; Field Group */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsAccordion&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;BenefitsBenefitCards&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BenefitsBenefitCards = AcfFieldGroup & AcfFieldGroupFields & BenefitsBenefitCards_Fields & {
  __typename?: 'BenefitsBenefitCards';
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;BenefitsBenefitCards&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;BenefitsBenefitCards&quot; Field Group */
  cardImage?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;BenefitsBenefitCards&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsBenefitCards&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;BenefitsBenefitCards&quot; Field Group */
export type BenefitsBenefitCards_Fields = {
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;BenefitsBenefitCards&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;BenefitsBenefitCards&quot; Field Group */
  cardImage?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;BenefitsBenefitCards&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsBenefitCards&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;BenefitsList&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BenefitsList = AcfFieldGroup & AcfFieldGroupFields & BenefitsList_Fields & {
  __typename?: 'BenefitsList';
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;BenefitsList&quot; Field Group */
  benefits?: Maybe<Array<Maybe<BenefitsListBenefits>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsList&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;BenefitsList&quot; Field Group */
  disclaimers?: Maybe<Array<Maybe<BenefitsListDisclaimers>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;BenefitsList&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsList&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;BenefitsListBenefits&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BenefitsListBenefits = AcfFieldGroup & AcfFieldGroupFields & BenefitsListBenefits_Fields & {
  __typename?: 'BenefitsListBenefits';
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;BenefitsListBenefits&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsListBenefits&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;BenefitsListBenefits&quot; Field Group */
export type BenefitsListBenefits_Fields = {
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;BenefitsListBenefits&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsListBenefits&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;BenefitsListDisclaimers&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BenefitsListDisclaimers = AcfFieldGroup & AcfFieldGroupFields & BenefitsListDisclaimers_Fields & {
  __typename?: 'BenefitsListDisclaimers';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsListDisclaimers&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;BenefitsListDisclaimers&quot; Field Group */
export type BenefitsListDisclaimers_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsListDisclaimers&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;BenefitsList&quot; Field Group */
export type BenefitsList_Fields = {
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;BenefitsList&quot; Field Group */
  benefits?: Maybe<Array<Maybe<BenefitsListBenefits>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsList&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;BenefitsList&quot; Field Group */
  disclaimers?: Maybe<Array<Maybe<BenefitsListDisclaimers>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;BenefitsList&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BenefitsList&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;Benefits&quot; Field Group */
export type Benefits_Fields = {
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;Benefits&quot; Field Group */
  benefitCards?: Maybe<Array<Maybe<BenefitsBenefitCards>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Benefits&quot; Field Group */
  sectionDescription?: Maybe<Scalars['String']['output']>;
};

/** The &quot;Benefitscontent&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type Benefitscontent = AcfFieldGroup & AcfFieldGroupFields & Benefitscontent_Fields & {
  __typename?: 'Benefitscontent';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;Benefitscontent&quot; Field Group */
  media?: Maybe<BenefitscontentMedia>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;Benefitscontent&quot; Field Group */
  textContent?: Maybe<Scalars['String']['output']>;
  /** Determines the vertical alignment of the Text Content block. Use with caution */
  textContentVerticalAlignment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Benefitscontent&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;BenefitscontentMedia&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BenefitscontentMedia = AcfFieldGroup & AcfFieldGroupFields & BenefitscontentMedia_Fields & {
  __typename?: 'BenefitscontentMedia';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;BenefitscontentMedia&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;BenefitscontentMedia&quot; Field Group */
  type?: Maybe<Scalars['String']['output']>;
  /** This should be a URL to a YouTube or Vimeo video */
  video?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;BenefitscontentMedia&quot; Field Group */
export type BenefitscontentMedia_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;BenefitscontentMedia&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;BenefitscontentMedia&quot; Field Group */
  type?: Maybe<Scalars['String']['output']>;
  /** This should be a URL to a YouTube or Vimeo video */
  video?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;Benefitscontent&quot; Field Group */
export type Benefitscontent_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;Benefitscontent&quot; Field Group */
  media?: Maybe<BenefitscontentMedia>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;Benefitscontent&quot; Field Group */
  textContent?: Maybe<Scalars['String']['output']>;
  /** Determines the vertical alignment of the Text Content block. Use with caution */
  textContentVerticalAlignment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Benefitscontent&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;BlockFooter&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BlockFooter = AcfFieldGroup & AcfFieldGroupFields & BlockFooter_Fields & {
  __typename?: 'BlockFooter';
  /** Field of the &quot;email&quot; Field Type added to the schema as part of the &quot;BlockFooter&quot; Field Group */
  email?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlockFooter&quot; Field Group */
  emailLinkText?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;BlockFooter&quot; Field Group */
  footerAddress?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;BlockFooter&quot; Field Group */
  footerDisclosure?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;BlockFooter&quot; Field Group */
  footerLogo?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;number&quot; Field Type added to the schema as part of the &quot;BlockFooter&quot; Field Group */
  phone?: Maybe<Scalars['Float']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;BlockFooter&quot; Field Group */
  socialMediaIcons?: Maybe<Array<Maybe<BlockFooterSocialMediaIcons>>>;
};

/** The &quot;BlockFooterSocialMediaIcons&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BlockFooterSocialMediaIcons = AcfFieldGroup & AcfFieldGroupFields & BlockFooterSocialMediaIcons_Fields & {
  __typename?: 'BlockFooterSocialMediaIcons';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;BlockFooterSocialMediaIcons&quot; Field Group */
  iconImage?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;url&quot; Field Type added to the schema as part of the &quot;BlockFooterSocialMediaIcons&quot; Field Group */
  socialMediaUrl?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;BlockFooterSocialMediaIcons&quot; Field Group */
export type BlockFooterSocialMediaIcons_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;BlockFooterSocialMediaIcons&quot; Field Group */
  iconImage?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;url&quot; Field Type added to the schema as part of the &quot;BlockFooterSocialMediaIcons&quot; Field Group */
  socialMediaUrl?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;BlockFooter&quot; Field Group */
export type BlockFooter_Fields = {
  /** Field of the &quot;email&quot; Field Type added to the schema as part of the &quot;BlockFooter&quot; Field Group */
  email?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlockFooter&quot; Field Group */
  emailLinkText?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;BlockFooter&quot; Field Group */
  footerAddress?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;BlockFooter&quot; Field Group */
  footerDisclosure?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;BlockFooter&quot; Field Group */
  footerLogo?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;number&quot; Field Type added to the schema as part of the &quot;BlockFooter&quot; Field Group */
  phone?: Maybe<Scalars['Float']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;BlockFooter&quot; Field Group */
  socialMediaIcons?: Maybe<Array<Maybe<BlockFooterSocialMediaIcons>>>;
};

/** The &quot;BlockModal&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BlockModal = AcfFieldGroup & AcfFieldGroupFields & BlockModal_Fields & {
  __typename?: 'BlockModal';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlockModal&quot; Field Group */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;BlockModal&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlockModal&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;BlockModal&quot; Field Group */
export type BlockModal_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlockModal&quot; Field Group */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;BlockModal&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlockModal&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;BlockVideo&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BlockVideo = AcfFieldGroup & AcfFieldGroupFields & BlockVideo_Fields & {
  __typename?: 'BlockVideo';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;url&quot; Field Type added to the schema as part of the &quot;BlockVideo&quot; Field Group */
  url?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;BlockVideo&quot; Field Group */
export type BlockVideo_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;url&quot; Field Type added to the schema as part of the &quot;BlockVideo&quot; Field Group */
  url?: Maybe<Scalars['String']['output']>;
};

/** Block that supports Anchor field */
export type BlockWithSupportsAnchor = {
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
};

/** The &quot;Blocks&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type Blocks = AcfFieldGroup & AcfFieldGroupFields & Blocks_Fields & {
  __typename?: 'Blocks';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;Blocks&quot; Field Group */
export type Blocks_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** The &quot;BlogArticles&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BlogArticles = AcfFieldGroup & AcfFieldGroupFields & BlogArticles_Fields & {
  __typename?: 'BlogArticles';
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;BlogArticles&quot; Field Group */
  featuredArticles?: Maybe<Array<Maybe<BlogArticlesFeaturedArticles>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** The &quot;BlogArticlesFeaturedArticles&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BlogArticlesFeaturedArticles = AcfFieldGroup & AcfFieldGroupFields & BlogArticlesFeaturedArticles_Fields & {
  __typename?: 'BlogArticlesFeaturedArticles';
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;BlogArticlesFeaturedArticles&quot; Field Group */
  articles?: Maybe<Array<Maybe<BlogArticlesFeaturedArticlesArticles>>>;
  /** Field of the &quot;taxonomy&quot; Field Type added to the schema as part of the &quot;BlogArticlesFeaturedArticles&quot; Field Group */
  category?: Maybe<AcfTermNodeConnection>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};


/** The &quot;BlogArticlesFeaturedArticles&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BlogArticlesFeaturedArticlesCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The &quot;BlogArticlesFeaturedArticlesArticles&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BlogArticlesFeaturedArticlesArticles = AcfFieldGroup & AcfFieldGroupFields & BlogArticlesFeaturedArticlesArticles_Fields & {
  __typename?: 'BlogArticlesFeaturedArticlesArticles';
  /** Field of the &quot;post_object&quot; Field Type added to the schema as part of the &quot;BlogArticlesFeaturedArticlesArticles&quot; Field Group */
  article?: Maybe<AcfContentNodeConnection>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};


/** The &quot;BlogArticlesFeaturedArticlesArticles&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BlogArticlesFeaturedArticlesArticlesArticleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Interface representing fields of the ACF &quot;BlogArticlesFeaturedArticlesArticles&quot; Field Group */
export type BlogArticlesFeaturedArticlesArticles_Fields = {
  /** Field of the &quot;post_object&quot; Field Type added to the schema as part of the &quot;BlogArticlesFeaturedArticlesArticles&quot; Field Group */
  article?: Maybe<AcfContentNodeConnection>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};


/** Interface representing fields of the ACF &quot;BlogArticlesFeaturedArticlesArticles&quot; Field Group */
export type BlogArticlesFeaturedArticlesArticles_FieldsArticleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Interface representing fields of the ACF &quot;BlogArticlesFeaturedArticles&quot; Field Group */
export type BlogArticlesFeaturedArticles_Fields = {
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;BlogArticlesFeaturedArticles&quot; Field Group */
  articles?: Maybe<Array<Maybe<BlogArticlesFeaturedArticlesArticles>>>;
  /** Field of the &quot;taxonomy&quot; Field Type added to the schema as part of the &quot;BlogArticlesFeaturedArticles&quot; Field Group */
  category?: Maybe<AcfTermNodeConnection>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};


/** Interface representing fields of the ACF &quot;BlogArticlesFeaturedArticles&quot; Field Group */
export type BlogArticlesFeaturedArticles_FieldsCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Interface representing fields of the ACF &quot;BlogArticles&quot; Field Group */
export type BlogArticles_Fields = {
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;BlogArticles&quot; Field Group */
  featuredArticles?: Maybe<Array<Maybe<BlogArticlesFeaturedArticles>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** The &quot;BlogCtaCard&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BlogCtaCard = AcfFieldGroup & AcfFieldGroupFields & BlogCtaCard_Fields & {
  __typename?: 'BlogCtaCard';
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;BlogCtaCard&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogCtaCard&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;BlogCtaCard&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogCtaCard&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;BlogCtaCard&quot; Field Group */
export type BlogCtaCard_Fields = {
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;BlogCtaCard&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogCtaCard&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;BlogCtaCard&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogCtaCard&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;BlogIndexContent&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BlogIndexContent = AcfFieldGroup & AcfFieldGroupFields & BlogIndexContent_Fields & {
  __typename?: 'BlogIndexContent';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;BlogIndexContent&quot; Field Group */
  newsletter?: Maybe<BlogIndexContentNewsletter>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** The &quot;BlogIndexContentNewsletter&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type BlogIndexContentNewsletter = AcfFieldGroup & AcfFieldGroupFields & BlogIndexContentNewsletter_Fields & {
  __typename?: 'BlogIndexContentNewsletter';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogIndexContentNewsletter&quot; Field Group */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogIndexContentNewsletter&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogIndexContentNewsletter&quot; Field Group */
  inputPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogIndexContentNewsletter&quot; Field Group */
  marketoFormId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogIndexContentNewsletter&quot; Field Group */
  successMessage?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogIndexContentNewsletter&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;BlogIndexContentNewsletter&quot; Field Group */
export type BlogIndexContentNewsletter_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogIndexContentNewsletter&quot; Field Group */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogIndexContentNewsletter&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogIndexContentNewsletter&quot; Field Group */
  inputPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogIndexContentNewsletter&quot; Field Group */
  marketoFormId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogIndexContentNewsletter&quot; Field Group */
  successMessage?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;BlogIndexContentNewsletter&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;BlogIndexContent&quot; Field Group */
export type BlogIndexContent_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;BlogIndexContent&quot; Field Group */
  newsletter?: Maybe<BlogIndexContentNewsletter>;
};

/** The &quot;CalloutText&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type CalloutText = AcfFieldGroup & AcfFieldGroupFields & CalloutText_Fields & {
  __typename?: 'CalloutText';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;CalloutText&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CalloutText&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;CalloutText&quot; Field Group */
export type CalloutText_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;CalloutText&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CalloutText&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms captcha field. */
export type CaptchaField = FormField & GfFieldWithCaptchaBackgroundSetting & GfFieldWithCaptchaBadgeSetting & GfFieldWithCaptchaForegroundSetting & GfFieldWithCaptchaLanguageSetting & GfFieldWithCaptchaSizeSetting & GfFieldWithCaptchaThemeSetting & GfFieldWithCaptchaTypeSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & Node & {
  __typename?: 'CaptchaField';
  /** The language used when the captcha is displayed. This property is available when the captchaType is “captcha”, the default. The possible values are the language codes used by WordPress. */
  captchaBadgePosition?: Maybe<CaptchaFieldBadgePositionEnum>;
  /** The language used when the captcha is displayed. This property is available when the captchaType is “captcha”, the default. The possible values are the language codes used by WordPress. */
  captchaLanguage?: Maybe<Scalars['String']['output']>;
  /** Determines the theme to be used for the reCAPTCHA field. Only applicable to the recaptcha captcha type. */
  captchaTheme?: Maybe<CaptchaFieldThemeEnum>;
  /** Determines the type of CAPTCHA field to be used. */
  captchaType?: Maybe<CaptchaFieldTypeEnum>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** Determines the image’s background color, in HEX format (i.e. #CCCCCC). Only applicable to simple_captcha and math captcha types. */
  simpleCaptchaBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** Determines the image’s font color, in HEX format (i.e. #CCCCCC). Only applicable to simple_captcha and math captcha types. */
  simpleCaptchaFontColor?: Maybe<Scalars['String']['output']>;
  /** Determines the CAPTCHA image size. Only applicable to simple_captcha and math captcha types. */
  simpleCaptchaSize?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** The position to place the (invisible) reCaptcha badge. */
export enum CaptchaFieldBadgePositionEnum {
  /** Bottom-left position. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Bottom-right position. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Inline position. */
  Inline = 'INLINE'
}

/** The theme to be used for the reCAPTCHA field. */
export enum CaptchaFieldThemeEnum {
  /** Dark reCAPTCHA theme. */
  Dark = 'DARK',
  /** Light reCAPTCHA theme. */
  Light = 'LIGHT'
}

/** Type of CAPTCHA field to be used. */
export enum CaptchaFieldTypeEnum {
  /** Math CAPTCHA type. */
  Math = 'MATH',
  /** reCAPTCHA type. */
  Recaptcha = 'RECAPTCHA',
  /** Simple CAPTCHA type. */
  Simple = 'SIMPLE'
}

/** The &quot;CardGrid&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type CardGrid = AcfFieldGroup & AcfFieldGroupFields & CardGrid_Fields & {
  __typename?: 'CardGrid';
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;CardGrid&quot; Field Group */
  cardBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;CardGrid&quot; Field Group */
  cardBorder?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;CardGrid&quot; Field Group */
  cards?: Maybe<Array<Maybe<CardGridCards>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CardGrid&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;number&quot; Field Type added to the schema as part of the &quot;CardGrid&quot; Field Group */
  maxColumns?: Maybe<Scalars['Float']['output']>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;CardGrid&quot; Field Group */
  sectionBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CardGrid&quot; Field Group */
  sectionTitle?: Maybe<Scalars['String']['output']>;
};

/** The &quot;CardGridCards&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type CardGridCards = AcfFieldGroup & AcfFieldGroupFields & CardGridCards_Fields & {
  __typename?: 'CardGridCards';
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;CardGridCards&quot; Field Group */
  card?: Maybe<Array<Maybe<CardGridCardsCard>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** The &quot;CardGridCardsCard&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type CardGridCardsCard = AcfFieldGroup & AcfFieldGroupFields & CardGridCardsCard_Fields & {
  __typename?: 'CardGridCardsCard';
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  buttonColor?: Maybe<Scalars['String']['output']>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;select&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  elementType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  heading?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  imageData?: Maybe<CardGridCardsCardImageData>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  list?: Maybe<Array<Maybe<CardGridCardsCardList>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  paragraph?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;CardGridCardsCardImageData&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type CardGridCardsCardImageData = AcfFieldGroup & AcfFieldGroupFields & CardGridCardsCardImageData_Fields & {
  __typename?: 'CardGridCardsCardImageData';
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;CardGridCardsCardImageData&quot; Field Group */
  alignment?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CardGridCardsCardImageData&quot; Field Group */
  caption?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;CardGridCardsCardImageData&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
};

/** Interface representing fields of the ACF &quot;CardGridCardsCardImageData&quot; Field Group */
export type CardGridCardsCardImageData_Fields = {
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;CardGridCardsCardImageData&quot; Field Group */
  alignment?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CardGridCardsCardImageData&quot; Field Group */
  caption?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;CardGridCardsCardImageData&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
};

/** The &quot;CardGridCardsCardList&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type CardGridCardsCardList = AcfFieldGroup & AcfFieldGroupFields & CardGridCardsCardList_Fields & {
  __typename?: 'CardGridCardsCardList';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CardGridCardsCardList&quot; Field Group */
  item?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;CardGridCardsCardList&quot; Field Group */
export type CardGridCardsCardList_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CardGridCardsCardList&quot; Field Group */
  item?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;CardGridCardsCard&quot; Field Group */
export type CardGridCardsCard_Fields = {
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  buttonColor?: Maybe<Scalars['String']['output']>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;select&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  elementType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  heading?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  imageData?: Maybe<CardGridCardsCardImageData>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  list?: Maybe<Array<Maybe<CardGridCardsCardList>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  paragraph?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CardGridCardsCard&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;CardGridCards&quot; Field Group */
export type CardGridCards_Fields = {
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;CardGridCards&quot; Field Group */
  card?: Maybe<Array<Maybe<CardGridCardsCard>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;CardGrid&quot; Field Group */
export type CardGrid_Fields = {
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;CardGrid&quot; Field Group */
  cardBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;CardGrid&quot; Field Group */
  cardBorder?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;CardGrid&quot; Field Group */
  cards?: Maybe<Array<Maybe<CardGridCards>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CardGrid&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;number&quot; Field Type added to the schema as part of the &quot;CardGrid&quot; Field Group */
  maxColumns?: Maybe<Scalars['Float']['output']>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;CardGrid&quot; Field Group */
  sectionBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CardGrid&quot; Field Group */
  sectionTitle?: Maybe<Scalars['String']['output']>;
};

/** The &quot;CaseStudies&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type CaseStudies = AcfFieldGroup & AcfFieldGroupFields & CaseStudies_Fields & {
  __typename?: 'CaseStudies';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CaseStudies&quot; Field Group */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;CaseStudies&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;CaseStudies&quot; Field Group */
  items?: Maybe<Array<Maybe<CaseStudiesItems>>>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CaseStudies&quot; Field Group */
  sectionTitle?: Maybe<Scalars['String']['output']>;
};

/** The &quot;CaseStudiesItems&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type CaseStudiesItems = AcfFieldGroup & AcfFieldGroupFields & CaseStudiesItems_Fields & {
  __typename?: 'CaseStudiesItems';
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;CaseStudiesItems&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;post_object&quot; Field Type added to the schema as part of the &quot;CaseStudiesItems&quot; Field Group */
  post?: Maybe<AcfContentNodeConnection>;
};


/** The &quot;CaseStudiesItems&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type CaseStudiesItemsPostArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Interface representing fields of the ACF &quot;CaseStudiesItems&quot; Field Group */
export type CaseStudiesItems_Fields = {
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;CaseStudiesItems&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;post_object&quot; Field Type added to the schema as part of the &quot;CaseStudiesItems&quot; Field Group */
  post?: Maybe<AcfContentNodeConnection>;
};


/** Interface representing fields of the ACF &quot;CaseStudiesItems&quot; Field Group */
export type CaseStudiesItems_FieldsPostArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Interface representing fields of the ACF &quot;CaseStudies&quot; Field Group */
export type CaseStudies_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CaseStudies&quot; Field Group */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;CaseStudies&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;CaseStudies&quot; Field Group */
  items?: Maybe<Array<Maybe<CaseStudiesItems>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CaseStudies&quot; Field Group */
  sectionTitle?: Maybe<Scalars['String']['output']>;
};

/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type Category = DatabaseIdentifier & HierarchicalNode & HierarchicalTermNode & MenuItemLinkable & Node & TermNode & UniformResourceIdentifiable & {
  __typename?: 'Category';
  /** The ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<CategoryToAncestorsCategoryConnection>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of databaseId
   */
  categoryId?: Maybe<Scalars['Int']['output']>;
  /** Connection between the category type and its children categories. */
  children?: Maybe<CategoryToCategoryConnection>;
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** Connection between the Category type and the ContentNode type */
  contentNodes?: Maybe<CategoryToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** The description of the object */
  description?: Maybe<Scalars['String']['output']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  /** The link to the term */
  link?: Maybe<Scalars['String']['output']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']['output']>;
  /** Connection between the category type and its parent category. */
  parent?: Maybe<CategoryToParentCategoryConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']['output']>;
  /** Connection between the Category type and the post type */
  posts?: Maybe<CategoryToPostConnection>;
  /** The Yoast SEO data of the Categories taxonomy. */
  seo?: Maybe<TaxonomySeo>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Connection between the Category type and the Taxonomy type */
  taxonomy?: Maybe<CategoryToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']['output']>;
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']['output']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']['output']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
};


/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type CategoryAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type CategoryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryToCategoryConnectionWhereArgs>;
};


/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type CategoryContentNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryToContentNodeConnectionWhereArgs>;
};


/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type CategoryEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type CategoryEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A taxonomy term that classifies content. Categories support hierarchy and can be used to create a nested structure. */
export type CategoryPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryToPostConnectionWhereArgs>;
};

/** A paginated collection of category Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of category Nodes */
export type CategoryConnection = {
  /** A list of edges (relational context) between RootQuery and connected category Nodes */
  edges: Array<CategoryConnectionEdge>;
  /** A list of connected category Nodes */
  nodes: Array<Category>;
  /** Information about pagination in a connection. */
  pageInfo: CategoryConnectionPageInfo;
};

/** Represents a connection to a category. Contains both the category Node and metadata about the relationship. */
export type CategoryConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected category Node */
  node: Category;
};

/** Pagination metadata specific to &quot;CategoryConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;CategoryConnectionEdge&quot; Nodes. */
export type CategoryConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Identifier types for retrieving a specific Category. Determines which unique property (global ID, database ID, slug, etc.) is used to locate the Category. */
export enum CategoryIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the Category type and the category type */
export type CategoryToAncestorsCategoryConnection = CategoryConnection & Connection & {
  __typename?: 'CategoryToAncestorsCategoryConnection';
  /** Edges for the CategoryToAncestorsCategoryConnection connection */
  edges: Array<CategoryToAncestorsCategoryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Category>;
  /** Information about pagination in a connection. */
  pageInfo: CategoryToAncestorsCategoryConnectionPageInfo;
};

/** An edge in a connection */
export type CategoryToAncestorsCategoryConnectionEdge = CategoryConnectionEdge & Edge & {
  __typename?: 'CategoryToAncestorsCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Category;
};

/** Pagination metadata specific to &quot;CategoryToAncestorsCategoryConnection&quot; collections. Provides cursors and flags for navigating through sets of CategoryToAncestorsCategoryConnection Nodes. */
export type CategoryToAncestorsCategoryConnectionPageInfo = CategoryConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'CategoryToAncestorsCategoryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Connection between the Category type and the category type */
export type CategoryToCategoryConnection = CategoryConnection & Connection & {
  __typename?: 'CategoryToCategoryConnection';
  /** Edges for the CategoryToCategoryConnection connection */
  edges: Array<CategoryToCategoryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Category>;
  /** Information about pagination in a connection. */
  pageInfo: CategoryToCategoryConnectionPageInfo;
};

/** An edge in a connection */
export type CategoryToCategoryConnectionEdge = CategoryConnectionEdge & Edge & {
  __typename?: 'CategoryToCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Category;
};

/** Pagination metadata specific to &quot;CategoryToCategoryConnection&quot; collections. Provides cursors and flags for navigating through sets of CategoryToCategoryConnection Nodes. */
export type CategoryToCategoryConnectionPageInfo = CategoryConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'CategoryToCategoryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the CategoryToCategoryConnection connection */
export type CategoryToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the Category type and the ContentNode type */
export type CategoryToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'CategoryToContentNodeConnection';
  /** Edges for the CategoryToContentNodeConnection connection */
  edges: Array<CategoryToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: CategoryToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type CategoryToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'CategoryToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Pagination metadata specific to &quot;CategoryToContentNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of CategoryToContentNodeConnection Nodes. */
export type CategoryToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'CategoryToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the CategoryToContentNodeConnection connection */
export type CategoryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfCategoryEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the Category type and the category type */
export type CategoryToParentCategoryConnectionEdge = CategoryConnectionEdge & Edge & OneToOneConnection & {
  __typename?: 'CategoryToParentCategoryConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: Category;
};

/** Connection between the Category type and the post type */
export type CategoryToPostConnection = Connection & PostConnection & {
  __typename?: 'CategoryToPostConnection';
  /** Edges for the CategoryToPostConnection connection */
  edges: Array<CategoryToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: CategoryToPostConnectionPageInfo;
};

/** An edge in a connection */
export type CategoryToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'CategoryToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Pagination metadata specific to &quot;CategoryToPostConnection&quot; collections. Provides cursors and flags for navigating through sets of CategoryToPostConnection Nodes. */
export type CategoryToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'CategoryToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the CategoryToPostConnection connection */
export type CategoryToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the Category type and the Taxonomy type */
export type CategoryToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  __typename?: 'CategoryToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: Taxonomy;
};

/** A Gravity Forms checkbox field. */
export type CheckboxField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSelectAllChoicesSetting & Node & {
  __typename?: 'CheckboxField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Checkbox field value. */
  checkboxValues?: Maybe<Array<Maybe<CheckboxFieldValue>>>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<CheckboxFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the \&quot;select all\&quot; choice should be displayed. */
  hasSelectAll?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<CheckboxInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** CheckboxFieldChoice choice values. */
export type CheckboxFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & {
  __typename?: 'CheckboxFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Input fields for a single checkbox. */
export type CheckboxFieldInput = {
  /** Input ID. */
  inputId?: InputMaybe<Scalars['Float']['input']>;
  /** Input value. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** The individual properties for each element of the Checkbox value field. */
export type CheckboxFieldValue = GfFieldValueWithChoice & GfFieldValueWithInput & {
  __typename?: 'CheckboxFieldValue';
  /** The selected Gravity Forms field choice object. */
  connectedChoice?: Maybe<GfFieldChoice>;
  /** The selected Gravity Forms field input object. */
  connectedInput?: Maybe<GfFieldInput>;
  /** Input ID. */
  inputId?: Maybe<Scalars['Float']['output']>;
  /** Input text. */
  text?: Maybe<Scalars['String']['output']>;
  /** Input value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** CheckboxInputProperty input values. */
export type CheckboxInputProperty = GfFieldInput & GfFieldInputWithSelectAllChoicesSetting & {
  __typename?: 'CheckboxInputProperty';
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
};

/** A response or reaction to content submitted by users. Comments are typically associated with a specific content entry. */
export type Comment = DatabaseIdentifier & Node & UniformResourceIdentifiable & {
  __typename?: 'Comment';
  /** User agent used to post the comment. This field is equivalent to WP_Comment-&gt;comment_agent and the value matching the &quot;comment_agent&quot; column in SQL. */
  agent?: Maybe<Scalars['String']['output']>;
  /**
   * The approval status of the comment. This field is equivalent to WP_Comment-&gt;comment_approved and the value matching the &quot;comment_approved&quot; column in SQL.
   * @deprecated Deprecated in favor of the `status` field
   */
  approved?: Maybe<Scalars['Boolean']['output']>;
  /** The author of the comment */
  author?: Maybe<CommentToCommenterConnectionEdge>;
  /**
   * IP address for the author at the time of commenting. This field is equivalent to WP_Comment-&gt;comment_author_IP and the value matching the &quot;comment_author_IP&quot; column in SQL.
   * @deprecated Use the ipAddress field on the edge between the comment and author
   */
  authorIp?: Maybe<Scalars['String']['output']>;
  /**
   * ID for the comment, unique among comments.
   * @deprecated Deprecated in favor of databaseId
   */
  commentId?: Maybe<Scalars['Int']['output']>;
  /** Connection between the Comment type and the ContentNode type */
  commentedOn?: Maybe<CommentToContentNodeConnectionEdge>;
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** Content of the comment. This field is equivalent to WP_Comment-&gt;comment_content and the value matching the &quot;comment_content&quot; column in SQL. */
  content?: Maybe<Scalars['String']['output']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** Date the comment was posted in local time. This field is equivalent to WP_Comment-&gt;date and the value matching the &quot;date&quot; column in SQL. */
  date?: Maybe<Scalars['String']['output']>;
  /** Date the comment was posted in GMT. This field is equivalent to WP_Comment-&gt;date_gmt and the value matching the &quot;date_gmt&quot; column in SQL. */
  dateGmt?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier for the comment object */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  /** Karma value for the comment. This field is equivalent to WP_Comment-&gt;comment_karma and the value matching the &quot;comment_karma&quot; column in SQL. */
  karma?: Maybe<Scalars['Int']['output']>;
  /** The permalink of the comment */
  link?: Maybe<Scalars['String']['output']>;
  /** Connection between the Comment type and the Comment type */
  parent?: Maybe<CommentToParentCommentConnectionEdge>;
  /** The database id of the parent comment node or null if it is the root comment */
  parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent comment node. */
  parentId?: Maybe<Scalars['ID']['output']>;
  /** Connection between the Comment type and the Comment type */
  replies?: Maybe<CommentToCommentConnection>;
  /** The approval status of the comment. This field is equivalent to WP_Comment-&gt;comment_approved and the value matching the &quot;comment_approved&quot; column in SQL. */
  status?: Maybe<CommentStatusEnum>;
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Type of comment. This field is equivalent to WP_Comment-&gt;comment_type and the value matching the &quot;comment_type&quot; column in SQL. */
  type?: Maybe<Scalars['String']['output']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
};


/** A response or reaction to content submitted by users. Comments are typically associated with a specific content entry. */
export type CommentContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** A response or reaction to content submitted by users. Comments are typically associated with a specific content entry. */
export type CommentParentArgs = {
  where?: InputMaybe<CommentToParentCommentConnectionWhereArgs>;
};


/** A response or reaction to content submitted by users. Comments are typically associated with a specific content entry. */
export type CommentRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommentToCommentConnectionWhereArgs>;
};

/** A Comment Author object */
export type CommentAuthor = Commenter & DatabaseIdentifier & Node & {
  __typename?: 'CommentAuthor';
  /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
  avatar?: Maybe<Avatar>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** The email for the comment author */
  email?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier for the comment author object */
  id: Scalars['ID']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** The name for the comment author. */
  name?: Maybe<Scalars['String']['output']>;
  /** The url the comment author. */
  url?: Maybe<Scalars['String']['output']>;
};


/** A Comment Author object */
export type CommentAuthorAvatarArgs = {
  forceDefault?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<AvatarRatingEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated collection of Comment Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of Comment Nodes */
export type CommentConnection = {
  /** A list of edges (relational context) between RootQuery and connected Comment Nodes */
  edges: Array<CommentConnectionEdge>;
  /** A list of connected Comment Nodes */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: CommentConnectionPageInfo;
};

/** Represents a connection to a Comment. Contains both the Comment Node and metadata about the relationship. */
export type CommentConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Comment Node */
  node: Comment;
};

/** Pagination metadata specific to &quot;CommentConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;CommentConnectionEdge&quot; Nodes. */
export type CommentConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Identifier types for retrieving a specific comment. Specifies which unique attribute is used to find a particular comment. */
export enum CommentNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID'
}

/** Moderation state for user comments. Determines whether comments are publicly visible, pending approval, or marked as spam. */
export enum CommentStatusEnum {
  /** Comments with the Approved status */
  Approve = 'APPROVE',
  /** Comments with the Unapproved status */
  Hold = 'HOLD',
  /** Comments with the Spam status */
  Spam = 'SPAM',
  /** Comments with the Trash status */
  Trash = 'TRASH'
}

/** Connection between the Comment type and the Comment type */
export type CommentToCommentConnection = CommentConnection & Connection & {
  __typename?: 'CommentToCommentConnection';
  /** Edges for the CommentToCommentConnection connection */
  edges: Array<CommentToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: CommentToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type CommentToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  __typename?: 'CommentToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Comment;
};

/** Pagination metadata specific to &quot;CommentToCommentConnection&quot; collections. Provides cursors and flags for navigating through sets of CommentToCommentConnection Nodes. */
export type CommentToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'CommentToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the CommentToCommentConnection connection */
export type CommentToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']['input']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']['input']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']['input']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']['input']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** One or more Comment Statuses to limit results by */
  statusIn?: InputMaybe<Array<InputMaybe<CommentStatusEnum>>>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection between the Comment type and the Commenter type */
export type CommentToCommenterConnectionEdge = CommenterConnectionEdge & Edge & OneToOneConnection & {
  __typename?: 'CommentToCommenterConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The email address representing the author for this particular comment */
  email?: Maybe<Scalars['String']['output']>;
  /** IP address of the author at the time of making this comment. This field is equivalent to WP_Comment-&gt;comment_author_IP and the value matching the &quot;comment_author_IP&quot; column in SQL. */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** The display name of the comment author for this particular comment */
  name?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: Commenter;
  /** The url entered for the comment author on this particular comment */
  url?: Maybe<Scalars['String']['output']>;
};

/** Connection between the Comment type and the ContentNode type */
export type CommentToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & OneToOneConnection & {
  __typename?: 'CommentToContentNodeConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: ContentNode;
};

/** Connection between the Comment type and the Comment type */
export type CommentToParentCommentConnectionEdge = CommentConnectionEdge & Edge & OneToOneConnection & {
  __typename?: 'CommentToParentCommentConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: Comment;
};

/** Arguments for filtering the CommentToParentCommentConnection connection */
export type CommentToParentCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']['input']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']['input']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']['input']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']['input']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** One or more Comment Statuses to limit results by */
  statusIn?: InputMaybe<Array<InputMaybe<CommentStatusEnum>>>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** A user or guest who has submitted a comment. Provides identification and contact information for the comment author. */
export type Commenter = {
  /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
  avatar?: Maybe<Avatar>;
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** The email address of the author of a comment. */
  email?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier for the comment author. */
  id: Scalars['ID']['output'];
  /** Whether the author information is considered restricted. (not fully public) */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the author of a comment. */
  name?: Maybe<Scalars['String']['output']>;
  /** The url of the author of a comment. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Represents a connection to a Commenter. Contains both the Commenter Node and metadata about the relationship. */
export type CommenterConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Commenter Node */
  node: Commenter;
};

/** Sorting attributes for comment collections. Specifies which comment property determines the order of results. */
export enum CommentsConnectionOrderbyEnum {
  /** Order by browser user agent of the commenter. */
  CommentAgent = 'COMMENT_AGENT',
  /** Order by approval status of the comment. */
  CommentApproved = 'COMMENT_APPROVED',
  /** Order by name of the comment author. */
  CommentAuthor = 'COMMENT_AUTHOR',
  /** Order by e-mail of the comment author. */
  CommentAuthorEmail = 'COMMENT_AUTHOR_EMAIL',
  /** Order by IP address of the comment author. */
  CommentAuthorIp = 'COMMENT_AUTHOR_IP',
  /** Order by URL address of the comment author. */
  CommentAuthorUrl = 'COMMENT_AUTHOR_URL',
  /** Order by the comment contents. */
  CommentContent = 'COMMENT_CONTENT',
  /** Chronological ordering by comment submission date. */
  CommentDate = 'COMMENT_DATE',
  /** Chronological ordering by comment date in UTC/GMT time. */
  CommentDateGmt = 'COMMENT_DATE_GMT',
  /** Ordering by internal ID (typically reflects creation order). */
  CommentId = 'COMMENT_ID',
  /** Preserve custom order of IDs as specified in the query. */
  CommentIn = 'COMMENT_IN',
  /** Order by the comment karma score. */
  CommentKarma = 'COMMENT_KARMA',
  /** Ordering by parent comment relationship (threaded discussions). */
  CommentParent = 'COMMENT_PARENT',
  /** Ordering by associated content item ID. */
  CommentPostId = 'COMMENT_POST_ID',
  /** Ordering by comment classification (standard comments, pingbacks, etc.). */
  CommentType = 'COMMENT_TYPE',
  /** Ordering by the user account ID associated with the comment as the comment author. */
  UserId = 'USER_ID'
}

/** The &quot;CompanyList&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type CompanyList = AcfFieldGroup & AcfFieldGroupFields & CompanyList_Fields & {
  __typename?: 'CompanyList';
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;CompanyList&quot; Field Group */
  companies?: Maybe<Array<Maybe<CompanyListCompanies>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** The &quot;CompanyListCompanies&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type CompanyListCompanies = AcfFieldGroup & AcfFieldGroupFields & CompanyListCompanies_Fields & {
  __typename?: 'CompanyListCompanies';
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;CompanyListCompanies&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CompanyListCompanies&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;CompanyListCompanies&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;CompanyListCompanies&quot; Field Group */
  logo?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CompanyListCompanies&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;CompanyListCompanies&quot; Field Group */
export type CompanyListCompanies_Fields = {
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;CompanyListCompanies&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CompanyListCompanies&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;CompanyListCompanies&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;CompanyListCompanies&quot; Field Group */
  logo?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CompanyListCompanies&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;CompanyList&quot; Field Group */
export type CompanyList_Fields = {
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;CompanyList&quot; Field Group */
  companies?: Maybe<Array<Maybe<CompanyListCompanies>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** Gravity Forms conditional logic. */
export type ConditionalLogic = {
  __typename?: 'ConditionalLogic';
  /** The type of action the conditional logic will perform. */
  actionType?: Maybe<ConditionalLogicActionTypeEnum>;
  /** Determines how to the rules should be evaluated. */
  logicType?: Maybe<ConditionalLogicLogicTypeEnum>;
  /** Conditional logic rules. */
  rules?: Maybe<Array<Maybe<ConditionalLogicRule>>>;
};

/** The type of action the conditional logic will perform. */
export enum ConditionalLogicActionTypeEnum {
  /** Text button (default). */
  Hide = 'HIDE',
  /** Image button. */
  Show = 'SHOW'
}

/** Determines how to the rules should be evaluated. */
export enum ConditionalLogicLogicTypeEnum {
  /** Evaulate all logic rules. */
  All = 'ALL',
  /** Evaluate any logic rule. */
  Any = 'ANY'
}

/** Gravity Forms conditional logic rule. */
export type ConditionalLogicRule = {
  __typename?: 'ConditionalLogicRule';
  /** Target field Id. Field that will have it’s value compared with the value property to determine if this rule is a match. */
  fieldId?: Maybe<Scalars['Float']['output']>;
  /** Operator to be used when evaluating this rule. */
  operator?: Maybe<FormRuleOperatorEnum>;
  /** The value to compare with field specified by fieldId. */
  value?: Maybe<Scalars['String']['output']>;
};

/** GraphQL representation of WordPress Conditional Tags. */
export type ConditionalTags = {
  __typename?: 'ConditionalTags';
  /**
   * Determines whether the query is for an existing archive page.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isArchive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for an existing attachment page.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isAttachment?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for an existing author archive page.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isAuthor?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for an existing category archive page.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isCategory?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for an existing date archive.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isDate?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for an existing day archive.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isDay?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for the front page of the site.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isFrontPage?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for the blog homepage.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isHome?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for an existing month archive.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isMonth?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether this site has more than one author.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isMultiAuthor?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for an existing single page.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isPage?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether currently in a page template.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isPageTemplate?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for an existing post type archive page.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isPostTypeArchive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for a post or page preview.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for the Privacy Policy page.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isPrivacyPolicy?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for a search.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isSearch?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for an existing single post.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isSingle?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for an existing single post of any post type (post, attachment, page, custom post types).
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isSingular?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether a post is sticky.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isSticky?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for an existing tag archive page.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isTag?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for an existing custom taxonomy archive page.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isTax?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Determines whether the query is for an existing year archive.
   * @deprecated Deprecated in favor of using Next.js pages
   */
  isYear?: Maybe<Scalars['Boolean']['output']>;
};

/** A paginated relationship between objects. Supports cursor-based pagination with edges containing relationship metadata and nodes containing the related objects. */
export type Connection = {
  /** A list of edges (relational context) between connected nodes */
  edges: Array<Edge>;
  /** A list of connected nodes */
  nodes: Array<Node>;
  /** Information about pagination in a connection. */
  pageInfo: PageInfo;
};

/** A Gravity Forms consent field. */
export type ConsentField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithCheckboxLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithRulesSetting & Node & {
  __typename?: 'ConsentField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Text of the consent checkbox. */
  checkboxLabel?: Maybe<Scalars['String']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** Consent field value. This is `true` when consent is given, `false` when it is not. */
  consentValue?: Maybe<Scalars['Boolean']['output']>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** Base interface for content objects like posts, pages, and media items. Provides common fields available across these content types. */
export type ContentNode = {
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String']['output'];
  /** The ID of the node in the database. */
  databaseId: Scalars['Int']['output'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']['output']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']['output']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']['output']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']['output']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']['output']>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']['output']>;
  /** The Yoast SEO data of the ContentNode */
  seo?: Maybe<PostTypeSeo>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']['output']>;
  /** The template assigned to a node of content */
  template?: Maybe<ContentTemplate>;
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
};


/** Base interface for content objects like posts, pages, and media items. Provides common fields available across these content types. */
export type ContentNodeEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Base interface for content objects like posts, pages, and media items. Provides common fields available across these content types. */
export type ContentNodeEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated collection of ContentNode Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of ContentNode Nodes */
export type ContentNodeConnection = {
  /** A list of edges (relational context) between ContentType and connected ContentNode Nodes */
  edges: Array<ContentNodeConnectionEdge>;
  /** A list of connected ContentNode Nodes */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: ContentNodeConnectionPageInfo;
};

/** Represents a connection to a ContentNode. Contains both the ContentNode Node and metadata about the relationship. */
export type ContentNodeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected ContentNode Node */
  node: ContentNode;
};

/** Pagination metadata specific to &quot;ContentNodeConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;ContentNodeConnectionEdge&quot; Nodes. */
export type ContentNodeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Identifier types for retrieving specific content. Determines which property (global ID, database ID, URI) is used to locate content objects. */
export enum ContentNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Connection between the ContentNode type and the ContentType type */
export type ContentNodeToContentTypeConnectionEdge = ContentTypeConnectionEdge & Edge & OneToOneConnection & {
  __typename?: 'ContentNodeToContentTypeConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: ContentType;
};

/** Connection between the ContentNode type and the User type */
export type ContentNodeToEditLastConnectionEdge = Edge & OneToOneConnection & UserConnectionEdge & {
  __typename?: 'ContentNodeToEditLastConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: User;
};

/** Connection between the ContentNode type and the User type */
export type ContentNodeToEditLockConnectionEdge = Edge & OneToOneConnection & UserConnectionEdge & {
  __typename?: 'ContentNodeToEditLockConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The timestamp for when the node was last edited */
  lockTimestamp?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: User;
};

/** Connection between the ContentNode type and the EnqueuedScript type */
export type ContentNodeToEnqueuedScriptConnection = Connection & EnqueuedScriptConnection & {
  __typename?: 'ContentNodeToEnqueuedScriptConnection';
  /** Edges for the ContentNodeToEnqueuedScriptConnection connection */
  edges: Array<ContentNodeToEnqueuedScriptConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedScript>;
  /** Information about pagination in a connection. */
  pageInfo: ContentNodeToEnqueuedScriptConnectionPageInfo;
};

/** An edge in a connection */
export type ContentNodeToEnqueuedScriptConnectionEdge = Edge & EnqueuedScriptConnectionEdge & {
  __typename?: 'ContentNodeToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: EnqueuedScript;
};

/** Pagination metadata specific to &quot;ContentNodeToEnqueuedScriptConnection&quot; collections. Provides cursors and flags for navigating through sets of ContentNodeToEnqueuedScriptConnection Nodes. */
export type ContentNodeToEnqueuedScriptConnectionPageInfo = EnqueuedScriptConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'ContentNodeToEnqueuedScriptConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Connection between the ContentNode type and the EnqueuedStylesheet type */
export type ContentNodeToEnqueuedStylesheetConnection = Connection & EnqueuedStylesheetConnection & {
  __typename?: 'ContentNodeToEnqueuedStylesheetConnection';
  /** Edges for the ContentNodeToEnqueuedStylesheetConnection connection */
  edges: Array<ContentNodeToEnqueuedStylesheetConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  pageInfo: ContentNodeToEnqueuedStylesheetConnectionPageInfo;
};

/** An edge in a connection */
export type ContentNodeToEnqueuedStylesheetConnectionEdge = Edge & EnqueuedStylesheetConnectionEdge & {
  __typename?: 'ContentNodeToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: EnqueuedStylesheet;
};

/** Pagination metadata specific to &quot;ContentNodeToEnqueuedStylesheetConnection&quot; collections. Provides cursors and flags for navigating through sets of ContentNodeToEnqueuedStylesheetConnection Nodes. */
export type ContentNodeToEnqueuedStylesheetConnectionPageInfo = EnqueuedStylesheetConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'ContentNodeToEnqueuedStylesheetConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** A layout pattern that can help inform how content might be structured and displayed. Templates can define specialized layouts for different types of content. */
export type ContentTemplate = {
  /** The name of the template */
  templateName?: Maybe<Scalars['String']['output']>;
};

/** An Post Type object */
export type ContentType = Node & UniformResourceIdentifiable & {
  __typename?: 'ContentType';
  /** Whether this content type should can be exported. */
  canExport?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** Connection between the ContentType type and the Taxonomy type */
  connectedTaxonomies?: Maybe<ContentTypeToTaxonomyConnection>;
  /** Connection between the ContentType type and the ContentNode type */
  contentNodes?: Maybe<ContentTypeToContentNodeConnection>;
  /** Whether content of this type should be deleted when the author of it is deleted from the system. */
  deleteWithUser?: Maybe<Scalars['Boolean']['output']>;
  /** Description of the content type. */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether to exclude nodes of this content type from front end search results. */
  excludeFromSearch?: Maybe<Scalars['Boolean']['output']>;
  /** The plural name of the content type within the GraphQL Schema. */
  graphqlPluralName?: Maybe<Scalars['String']['output']>;
  /** The singular name of the content type within the GraphQL Schema. */
  graphqlSingleName?: Maybe<Scalars['String']['output']>;
  /** Whether this content type should have archives. Content archives are generated by type and by date. */
  hasArchive?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the content type is hierarchical, for example pages. */
  hierarchical?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique identifier of the post-type object. */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether this page is set to the static front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether this page is set to the blog posts page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  /** Display name of the content type. */
  label?: Maybe<Scalars['String']['output']>;
  /** Details about the content type labels. */
  labels?: Maybe<PostTypeLabelDetails>;
  /** The name of the icon file to display as a menu icon. */
  menuIcon?: Maybe<Scalars['String']['output']>;
  /** The position of this post type in the menu. Only applies if show_in_menu is true. */
  menuPosition?: Maybe<Scalars['Int']['output']>;
  /** The internal name of the post type. This should not be used for display purposes. */
  name?: Maybe<Scalars['String']['output']>;
  /** Whether a content type is intended for use publicly either via the admin interface or by front-end users. While the default settings of exclude_from_search, publicly_queryable, show_ui, and show_in_nav_menus are inherited from public, each does not rely on this relationship and controls a very specific intention. */
  public?: Maybe<Scalars['Boolean']['output']>;
  /** Whether queries can be performed on the front end for the content type as part of parse_request(). */
  publiclyQueryable?: Maybe<Scalars['Boolean']['output']>;
  /** Name of content type to display in REST API &quot;wp/v2&quot; namespace. */
  restBase?: Maybe<Scalars['String']['output']>;
  /** The REST Controller class assigned to handling this content type. */
  restControllerClass?: Maybe<Scalars['String']['output']>;
  /** Makes this content type available via the admin bar. */
  showInAdminBar?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to add the content type to the GraphQL Schema. */
  showInGraphql?: Maybe<Scalars['Boolean']['output']>;
  /** Where to show the content type in the admin menu. To work, $show_ui must be true. If true, the post type is shown in its own top level menu. If false, no menu is shown. If a string of an existing top level menu (eg. &quot;tools.php&quot; or &quot;edit.php?post_type=page&quot;), the post type will be placed as a sub-menu of that. */
  showInMenu?: Maybe<Scalars['Boolean']['output']>;
  /** Makes this content type available for selection in navigation menus. */
  showInNavMenus?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the content type is associated with a route under the the REST API &quot;wp/v2&quot; namespace. */
  showInRest?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to generate and allow a UI for managing this content type in the admin. */
  showUi?: Maybe<Scalars['Boolean']['output']>;
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
};


/** An Post Type object */
export type ContentTypeConnectedTaxonomiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Post Type object */
export type ContentTypeContentNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentTypeToContentNodeConnectionWhereArgs>;
};

/** A paginated collection of ContentType Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of ContentType Nodes */
export type ContentTypeConnection = {
  /** A list of edges (relational context) between RootQuery and connected ContentType Nodes */
  edges: Array<ContentTypeConnectionEdge>;
  /** A list of connected ContentType Nodes */
  nodes: Array<ContentType>;
  /** Information about pagination in a connection. */
  pageInfo: ContentTypeConnectionPageInfo;
};

/** Represents a connection to a ContentType. Contains both the ContentType Node and metadata about the relationship. */
export type ContentTypeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected ContentType Node */
  node: ContentType;
};

/** Pagination metadata specific to &quot;ContentTypeConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;ContentTypeConnectionEdge&quot; Nodes. */
export type ContentTypeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Available content entity types that can be queried or filtered. Identifies the primary content structures available in the system. */
export enum ContentTypeEnum {
  /** The Type of Content object */
  Attachment = 'ATTACHMENT',
  /** The Type of Content object */
  Page = 'PAGE',
  /** The Type of Content object */
  Post = 'POST'
}

/** Identifier types for retrieving a specific content type definition. Determines whether to look up content types by ID or name. */
export enum ContentTypeIdTypeEnum {
  /** The globally unique ID */
  Id = 'ID',
  /** The name of the content type. */
  Name = 'NAME'
}

/** Connection between the ContentType type and the ContentNode type */
export type ContentTypeToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'ContentTypeToContentNodeConnection';
  /** Edges for the ContentTypeToContentNodeConnection connection */
  edges: Array<ContentTypeToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: ContentTypeToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type ContentTypeToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'ContentTypeToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Pagination metadata specific to &quot;ContentTypeToContentNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of ContentTypeToContentNodeConnection Nodes. */
export type ContentTypeToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'ContentTypeToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the ContentTypeToContentNodeConnection connection */
export type ContentTypeToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the ContentType type and the Taxonomy type */
export type ContentTypeToTaxonomyConnection = Connection & TaxonomyConnection & {
  __typename?: 'ContentTypeToTaxonomyConnection';
  /** Edges for the ContentTypeToTaxonomyConnection connection */
  edges: Array<ContentTypeToTaxonomyConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Taxonomy>;
  /** Information about pagination in a connection. */
  pageInfo: ContentTypeToTaxonomyConnectionPageInfo;
};

/** An edge in a connection */
export type ContentTypeToTaxonomyConnectionEdge = Edge & TaxonomyConnectionEdge & {
  __typename?: 'ContentTypeToTaxonomyConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Taxonomy;
};

/** Pagination metadata specific to &quot;ContentTypeToTaxonomyConnection&quot; collections. Provides cursors and flags for navigating through sets of ContentTypeToTaxonomyConnection Nodes. */
export type ContentTypeToTaxonomyConnectionPageInfo = PageInfo & TaxonomyConnectionPageInfo & WpPageInfo & {
  __typename?: 'ContentTypeToTaxonomyConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Allowed Content Types of the Category taxonomy. */
export enum ContentTypesOfCategoryEnum {
  /** The Type of Content object */
  Post = 'POST'
}

/** Allowed Content Types of the PostFormat taxonomy. */
export enum ContentTypesOfPostFormatEnum {
  /** The Type of Content object */
  Post = 'POST'
}

/** Allowed Content Types of the Tag taxonomy. */
export enum ContentTypesOfTagEnum {
  /** The Type of Content object */
  Post = 'POST'
}

/** A block used for editing the site */
export type CoreArchives = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreArchives';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreArchives Block Type */
  attributes?: Maybe<CoreArchivesAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreArchives Block Type */
export type CoreArchivesAttributes = {
  __typename?: 'CoreArchivesAttributes';
  /** The &quot;align&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;displayAsDropdown&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  displayAsDropdown: Scalars['Boolean']['output'];
  /** The &quot;fontFamily&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;showLabel&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  showLabel: Scalars['Boolean']['output'];
  /** The &quot;showPostCounts&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  showPostCounts: Scalars['Boolean']['output'];
  /** The &quot;style&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;type&quot; field on the &quot;CoreArchivesAttributes&quot; block or block attributes */
  type: Scalars['String']['output'];
};

/** A block used for editing the site */
export type CoreAudio = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreAudio';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreAudio Block Type */
  attributes?: Maybe<CoreAudioAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreAudio Block Type */
export type CoreAudioAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreAudioAttributes';
  /** The &quot;align&quot; field on the &quot;CoreAudioAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;autoplay&quot; field on the &quot;CoreAudioAttributes&quot; block or block attributes */
  autoplay?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;blob&quot; field on the &quot;CoreAudioAttributes&quot; block or block attributes */
  blob?: Maybe<Scalars['String']['output']>;
  /** The &quot;caption&quot; field on the &quot;CoreAudioAttributes&quot; block or block attributes */
  caption?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreAudioAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;id&quot; field on the &quot;CoreAudioAttributes&quot; block or block attributes */
  id?: Maybe<Scalars['Float']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreAudioAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;loop&quot; field on the &quot;CoreAudioAttributes&quot; block or block attributes */
  loop?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreAudioAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;preload&quot; field on the &quot;CoreAudioAttributes&quot; block or block attributes */
  preload?: Maybe<Scalars['String']['output']>;
  /** The &quot;src&quot; field on the &quot;CoreAudioAttributes&quot; block or block attributes */
  src?: Maybe<Scalars['String']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreAudioAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreAvatar = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreAvatar';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreAvatar Block Type */
  attributes?: Maybe<CoreAvatarAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreAvatar Block Type */
export type CoreAvatarAttributes = {
  __typename?: 'CoreAvatarAttributes';
  /** The &quot;align&quot; field on the &quot;CoreAvatarAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreAvatarAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreAvatarAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;isLink&quot; field on the &quot;CoreAvatarAttributes&quot; block or block attributes */
  isLink: Scalars['Boolean']['output'];
  /** The &quot;linkTarget&quot; field on the &quot;CoreAvatarAttributes&quot; block or block attributes */
  linkTarget: Scalars['String']['output'];
  /** The &quot;lock&quot; field on the &quot;CoreAvatarAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreAvatarAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;size&quot; field on the &quot;CoreAvatarAttributes&quot; block or block attributes */
  size: Scalars['Float']['output'];
  /** The &quot;style&quot; field on the &quot;CoreAvatarAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;userId&quot; field on the &quot;CoreAvatarAttributes&quot; block or block attributes */
  userId?: Maybe<Scalars['Float']['output']>;
};

/** A block used for editing the site */
export type CoreBlock = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreBlock';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreBlock Block Type */
  attributes?: Maybe<CoreBlockAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreBlock Block Type */
export type CoreBlockAttributes = {
  __typename?: 'CoreBlockAttributes';
  /** The &quot;content&quot; field on the &quot;CoreBlockAttributes&quot; block or block attributes */
  content: Scalars['BlockAttributesObject']['output'];
  /** The &quot;lock&quot; field on the &quot;CoreBlockAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreBlockAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;ref&quot; field on the &quot;CoreBlockAttributes&quot; block or block attributes */
  ref?: Maybe<Scalars['Float']['output']>;
};

/** A block used for editing the site */
export type CoreButton = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreButton';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreButton Block Type */
  attributes?: Maybe<CoreButtonAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreButton Block Type */
export type CoreButtonAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreButtonAttributes';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;cssClassName&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  cssClassName?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;linkClassName&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  linkClassName?: Maybe<Scalars['String']['output']>;
  /** The &quot;linkTarget&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  linkTarget?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;placeholder&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The &quot;rel&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  rel?: Maybe<Scalars['String']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;tagName&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  tagName: Scalars['String']['output'];
  /** The &quot;text&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  text?: Maybe<Scalars['String']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;title&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  title?: Maybe<Scalars['String']['output']>;
  /** The &quot;type&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  type: Scalars['String']['output'];
  /** The &quot;url&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  url?: Maybe<Scalars['String']['output']>;
  /** The &quot;width&quot; field on the &quot;CoreButtonAttributes&quot; block or block attributes */
  width?: Maybe<Scalars['Float']['output']>;
};

/** A block used for editing the site */
export type CoreButtons = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreButtons';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreButtons Block Type */
  attributes?: Maybe<CoreButtonsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreButtons Block Type */
export type CoreButtonsAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreButtonsAttributes';
  /** The &quot;align&quot; field on the &quot;CoreButtonsAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreButtonsAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreButtonsAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreButtonsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;cssClassName&quot; field on the &quot;CoreButtonsAttributes&quot; block or block attributes */
  cssClassName?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreButtonsAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreButtonsAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreButtonsAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;layout&quot; field on the &quot;CoreButtonsAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreButtonsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreButtonsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreButtonsAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreCalendar = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCalendar';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCalendar Block Type */
  attributes?: Maybe<CoreCalendarAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCalendar Block Type */
export type CoreCalendarAttributes = {
  __typename?: 'CoreCalendarAttributes';
  /** The &quot;align&quot; field on the &quot;CoreCalendarAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreCalendarAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCalendarAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCalendarAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCalendarAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreCalendarAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCalendarAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;month&quot; field on the &quot;CoreCalendarAttributes&quot; block or block attributes */
  month?: Maybe<Scalars['Int']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreCalendarAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreCalendarAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;year&quot; field on the &quot;CoreCalendarAttributes&quot; block or block attributes */
  year?: Maybe<Scalars['Int']['output']>;
};

/** A block used for editing the site */
export type CoreCategories = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCategories';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCategories Block Type */
  attributes?: Maybe<CoreCategoriesAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCategories Block Type */
export type CoreCategoriesAttributes = {
  __typename?: 'CoreCategoriesAttributes';
  /** The &quot;align&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;displayAsDropdown&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  displayAsDropdown: Scalars['Boolean']['output'];
  /** The &quot;fontFamily&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;label&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  label?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;showEmpty&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  showEmpty: Scalars['Boolean']['output'];
  /** The &quot;showHierarchy&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  showHierarchy: Scalars['Boolean']['output'];
  /** The &quot;showLabel&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  showLabel: Scalars['Boolean']['output'];
  /** The &quot;showOnlyTopLevel&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  showOnlyTopLevel: Scalars['Boolean']['output'];
  /** The &quot;showPostCounts&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  showPostCounts: Scalars['Boolean']['output'];
  /** The &quot;style&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;taxonomy&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  taxonomy: Scalars['String']['output'];
  /** The &quot;textColor&quot; field on the &quot;CoreCategoriesAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreCode = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCode';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCode Block Type */
  attributes?: Maybe<CoreCodeAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCode Block Type */
export type CoreCodeAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreCodeAttributes';
  /** The &quot;align&quot; field on the &quot;CoreCodeAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreCodeAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreCodeAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCodeAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;content&quot; field on the &quot;CoreCodeAttributes&quot; block or block attributes */
  content?: Maybe<Scalars['String']['output']>;
  /** The &quot;cssClassName&quot; field on the &quot;CoreCodeAttributes&quot; block or block attributes */
  cssClassName?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCodeAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCodeAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreCodeAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreCodeAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCodeAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreCodeAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreCodeAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreColumn = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreColumn';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreColumn Block Type */
  attributes?: Maybe<CoreColumnAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreColumn Block Type */
export type CoreColumnAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreColumnAttributes';
  /** The &quot;allowedBlocks&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  allowedBlocks?: Maybe<Scalars['BlockAttributesArray']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;cssClassName&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  cssClassName?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;layout&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;verticalAlignment&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  verticalAlignment?: Maybe<Scalars['String']['output']>;
  /** The &quot;width&quot; field on the &quot;CoreColumnAttributes&quot; block or block attributes */
  width?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreColumns = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreColumns';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreColumns Block Type */
  attributes?: Maybe<CoreColumnsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreColumns Block Type */
export type CoreColumnsAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreColumnsAttributes';
  /** The &quot;align&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;cssClassName&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  cssClassName?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;isStackedOnMobile&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  isStackedOnMobile: Scalars['Boolean']['output'];
  /** The &quot;layout&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;verticalAlignment&quot; field on the &quot;CoreColumnsAttributes&quot; block or block attributes */
  verticalAlignment?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreCommentAuthorName = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCommentAuthorName';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCommentAuthorName Block Type */
  attributes?: Maybe<CoreCommentAuthorNameAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCommentAuthorName Block Type */
export type CoreCommentAuthorNameAttributes = {
  __typename?: 'CoreCommentAuthorNameAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CoreCommentAuthorNameAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreCommentAuthorNameAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCommentAuthorNameAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCommentAuthorNameAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCommentAuthorNameAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreCommentAuthorNameAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;isLink&quot; field on the &quot;CoreCommentAuthorNameAttributes&quot; block or block attributes */
  isLink: Scalars['Boolean']['output'];
  /** The &quot;linkTarget&quot; field on the &quot;CoreCommentAuthorNameAttributes&quot; block or block attributes */
  linkTarget: Scalars['String']['output'];
  /** The &quot;lock&quot; field on the &quot;CoreCommentAuthorNameAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCommentAuthorNameAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreCommentAuthorNameAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CoreCommentAuthorNameAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreCommentAuthorNameAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreCommentContent = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCommentContent';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCommentContent Block Type */
  attributes?: Maybe<CoreCommentContentAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCommentContent Block Type */
export type CoreCommentContentAttributes = {
  __typename?: 'CoreCommentContentAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CoreCommentContentAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreCommentContentAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCommentContentAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCommentContentAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCommentContentAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreCommentContentAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreCommentContentAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCommentContentAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreCommentContentAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CoreCommentContentAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreCommentContentAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreCommentDate = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCommentDate';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCommentDate Block Type */
  attributes?: Maybe<CoreCommentDateAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCommentDate Block Type */
export type CoreCommentDateAttributes = {
  __typename?: 'CoreCommentDateAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CoreCommentDateAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreCommentDateAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCommentDateAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCommentDateAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCommentDateAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;format&quot; field on the &quot;CoreCommentDateAttributes&quot; block or block attributes */
  format?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreCommentDateAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;isLink&quot; field on the &quot;CoreCommentDateAttributes&quot; block or block attributes */
  isLink: Scalars['Boolean']['output'];
  /** The &quot;lock&quot; field on the &quot;CoreCommentDateAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCommentDateAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreCommentDateAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreCommentDateAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreCommentEditLink = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCommentEditLink';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCommentEditLink Block Type */
  attributes?: Maybe<CoreCommentEditLinkAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCommentEditLink Block Type */
export type CoreCommentEditLinkAttributes = {
  __typename?: 'CoreCommentEditLinkAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CoreCommentEditLinkAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreCommentEditLinkAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCommentEditLinkAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCommentEditLinkAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCommentEditLinkAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreCommentEditLinkAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;linkTarget&quot; field on the &quot;CoreCommentEditLinkAttributes&quot; block or block attributes */
  linkTarget: Scalars['String']['output'];
  /** The &quot;lock&quot; field on the &quot;CoreCommentEditLinkAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCommentEditLinkAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreCommentEditLinkAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CoreCommentEditLinkAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreCommentReplyLink = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCommentReplyLink';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCommentReplyLink Block Type */
  attributes?: Maybe<CoreCommentReplyLinkAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCommentReplyLink Block Type */
export type CoreCommentReplyLinkAttributes = {
  __typename?: 'CoreCommentReplyLinkAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CoreCommentReplyLinkAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreCommentReplyLinkAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCommentReplyLinkAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCommentReplyLinkAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCommentReplyLinkAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreCommentReplyLinkAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreCommentReplyLinkAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCommentReplyLinkAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreCommentReplyLinkAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CoreCommentReplyLinkAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreCommentTemplate = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCommentTemplate';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCommentTemplate Block Type */
  attributes?: Maybe<CoreCommentTemplateAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCommentTemplate Block Type */
export type CoreCommentTemplateAttributes = {
  __typename?: 'CoreCommentTemplateAttributes';
  /** The &quot;align&quot; field on the &quot;CoreCommentTemplateAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreCommentTemplateAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCommentTemplateAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCommentTemplateAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCommentTemplateAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreCommentTemplateAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCommentTemplateAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreCommentTemplateAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreComments = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreComments';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreComments Block Type */
  attributes?: Maybe<CoreCommentsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreComments Block Type */
export type CoreCommentsAttributes = {
  __typename?: 'CoreCommentsAttributes';
  /** The &quot;align&quot; field on the &quot;CoreCommentsAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreCommentsAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreCommentsAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCommentsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCommentsAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCommentsAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreCommentsAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;legacy&quot; field on the &quot;CoreCommentsAttributes&quot; block or block attributes */
  legacy: Scalars['Boolean']['output'];
  /** The &quot;lock&quot; field on the &quot;CoreCommentsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCommentsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreCommentsAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;tagName&quot; field on the &quot;CoreCommentsAttributes&quot; block or block attributes */
  tagName: Scalars['String']['output'];
  /** The &quot;textColor&quot; field on the &quot;CoreCommentsAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreCommentsPagination = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCommentsPagination';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCommentsPagination Block Type */
  attributes?: Maybe<CoreCommentsPaginationAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCommentsPagination Block Type */
export type CoreCommentsPaginationAttributes = {
  __typename?: 'CoreCommentsPaginationAttributes';
  /** The &quot;align&quot; field on the &quot;CoreCommentsPaginationAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreCommentsPaginationAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCommentsPaginationAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCommentsPaginationAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCommentsPaginationAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreCommentsPaginationAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;layout&quot; field on the &quot;CoreCommentsPaginationAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreCommentsPaginationAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCommentsPaginationAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;paginationArrow&quot; field on the &quot;CoreCommentsPaginationAttributes&quot; block or block attributes */
  paginationArrow: Scalars['String']['output'];
  /** The &quot;style&quot; field on the &quot;CoreCommentsPaginationAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreCommentsPaginationAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreCommentsPaginationNext = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCommentsPaginationNext';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCommentsPaginationNext Block Type */
  attributes?: Maybe<CoreCommentsPaginationNextAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCommentsPaginationNext Block Type */
export type CoreCommentsPaginationNextAttributes = {
  __typename?: 'CoreCommentsPaginationNextAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CoreCommentsPaginationNextAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCommentsPaginationNextAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCommentsPaginationNextAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCommentsPaginationNextAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreCommentsPaginationNextAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;label&quot; field on the &quot;CoreCommentsPaginationNextAttributes&quot; block or block attributes */
  label?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreCommentsPaginationNextAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCommentsPaginationNextAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreCommentsPaginationNextAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreCommentsPaginationNumbers = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCommentsPaginationNumbers';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCommentsPaginationNumbers Block Type */
  attributes?: Maybe<CoreCommentsPaginationNumbersAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCommentsPaginationNumbers Block Type */
export type CoreCommentsPaginationNumbersAttributes = {
  __typename?: 'CoreCommentsPaginationNumbersAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CoreCommentsPaginationNumbersAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCommentsPaginationNumbersAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCommentsPaginationNumbersAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCommentsPaginationNumbersAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreCommentsPaginationNumbersAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreCommentsPaginationNumbersAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCommentsPaginationNumbersAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreCommentsPaginationNumbersAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreCommentsPaginationPrevious = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCommentsPaginationPrevious';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCommentsPaginationPrevious Block Type */
  attributes?: Maybe<CoreCommentsPaginationPreviousAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCommentsPaginationPrevious Block Type */
export type CoreCommentsPaginationPreviousAttributes = {
  __typename?: 'CoreCommentsPaginationPreviousAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CoreCommentsPaginationPreviousAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCommentsPaginationPreviousAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCommentsPaginationPreviousAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCommentsPaginationPreviousAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreCommentsPaginationPreviousAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;label&quot; field on the &quot;CoreCommentsPaginationPreviousAttributes&quot; block or block attributes */
  label?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreCommentsPaginationPreviousAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCommentsPaginationPreviousAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreCommentsPaginationPreviousAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreCommentsTitle = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCommentsTitle';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCommentsTitle Block Type */
  attributes?: Maybe<CoreCommentsTitleAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCommentsTitle Block Type */
export type CoreCommentsTitleAttributes = {
  __typename?: 'CoreCommentsTitleAttributes';
  /** The &quot;align&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;level&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  level: Scalars['Float']['output'];
  /** The &quot;levelOptions&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  levelOptions?: Maybe<Scalars['BlockAttributesArray']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;showCommentsCount&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  showCommentsCount: Scalars['Boolean']['output'];
  /** The &quot;showPostTitle&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  showPostTitle: Scalars['Boolean']['output'];
  /** The &quot;style&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreCommentsTitleAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreCover = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreCover';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreCover Block Type */
  attributes?: Maybe<CoreCoverAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreCover Block Type */
export type CoreCoverAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreCoverAttributes';
  /** The &quot;align&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;allowedBlocks&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  allowedBlocks?: Maybe<Scalars['BlockAttributesArray']['output']>;
  /** The &quot;alt&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  alt: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundType&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  backgroundType: Scalars['String']['output'];
  /** The &quot;borderColor&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;contentPosition&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  contentPosition?: Maybe<Scalars['String']['output']>;
  /** The &quot;customGradient&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  customGradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;customOverlayColor&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  customOverlayColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;dimRatio&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  dimRatio: Scalars['Float']['output'];
  /** The &quot;focalPoint&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  focalPoint?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;hasParallax&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  hasParallax: Scalars['Boolean']['output'];
  /** The &quot;id&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  id?: Maybe<Scalars['Float']['output']>;
  /** The &quot;isDark&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  isDark: Scalars['Boolean']['output'];
  /** The &quot;isRepeated&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  isRepeated: Scalars['Boolean']['output'];
  /** The &quot;isUserOverlayColor&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  isUserOverlayColor?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;layout&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;minHeight&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  minHeight?: Maybe<Scalars['Float']['output']>;
  /** The &quot;minHeightUnit&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  minHeightUnit?: Maybe<Scalars['String']['output']>;
  /** The &quot;overlayColor&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  overlayColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;sizeSlug&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  sizeSlug?: Maybe<Scalars['String']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;tagName&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  tagName: Scalars['String']['output'];
  /** The &quot;textColor&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;url&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  url?: Maybe<Scalars['String']['output']>;
  /** The &quot;useFeaturedImage&quot; field on the &quot;CoreCoverAttributes&quot; block or block attributes */
  useFeaturedImage: Scalars['Boolean']['output'];
};

/** A block used for editing the site */
export type CoreDetails = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreDetails';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreDetails Block Type */
  attributes?: Maybe<CoreDetailsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreDetails Block Type */
export type CoreDetailsAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreDetailsAttributes';
  /** The &quot;align&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;allowedBlocks&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  allowedBlocks?: Maybe<Scalars['BlockAttributesArray']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;layout&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;name&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  name?: Maybe<Scalars['String']['output']>;
  /** The &quot;placeholder&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The &quot;showContent&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  showContent: Scalars['Boolean']['output'];
  /** The &quot;style&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;summary&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  summary?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreDetailsAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreEmbed = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreEmbed';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreEmbed Block Type */
  attributes?: Maybe<CoreEmbedAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreEmbed Block Type */
export type CoreEmbedAttributes = {
  __typename?: 'CoreEmbedAttributes';
  /** The &quot;align&quot; field on the &quot;CoreEmbedAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;allowResponsive&quot; field on the &quot;CoreEmbedAttributes&quot; block or block attributes */
  allowResponsive: Scalars['Boolean']['output'];
  /** The &quot;caption&quot; field on the &quot;CoreEmbedAttributes&quot; block or block attributes */
  caption?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreEmbedAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreEmbedAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreEmbedAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;previewable&quot; field on the &quot;CoreEmbedAttributes&quot; block or block attributes */
  previewable: Scalars['Boolean']['output'];
  /** The &quot;providerNameSlug&quot; field on the &quot;CoreEmbedAttributes&quot; block or block attributes */
  providerNameSlug?: Maybe<Scalars['String']['output']>;
  /** The &quot;responsive&quot; field on the &quot;CoreEmbedAttributes&quot; block or block attributes */
  responsive: Scalars['Boolean']['output'];
  /** The &quot;style&quot; field on the &quot;CoreEmbedAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;type&quot; field on the &quot;CoreEmbedAttributes&quot; block or block attributes */
  type?: Maybe<Scalars['String']['output']>;
  /** The &quot;url&quot; field on the &quot;CoreEmbedAttributes&quot; block or block attributes */
  url?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreFile = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreFile';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreFile Block Type */
  attributes?: Maybe<CoreFileAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreFile Block Type */
export type CoreFileAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreFileAttributes';
  /** The &quot;align&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;blob&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  blob?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;displayPreview&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  displayPreview?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;downloadButtonText&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  downloadButtonText?: Maybe<Scalars['String']['output']>;
  /** The &quot;fileId&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  fileId?: Maybe<Scalars['String']['output']>;
  /** The &quot;fileName&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  fileName?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;href&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  href?: Maybe<Scalars['String']['output']>;
  /** The &quot;id&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  id?: Maybe<Scalars['Float']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;previewHeight&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  previewHeight: Scalars['Float']['output'];
  /** The &quot;showDownloadButton&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  showDownloadButton: Scalars['Boolean']['output'];
  /** The &quot;style&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textLinkHref&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  textLinkHref?: Maybe<Scalars['String']['output']>;
  /** The &quot;textLinkTarget&quot; field on the &quot;CoreFileAttributes&quot; block or block attributes */
  textLinkTarget?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreFootnotes = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreFootnotes';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreFootnotes Block Type */
  attributes?: Maybe<CoreFootnotesAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreFootnotes Block Type */
export type CoreFootnotesAttributes = {
  __typename?: 'CoreFootnotesAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CoreFootnotesAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreFootnotesAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreFootnotesAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreFootnotesAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreFootnotesAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreFootnotesAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreFootnotesAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreFootnotesAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreFootnotesAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreFreeform = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreFreeform';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreFreeform Block Type */
  attributes?: Maybe<CoreFreeformAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreFreeform Block Type */
export type CoreFreeformAttributes = {
  __typename?: 'CoreFreeformAttributes';
  /** The &quot;content&quot; field on the &quot;CoreFreeformAttributes&quot; block or block attributes */
  content?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreFreeformAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreFreeformAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreGallery = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreGallery';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreGallery Block Type */
  attributes?: Maybe<CoreGalleryAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreGallery Block Type */
export type CoreGalleryAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreGalleryAttributes';
  /** The &quot;align&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;allowResize&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  allowResize: Scalars['Boolean']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;caption&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  caption?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;columns&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  columns?: Maybe<Scalars['Float']['output']>;
  /** The &quot;fixedHeight&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  fixedHeight: Scalars['Boolean']['output'];
  /** The &quot;gradient&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;ids&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  ids: Array<Maybe<Scalars['Float']['output']>>;
  /** The &quot;imageCrop&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  imageCrop: Scalars['Boolean']['output'];
  /** The &quot;images&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  images: Array<Maybe<CoreGalleryAttributesImages>>;
  /** The &quot;layout&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;linkTarget&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  linkTarget?: Maybe<Scalars['String']['output']>;
  /** The &quot;linkTo&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  linkTo?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;randomOrder&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  randomOrder: Scalars['Boolean']['output'];
  /** The &quot;shortCodeTransforms&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  shortCodeTransforms: Array<Maybe<Scalars['BlockAttributesObject']['output']>>;
  /** The &quot;sizeSlug&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  sizeSlug: Scalars['String']['output'];
  /** The &quot;style&quot; field on the &quot;CoreGalleryAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** The &quot;CoreGalleryAttributesImages&quot; field on the &quot;CoreGalleryAttributes&quot; block attribute field */
export type CoreGalleryAttributesImages = {
  __typename?: 'CoreGalleryAttributesImages';
  /** The &quot;alt&quot; field on the &quot;CoreGalleryAttributesImages&quot; block attribute field */
  alt: Scalars['String']['output'];
  /** The &quot;caption&quot; field on the &quot;CoreGalleryAttributesImages&quot; block attribute field */
  caption?: Maybe<Scalars['String']['output']>;
  /** The &quot;fullUrl&quot; field on the &quot;CoreGalleryAttributesImages&quot; block attribute field */
  fullUrl?: Maybe<Scalars['String']['output']>;
  /** The &quot;id&quot; field on the &quot;CoreGalleryAttributesImages&quot; block attribute field */
  id?: Maybe<Scalars['String']['output']>;
  /** The &quot;link&quot; field on the &quot;CoreGalleryAttributesImages&quot; block attribute field */
  link?: Maybe<Scalars['String']['output']>;
  /** The &quot;url&quot; field on the &quot;CoreGalleryAttributesImages&quot; block attribute field */
  url?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreGroup = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreGroup';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreGroup Block Type */
  attributes?: Maybe<CoreGroupAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreGroup Block Type */
export type CoreGroupAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreGroupAttributes';
  /** The &quot;align&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;allowedBlocks&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  allowedBlocks?: Maybe<Scalars['BlockAttributesArray']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;ariaLabel&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;cssClassName&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  cssClassName?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;layout&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;tagName&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  tagName: Scalars['String']['output'];
  /** The &quot;textColor&quot; field on the &quot;CoreGroupAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreHeading = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreHeading';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreHeading Block Type */
  attributes?: Maybe<CoreHeadingAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreHeading Block Type */
export type CoreHeadingAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreHeadingAttributes';
  /** The &quot;align&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;content&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  content?: Maybe<Scalars['String']['output']>;
  /** The &quot;cssClassName&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  cssClassName?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;level&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  level: Scalars['Float']['output'];
  /** The &quot;levelOptions&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  levelOptions?: Maybe<Scalars['BlockAttributesArray']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;placeholder&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreHeadingAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreHomeLink = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreHomeLink';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreHomeLink Block Type */
  attributes?: Maybe<CoreHomeLinkAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreHomeLink Block Type */
export type CoreHomeLinkAttributes = {
  __typename?: 'CoreHomeLinkAttributes';
  /** The &quot;className&quot; field on the &quot;CoreHomeLinkAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreHomeLinkAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreHomeLinkAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;label&quot; field on the &quot;CoreHomeLinkAttributes&quot; block or block attributes */
  label?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreHomeLinkAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreHomeLinkAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreHomeLinkAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreHtml = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreHtml';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreHtml Block Type */
  attributes?: Maybe<CoreHtmlAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreHtml Block Type */
export type CoreHtmlAttributes = {
  __typename?: 'CoreHtmlAttributes';
  /** The &quot;content&quot; field on the &quot;CoreHtmlAttributes&quot; block or block attributes */
  content?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreHtmlAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreHtmlAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreImage = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreImage';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreImage Block Type */
  attributes?: Maybe<CoreImageAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** Media Details of the CoreImage Block Type */
  mediaDetails?: Maybe<MediaDetails>;
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreImage Block Type */
export type CoreImageAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreImageAttributes';
  /** The &quot;align&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;alt&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  alt: Scalars['String']['output'];
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;aspectRatio&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  aspectRatio?: Maybe<Scalars['String']['output']>;
  /** The &quot;blob&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  blob?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;caption&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  caption?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;cssClassName&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  cssClassName?: Maybe<Scalars['String']['output']>;
  /** The &quot;height&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  height?: Maybe<Scalars['String']['output']>;
  /** The &quot;href&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  href?: Maybe<Scalars['String']['output']>;
  /** The &quot;id&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  id?: Maybe<Scalars['Float']['output']>;
  /** The &quot;lightbox&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  lightbox?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;linkClass&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  linkClass?: Maybe<Scalars['String']['output']>;
  /** The &quot;linkDestination&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  linkDestination?: Maybe<Scalars['String']['output']>;
  /** The &quot;linkTarget&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  linkTarget?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;rel&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  rel?: Maybe<Scalars['String']['output']>;
  /** The &quot;scale&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  scale?: Maybe<Scalars['String']['output']>;
  /** The &quot;sizeSlug&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  sizeSlug?: Maybe<Scalars['String']['output']>;
  /** The &quot;src&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  src?: Maybe<Scalars['String']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;title&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  title?: Maybe<Scalars['String']['output']>;
  /** The &quot;url&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  url?: Maybe<Scalars['String']['output']>;
  /** The &quot;width&quot; field on the &quot;CoreImageAttributes&quot; block or block attributes */
  width?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreLatestComments = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreLatestComments';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreLatestComments Block Type */
  attributes?: Maybe<CoreLatestCommentsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreLatestComments Block Type */
export type CoreLatestCommentsAttributes = {
  __typename?: 'CoreLatestCommentsAttributes';
  /** The &quot;align&quot; field on the &quot;CoreLatestCommentsAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreLatestCommentsAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreLatestCommentsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;commentsToShow&quot; field on the &quot;CoreLatestCommentsAttributes&quot; block or block attributes */
  commentsToShow: Scalars['Float']['output'];
  /** The &quot;displayAvatar&quot; field on the &quot;CoreLatestCommentsAttributes&quot; block or block attributes */
  displayAvatar: Scalars['Boolean']['output'];
  /** The &quot;displayDate&quot; field on the &quot;CoreLatestCommentsAttributes&quot; block or block attributes */
  displayDate: Scalars['Boolean']['output'];
  /** The &quot;displayExcerpt&quot; field on the &quot;CoreLatestCommentsAttributes&quot; block or block attributes */
  displayExcerpt: Scalars['Boolean']['output'];
  /** The &quot;fontFamily&quot; field on the &quot;CoreLatestCommentsAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreLatestCommentsAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreLatestCommentsAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreLatestCommentsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreLatestCommentsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreLatestCommentsAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreLatestCommentsAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreLatestPosts = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreLatestPosts';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreLatestPosts Block Type */
  attributes?: Maybe<CoreLatestPostsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreLatestPosts Block Type */
export type CoreLatestPostsAttributes = {
  __typename?: 'CoreLatestPostsAttributes';
  /** The &quot;addLinkToFeaturedImage&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  addLinkToFeaturedImage: Scalars['Boolean']['output'];
  /** The &quot;align&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;categories&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  categories?: Maybe<Array<Maybe<Scalars['BlockAttributesObject']['output']>>>;
  /** The &quot;className&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;columns&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  columns: Scalars['Float']['output'];
  /** The &quot;displayAuthor&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  displayAuthor: Scalars['Boolean']['output'];
  /** The &quot;displayFeaturedImage&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  displayFeaturedImage: Scalars['Boolean']['output'];
  /** The &quot;displayPostContent&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  displayPostContent: Scalars['Boolean']['output'];
  /** The &quot;displayPostContentRadio&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  displayPostContentRadio: Scalars['String']['output'];
  /** The &quot;displayPostDate&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  displayPostDate: Scalars['Boolean']['output'];
  /** The &quot;excerptLength&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  excerptLength: Scalars['Float']['output'];
  /** The &quot;featuredImageAlign&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  featuredImageAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;featuredImageSizeHeight&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  featuredImageSizeHeight?: Maybe<Scalars['Float']['output']>;
  /** The &quot;featuredImageSizeSlug&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  featuredImageSizeSlug: Scalars['String']['output'];
  /** The &quot;featuredImageSizeWidth&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  featuredImageSizeWidth?: Maybe<Scalars['Float']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;order&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  order: Scalars['String']['output'];
  /** The &quot;orderBy&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  orderBy: Scalars['String']['output'];
  /** The &quot;postLayout&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  postLayout: Scalars['String']['output'];
  /** The &quot;postsToShow&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  postsToShow: Scalars['Float']['output'];
  /** The &quot;selectedAuthor&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  selectedAuthor?: Maybe<Scalars['Float']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreLatestPostsAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreLegacyWidget = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreLegacyWidget';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreLegacyWidget Block Type */
  attributes?: Maybe<CoreLegacyWidgetAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreLegacyWidget Block Type */
export type CoreLegacyWidgetAttributes = {
  __typename?: 'CoreLegacyWidgetAttributes';
  /** The &quot;id&quot; field on the &quot;CoreLegacyWidgetAttributes&quot; block or block attributes */
  id?: Maybe<Scalars['String']['output']>;
  /** The &quot;idBase&quot; field on the &quot;CoreLegacyWidgetAttributes&quot; block or block attributes */
  idBase?: Maybe<Scalars['String']['output']>;
  /** The &quot;instance&quot; field on the &quot;CoreLegacyWidgetAttributes&quot; block or block attributes */
  instance?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreLegacyWidgetAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreLegacyWidgetAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreList = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreList';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreList Block Type */
  attributes?: Maybe<CoreListAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreList Block Type */
export type CoreListAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreListAttributes';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;cssClassName&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  cssClassName?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;ordered&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  ordered: Scalars['Boolean']['output'];
  /** The &quot;placeholder&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The &quot;reversed&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  reversed?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;start&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  start?: Maybe<Scalars['Float']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;type&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  type?: Maybe<Scalars['String']['output']>;
  /** The &quot;values&quot; field on the &quot;CoreListAttributes&quot; block or block attributes */
  values: Scalars['String']['output'];
};

/** A block used for editing the site */
export type CoreListItem = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreListItem';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreListItem Block Type */
  attributes?: Maybe<CoreListItemAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreListItem Block Type */
export type CoreListItemAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreListItemAttributes';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreListItemAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreListItemAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreListItemAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;content&quot; field on the &quot;CoreListItemAttributes&quot; block or block attributes */
  content?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreListItemAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreListItemAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreListItemAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreListItemAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreListItemAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;placeholder&quot; field on the &quot;CoreListItemAttributes&quot; block or block attributes */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreListItemAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreListItemAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreLoginout = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreLoginout';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreLoginout Block Type */
  attributes?: Maybe<CoreLoginoutAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreLoginout Block Type */
export type CoreLoginoutAttributes = {
  __typename?: 'CoreLoginoutAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CoreLoginoutAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreLoginoutAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreLoginoutAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;displayLoginAsForm&quot; field on the &quot;CoreLoginoutAttributes&quot; block or block attributes */
  displayLoginAsForm: Scalars['Boolean']['output'];
  /** The &quot;fontFamily&quot; field on the &quot;CoreLoginoutAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreLoginoutAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreLoginoutAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreLoginoutAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreLoginoutAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;redirectToCurrent&quot; field on the &quot;CoreLoginoutAttributes&quot; block or block attributes */
  redirectToCurrent: Scalars['Boolean']['output'];
  /** The &quot;style&quot; field on the &quot;CoreLoginoutAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreMediaText = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreMediaText';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreMediaText Block Type */
  attributes?: Maybe<CoreMediaTextAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreMediaText Block Type */
export type CoreMediaTextAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreMediaTextAttributes';
  /** The &quot;align&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  align: Scalars['String']['output'];
  /** The &quot;allowedBlocks&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  allowedBlocks?: Maybe<Scalars['BlockAttributesArray']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;focalPoint&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  focalPoint?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;href&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  href?: Maybe<Scalars['String']['output']>;
  /** The &quot;imageFill&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  imageFill?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;isStackedOnMobile&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  isStackedOnMobile: Scalars['Boolean']['output'];
  /** The &quot;linkClass&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  linkClass?: Maybe<Scalars['String']['output']>;
  /** The &quot;linkDestination&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  linkDestination?: Maybe<Scalars['String']['output']>;
  /** The &quot;linkTarget&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  linkTarget?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;mediaAlt&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  mediaAlt: Scalars['String']['output'];
  /** The &quot;mediaId&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  mediaId?: Maybe<Scalars['Float']['output']>;
  /** The &quot;mediaLink&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  mediaLink?: Maybe<Scalars['String']['output']>;
  /** The &quot;mediaPosition&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  mediaPosition: Scalars['String']['output'];
  /** The &quot;mediaSizeSlug&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  mediaSizeSlug?: Maybe<Scalars['String']['output']>;
  /** The &quot;mediaType&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  mediaType?: Maybe<Scalars['String']['output']>;
  /** The &quot;mediaUrl&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  mediaUrl?: Maybe<Scalars['String']['output']>;
  /** The &quot;mediaWidth&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  mediaWidth: Scalars['Float']['output'];
  /** The &quot;metadata&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;rel&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  rel?: Maybe<Scalars['String']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;useFeaturedImage&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  useFeaturedImage: Scalars['Boolean']['output'];
  /** The &quot;verticalAlignment&quot; field on the &quot;CoreMediaTextAttributes&quot; block or block attributes */
  verticalAlignment?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreMissing = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreMissing';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreMissing Block Type */
  attributes?: Maybe<CoreMissingAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreMissing Block Type */
export type CoreMissingAttributes = {
  __typename?: 'CoreMissingAttributes';
  /** The &quot;lock&quot; field on the &quot;CoreMissingAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreMissingAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;originalContent&quot; field on the &quot;CoreMissingAttributes&quot; block or block attributes */
  originalContent?: Maybe<Scalars['String']['output']>;
  /** The &quot;originalName&quot; field on the &quot;CoreMissingAttributes&quot; block or block attributes */
  originalName?: Maybe<Scalars['String']['output']>;
  /** The &quot;originalUndelimitedContent&quot; field on the &quot;CoreMissingAttributes&quot; block or block attributes */
  originalUndelimitedContent?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreMore = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreMore';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreMore Block Type */
  attributes?: Maybe<CoreMoreAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreMore Block Type */
export type CoreMoreAttributes = {
  __typename?: 'CoreMoreAttributes';
  /** The &quot;customText&quot; field on the &quot;CoreMoreAttributes&quot; block or block attributes */
  customText: Scalars['String']['output'];
  /** The &quot;lock&quot; field on the &quot;CoreMoreAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreMoreAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;noTeaser&quot; field on the &quot;CoreMoreAttributes&quot; block or block attributes */
  noTeaser: Scalars['Boolean']['output'];
};

/** A block used for editing the site */
export type CoreNavigation = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreNavigation';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreNavigation Block Type */
  attributes?: Maybe<CoreNavigationAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreNavigation Block Type */
export type CoreNavigationAttributes = {
  __typename?: 'CoreNavigationAttributes';
  /** The &quot;align&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;ariaLabel&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;customBackgroundColor&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  customBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;customOverlayBackgroundColor&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  customOverlayBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;customOverlayTextColor&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  customOverlayTextColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;customTextColor&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  customTextColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;hasIcon&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  hasIcon: Scalars['Boolean']['output'];
  /** The &quot;icon&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  icon: Scalars['String']['output'];
  /** The &quot;layout&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;maxNestingLevel&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  maxNestingLevel: Scalars['Float']['output'];
  /** The &quot;metadata&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;openSubmenusOnClick&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  openSubmenusOnClick: Scalars['Boolean']['output'];
  /** The &quot;overlayBackgroundColor&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  overlayBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;overlayMenu&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  overlayMenu: Scalars['String']['output'];
  /** The &quot;overlayTextColor&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  overlayTextColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;ref&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  ref?: Maybe<Scalars['Float']['output']>;
  /** The &quot;rgbBackgroundColor&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  rgbBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;rgbTextColor&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  rgbTextColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;showSubmenuIcon&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  showSubmenuIcon: Scalars['Boolean']['output'];
  /** The &quot;style&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;__unstableLocation&quot; field on the &quot;CoreNavigationAttributes&quot; block or block attributes */
  unstableLocation?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreNavigationLink = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreNavigationLink';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreNavigationLink Block Type */
  attributes?: Maybe<CoreNavigationLinkAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreNavigationLink Block Type */
export type CoreNavigationLinkAttributes = {
  __typename?: 'CoreNavigationLinkAttributes';
  /** The &quot;className&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;description&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  description?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;id&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  id?: Maybe<Scalars['Float']['output']>;
  /** The &quot;isTopLevelLink&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  isTopLevelLink?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;kind&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  kind?: Maybe<Scalars['String']['output']>;
  /** The &quot;label&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  label?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;opensInNewTab&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  opensInNewTab: Scalars['Boolean']['output'];
  /** The &quot;rel&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  rel?: Maybe<Scalars['String']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;title&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  title?: Maybe<Scalars['String']['output']>;
  /** The &quot;type&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  type?: Maybe<Scalars['String']['output']>;
  /** The &quot;url&quot; field on the &quot;CoreNavigationLinkAttributes&quot; block or block attributes */
  url?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreNavigationSubmenu = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreNavigationSubmenu';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreNavigationSubmenu Block Type */
  attributes?: Maybe<CoreNavigationSubmenuAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreNavigationSubmenu Block Type */
export type CoreNavigationSubmenuAttributes = {
  __typename?: 'CoreNavigationSubmenuAttributes';
  /** The &quot;className&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;description&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  description?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;id&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  id?: Maybe<Scalars['Float']['output']>;
  /** The &quot;isTopLevelItem&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  isTopLevelItem?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;kind&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  kind?: Maybe<Scalars['String']['output']>;
  /** The &quot;label&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  label?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;opensInNewTab&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  opensInNewTab: Scalars['Boolean']['output'];
  /** The &quot;rel&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  rel?: Maybe<Scalars['String']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;title&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  title?: Maybe<Scalars['String']['output']>;
  /** The &quot;type&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  type?: Maybe<Scalars['String']['output']>;
  /** The &quot;url&quot; field on the &quot;CoreNavigationSubmenuAttributes&quot; block or block attributes */
  url?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreNextpage = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreNextpage';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreNextpage Block Type */
  attributes?: Maybe<CoreNextpageAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreNextpage Block Type */
export type CoreNextpageAttributes = {
  __typename?: 'CoreNextpageAttributes';
  /** The &quot;lock&quot; field on the &quot;CoreNextpageAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreNextpageAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CorePageList = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePageList';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePageList Block Type */
  attributes?: Maybe<CorePageListAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePageList Block Type */
export type CorePageListAttributes = {
  __typename?: 'CorePageListAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CorePageListAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CorePageListAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePageListAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CorePageListAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePageListAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CorePageListAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;isNested&quot; field on the &quot;CorePageListAttributes&quot; block or block attributes */
  isNested: Scalars['Boolean']['output'];
  /** The &quot;lock&quot; field on the &quot;CorePageListAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePageListAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;parentPageID&quot; field on the &quot;CorePageListAttributes&quot; block or block attributes */
  parentPageID: Scalars['Int']['output'];
  /** The &quot;style&quot; field on the &quot;CorePageListAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePageListAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePageListItem = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePageListItem';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePageListItem Block Type */
  attributes?: Maybe<CorePageListItemAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePageListItem Block Type */
export type CorePageListItemAttributes = {
  __typename?: 'CorePageListItemAttributes';
  /** The &quot;className&quot; field on the &quot;CorePageListItemAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;hasChildren&quot; field on the &quot;CorePageListItemAttributes&quot; block or block attributes */
  hasChildren?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;id&quot; field on the &quot;CorePageListItemAttributes&quot; block or block attributes */
  id?: Maybe<Scalars['Float']['output']>;
  /** The &quot;label&quot; field on the &quot;CorePageListItemAttributes&quot; block or block attributes */
  label?: Maybe<Scalars['String']['output']>;
  /** The &quot;link&quot; field on the &quot;CorePageListItemAttributes&quot; block or block attributes */
  link?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CorePageListItemAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePageListItemAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;title&quot; field on the &quot;CorePageListItemAttributes&quot; block or block attributes */
  title?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreParagraph = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreParagraph';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreParagraph Block Type */
  attributes?: Maybe<CoreParagraphAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreParagraph Block Type */
export type CoreParagraphAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreParagraphAttributes';
  /** The &quot;align&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;content&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  content?: Maybe<Scalars['String']['output']>;
  /** The &quot;cssClassName&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  cssClassName?: Maybe<Scalars['String']['output']>;
  /** The &quot;direction&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  direction?: Maybe<Scalars['String']['output']>;
  /** The &quot;dropCap&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  dropCap: Scalars['Boolean']['output'];
  /** The &quot;fontFamily&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;placeholder&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreParagraphAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePattern = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePattern';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePattern Block Type */
  attributes?: Maybe<CorePatternAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePattern Block Type */
export type CorePatternAttributes = {
  __typename?: 'CorePatternAttributes';
  /** The &quot;className&quot; field on the &quot;CorePatternAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CorePatternAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePatternAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;slug&quot; field on the &quot;CorePatternAttributes&quot; block or block attributes */
  slug?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePostAuthor = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePostAuthor';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePostAuthor Block Type */
  attributes?: Maybe<CorePostAuthorAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePostAuthor Block Type */
export type CorePostAuthorAttributes = {
  __typename?: 'CorePostAuthorAttributes';
  /** The &quot;avatarSize&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  avatarSize: Scalars['Float']['output'];
  /** The &quot;backgroundColor&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;byline&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  byline?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;isLink&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  isLink: Scalars['Boolean']['output'];
  /** The &quot;linkTarget&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  linkTarget: Scalars['String']['output'];
  /** The &quot;lock&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;showAvatar&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  showAvatar: Scalars['Boolean']['output'];
  /** The &quot;showBio&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  showBio?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;style&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePostAuthorAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePostAuthorBiography = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePostAuthorBiography';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePostAuthorBiography Block Type */
  attributes?: Maybe<CorePostAuthorBiographyAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePostAuthorBiography Block Type */
export type CorePostAuthorBiographyAttributes = {
  __typename?: 'CorePostAuthorBiographyAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CorePostAuthorBiographyAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CorePostAuthorBiographyAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePostAuthorBiographyAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CorePostAuthorBiographyAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePostAuthorBiographyAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CorePostAuthorBiographyAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CorePostAuthorBiographyAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePostAuthorBiographyAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CorePostAuthorBiographyAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CorePostAuthorBiographyAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePostAuthorBiographyAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePostAuthorName = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePostAuthorName';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePostAuthorName Block Type */
  attributes?: Maybe<CorePostAuthorNameAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePostAuthorName Block Type */
export type CorePostAuthorNameAttributes = {
  __typename?: 'CorePostAuthorNameAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CorePostAuthorNameAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CorePostAuthorNameAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePostAuthorNameAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CorePostAuthorNameAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePostAuthorNameAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CorePostAuthorNameAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;isLink&quot; field on the &quot;CorePostAuthorNameAttributes&quot; block or block attributes */
  isLink: Scalars['Boolean']['output'];
  /** The &quot;linkTarget&quot; field on the &quot;CorePostAuthorNameAttributes&quot; block or block attributes */
  linkTarget: Scalars['String']['output'];
  /** The &quot;lock&quot; field on the &quot;CorePostAuthorNameAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePostAuthorNameAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CorePostAuthorNameAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CorePostAuthorNameAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePostAuthorNameAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePostComments = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePostComments';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePostComments Block Type */
  attributes?: Maybe<CorePostCommentsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePostComments Block Type */
export type CorePostCommentsAttributes = {
  __typename?: 'CorePostCommentsAttributes';
  /** The &quot;align&quot; field on the &quot;CorePostCommentsAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CorePostCommentsAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePostCommentsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePostCommentsAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CorePostCommentsAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CorePostCommentsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePostCommentsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CorePostCommentsAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CorePostCommentsAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePostCommentsAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePostCommentsForm = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePostCommentsForm';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePostCommentsForm Block Type */
  attributes?: Maybe<CorePostCommentsFormAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePostCommentsForm Block Type */
export type CorePostCommentsFormAttributes = {
  __typename?: 'CorePostCommentsFormAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CorePostCommentsFormAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CorePostCommentsFormAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePostCommentsFormAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePostCommentsFormAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CorePostCommentsFormAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CorePostCommentsFormAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePostCommentsFormAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CorePostCommentsFormAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CorePostCommentsFormAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePostCommentsFormAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePostContent = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePostContent';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePostContent Block Type */
  attributes?: Maybe<CorePostContentAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePostContent Block Type */
export type CorePostContentAttributes = {
  __typename?: 'CorePostContentAttributes';
  /** The &quot;align&quot; field on the &quot;CorePostContentAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CorePostContentAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CorePostContentAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePostContentAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CorePostContentAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePostContentAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CorePostContentAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;layout&quot; field on the &quot;CorePostContentAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CorePostContentAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePostContentAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CorePostContentAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePostContentAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePostDate = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePostDate';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePostDate Block Type */
  attributes?: Maybe<CorePostDateAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePostDate Block Type */
export type CorePostDateAttributes = {
  __typename?: 'CorePostDateAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CorePostDateAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CorePostDateAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePostDateAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;displayType&quot; field on the &quot;CorePostDateAttributes&quot; block or block attributes */
  displayType: Scalars['String']['output'];
  /** The &quot;fontFamily&quot; field on the &quot;CorePostDateAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePostDateAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;format&quot; field on the &quot;CorePostDateAttributes&quot; block or block attributes */
  format?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CorePostDateAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;isLink&quot; field on the &quot;CorePostDateAttributes&quot; block or block attributes */
  isLink: Scalars['Boolean']['output'];
  /** The &quot;lock&quot; field on the &quot;CorePostDateAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePostDateAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CorePostDateAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CorePostDateAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePostDateAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePostExcerpt = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePostExcerpt';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePostExcerpt Block Type */
  attributes?: Maybe<CorePostExcerptAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePostExcerpt Block Type */
export type CorePostExcerptAttributes = {
  __typename?: 'CorePostExcerptAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CorePostExcerptAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CorePostExcerptAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePostExcerptAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;excerptLength&quot; field on the &quot;CorePostExcerptAttributes&quot; block or block attributes */
  excerptLength: Scalars['Float']['output'];
  /** The &quot;fontFamily&quot; field on the &quot;CorePostExcerptAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePostExcerptAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CorePostExcerptAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CorePostExcerptAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePostExcerptAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;moreText&quot; field on the &quot;CorePostExcerptAttributes&quot; block or block attributes */
  moreText?: Maybe<Scalars['String']['output']>;
  /** The &quot;showMoreOnNewLine&quot; field on the &quot;CorePostExcerptAttributes&quot; block or block attributes */
  showMoreOnNewLine: Scalars['Boolean']['output'];
  /** The &quot;style&quot; field on the &quot;CorePostExcerptAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CorePostExcerptAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePostExcerptAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePostFeaturedImage = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePostFeaturedImage';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePostFeaturedImage Block Type */
  attributes?: Maybe<CorePostFeaturedImageAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePostFeaturedImage Block Type */
export type CorePostFeaturedImageAttributes = {
  __typename?: 'CorePostFeaturedImageAttributes';
  /** The &quot;align&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;aspectRatio&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  aspectRatio?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;customGradient&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  customGradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;customOverlayColor&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  customOverlayColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;dimRatio&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  dimRatio: Scalars['Float']['output'];
  /** The &quot;gradient&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;height&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  height?: Maybe<Scalars['String']['output']>;
  /** The &quot;isLink&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  isLink: Scalars['Boolean']['output'];
  /** The &quot;linkTarget&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  linkTarget: Scalars['String']['output'];
  /** The &quot;lock&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;overlayColor&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  overlayColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;rel&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  rel: Scalars['String']['output'];
  /** The &quot;scale&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  scale: Scalars['String']['output'];
  /** The &quot;sizeSlug&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  sizeSlug?: Maybe<Scalars['String']['output']>;
  /** The &quot;style&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;useFirstImageFromPost&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  useFirstImageFromPost: Scalars['Boolean']['output'];
  /** The &quot;width&quot; field on the &quot;CorePostFeaturedImageAttributes&quot; block or block attributes */
  width?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePostNavigationLink = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePostNavigationLink';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePostNavigationLink Block Type */
  attributes?: Maybe<CorePostNavigationLinkAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePostNavigationLink Block Type */
export type CorePostNavigationLinkAttributes = {
  __typename?: 'CorePostNavigationLinkAttributes';
  /** The &quot;arrow&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  arrow: Scalars['String']['output'];
  /** The &quot;backgroundColor&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;label&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  label?: Maybe<Scalars['String']['output']>;
  /** The &quot;linkLabel&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  linkLabel: Scalars['Boolean']['output'];
  /** The &quot;lock&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;showTitle&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  showTitle: Scalars['Boolean']['output'];
  /** The &quot;style&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;taxonomy&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  taxonomy: Scalars['String']['output'];
  /** The &quot;textAlign&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;type&quot; field on the &quot;CorePostNavigationLinkAttributes&quot; block or block attributes */
  type: Scalars['String']['output'];
};

/** A block used for editing the site */
export type CorePostTemplate = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePostTemplate';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePostTemplate Block Type */
  attributes?: Maybe<CorePostTemplateAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePostTemplate Block Type */
export type CorePostTemplateAttributes = {
  __typename?: 'CorePostTemplateAttributes';
  /** The &quot;align&quot; field on the &quot;CorePostTemplateAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CorePostTemplateAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CorePostTemplateAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePostTemplateAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CorePostTemplateAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePostTemplateAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CorePostTemplateAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;layout&quot; field on the &quot;CorePostTemplateAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CorePostTemplateAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePostTemplateAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CorePostTemplateAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePostTemplateAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePostTerms = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePostTerms';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePostTerms Block Type */
  attributes?: Maybe<CorePostTermsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** Prefix to display before the post terms */
  prefix?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** Suffix to display after the post terms */
  suffix?: Maybe<Scalars['String']['output']>;
  /** Connection between the CorePostTerms type and the Taxonomy type */
  taxonomy?: Maybe<CorePostTermsToTaxonomyConnectionEdge>;
  /** Connection between the CorePostTerms type and the TermNode type */
  terms?: Maybe<CorePostTermsToTermNodeConnection>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};


/** A block used for editing the site */
export type CorePostTermsTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Attributes of the CorePostTerms Block Type */
export type CorePostTermsAttributes = {
  __typename?: 'CorePostTermsAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;prefix&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  prefix: Scalars['String']['output'];
  /** The &quot;separator&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  separator: Scalars['String']['output'];
  /** The &quot;style&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;suffix&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  suffix: Scalars['String']['output'];
  /** The &quot;term&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  term?: Maybe<Scalars['String']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePostTermsAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the CorePostTerms type and the Taxonomy type */
export type CorePostTermsToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  __typename?: 'CorePostTermsToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: Taxonomy;
};

/** Connection between the CorePostTerms type and the TermNode type */
export type CorePostTermsToTermNodeConnection = Connection & TermNodeConnection & {
  __typename?: 'CorePostTermsToTermNodeConnection';
  /** Edges for the CorePostTermsToTermNodeConnection connection */
  edges: Array<CorePostTermsToTermNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<TermNode>;
  /** Information about pagination in a connection. */
  pageInfo: CorePostTermsToTermNodeConnectionPageInfo;
};

/** An edge in a connection */
export type CorePostTermsToTermNodeConnectionEdge = Edge & TermNodeConnectionEdge & {
  __typename?: 'CorePostTermsToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: TermNode;
};

/** Pagination metadata specific to &quot;CorePostTermsToTermNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of CorePostTermsToTermNodeConnection Nodes. */
export type CorePostTermsToTermNodeConnectionPageInfo = PageInfo & TermNodeConnectionPageInfo & WpPageInfo & {
  __typename?: 'CorePostTermsToTermNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** A block used for editing the site */
export type CorePostTitle = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePostTitle';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePostTitle Block Type */
  attributes?: Maybe<CorePostTitleAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePostTitle Block Type */
export type CorePostTitleAttributes = {
  __typename?: 'CorePostTitleAttributes';
  /** The &quot;align&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;isLink&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  isLink: Scalars['Boolean']['output'];
  /** The &quot;level&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  level: Scalars['Float']['output'];
  /** The &quot;levelOptions&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  levelOptions?: Maybe<Scalars['BlockAttributesArray']['output']>;
  /** The &quot;linkTarget&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  linkTarget: Scalars['String']['output'];
  /** The &quot;lock&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;rel&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  rel: Scalars['String']['output'];
  /** The &quot;style&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePostTitleAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePreformatted = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePreformatted';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePreformatted Block Type */
  attributes?: Maybe<CorePreformattedAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePreformatted Block Type */
export type CorePreformattedAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CorePreformattedAttributes';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CorePreformattedAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CorePreformattedAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePreformattedAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;content&quot; field on the &quot;CorePreformattedAttributes&quot; block or block attributes */
  content?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CorePreformattedAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePreformattedAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CorePreformattedAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CorePreformattedAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePreformattedAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CorePreformattedAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePreformattedAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CorePullquote = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CorePullquote';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CorePullquote Block Type */
  attributes?: Maybe<CorePullquoteAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CorePullquote Block Type */
export type CorePullquoteAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CorePullquoteAttributes';
  /** The &quot;align&quot; field on the &quot;CorePullquoteAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CorePullquoteAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CorePullquoteAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;citation&quot; field on the &quot;CorePullquoteAttributes&quot; block or block attributes */
  citation?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CorePullquoteAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CorePullquoteAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CorePullquoteAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CorePullquoteAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CorePullquoteAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CorePullquoteAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CorePullquoteAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CorePullquoteAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CorePullquoteAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;value&quot; field on the &quot;CorePullquoteAttributes&quot; block or block attributes */
  value?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreQuery = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreQuery';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreQuery Block Type */
  attributes?: Maybe<CoreQueryAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreQuery Block Type */
export type CoreQueryAttributes = {
  __typename?: 'CoreQueryAttributes';
  /** The &quot;align&quot; field on the &quot;CoreQueryAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreQueryAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;enhancedPagination&quot; field on the &quot;CoreQueryAttributes&quot; block or block attributes */
  enhancedPagination: Scalars['Boolean']['output'];
  /** The &quot;layout&quot; field on the &quot;CoreQueryAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreQueryAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreQueryAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;namespace&quot; field on the &quot;CoreQueryAttributes&quot; block or block attributes */
  namespace?: Maybe<Scalars['String']['output']>;
  /** The &quot;query&quot; field on the &quot;CoreQueryAttributes&quot; block or block attributes */
  query: Scalars['BlockAttributesObject']['output'];
  /** The &quot;queryId&quot; field on the &quot;CoreQueryAttributes&quot; block or block attributes */
  queryId?: Maybe<Scalars['Float']['output']>;
  /** The &quot;tagName&quot; field on the &quot;CoreQueryAttributes&quot; block or block attributes */
  tagName: Scalars['String']['output'];
};

/** A block used for editing the site */
export type CoreQueryNoResults = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreQueryNoResults';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreQueryNoResults Block Type */
  attributes?: Maybe<CoreQueryNoResultsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreQueryNoResults Block Type */
export type CoreQueryNoResultsAttributes = {
  __typename?: 'CoreQueryNoResultsAttributes';
  /** The &quot;align&quot; field on the &quot;CoreQueryNoResultsAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreQueryNoResultsAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreQueryNoResultsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreQueryNoResultsAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreQueryNoResultsAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreQueryNoResultsAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreQueryNoResultsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreQueryNoResultsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreQueryNoResultsAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreQueryNoResultsAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreQueryPagination = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreQueryPagination';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreQueryPagination Block Type */
  attributes?: Maybe<CoreQueryPaginationAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreQueryPagination Block Type */
export type CoreQueryPaginationAttributes = {
  __typename?: 'CoreQueryPaginationAttributes';
  /** The &quot;align&quot; field on the &quot;CoreQueryPaginationAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreQueryPaginationAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreQueryPaginationAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreQueryPaginationAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreQueryPaginationAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreQueryPaginationAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;layout&quot; field on the &quot;CoreQueryPaginationAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreQueryPaginationAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreQueryPaginationAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;paginationArrow&quot; field on the &quot;CoreQueryPaginationAttributes&quot; block or block attributes */
  paginationArrow: Scalars['String']['output'];
  /** The &quot;showLabel&quot; field on the &quot;CoreQueryPaginationAttributes&quot; block or block attributes */
  showLabel: Scalars['Boolean']['output'];
  /** The &quot;style&quot; field on the &quot;CoreQueryPaginationAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreQueryPaginationAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreQueryPaginationNext = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreQueryPaginationNext';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreQueryPaginationNext Block Type */
  attributes?: Maybe<CoreQueryPaginationNextAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreQueryPaginationNext Block Type */
export type CoreQueryPaginationNextAttributes = {
  __typename?: 'CoreQueryPaginationNextAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CoreQueryPaginationNextAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreQueryPaginationNextAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreQueryPaginationNextAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreQueryPaginationNextAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreQueryPaginationNextAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;label&quot; field on the &quot;CoreQueryPaginationNextAttributes&quot; block or block attributes */
  label?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreQueryPaginationNextAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreQueryPaginationNextAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreQueryPaginationNextAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreQueryPaginationNumbers = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreQueryPaginationNumbers';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreQueryPaginationNumbers Block Type */
  attributes?: Maybe<CoreQueryPaginationNumbersAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreQueryPaginationNumbers Block Type */
export type CoreQueryPaginationNumbersAttributes = {
  __typename?: 'CoreQueryPaginationNumbersAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CoreQueryPaginationNumbersAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreQueryPaginationNumbersAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreQueryPaginationNumbersAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreQueryPaginationNumbersAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreQueryPaginationNumbersAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreQueryPaginationNumbersAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreQueryPaginationNumbersAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;midSize&quot; field on the &quot;CoreQueryPaginationNumbersAttributes&quot; block or block attributes */
  midSize: Scalars['Float']['output'];
  /** The &quot;style&quot; field on the &quot;CoreQueryPaginationNumbersAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreQueryPaginationPrevious = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreQueryPaginationPrevious';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreQueryPaginationPrevious Block Type */
  attributes?: Maybe<CoreQueryPaginationPreviousAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreQueryPaginationPrevious Block Type */
export type CoreQueryPaginationPreviousAttributes = {
  __typename?: 'CoreQueryPaginationPreviousAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CoreQueryPaginationPreviousAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreQueryPaginationPreviousAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreQueryPaginationPreviousAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreQueryPaginationPreviousAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreQueryPaginationPreviousAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;label&quot; field on the &quot;CoreQueryPaginationPreviousAttributes&quot; block or block attributes */
  label?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreQueryPaginationPreviousAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreQueryPaginationPreviousAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreQueryPaginationPreviousAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreQueryTitle = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreQueryTitle';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreQueryTitle Block Type */
  attributes?: Maybe<CoreQueryTitleAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreQueryTitle Block Type */
export type CoreQueryTitleAttributes = {
  __typename?: 'CoreQueryTitleAttributes';
  /** The &quot;align&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;level&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  level: Scalars['Float']['output'];
  /** The &quot;levelOptions&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  levelOptions?: Maybe<Scalars['BlockAttributesArray']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;showPrefix&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  showPrefix: Scalars['Boolean']['output'];
  /** The &quot;showSearchTerm&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  showSearchTerm: Scalars['Boolean']['output'];
  /** The &quot;style&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;type&quot; field on the &quot;CoreQueryTitleAttributes&quot; block or block attributes */
  type?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreQueryTotal = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreQueryTotal';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreQueryTotal Block Type */
  attributes?: Maybe<CoreQueryTotalAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreQueryTotal Block Type */
export type CoreQueryTotalAttributes = {
  __typename?: 'CoreQueryTotalAttributes';
  /** The &quot;align&quot; field on the &quot;CoreQueryTotalAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreQueryTotalAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreQueryTotalAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreQueryTotalAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;displayType&quot; field on the &quot;CoreQueryTotalAttributes&quot; block or block attributes */
  displayType: Scalars['String']['output'];
  /** The &quot;fontFamily&quot; field on the &quot;CoreQueryTotalAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreQueryTotalAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreQueryTotalAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreQueryTotalAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreQueryTotalAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreQueryTotalAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreQueryTotalAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreQuote = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreQuote';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreQuote Block Type */
  attributes?: Maybe<CoreQuoteAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreQuote Block Type */
export type CoreQuoteAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreQuoteAttributes';
  /** The &quot;align&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;citation&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  citation?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;cssClassName&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  cssClassName?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;layout&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;value&quot; field on the &quot;CoreQuoteAttributes&quot; block or block attributes */
  value: Scalars['String']['output'];
};

/** A block used for editing the site */
export type CoreReadMore = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreReadMore';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreReadMore Block Type */
  attributes?: Maybe<CoreReadMoreAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreReadMore Block Type */
export type CoreReadMoreAttributes = {
  __typename?: 'CoreReadMoreAttributes';
  /** The &quot;backgroundColor&quot; field on the &quot;CoreReadMoreAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreReadMoreAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreReadMoreAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;content&quot; field on the &quot;CoreReadMoreAttributes&quot; block or block attributes */
  content?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreReadMoreAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreReadMoreAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreReadMoreAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;linkTarget&quot; field on the &quot;CoreReadMoreAttributes&quot; block or block attributes */
  linkTarget: Scalars['String']['output'];
  /** The &quot;lock&quot; field on the &quot;CoreReadMoreAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreReadMoreAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreReadMoreAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreReadMoreAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreRss = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreRss';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreRss Block Type */
  attributes?: Maybe<CoreRssAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreRss Block Type */
export type CoreRssAttributes = {
  __typename?: 'CoreRssAttributes';
  /** The &quot;align&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;blockLayout&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  blockLayout: Scalars['String']['output'];
  /** The &quot;borderColor&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;columns&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  columns: Scalars['Float']['output'];
  /** The &quot;displayAuthor&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  displayAuthor: Scalars['Boolean']['output'];
  /** The &quot;displayDate&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  displayDate: Scalars['Boolean']['output'];
  /** The &quot;displayExcerpt&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  displayExcerpt: Scalars['Boolean']['output'];
  /** The &quot;excerptLength&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  excerptLength: Scalars['Float']['output'];
  /** The &quot;feedURL&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  feedURL: Scalars['String']['output'];
  /** The &quot;gradient&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;itemsToShow&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  itemsToShow: Scalars['Float']['output'];
  /** The &quot;lock&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreRssAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreSearch = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreSearch';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreSearch Block Type */
  attributes?: Maybe<CoreSearchAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreSearch Block Type */
export type CoreSearchAttributes = {
  __typename?: 'CoreSearchAttributes';
  /** The &quot;align&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;buttonPosition&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  buttonPosition: Scalars['String']['output'];
  /** The &quot;buttonText&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** The &quot;buttonUseIcon&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  buttonUseIcon: Scalars['Boolean']['output'];
  /** The &quot;className&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;isSearchFieldHidden&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  isSearchFieldHidden: Scalars['Boolean']['output'];
  /** The &quot;label&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  label?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;placeholder&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  placeholder: Scalars['String']['output'];
  /** The &quot;query&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  query: Scalars['BlockAttributesObject']['output'];
  /** The &quot;showLabel&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  showLabel: Scalars['Boolean']['output'];
  /** The &quot;style&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;width&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  width?: Maybe<Scalars['Float']['output']>;
  /** The &quot;widthUnit&quot; field on the &quot;CoreSearchAttributes&quot; block or block attributes */
  widthUnit?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreSeparator = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreSeparator';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreSeparator Block Type */
  attributes?: Maybe<CoreSeparatorAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreSeparator Block Type */
export type CoreSeparatorAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreSeparatorAttributes';
  /** The &quot;align&quot; field on the &quot;CoreSeparatorAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreSeparatorAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreSeparatorAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;cssClassName&quot; field on the &quot;CoreSeparatorAttributes&quot; block or block attributes */
  cssClassName?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreSeparatorAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreSeparatorAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreSeparatorAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;opacity&quot; field on the &quot;CoreSeparatorAttributes&quot; block or block attributes */
  opacity: Scalars['String']['output'];
  /** The &quot;style&quot; field on the &quot;CoreSeparatorAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;tagName&quot; field on the &quot;CoreSeparatorAttributes&quot; block or block attributes */
  tagName: Scalars['String']['output'];
};

/** A block used for editing the site */
export type CoreShortcode = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreShortcode';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreShortcode Block Type */
  attributes?: Maybe<CoreShortcodeAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreShortcode Block Type */
export type CoreShortcodeAttributes = {
  __typename?: 'CoreShortcodeAttributes';
  /** The &quot;lock&quot; field on the &quot;CoreShortcodeAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreShortcodeAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;text&quot; field on the &quot;CoreShortcodeAttributes&quot; block or block attributes */
  text?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreSiteLogo = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreSiteLogo';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreSiteLogo Block Type */
  attributes?: Maybe<CoreSiteLogoAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreSiteLogo Block Type */
export type CoreSiteLogoAttributes = {
  __typename?: 'CoreSiteLogoAttributes';
  /** The &quot;align&quot; field on the &quot;CoreSiteLogoAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreSiteLogoAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;isLink&quot; field on the &quot;CoreSiteLogoAttributes&quot; block or block attributes */
  isLink: Scalars['Boolean']['output'];
  /** The &quot;linkTarget&quot; field on the &quot;CoreSiteLogoAttributes&quot; block or block attributes */
  linkTarget: Scalars['String']['output'];
  /** The &quot;lock&quot; field on the &quot;CoreSiteLogoAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreSiteLogoAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;shouldSyncIcon&quot; field on the &quot;CoreSiteLogoAttributes&quot; block or block attributes */
  shouldSyncIcon?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreSiteLogoAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;width&quot; field on the &quot;CoreSiteLogoAttributes&quot; block or block attributes */
  width?: Maybe<Scalars['Float']['output']>;
};

/** A block used for editing the site */
export type CoreSiteTagline = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreSiteTagline';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreSiteTagline Block Type */
  attributes?: Maybe<CoreSiteTaglineAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreSiteTagline Block Type */
export type CoreSiteTaglineAttributes = {
  __typename?: 'CoreSiteTaglineAttributes';
  /** The &quot;align&quot; field on the &quot;CoreSiteTaglineAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreSiteTaglineAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreSiteTaglineAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreSiteTaglineAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreSiteTaglineAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreSiteTaglineAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreSiteTaglineAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;level&quot; field on the &quot;CoreSiteTaglineAttributes&quot; block or block attributes */
  level: Scalars['Float']['output'];
  /** The &quot;levelOptions&quot; field on the &quot;CoreSiteTaglineAttributes&quot; block or block attributes */
  levelOptions: Scalars['BlockAttributesArray']['output'];
  /** The &quot;lock&quot; field on the &quot;CoreSiteTaglineAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreSiteTaglineAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreSiteTaglineAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CoreSiteTaglineAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreSiteTaglineAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreSiteTitle = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreSiteTitle';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreSiteTitle Block Type */
  attributes?: Maybe<CoreSiteTitleAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreSiteTitle Block Type */
export type CoreSiteTitleAttributes = {
  __typename?: 'CoreSiteTitleAttributes';
  /** The &quot;align&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;isLink&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  isLink: Scalars['Boolean']['output'];
  /** The &quot;level&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  level: Scalars['Float']['output'];
  /** The &quot;levelOptions&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  levelOptions: Scalars['BlockAttributesArray']['output'];
  /** The &quot;linkTarget&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  linkTarget: Scalars['String']['output'];
  /** The &quot;lock&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreSiteTitleAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreSocialLink = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreSocialLink';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreSocialLink Block Type */
  attributes?: Maybe<CoreSocialLinkAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreSocialLink Block Type */
export type CoreSocialLinkAttributes = {
  __typename?: 'CoreSocialLinkAttributes';
  /** The &quot;className&quot; field on the &quot;CoreSocialLinkAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;label&quot; field on the &quot;CoreSocialLinkAttributes&quot; block or block attributes */
  label?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreSocialLinkAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreSocialLinkAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;rel&quot; field on the &quot;CoreSocialLinkAttributes&quot; block or block attributes */
  rel?: Maybe<Scalars['String']['output']>;
  /** The &quot;service&quot; field on the &quot;CoreSocialLinkAttributes&quot; block or block attributes */
  service?: Maybe<Scalars['String']['output']>;
  /** The &quot;url&quot; field on the &quot;CoreSocialLinkAttributes&quot; block or block attributes */
  url?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreSocialLinks = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreSocialLinks';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreSocialLinks Block Type */
  attributes?: Maybe<CoreSocialLinksAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreSocialLinks Block Type */
export type CoreSocialLinksAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreSocialLinksAttributes';
  /** The &quot;align&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;customIconBackgroundColor&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  customIconBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;customIconColor&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  customIconColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;iconBackgroundColor&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  iconBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;iconBackgroundColorValue&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  iconBackgroundColorValue?: Maybe<Scalars['String']['output']>;
  /** The &quot;iconColor&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  iconColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;iconColorValue&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  iconColorValue?: Maybe<Scalars['String']['output']>;
  /** The &quot;layout&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  layout?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;openInNewTab&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  openInNewTab: Scalars['Boolean']['output'];
  /** The &quot;showLabels&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  showLabels: Scalars['Boolean']['output'];
  /** The &quot;size&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  size?: Maybe<Scalars['String']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreSocialLinksAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

/** A block used for editing the site */
export type CoreSpacer = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreSpacer';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreSpacer Block Type */
  attributes?: Maybe<CoreSpacerAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreSpacer Block Type */
export type CoreSpacerAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreSpacerAttributes';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreSpacerAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;height&quot; field on the &quot;CoreSpacerAttributes&quot; block or block attributes */
  height: Scalars['String']['output'];
  /** The &quot;lock&quot; field on the &quot;CoreSpacerAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreSpacerAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreSpacerAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;width&quot; field on the &quot;CoreSpacerAttributes&quot; block or block attributes */
  width?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreTable = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreTable';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreTable Block Type */
  attributes?: Maybe<CoreTableAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreTable Block Type */
export type CoreTableAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreTableAttributes';
  /** The &quot;align&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;body&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  body: Array<Maybe<CoreTableAttributesBody>>;
  /** The &quot;borderColor&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;caption&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  caption?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;foot&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  foot: Array<Maybe<CoreTableAttributesFoot>>;
  /** The &quot;gradient&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;hasFixedLayout&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  hasFixedLayout: Scalars['Boolean']['output'];
  /** The &quot;head&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  head: Array<Maybe<CoreTableAttributesHead>>;
  /** The &quot;lock&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreTableAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** The &quot;CoreTableAttributesBody&quot; field on the &quot;CoreTableAttributes&quot; block attribute field */
export type CoreTableAttributesBody = {
  __typename?: 'CoreTableAttributesBody';
  /** The &quot;cells&quot; field on the &quot;CoreTableAttributesBody&quot; block attribute field */
  cells: Array<Maybe<CoreTableAttributesBodyCells>>;
};

/** The &quot;CoreTableAttributesBodyCells&quot; field on the &quot;CoreTableAttributesBody&quot; block attribute field */
export type CoreTableAttributesBodyCells = {
  __typename?: 'CoreTableAttributesBodyCells';
  /** The &quot;align&quot; field on the &quot;CoreTableAttributesBodyCells&quot; block attribute field */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;colspan&quot; field on the &quot;CoreTableAttributesBodyCells&quot; block attribute field */
  colspan?: Maybe<Scalars['String']['output']>;
  /** The &quot;content&quot; field on the &quot;CoreTableAttributesBodyCells&quot; block attribute field */
  content?: Maybe<Scalars['String']['output']>;
  /** The &quot;rowspan&quot; field on the &quot;CoreTableAttributesBodyCells&quot; block attribute field */
  rowspan?: Maybe<Scalars['String']['output']>;
  /** The &quot;scope&quot; field on the &quot;CoreTableAttributesBodyCells&quot; block attribute field */
  scope?: Maybe<Scalars['String']['output']>;
  /** The &quot;tag&quot; field on the &quot;CoreTableAttributesBodyCells&quot; block attribute field */
  tag: Scalars['String']['output'];
};

/** The &quot;CoreTableAttributesFoot&quot; field on the &quot;CoreTableAttributes&quot; block attribute field */
export type CoreTableAttributesFoot = {
  __typename?: 'CoreTableAttributesFoot';
  /** The &quot;cells&quot; field on the &quot;CoreTableAttributesFoot&quot; block attribute field */
  cells: Array<Maybe<CoreTableAttributesFootCells>>;
};

/** The &quot;CoreTableAttributesFootCells&quot; field on the &quot;CoreTableAttributesFoot&quot; block attribute field */
export type CoreTableAttributesFootCells = {
  __typename?: 'CoreTableAttributesFootCells';
  /** The &quot;align&quot; field on the &quot;CoreTableAttributesFootCells&quot; block attribute field */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;colspan&quot; field on the &quot;CoreTableAttributesFootCells&quot; block attribute field */
  colspan?: Maybe<Scalars['String']['output']>;
  /** The &quot;content&quot; field on the &quot;CoreTableAttributesFootCells&quot; block attribute field */
  content?: Maybe<Scalars['String']['output']>;
  /** The &quot;rowspan&quot; field on the &quot;CoreTableAttributesFootCells&quot; block attribute field */
  rowspan?: Maybe<Scalars['String']['output']>;
  /** The &quot;scope&quot; field on the &quot;CoreTableAttributesFootCells&quot; block attribute field */
  scope?: Maybe<Scalars['String']['output']>;
  /** The &quot;tag&quot; field on the &quot;CoreTableAttributesFootCells&quot; block attribute field */
  tag: Scalars['String']['output'];
};

/** The &quot;CoreTableAttributesHead&quot; field on the &quot;CoreTableAttributes&quot; block attribute field */
export type CoreTableAttributesHead = {
  __typename?: 'CoreTableAttributesHead';
  /** The &quot;cells&quot; field on the &quot;CoreTableAttributesHead&quot; block attribute field */
  cells: Array<Maybe<CoreTableAttributesHeadCells>>;
};

/** The &quot;CoreTableAttributesHeadCells&quot; field on the &quot;CoreTableAttributesHead&quot; block attribute field */
export type CoreTableAttributesHeadCells = {
  __typename?: 'CoreTableAttributesHeadCells';
  /** The &quot;align&quot; field on the &quot;CoreTableAttributesHeadCells&quot; block attribute field */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;colspan&quot; field on the &quot;CoreTableAttributesHeadCells&quot; block attribute field */
  colspan?: Maybe<Scalars['String']['output']>;
  /** The &quot;content&quot; field on the &quot;CoreTableAttributesHeadCells&quot; block attribute field */
  content?: Maybe<Scalars['String']['output']>;
  /** The &quot;rowspan&quot; field on the &quot;CoreTableAttributesHeadCells&quot; block attribute field */
  rowspan?: Maybe<Scalars['String']['output']>;
  /** The &quot;scope&quot; field on the &quot;CoreTableAttributesHeadCells&quot; block attribute field */
  scope?: Maybe<Scalars['String']['output']>;
  /** The &quot;tag&quot; field on the &quot;CoreTableAttributesHeadCells&quot; block attribute field */
  tag: Scalars['String']['output'];
};

/** A block used for editing the site */
export type CoreTagCloud = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreTagCloud';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreTagCloud Block Type */
  attributes?: Maybe<CoreTagCloudAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreTagCloud Block Type */
export type CoreTagCloudAttributes = {
  __typename?: 'CoreTagCloudAttributes';
  /** The &quot;align&quot; field on the &quot;CoreTagCloudAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreTagCloudAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreTagCloudAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreTagCloudAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;largestFontSize&quot; field on the &quot;CoreTagCloudAttributes&quot; block or block attributes */
  largestFontSize: Scalars['String']['output'];
  /** The &quot;lock&quot; field on the &quot;CoreTagCloudAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreTagCloudAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;numberOfTags&quot; field on the &quot;CoreTagCloudAttributes&quot; block or block attributes */
  numberOfTags: Scalars['Float']['output'];
  /** The &quot;showTagCounts&quot; field on the &quot;CoreTagCloudAttributes&quot; block or block attributes */
  showTagCounts: Scalars['Boolean']['output'];
  /** The &quot;smallestFontSize&quot; field on the &quot;CoreTagCloudAttributes&quot; block or block attributes */
  smallestFontSize: Scalars['String']['output'];
  /** The &quot;style&quot; field on the &quot;CoreTagCloudAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;taxonomy&quot; field on the &quot;CoreTagCloudAttributes&quot; block or block attributes */
  taxonomy: Scalars['String']['output'];
};

/** A block used for editing the site */
export type CoreTemplatePart = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreTemplatePart';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreTemplatePart Block Type */
  attributes?: Maybe<CoreTemplatePartAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreTemplatePart Block Type */
export type CoreTemplatePartAttributes = {
  __typename?: 'CoreTemplatePartAttributes';
  /** The &quot;align&quot; field on the &quot;CoreTemplatePartAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;area&quot; field on the &quot;CoreTemplatePartAttributes&quot; block or block attributes */
  area?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreTemplatePartAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreTemplatePartAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreTemplatePartAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;slug&quot; field on the &quot;CoreTemplatePartAttributes&quot; block or block attributes */
  slug?: Maybe<Scalars['String']['output']>;
  /** The &quot;tagName&quot; field on the &quot;CoreTemplatePartAttributes&quot; block or block attributes */
  tagName?: Maybe<Scalars['String']['output']>;
  /** The &quot;theme&quot; field on the &quot;CoreTemplatePartAttributes&quot; block or block attributes */
  theme?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreTermDescription = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreTermDescription';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreTermDescription Block Type */
  attributes?: Maybe<CoreTermDescriptionAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreTermDescription Block Type */
export type CoreTermDescriptionAttributes = {
  __typename?: 'CoreTermDescriptionAttributes';
  /** The &quot;align&quot; field on the &quot;CoreTermDescriptionAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreTermDescriptionAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreTermDescriptionAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreTermDescriptionAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreTermDescriptionAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreTermDescriptionAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreTermDescriptionAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreTermDescriptionAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreTermDescriptionAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CoreTermDescriptionAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreTermDescriptionAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreTextColumns = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreTextColumns';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreTextColumns Block Type */
  attributes?: Maybe<CoreTextColumnsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreTextColumns Block Type */
export type CoreTextColumnsAttributes = {
  __typename?: 'CoreTextColumnsAttributes';
  /** The &quot;className&quot; field on the &quot;CoreTextColumnsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;columns&quot; field on the &quot;CoreTextColumnsAttributes&quot; block or block attributes */
  columns: Scalars['Float']['output'];
  /** The &quot;content&quot; field on the &quot;CoreTextColumnsAttributes&quot; block or block attributes */
  content: Array<Maybe<CoreTextColumnsAttributesContent>>;
  /** The &quot;lock&quot; field on the &quot;CoreTextColumnsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreTextColumnsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;width&quot; field on the &quot;CoreTextColumnsAttributes&quot; block or block attributes */
  width?: Maybe<Scalars['String']['output']>;
};

/** The &quot;CoreTextColumnsAttributesContent&quot; field on the &quot;CoreTextColumnsAttributes&quot; block attribute field */
export type CoreTextColumnsAttributesContent = {
  __typename?: 'CoreTextColumnsAttributesContent';
  /** The &quot;children&quot; field on the &quot;CoreTextColumnsAttributesContent&quot; block attribute field */
  children?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreVerse = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreVerse';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreVerse Block Type */
  attributes?: Maybe<CoreVerseAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreVerse Block Type */
export type CoreVerseAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreVerseAttributes';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;backgroundColor&quot; field on the &quot;CoreVerseAttributes&quot; block or block attributes */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;borderColor&quot; field on the &quot;CoreVerseAttributes&quot; block or block attributes */
  borderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreVerseAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;content&quot; field on the &quot;CoreVerseAttributes&quot; block or block attributes */
  content?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontFamily&quot; field on the &quot;CoreVerseAttributes&quot; block or block attributes */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** The &quot;fontSize&quot; field on the &quot;CoreVerseAttributes&quot; block or block attributes */
  fontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;gradient&quot; field on the &quot;CoreVerseAttributes&quot; block or block attributes */
  gradient?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreVerseAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreVerseAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreVerseAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;textAlign&quot; field on the &quot;CoreVerseAttributes&quot; block or block attributes */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** The &quot;textColor&quot; field on the &quot;CoreVerseAttributes&quot; block or block attributes */
  textColor?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type CoreVideo = BlockWithSupportsAnchor & EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreVideo';
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreVideo Block Type */
  attributes?: Maybe<CoreVideoAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreVideo Block Type */
export type CoreVideoAttributes = BlockWithSupportsAnchor & {
  __typename?: 'CoreVideoAttributes';
  /** The &quot;align&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  align?: Maybe<Scalars['String']['output']>;
  /** The anchor field for the block. */
  anchor?: Maybe<Scalars['String']['output']>;
  /** The &quot;autoplay&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  autoplay?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;blob&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  blob?: Maybe<Scalars['String']['output']>;
  /** The &quot;caption&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  caption?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;controls&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  controls: Scalars['Boolean']['output'];
  /** The &quot;id&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  id?: Maybe<Scalars['Float']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;loop&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  loop?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;muted&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  muted?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;playsInline&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  playsInline?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;poster&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  poster?: Maybe<Scalars['String']['output']>;
  /** The &quot;preload&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  preload: Scalars['String']['output'];
  /** The &quot;src&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  src?: Maybe<Scalars['String']['output']>;
  /** The &quot;style&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  style?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;tracks&quot; field on the &quot;CoreVideoAttributes&quot; block or block attributes */
  tracks: Array<Maybe<Scalars['BlockAttributesObject']['output']>>;
};

/** A block used for editing the site */
export type CoreWidgetGroup = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'CoreWidgetGroup';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the CoreWidgetGroup Block Type */
  attributes?: Maybe<CoreWidgetGroupAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the CoreWidgetGroup Block Type */
export type CoreWidgetGroupAttributes = {
  __typename?: 'CoreWidgetGroupAttributes';
  /** The &quot;className&quot; field on the &quot;CoreWidgetGroupAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;CoreWidgetGroupAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;CoreWidgetGroupAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;title&quot; field on the &quot;CoreWidgetGroupAttributes&quot; block or block attributes */
  title?: Maybe<Scalars['String']['output']>;
};

/** Input for the createCategory mutation. */
export type CreateCategoryInput = {
  /** The slug that the category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the category object */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the category object to mutate */
  name: Scalars['String']['input'];
  /** The database ID of the category that should be set as the parent. This field cannot be used in conjunction with parentId */
  parentDatabaseId?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the category that should be set as the parent. This field cannot be used in conjunction with parentDatabaseId */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createCategory mutation. */
export type CreateCategoryPayload = {
  __typename?: 'CreateCategoryPayload';
  /** The created category */
  category?: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Input for the createComment mutation. */
export type CreateCommentInput = {
  /** The name of the comment's author. */
  author?: InputMaybe<Scalars['String']['input']>;
  /** The email of the comment's author. */
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** The url of the comment's author. */
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The database ID of the post object the comment belongs to. */
  commentOn?: InputMaybe<Scalars['Int']['input']>;
  /** Content of the comment. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day ( e.g. 01/31/2017 ) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Parent comment ID of current comment. */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** The approval status of the comment */
  status?: InputMaybe<CommentStatusEnum>;
  /** Type of comment. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createComment mutation. */
export type CreateCommentPayload = {
  __typename?: 'CreateCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The comment that was created */
  comment?: Maybe<Comment>;
  /** Whether the mutation succeeded. If the comment is not approved, the server will not return the comment to a non authenticated user, but a success message can be returned if the create succeeded, and the client can optimistically add the comment to the client cache */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for the createMediaItem mutation. */
export type CreateMediaItemInput = {
  /** Alternative text to display when mediaItem is not displayed */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** The userId to assign as the author of the mediaItem */
  authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The caption for the mediaItem */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment status for the mediaItem */
  commentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The date of the mediaItem */
  date?: InputMaybe<Scalars['String']['input']>;
  /** The date (in GMT zone) of the mediaItem */
  dateGmt?: InputMaybe<Scalars['String']['input']>;
  /** Description of the mediaItem */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The file name of the mediaItem */
  filePath?: InputMaybe<Scalars['String']['input']>;
  /** The file type of the mediaItem */
  fileType?: InputMaybe<MimeTypeEnum>;
  /** The ID of the parent object */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** The ping status for the mediaItem */
  pingStatus?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the mediaItem */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the mediaItem */
  status?: InputMaybe<MediaItemStatusEnum>;
  /** The title of the mediaItem */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createMediaItem mutation. */
export type CreateMediaItemPayload = {
  __typename?: 'CreateMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The MediaItem object mutation type. */
  mediaItem?: Maybe<MediaItem>;
};

/** Input for the createPage mutation. */
export type CreatePageInput = {
  /** The userId to assign as the author of the object */
  authorId?: InputMaybe<Scalars['ID']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment status for the object */
  commentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The content of the object */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the parent object */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createPage mutation. */
export type CreatePagePayload = {
  __typename?: 'CreatePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  page?: Maybe<Page>;
};

/** Input for the createPostFormat mutation. */
export type CreatePostFormatInput = {
  /** The slug that the post_format will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the post_format object */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the post_format object to mutate */
  name: Scalars['String']['input'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createPostFormat mutation. */
export type CreatePostFormatPayload = {
  __typename?: 'CreatePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created post_format */
  postFormat?: Maybe<PostFormat>;
};

/** Input for the createPost mutation. */
export type CreatePostInput = {
  /** The userId to assign as the author of the object */
  authorId?: InputMaybe<Scalars['ID']['input']>;
  /** Set connections between the post and categories */
  categories?: InputMaybe<PostCategoriesInput>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment status for the object */
  commentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The content of the object */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']['input']>;
  /** The excerpt of the object */
  excerpt?: InputMaybe<Scalars['String']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The ping status for the object */
  pingStatus?: InputMaybe<Scalars['String']['input']>;
  /** URLs that have been pinged. */
  pinged?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Set connections between the post and postFormats */
  postFormats?: InputMaybe<PostPostFormatsInput>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** Set connections between the post and tags */
  tags?: InputMaybe<PostTagsInput>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
  /** URLs queued to be pinged. */
  toPing?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The payload for the createPost mutation. */
export type CreatePostPayload = {
  __typename?: 'CreatePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  post?: Maybe<Post>;
};

/** Input for the createTag mutation. */
export type CreateTagInput = {
  /** The slug that the post_tag will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the post_tag object */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the post_tag object to mutate */
  name: Scalars['String']['input'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createTag mutation. */
export type CreateTagPayload = {
  __typename?: 'CreateTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created post_tag */
  tag?: Maybe<Tag>;
};

/** Input for the createUser mutation. */
export type CreateUserInput = {
  /** User's AOL IM account. */
  aim?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A string containing content about the user. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** A string containing the user's email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The user's first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User's Jabber account. */
  jabber?: InputMaybe<Scalars['String']['input']>;
  /** The user's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User's locale. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  nicename?: InputMaybe<Scalars['String']['input']>;
  /** The user's nickname, defaults to the user's username. */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains the plain text password for the user. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  registered?: InputMaybe<Scalars['String']['input']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  richEditing?: InputMaybe<Scalars['String']['input']>;
  /** An array of roles to be assigned to the user. */
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A string that contains the user's username for logging in. */
  username: Scalars['String']['input'];
  /** A string containing the user's URL for the user's web site. */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  /** User's Yahoo IM account. */
  yim?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the createUser mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The User object mutation type. */
  user?: Maybe<User>;
};

/** The &quot;CtaCard&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type CtaCard = AcfFieldGroup & AcfFieldGroupFields & CtaCard_Fields & {
  __typename?: 'CtaCard';
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;CtaCard&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CtaCard&quot; Field Group */
  heading?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;CtaCard&quot; Field Group */
  secondaryButton?: Maybe<AcfLink>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;CtaCard&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;CtaCard&quot; Field Group */
export type CtaCard_Fields = {
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;CtaCard&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;CtaCard&quot; Field Group */
  heading?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;CtaCard&quot; Field Group */
  secondaryButton?: Maybe<AcfLink>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;CtaCard&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** An object that has a unique numeric identifier in the database. Provides consistent access to the database ID across different object types. */
export type DatabaseIdentifier = {
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
};

/** A Gravity Forms date field. */
export type DateField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDateFormatSetting & GfFieldWithDateInputTypeSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSubLabelPlacementSetting & Node & {
  __typename?: 'DateField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines how the date field displays it’s calendar icon. */
  calendarIconType?: Maybe<FormFieldCalendarIconTypeEnum>;
  /** Contains the URL to the custom calendar icon. Only applicable when calendarIconType is set to custom. */
  calendarIconUrl?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Determines how the date is displayed. */
  dateFormat?: Maybe<DateFieldFormatEnum>;
  /** The type of date field to display. */
  dateType?: Maybe<DateFieldTypeEnum>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<DateInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** The placement of the labels for the subfields within the group. This setting controls all of the subfields, they cannot be set individually. They may be aligned above or below the inputs. If this property is not set, the “Sub-Label Placement” setting on the Form Settings-&gt;Form Layout page is used. If no setting is specified, the default is above inputs. */
  subLabelPlacement?: Maybe<FormFieldSubLabelPlacementEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** How the DateField date is displayed. */
export enum DateFieldFormatEnum {
  /** dd/mm/yyyy format. */
  Dmy = 'DMY',
  /** dd-mm-yyyy format. */
  DmyDash = 'DMY_DASH',
  /** dd.mm.yyyy format. */
  DmyDot = 'DMY_DOT',
  /** mm/dd/yyyy format. */
  Mdy = 'MDY',
  /** yyyy/mm/dd format. */
  YmdDash = 'YMD_DASH',
  /** yyyy.mm.dd format. */
  YmdDot = 'YMD_DOT',
  /** yyyy/mm/dd format. */
  YmdSlash = 'YMD_SLASH'
}

/** Type of date field to display. */
export enum DateFieldTypeEnum {
  /** A date dropdown. */
  Dropdown = 'DROPDOWN',
  /** A simple date field. */
  Field = 'FIELD',
  /** A datepicker. */
  Picker = 'PICKER'
}

/** Date values */
export type DateInput = {
  /** Day of the month (from 1 to 31) */
  day?: InputMaybe<Scalars['Int']['input']>;
  /** Month number (from 1 to 12) */
  month?: InputMaybe<Scalars['Int']['input']>;
  /** 4 digit year (e.g. 2017) */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** DateInputProperty input values. */
export type DateInputProperty = GfFieldInput & GfFieldInputWithDateFormatSetting & {
  __typename?: 'DateInputProperty';
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** Filter the connection based on input */
export type DateQueryInput = {
  /** Nodes should be returned after this date */
  after?: InputMaybe<DateInput>;
  /** Nodes should be returned before this date */
  before?: InputMaybe<DateInput>;
  /** Column to query against */
  column?: InputMaybe<PostObjectsConnectionDateColumnEnum>;
  /** For after/before, whether exact value should be matched or not */
  compare?: InputMaybe<Scalars['String']['input']>;
  /** Day of the month (from 1 to 31) */
  day?: InputMaybe<Scalars['Int']['input']>;
  /** Hour (from 0 to 23) */
  hour?: InputMaybe<Scalars['Int']['input']>;
  /** For after/before, whether exact value should be matched or not */
  inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minute (from 0 to 59) */
  minute?: InputMaybe<Scalars['Int']['input']>;
  /** Month number (from 1 to 12) */
  month?: InputMaybe<Scalars['Int']['input']>;
  /** OR or AND, how the sub-arrays should be compared */
  relation?: InputMaybe<RelationEnum>;
  /** Second (0 to 59) */
  second?: InputMaybe<Scalars['Int']['input']>;
  /** Week of the year (from 0 to 53) */
  week?: InputMaybe<Scalars['Int']['input']>;
  /** 4 digit year (e.g. 2017) */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** The template assigned to the node */
export type DefaultTemplate = ContentTemplate & {
  __typename?: 'DefaultTemplate';
  /** The name of the template */
  templateName?: Maybe<Scalars['String']['output']>;
};

/** Input for the deleteCategory mutation. */
export type DeleteCategoryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the category to delete */
  id: Scalars['ID']['input'];
};

/** The payload for the deleteCategory mutation. */
export type DeleteCategoryPayload = {
  __typename?: 'DeleteCategoryPayload';
  /** The deleted term object */
  category?: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Input for the deleteComment mutation. */
export type DeleteCommentInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the comment should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The deleted comment ID */
  id: Scalars['ID']['input'];
};

/** The payload for the deleteComment mutation. */
export type DeleteCommentPayload = {
  __typename?: 'DeleteCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The deleted comment object */
  comment?: Maybe<Comment>;
  /** The deleted comment ID */
  deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Input for the deleteGfDraftEntry mutation. */
export type DeleteGfDraftEntryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Either the global ID of the draft entry, or its resume token. */
  id: Scalars['ID']['input'];
  /** The ID type for the draft entry. Defaults to `ID` . */
  idType?: InputMaybe<DraftEntryIdTypeEnum>;
};

/** The payload for the deleteGfDraftEntry mutation. */
export type DeleteGfDraftEntryPayload = {
  __typename?: 'DeleteGfDraftEntryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The global ID of the draft entry that was deleted. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The draft entry object before it was deleted. */
  draftEntry?: Maybe<GfDraftEntry>;
};

/** Input for the deleteGfEntry mutation. */
export type DeleteGfEntryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the entry should be force deleted instead of being moved to the trash. */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the entry to delete, either a global or database ID. */
  id: Scalars['ID']['input'];
};

/** The payload for the deleteGfEntry mutation. */
export type DeleteGfEntryPayload = {
  __typename?: 'DeleteGfEntryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The global ID of the draft entry that was deleted. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The entry object before it was deleted. */
  entry?: Maybe<GfSubmittedEntry>;
};

/** Input for the deleteMediaItem mutation. */
export type DeleteMediaItemInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the mediaItem should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the mediaItem to delete */
  id: Scalars['ID']['input'];
};

/** The payload for the deleteMediaItem mutation. */
export type DeleteMediaItemPayload = {
  __typename?: 'DeleteMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted mediaItem */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The mediaItem before it was deleted */
  mediaItem?: Maybe<MediaItem>;
};

/** Input for the deletePage mutation. */
export type DeletePageInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the page to delete */
  id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payload for the deletePage mutation. */
export type DeletePagePayload = {
  __typename?: 'DeletePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The object before it was deleted */
  page?: Maybe<Page>;
};

/** Input for the deletePostFormat mutation. */
export type DeletePostFormatInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the postFormat to delete */
  id: Scalars['ID']['input'];
};

/** The payload for the deletePostFormat mutation. */
export type DeletePostFormatPayload = {
  __typename?: 'DeletePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The deleted term object */
  postFormat?: Maybe<PostFormat>;
};

/** Input for the deletePost mutation. */
export type DeletePostInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the post to delete */
  id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payload for the deletePost mutation. */
export type DeletePostPayload = {
  __typename?: 'DeletePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The object before it was deleted */
  post?: Maybe<Post>;
};

/** Input for the deleteTag mutation. */
export type DeleteTagInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the tag to delete */
  id: Scalars['ID']['input'];
};

/** The payload for the deleteTag mutation. */
export type DeleteTagPayload = {
  __typename?: 'DeleteTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The deleted term object */
  tag?: Maybe<Tag>;
};

/** Input for the deleteUser mutation. */
export type DeleteUserInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user you want to delete */
  id: Scalars['ID']['input'];
  /** Reassign posts and links to new User ID. */
  reassignId?: InputMaybe<Scalars['ID']['input']>;
};

/** The payload for the deleteUser mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the user that you just deleted */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The deleted user object */
  user?: Maybe<User>;
};

/** The discussion setting type */
export type DiscussionSettings = {
  __typename?: 'DiscussionSettings';
  /** Allow people to submit comments on new posts. */
  defaultCommentStatus?: Maybe<Scalars['String']['output']>;
  /** Allow link notifications from other blogs (pingbacks and trackbacks) on new articles. */
  defaultPingStatus?: Maybe<Scalars['String']['output']>;
};

/** The &quot;Divider&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type Divider = AcfFieldGroup & AcfFieldGroupFields & Divider_Fields & {
  __typename?: 'Divider';
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;Divider&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;Divider&quot; Field Group */
export type Divider_Fields = {
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;Divider&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** The Type of Identifier used to fetch a single resource. */
export enum DraftEntryIdTypeEnum {
  /** Unique global ID for the object. */
  Id = 'ID',
  /** The resume token assigned by Gravity Forms. Used by draft entries. */
  ResumeToken = 'RESUME_TOKEN'
}

/** Represents a connection between two objects. Contains both the related object (node) and metadata about the relationship (cursor). */
export type Edge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected node */
  node: Node;
};

/** Blocks that can be edited to create content and layouts */
export type EditorBlock = {
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the Block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms email field. */
export type EmailField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & GfFieldWithSubLabelPlacementSetting & GfGfFieldWithEmailConfirmationSetting & Node & {
  __typename?: 'EmailField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Determines whether the Confirm Email field is active. */
  hasEmailConfirmation?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<EmailInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The placement of the labels for the subfields within the group. This setting controls all of the subfields, they cannot be set individually. They may be aligned above or below the inputs. If this property is not set, the “Sub-Label Placement” setting on the Form Settings-&gt;Form Layout page is used. If no setting is specified, the default is above inputs. */
  subLabelPlacement?: Maybe<FormFieldSubLabelPlacementEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** Input fields for email field. */
export type EmailFieldInput = {
  /** Email confirmation input value. Only used when email confirmation is enabled. */
  confirmationValue?: InputMaybe<Scalars['String']['input']>;
  /** Email input value. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** EmailInputProperty input values. */
export type EmailInputProperty = GfFieldInput & GfFieldInputWithEmailConfirmationSetting & {
  __typename?: 'EmailInputProperty';
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** A script or stylesheet resource that should be loaded by the client. Contains information about the resource&#039;s location, dependencies, and loading behavior. */
export type EnqueuedAsset = {
  /** The inline code to be run after the asset is loaded. */
  after?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Deprecated
   * @deprecated Use `EnqueuedAsset.media` instead.
   */
  args?: Maybe<Scalars['Boolean']['output']>;
  /** The inline code to be run before the asset is loaded. */
  before?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The HTML conditional comment for the enqueued asset. E.g. IE 6, lte IE 7, etc */
  conditional?: Maybe<Scalars['String']['output']>;
  /** Dependencies needed to use this asset */
  dependencies?: Maybe<Array<Maybe<EnqueuedAsset>>>;
  /**
   * Extra information needed for the script
   * @deprecated Use `EnqueuedScript.extraData` instead.
   */
  extra?: Maybe<Scalars['String']['output']>;
  /** The loading group to which this asset belongs. */
  group?: Maybe<Scalars['Int']['output']>;
  /** The handle of the enqueued asset */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the enqueued asset */
  id: Scalars['ID']['output'];
  /** The source of the asset */
  src?: Maybe<Scalars['String']['output']>;
  /** The version of the enqueued asset */
  version?: Maybe<Scalars['String']['output']>;
};

/** Script enqueued by the CMS */
export type EnqueuedScript = EnqueuedAsset & Node & {
  __typename?: 'EnqueuedScript';
  /** The inline code to be run after the asset is loaded. */
  after?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Deprecated
   * @deprecated Use `EnqueuedAsset.media` instead.
   */
  args?: Maybe<Scalars['Boolean']['output']>;
  /** The inline code to be run before the asset is loaded. */
  before?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The HTML conditional comment for the enqueued asset. E.g. IE 6, lte IE 7, etc */
  conditional?: Maybe<Scalars['String']['output']>;
  /** Dependencies needed to use this asset */
  dependencies?: Maybe<Array<Maybe<EnqueuedScript>>>;
  /**
   * Extra information needed for the script
   * @deprecated Use `EnqueuedScript.extraData` instead.
   */
  extra?: Maybe<Scalars['String']['output']>;
  /** Extra data supplied to the enqueued script */
  extraData?: Maybe<Scalars['String']['output']>;
  /** The loading group to which this asset belongs. */
  group?: Maybe<Scalars['Int']['output']>;
  /** The location where this script should be loaded */
  groupLocation?: Maybe<ScriptLoadingGroupLocationEnum>;
  /** The handle of the enqueued asset */
  handle?: Maybe<Scalars['String']['output']>;
  /** The global ID of the enqueued script */
  id: Scalars['ID']['output'];
  /** The source of the asset */
  src?: Maybe<Scalars['String']['output']>;
  /** The loading strategy to use on the script tag */
  strategy?: Maybe<ScriptLoadingStrategyEnum>;
  /** The version of the enqueued script */
  version?: Maybe<Scalars['String']['output']>;
};

/** A paginated collection of EnqueuedScript Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of EnqueuedScript Nodes */
export type EnqueuedScriptConnection = {
  /** A list of edges (relational context) between ContentNode and connected EnqueuedScript Nodes */
  edges: Array<EnqueuedScriptConnectionEdge>;
  /** A list of connected EnqueuedScript Nodes */
  nodes: Array<EnqueuedScript>;
  /** Information about pagination in a connection. */
  pageInfo: EnqueuedScriptConnectionPageInfo;
};

/** Represents a connection to a EnqueuedScript. Contains both the EnqueuedScript Node and metadata about the relationship. */
export type EnqueuedScriptConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected EnqueuedScript Node */
  node: EnqueuedScript;
};

/** Pagination metadata specific to &quot;EnqueuedScriptConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;EnqueuedScriptConnectionEdge&quot; Nodes. */
export type EnqueuedScriptConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Stylesheet enqueued by the CMS */
export type EnqueuedStylesheet = EnqueuedAsset & Node & {
  __typename?: 'EnqueuedStylesheet';
  /** The inline code to be run after the asset is loaded. */
  after?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Deprecated
   * @deprecated Use `EnqueuedAsset.media` instead.
   */
  args?: Maybe<Scalars['Boolean']['output']>;
  /** The inline code to be run before the asset is loaded. */
  before?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The HTML conditional comment for the enqueued asset. E.g. IE 6, lte IE 7, etc */
  conditional?: Maybe<Scalars['String']['output']>;
  /** Dependencies needed to use this asset */
  dependencies?: Maybe<Array<Maybe<EnqueuedStylesheet>>>;
  /**
   * Extra information needed for the script
   * @deprecated Use `EnqueuedScript.extraData` instead.
   */
  extra?: Maybe<Scalars['String']['output']>;
  /** The loading group to which this asset belongs. */
  group?: Maybe<Scalars['Int']['output']>;
  /** The handle of the enqueued asset */
  handle?: Maybe<Scalars['String']['output']>;
  /** The global ID of the enqueued stylesheet */
  id: Scalars['ID']['output'];
  /** Whether the enqueued style is RTL or not */
  isRtl?: Maybe<Scalars['Boolean']['output']>;
  /** The media attribute to use for the link */
  media?: Maybe<Scalars['String']['output']>;
  /** The absolute path to the enqueued style. Set when the stylesheet is meant to load inline. */
  path?: Maybe<Scalars['String']['output']>;
  /** The `rel` attribute to use for the link */
  rel?: Maybe<Scalars['String']['output']>;
  /** The source of the asset */
  src?: Maybe<Scalars['String']['output']>;
  /** Optional suffix, used in combination with RTL */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The title of the enqueued style. Used for preferred/alternate stylesheets. */
  title?: Maybe<Scalars['String']['output']>;
  /** The version of the enqueued style */
  version?: Maybe<Scalars['String']['output']>;
};

/** A paginated collection of EnqueuedStylesheet Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of EnqueuedStylesheet Nodes */
export type EnqueuedStylesheetConnection = {
  /** A list of edges (relational context) between ContentNode and connected EnqueuedStylesheet Nodes */
  edges: Array<EnqueuedStylesheetConnectionEdge>;
  /** A list of connected EnqueuedStylesheet Nodes */
  nodes: Array<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  pageInfo: EnqueuedStylesheetConnectionPageInfo;
};

/** Represents a connection to a EnqueuedStylesheet. Contains both the EnqueuedStylesheet Node and metadata about the relationship. */
export type EnqueuedStylesheetConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected EnqueuedStylesheet Node */
  node: EnqueuedStylesheet;
};

/** Pagination metadata specific to &quot;EnqueuedStylesheetConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;EnqueuedStylesheetConnectionEdge&quot; Nodes. */
export type EnqueuedStylesheetConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Options for ordering the connection. */
export type EntriesConnectionOrderbyInput = {
  /** The field name used to sort the results. */
  field?: InputMaybe<Scalars['String']['input']>;
  /** Whether the sorting field's values are numeric. */
  isNumeric?: InputMaybe<Scalars['Boolean']['input']>;
  /** The cardinality of the order of the connection. */
  order?: InputMaybe<OrderEnum>;
};

/** Date Filters input fields for Entries queries. */
export type EntriesDateFiltersInput = {
  /** End date in Y-m-d H:i:s format. */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Start date in Y-m-d H:i:s format. */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** Field Filters input fields for Entries queries. */
export type EntriesFieldFiltersInput = {
  /** The field value(s) to filter by. Must be boolean values. If using this field, do not also use stringValues, intValues or floatValues. */
  boolValues?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  /** The field value(s) to filter by. Must be float values. If using this field, do not also use stringValues, intValues or boolValues. */
  floatValues?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** The field value(s) to filter by. Must be integer values. If using this field, do not also use stringValues, floatValues or boolValues. */
  intValues?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Optional. The entry meta key to filter by. You can use the ID of the form field, or the names of any of the columns in Gravity Form's database table for entries, such as "date_created", "is_read, "created_by", etc. If omitted, the value will be checked against all meta keys. . */
  key?: InputMaybe<Scalars['String']['input']>;
  /** The operator to use for filtering. */
  operator?: InputMaybe<FieldFiltersOperatorEnum>;
  /** The field value(s) to filter by. Must be string values. If using this field, do not also use intValues, floatValues or boolValues. */
  stringValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The Type of Identifier used to fetch a single resource. */
export enum EntryIdTypeEnum {
  /** The database ID assigned by Gravity Forms. Used by submitted entries. */
  DatabaseId = 'DATABASE_ID',
  /** Unique global ID for the object. */
  Id = 'ID',
  /** The resume token assigned by Gravity Forms. Used by draft entries. */
  ResumeToken = 'RESUME_TOKEN'
}

/** Status of entries to get. Default is ACTIVE. */
export enum EntryStatusEnum {
  /** Active entries (default). */
  Active = 'ACTIVE',
  /** All entries. */
  All = 'ALL',
  /** Spam entries. */
  Spam = 'SPAM',
  /** Entries in the trash. */
  Trash = 'TRASH'
}

/** The type of Gravity Forms entry. */
export enum EntryTypeEnum {
  /** A Gravity Forms draft entry. */
  Draft = 'DRAFT',
  /** A Gravity Forms partial entry. */
  Partial = 'PARTIAL',
  /** A submitted Gravity Forms entry. */
  Submitted = 'SUBMITTED'
}

/** The &quot;FactoringInfoGraphic&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type FactoringInfoGraphic = AcfFieldGroup & AcfFieldGroupFields & FactoringInfoGraphic_Fields & {
  __typename?: 'FactoringInfoGraphic';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;FactoringInfoGraphic&quot; Field Group */
  items?: Maybe<Array<Maybe<FactoringInfoGraphicItems>>>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FactoringInfoGraphic&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;FactoringInfoGraphicItems&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type FactoringInfoGraphicItems = AcfFieldGroup & AcfFieldGroupFields & FactoringInfoGraphicItems_Fields & {
  __typename?: 'FactoringInfoGraphicItems';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FactoringInfoGraphicItems&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;FactoringInfoGraphicItems&quot; Field Group */
export type FactoringInfoGraphicItems_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FactoringInfoGraphicItems&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;FactoringInfoGraphic&quot; Field Group */
export type FactoringInfoGraphic_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;FactoringInfoGraphic&quot; Field Group */
  items?: Maybe<Array<Maybe<FactoringInfoGraphicItems>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FactoringInfoGraphic&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Field error. */
export type FieldError = {
  __typename?: 'FieldError';
  /** The form field that the error is connected to. */
  connectedFormField?: Maybe<FormField>;
  /** The field with the associated error message. */
  id?: Maybe<Scalars['Float']['output']>;
  /** Error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Whether to filter by ALL or ANY of the field filters. Default is ALL. */
export enum FieldFiltersModeEnum {
  /** All field filters (default). */
  All = 'ALL',
  /** Any field filters. */
  Any = 'ANY'
}

/** The operator to use for filtering. */
export enum FieldFiltersOperatorEnum {
  /** Find field values that contain the passed value. Only one value may be passed when using this operator. SQL Equivalent: `LIKE %value%`. */
  Contains = 'CONTAINS',
  /** Default. Find field values that are equal to one of the values in the passed array. Default. */
  In = 'IN',
  /** Find field values that are an exact match for the passed value. Only one value may be passed when using this operator. SQL Equivalent: `=`. */
  Is = 'IS',
  /** Find field values that are NOT an exact match for the passed value. Only one value may be passed when using this operator. SQL Equivalent: `NOT`. */
  IsNot = 'IS_NOT',
  /** Find field values that are an exact match for the passed value. SQL wildcards are supported. Only one value may be passed when using this operator. SQL Equivalent: `LIKE`. */
  Like = 'LIKE',
  /** Find field values that do NOT match those in the values array. */
  NotIn = 'NOT_IN'
}

/** A Gravity Forms fileupload field. */
export type FileUploadField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithFileExtensionsSetting & GfFieldWithFileSizeSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithMultipleFilesSetting & GfFieldWithPersonalData & GfFieldWithRulesSetting & Node & {
  __typename?: 'FileUploadField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** A comma-delimited list of the file extensions which may be uploaded. */
  allowedExtensions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Indicates whether multiple files may be uploaded. */
  canAcceptMultipleFiles?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** File upload value */
  fileUploadValues?: Maybe<Array<Maybe<FileUploadFieldValue>>>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The maximum size (in MB) an uploaded file may be . */
  maxFileSize?: Maybe<Scalars['Int']['output']>;
  /** When the field is set to allow multiple files to be uploaded, this property is available to set a limit on how many may be uploaded. */
  maxFiles?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** The individual file properties from an uploaded file. */
export type FileUploadFieldValue = {
  __typename?: 'FileUploadFieldValue';
  /** The path to the parent directory of the file. */
  basePath?: Maybe<Scalars['String']['output']>;
  /** The base url to the parent directory of the file. */
  baseUrl?: Maybe<Scalars['String']['output']>;
  /** The filename. */
  filename?: Maybe<Scalars['String']['output']>;
  /** The url to the file. */
  url?: Maybe<Scalars['String']['output']>;
};

/** The &quot;FinancingCta&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type FinancingCta = AcfFieldGroup & AcfFieldGroupFields & FinancingCta_Fields & {
  __typename?: 'FinancingCta';
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;FinancingCta&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FinancingCta&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;FinancingCta&quot; Field Group */
  keyPoints?: Maybe<Array<Maybe<FinancingCtaKeyPoints>>>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FinancingCta&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;FinancingCtaKeyPoints&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type FinancingCtaKeyPoints = AcfFieldGroup & AcfFieldGroupFields & FinancingCtaKeyPoints_Fields & {
  __typename?: 'FinancingCtaKeyPoints';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FinancingCtaKeyPoints&quot; Field Group */
  field?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FinancingCtaKeyPoints&quot; Field Group */
  value?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;FinancingCtaKeyPoints&quot; Field Group */
export type FinancingCtaKeyPoints_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FinancingCtaKeyPoints&quot; Field Group */
  field?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FinancingCtaKeyPoints&quot; Field Group */
  value?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;FinancingCta&quot; Field Group */
export type FinancingCta_Fields = {
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;FinancingCta&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FinancingCta&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;FinancingCta&quot; Field Group */
  keyPoints?: Maybe<Array<Maybe<FinancingCtaKeyPoints>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FinancingCta&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Gravity Forms button. */
export type FormButton = {
  __typename?: 'FormButton';
  /** Controls when the form button should be visible based on values selected on the form. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** Contains the URL for the image button. Only applicable when type is set to image. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Contains the button text. Only applicable when type is set to text. */
  text?: Maybe<Scalars['String']['output']>;
  /** Specifies the type of button to be displayed. Defaults to TEXT. */
  type?: Maybe<FormButtonTypeEnum>;
};

/** Type of button to be displayed. Default is TEXT. */
export enum FormButtonTypeEnum {
  /** Image button. */
  Image = 'IMAGE',
  /** Text button (default). */
  Text = 'TEXT'
}

/** Properties for all the email notifications which exist for a form. */
export type FormConfirmation = {
  __typename?: 'FormConfirmation';
  /** Controls which form confirmation message should be displayed. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** ID. */
  id?: Maybe<Scalars['String']['output']>;
  /** Whether the confirmation is active or inactive. The default confirmation is always active. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the confirmation message should be formatted so that paragraphs are automatically added for new lines. */
  isAutoformatted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is the default confirmation. */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the confirmation message that will be displayed. Only applicable when type is set to &quot;MESSAGE&quot;. */
  message?: Maybe<Scalars['String']['output']>;
  /** The confirmation name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The page that the browser will be redirected to. Only applicable when type is set to `PAGE`. */
  page?: Maybe<FormConfirmationToPageConnectionEdge>;
  /** Contains the Id of the WordPress page that the browser will be redirected to. Only applicable when type is set to `PAGE`. */
  pageId?: Maybe<Scalars['Int']['output']>;
  /** Contains the query string to be appended to the redirection url. Only applicable when type is set to `REDIRECT`. */
  queryString?: Maybe<Scalars['String']['output']>;
  /** Determines the type of confirmation to be used. */
  type?: Maybe<FormConfirmationTypeEnum>;
  /** Contains the URL that the browser will be redirected to. Only applicable when type is set to `REDIRECT`. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Connection between the FormConfirmation type and the Page type */
export type FormConfirmationToPageConnectionEdge = Edge & OneToOneConnection & PageConnectionEdge & {
  __typename?: 'FormConfirmationToPageConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: Page;
};

/** Type of form confirmation to be used. */
export enum FormConfirmationTypeEnum {
  /** Use a confirmation "message". */
  Message = 'MESSAGE',
  /** Use a redirect to a different WordPress "page". */
  Page = 'PAGE',
  /** Use a "redirect" to a given URL. */
  Redirect = 'REDIRECT'
}

/** The &quot;FormContentBlock&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type FormContentBlock = AcfFieldGroup & AcfFieldGroupFields & FormContentBlock_Fields & {
  __typename?: 'FormContentBlock';
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;FormContentBlock&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;FormContentBlock&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;FormContentBlock&quot; Field Group */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** The Gravity Form associated with this ACF block */
  gravityForm?: Maybe<GfForm>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FormContentBlock&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;FormContentBlock&quot; Field Group */
  titlePlacement?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;FormContentBlock&quot; Field Group */
export type FormContentBlock_Fields = {
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;FormContentBlock&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;FormContentBlock&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;FormContentBlock&quot; Field Group */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FormContentBlock&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;FormContentBlock&quot; Field Group */
  titlePlacement?: Maybe<Scalars['String']['output']>;
};

/** The policies governing which entry data to include when erasing and exporting personal data. */
export type FormDataPolicies = {
  __typename?: 'FormDataPolicies';
  /** Whether entry data from this form is included when erasing and exporting personal data. */
  canExportAndErase?: Maybe<Scalars['Boolean']['output']>;
  /** The individual entry data exporting and erasing policies. */
  entryData?: Maybe<Array<Maybe<FormEntryDataPolicy>>>;
  /** The database ID of the Gravity Forms field used to identify the user. */
  identificationFieldDatabaseId?: Maybe<Scalars['Int']['output']>;
};

/** Determines where the field description is displayed relative to the field. */
export enum FormDescriptionPlacementEnum {
  /** The field description is displayed above the field input (i.e. immediately after the field label). */
  Above = 'ABOVE',
  /** The field description is displayed below the field input. */
  Below = 'BELOW'
}

/** The individual entry data exporting and erasing policies. */
export type FormEntryDataPolicy = {
  __typename?: 'FormEntryDataPolicy';
  /** The array key for the Gravity Forms Entry. */
  key?: Maybe<Scalars['String']['output']>;
  /** Whether this field should be included when erasing personal data. */
  shouldErase?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this field should be included when exporting personal data. */
  shouldExport?: Maybe<Scalars['Boolean']['output']>;
};

/** Gravity Forms form entry limititation details. */
export type FormEntryLimits = {
  __typename?: 'FormEntryLimits';
  /** Whether the form has a limit on the number of submissions. */
  hasLimit?: Maybe<Scalars['Boolean']['output']>;
  /** Message that will be displayed when the maximum number of submissions have been reached. */
  limitReachedMessage?: Maybe<Scalars['String']['output']>;
  /** The time period during which submissions are allowed. */
  limitationPeriod?: Maybe<FormLimitEntriesPeriodEnum>;
  /** The number of submissions allowed. */
  maxEntries?: Maybe<Scalars['Int']['output']>;
};

/** Gravity Forms field. */
export type FormField = {
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Global ID. */
  id: Scalars['ID']['output'];
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** How the date field displays its calendar icon. */
export enum FormFieldCalendarIconTypeEnum {
  /** Default calendar icon. */
  Calendar = 'CALENDAR',
  /** Custom calendar icon. */
  Custom = 'CUSTOM',
  /** No calendar icon. */
  None = 'NONE'
}

/** A paginated collection of FormField Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of FormField Nodes */
export type FormFieldConnection = {
  /** A list of edges (relational context) between SubmitGfFormPayload and connected FormField Nodes */
  edges: Array<FormFieldConnectionEdge>;
  /** A list of connected FormField Nodes */
  nodes: Array<FormField>;
  /** Information about pagination in a connection. */
  pageInfo: FormFieldConnectionPageInfo;
};

/** Represents a connection to a FormField. Contains both the FormField Node and metadata about the relationship. */
export type FormFieldConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected FormField Node */
  node: FormField;
};

/** Pagination metadata specific to &quot;FormFieldConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;FormFieldConnectionEdge&quot; Nodes. */
export type FormFieldConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** The form field-specifc policies for exporting and erasing personal data. */
export type FormFieldDataPolicy = {
  __typename?: 'FormFieldDataPolicy';
  /** Whether this field is used to identify the user&#039;s personal data. */
  isIdentificationField?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this field should be included when erasing personal data. */
  shouldErase?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this field should be included when exporting personal data. */
  shouldExport?: Maybe<Scalars['Boolean']['output']>;
};

/** Determines where the field description is displayed relative to the field. */
export enum FormFieldDescriptionPlacementEnum {
  /** The field description is displayed above the field input (i.e. immediately after the field label). */
  Above = 'ABOVE',
  /** The field description is displayed below the field input. */
  Below = 'BELOW',
  /** The field description is inherited from the form default settings. */
  Inherit = 'INHERIT'
}

/** The field label position. Empty when using the form defaults or a value of "hidden_label". */
export enum FormFieldLabelPlacementEnum {
  /** Field label is hidden. */
  Hidden = 'HIDDEN',
  /** Field label is inherited from the form defaults. */
  Inherit = 'INHERIT',
  /** Field label is displayed beside the fields and aligned to the left. */
  Left = 'LEFT',
  /** Field label is displayed beside the fields and aligned to the right. */
  Right = 'RIGHT',
  /** Field label is displayed on top of the fields. */
  Top = 'TOP'
}

/** Type of indicator to use when field is required. */
export enum FormFieldRequiredIndicatorEnum {
  /** Asterisk (*) indicator. */
  Asterisk = 'ASTERISK',
  /** Custom indicator. */
  Custom = 'CUSTOM',
  /** Text (Required) indicator (default). */
  Text = 'TEXT'
}

/** The size of the field when displayed on the page. */
export enum FormFieldSizeEnum {
  /** Large field size. */
  Large = 'LARGE',
  /** Medium field size. */
  Medium = 'MEDIUM',
  /** Small field size. */
  Small = 'SMALL'
}

/** Determines how sub-labels are aligned. */
export enum FormFieldSubLabelPlacementEnum {
  /** The sub-label is displayed above the sub-field input (i.e. immediately after the field label). */
  Above = 'ABOVE',
  /** The sub-label is displayed below the sub-field input. */
  Below = 'BELOW',
  /** Field label is inherited from the form defaults. */
  Inherit = 'INHERIT'
}

/** Gravity Forms Field Type. */
export enum FormFieldTypeEnum {
  /** A Gravity Forms address field. */
  Address = 'ADDRESS',
  /** A Gravity Forms calculation field. */
  Calculation = 'CALCULATION',
  /** A Gravity Forms captcha field. */
  Captcha = 'CAPTCHA',
  /** A Gravity Forms checkbox field. */
  Checkbox = 'CHECKBOX',
  /** A Gravity Forms consent field. */
  Consent = 'CONSENT',
  /** A Gravity Forms date field. */
  Date = 'DATE',
  /** A Gravity Forms email field. */
  Email = 'EMAIL',
  /** A Gravity Forms fileupload field. */
  Fileupload = 'FILEUPLOAD',
  /** A Gravity Forms hidden field. */
  Hidden = 'HIDDEN',
  /** A Gravity Forms hiddenproduct field. */
  Hiddenproduct = 'HIDDENPRODUCT',
  /** A Gravity Forms html field. */
  Html = 'HTML',
  /** A Gravity Forms image_choice field. */
  ImageChoice = 'IMAGE_CHOICE',
  /** A Gravity Forms list field. */
  List = 'LIST',
  /** A Gravity Forms multiselect field. */
  Multiselect = 'MULTISELECT',
  /** A Gravity Forms multi_choice field. */
  MultiChoice = 'MULTI_CHOICE',
  /** A Gravity Forms name field. */
  Name = 'NAME',
  /** A Gravity Forms number field. */
  Number = 'NUMBER',
  /** A Gravity Forms option field. */
  Option = 'OPTION',
  /** A Gravity Forms page field. */
  Page = 'PAGE',
  /** A Gravity Forms password field. */
  Password = 'PASSWORD',
  /** A Gravity Forms phone field. */
  Phone = 'PHONE',
  /** A Gravity Forms post_category field. */
  PostCategory = 'POST_CATEGORY',
  /** A Gravity Forms post_content field. */
  PostContent = 'POST_CONTENT',
  /** A Gravity Forms post_custom_field field. */
  PostCustomField = 'POST_CUSTOM_FIELD',
  /** A Gravity Forms post_excerpt field. */
  PostExcerpt = 'POST_EXCERPT',
  /** A Gravity Forms post_image field. */
  PostImage = 'POST_IMAGE',
  /** A Gravity Forms post_tags field. */
  PostTags = 'POST_TAGS',
  /** A Gravity Forms post_title field. */
  PostTitle = 'POST_TITLE',
  /** A Gravity Forms price field. */
  Price = 'PRICE',
  /** A Gravity Forms product field. */
  Product = 'PRODUCT',
  /** A Gravity Forms quantity field. */
  Quantity = 'QUANTITY',
  /** A Gravity Forms radio field. */
  Radio = 'RADIO',
  /** A Gravity Forms section field. */
  Section = 'SECTION',
  /** A Gravity Forms select field. */
  Select = 'SELECT',
  /** A Gravity Forms shipping field. */
  Shipping = 'SHIPPING',
  /** A Gravity Forms singleproduct field. */
  Singleproduct = 'SINGLEPRODUCT',
  /** A Gravity Forms singleshipping field. */
  Singleshipping = 'SINGLESHIPPING',
  /** A Gravity Forms text field. */
  Text = 'TEXT',
  /** A Gravity Forms textarea field. */
  Textarea = 'TEXTAREA',
  /** A Gravity Forms time field. */
  Time = 'TIME',
  /** A Gravity Forms total field. */
  Total = 'TOTAL',
  /** A Gravity Forms website field. */
  Website = 'WEBSITE'
}

/** Field values input. Includes a field id, and a valid value Input. */
export type FormFieldValuesInput = {
  /** The form field values for Address fields. */
  addressValues?: InputMaybe<AddressFieldInput>;
  /** The form field values for Checkbox fields. */
  checkboxValues?: InputMaybe<Array<InputMaybe<CheckboxFieldInput>>>;
  /** The form field values for Email fields. */
  emailValues?: InputMaybe<EmailFieldInput>;
  /** The field id. */
  id: Scalars['Int']['input'];
  /** The form field values for List fields. */
  listValues?: InputMaybe<Array<InputMaybe<ListFieldInput>>>;
  /** The form field values for Name fields. */
  nameValues?: InputMaybe<NameFieldInput>;
  /** The form field values for Name fields. */
  productValues?: InputMaybe<ProductFieldInput>;
  /** The form field values for basic fields. */
  value?: InputMaybe<Scalars['String']['input']>;
  /** The form field values for fields that accept multiple string values. Used by MultiSelect, Post Category, Post Custom, and Post Tags fields. */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Field visibility. */
export enum FormFieldVisibilityEnum {
  /** The field is for "administrative" use. */
  Administrative = 'ADMINISTRATIVE',
  /** The field is "hidden". */
  Hidden = 'HIDDEN',
  /** The field is "visible". */
  Visible = 'VISIBLE'
}

/** The Type of Identifier used to fetch a single resource. */
export enum FormIdTypeEnum {
  /** The database ID assigned by Gravity Forms. */
  DatabaseId = 'DATABASE_ID',
  /** Unique global ID for the object. */
  Id = 'ID'
}

/** Determines where the field labels should be placed in relation to the field. */
export enum FormLabelPlacementEnum {
  /** Field labels are displayed beside the fields and aligned to the left. */
  Left = 'LEFT',
  /** Field labels are displayed beside the fields and aligned to the right. */
  Right = 'RIGHT',
  /** Field labels are displayed on top of the fields. */
  Top = 'TOP'
}

/** Gravity Forms button. */
export type FormLastPageButton = {
  __typename?: 'FormLastPageButton';
  /** Contains the URL for the image button. Only applicable when type is set to image. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Contains the button text. Only applicable when type is set to text. */
  text?: Maybe<Scalars['String']['output']>;
  /** Specifies the type of button to be displayed. Defaults to TEXT. */
  type?: Maybe<FormButtonTypeEnum>;
};

/** When limitEntries is set to 1, this property specifies the time period during which submissions are allowed. */
export enum FormLimitEntriesPeriodEnum {
  /** Limit entries by "day". */
  Day = 'DAY',
  /** Limit entries by "month". */
  Month = 'MONTH',
  /** Limit entries by "week". */
  Week = 'WEEK',
  /** Limit entries by "year". */
  Year = 'YEAR'
}

/** Gravity Forms form login requirements data. */
export type FormLogin = {
  __typename?: 'FormLogin';
  /** Whether the form is configured to be displayed only to logged in users. */
  isLoginRequired?: Maybe<Scalars['Boolean']['output']>;
  /** When `isLoginRequired` is set to true, this controls the message displayed when non-logged in user tries to access the form. */
  loginRequiredMessage?: Maybe<Scalars['String']['output']>;
};

/** Properties for all the email notifications which exist for a form. */
export type FormNotification = {
  __typename?: 'FormNotification';
  /** The email or merge tags to be used as the email bcc address. */
  bcc?: Maybe<Scalars['String']['output']>;
  /** An associative array containing the conditional logic rules. See the Conditional Logic Object for more details. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** The notification event. Default is form_submission. */
  event?: Maybe<Scalars['String']['output']>;
  /** The email or merge tag to be used as the email from address. */
  from?: Maybe<Scalars['String']['output']>;
  /** The text or merge tag to be used as the email from name. */
  fromName?: Maybe<Scalars['String']['output']>;
  /** The notification ID. A 13 character unique ID. */
  id?: Maybe<Scalars['String']['output']>;
  /** Is the notification active or inactive. The default is true (active). */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the email message should be formatted so that paragraphs are automatically added for new lines. */
  isAutoformatted?: Maybe<Scalars['Boolean']['output']>;
  /** The email body/content. Merge tags supported. */
  message?: Maybe<Scalars['String']['output']>;
  /** The notification name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The email or merge tags to be used as the email reply to address. */
  replyTo?: Maybe<Scalars['String']['output']>;
  /** Routing rules. */
  routing?: Maybe<Array<Maybe<FormNotificationRouting>>>;
  /** The name of the service to be used when sending this notification. Default is wordpress. */
  service?: Maybe<Scalars['String']['output']>;
  /** Determines if files uploaded on the form should be included when the notification is sent. */
  shouldSendAttachments?: Maybe<Scalars['Boolean']['output']>;
  /** The email subject line. Merge tags supported. */
  subject?: Maybe<Scalars['String']['output']>;
  /** The ID of an email field, an email address or merge tag to be used as the email to address. */
  to?: Maybe<Scalars['String']['output']>;
  /** Identifies what to use for the notification &quot;to&quot;. */
  toType?: Maybe<FormNotificationToTypeEnum>;
};

/** Properties for all the email notifications which exist for a form. */
export type FormNotificationRouting = {
  __typename?: 'FormNotificationRouting';
  /** The email or merge tag to be used as the email To address if this rule is a match. */
  email?: Maybe<Scalars['String']['output']>;
  /** Target field ID. The field that will have it’s value compared with the value property to determine if this rule is a match. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  /** Operator to be used when evaluating this rule. */
  operator?: Maybe<FormRuleOperatorEnum>;
  /** The value to compare with the field specified by fieldId. */
  value?: Maybe<Scalars['String']['output']>;
};

/** What to use for the notification "to". */
export enum FormNotificationToTypeEnum {
  /** Email address. */
  Email = 'EMAIL',
  /** Form field. */
  Field = 'FIELD',
  /** Hidden. */
  Hidden = 'HIDDEN',
  /** Routing using conditional rules. */
  Routing = 'ROUTING'
}

/** Style of progress bar. */
export enum FormPageProgressStyleEnum {
  /** Blue progress bar style. */
  Blue = 'BLUE',
  /** Custom progress bar style. */
  Custom = 'CUSTOM',
  /** Green progress bar style. */
  Green = 'GREEN',
  /** Grey progress bar style. */
  Grey = 'GREY',
  /** Orange progress bar style. */
  Orange = 'ORANGE',
  /** Red progress bar style. */
  Red = 'RED'
}

/** Type of page progress indicator to be displayed. */
export enum FormPageProgressTypeEnum {
  /** Don't show a page progress indicator. */
  None = 'NONE',
  /** Show page progress indicator as a percentage. */
  Percentage = 'PERCENTAGE',
  /** Show page progress indicator as steps. */
  Steps = 'STEPS'
}

/** Gravity Forms form pagination data. */
export type FormPagination = {
  __typename?: 'FormPagination';
  /** Progress bar background color. Can be any CSS color value. Only applies when `style` is set to &quot;CUSTOM&quot;. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Progress bar text color. Can be any CSS color value. Only applies when `style` is set to &quot;CUSTOM&quot;. */
  color?: Maybe<Scalars['String']['output']>;
  /** Whether the confirmation bar should be displayed with the confirmation text. */
  hasProgressbarOnConfirmation?: Maybe<Scalars['Boolean']['output']>;
  /** Last page button data. */
  lastPageButton?: Maybe<FormLastPageButton>;
  /** Names of the form&#039;s pages. */
  pageNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The confirmation text to display once the end of the progress bar has been reached. Only applies when `hasProgressbarOnConfirmation` is set to true. */
  progressbarCompletionText?: Maybe<Scalars['String']['output']>;
  /** Style of progress bar. */
  style?: Maybe<FormPageProgressStyleEnum>;
  /** Type of progress indicator. */
  type?: Maybe<FormPageProgressTypeEnum>;
};

/** Gravity Forms form Personal Data settings. */
export type FormPersonalData = {
  __typename?: 'FormPersonalData';
  /** The policies governing which entry data to include when erasing and exporting personal data. */
  dataPolicies?: Maybe<FormDataPolicies>;
  /** The number of days to retain entries. `null` if `retentionPolicy` is set to `RETAIN` entries indefinitely. */
  daysToRetain?: Maybe<Scalars['Int']['output']>;
  /** The policy for retaining old entry data. */
  retentionPolicy?: Maybe<FormRetentionPolicyEnum>;
  /** Whether the IP address should be saved to the form submission. */
  shouldSaveIP?: Maybe<Scalars['Boolean']['output']>;
};

/** Gravity Forms form entry limititation details. */
export type FormPostCreation = {
  __typename?: 'FormPostCreation';
  /** When `useCurrentUserAsAuthor` is `false`, this contains the User object for the author. */
  author?: Maybe<User>;
  /** When `useCurrentUserAsAuthor` is `false`, this property contains the user database that will be used as the Post author. */
  authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** When `useCurrentUserAsAuthor` is `false`, this property contains the user ID that will be used as the Post author. */
  authorId?: Maybe<Scalars['ID']['output']>;
  /** Form forms with Post fields, but without a Post Category field, this property contains the default category database ID the post will be associated with when created. */
  categoryDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Template to be used when creating the post content. Field variables (i.e. {Name:3} ) can be added to the template to insert user submitted values into the post content. Only applicable when `hasContentTemplate` is `true`. */
  contentTemplate?: Maybe<Scalars['String']['output']>;
  /** Determines the format that the Post should be created with. */
  format?: Maybe<PostFormatTypeEnum>;
  /** Determines if the post template functionality is enabled. When enabled, the post content will be created based on the template specified by `contentTemplate`. */
  hasContentTemplate?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the post title template functionality is enabled. When enabled, the post title will be created based on the template specified by `titleTemplate`. */
  hasTitleTemplate?: Maybe<Scalars['Boolean']['output']>;
  /** For forms with Post fields, this determines if the post should be created using the current logged in user as the author. */
  shouldUseCurrentUserAsAuthor?: Maybe<Scalars['Boolean']['output']>;
  /** For forms with Post fields, determines the status that the Post should be created with. */
  status?: Maybe<Scalars['String']['output']>;
  /** Template to be used when creating the post title. Field variables (i.e. {Name:3} ) can be added to the template to insert user submitted values into the post title. Only applicable when `hasTitleTemplate` is `true`. */
  titleTemplate?: Maybe<Scalars['String']['output']>;
};

/** The Personal Data retention policy. */
export enum FormRetentionPolicyEnum {
  /** Entries will be deleted automatically after a specified number of days. */
  Delete = 'DELETE',
  /** Entries will be retain indefinitely. */
  Retain = 'RETAIN',
  /** Entries will be trashed automatically after a specified number of days. */
  Trash = 'TRASH'
}

/** Operator to be used when evaluating logic rules. */
export enum FormRuleOperatorEnum {
  /** Evaluates values that CONTAIN the comparison value. */
  Contains = 'CONTAINS',
  /** Evaluates values that END with the comparison value. */
  EndsWith = 'ENDS_WITH',
  /** Evaluates values that are GREATER than the comparison value. */
  GreaterThan = 'GREATER_THAN',
  /** Evaluates values that match the comparison value. */
  Is = 'IS',
  /** Evaluates values that do NOT match the comparison value. */
  IsNot = 'IS_NOT',
  /** Evaluates values that are LESS than the comparison value. */
  LessThan = 'LESS_THAN',
  /** Evaluates values that START with the comparison value. */
  StartsWith = 'STARTS_WITH'
}

/** Gravity Forms form Save and Continue data. */
export type FormSaveAndContinue = {
  __typename?: 'FormSaveAndContinue';
  /** Contains the save button text. */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Whether the Save And Continue feature is enabled. */
  hasSaveAndContinue?: Maybe<Scalars['Boolean']['output']>;
};

/** Gravity Forms form scheduling data. */
export type FormSchedule = {
  __typename?: 'FormSchedule';
  /** Message to be displayed when form is no longer available. */
  closedMessage?: Maybe<Scalars['String']['output']>;
  /** The Date/time details when the form will become inactive. */
  endDetails?: Maybe<FormScheduleDetails>;
  /** Specifies if this form is scheduled to be displayed only during a certain configured date/time. */
  hasSchedule?: Maybe<Scalars['Boolean']['output']>;
  /** Message to be displayed when form is not yet available. */
  pendingMessage?: Maybe<Scalars['String']['output']>;
  /** The Date/time details when the form will become active/visible. */
  startDetails?: Maybe<FormScheduleDetails>;
};

/** Gravity Forms form scheduling data. */
export type FormScheduleDetails = {
  __typename?: 'FormScheduleDetails';
  /** Whether the date is in the AM or PM of a 12-hour clock. */
  amPm?: Maybe<AmPmEnum>;
  /** The schedule date in local time. */
  date?: Maybe<Scalars['String']['output']>;
  /** The schedule date in GMT. */
  dateGmt?: Maybe<Scalars['String']['output']>;
  /** The hour (1-12). */
  hour?: Maybe<Scalars['Int']['output']>;
  /** The minute. */
  minute?: Maybe<Scalars['Int']['output']>;
};

/** Status of forms to get. Default is ACTIVE. */
export enum FormStatusEnum {
  /** Active forms (default). */
  Active = 'ACTIVE',
  /** Inactive forms. */
  Inactive = 'INACTIVE',
  /** Inactive forms in the trash. */
  InactiveTrashed = 'INACTIVE_TRASHED',
  /** Active forms in the trash. */
  Trashed = 'TRASHED'
}

/** Determines how sub-labels are aligned. */
export enum FormSubLabelPlacementEnum {
  /** The sub-label is displayed above the sub-field input (i.e. immediately after the field label). */
  Above = 'ABOVE',
  /** The sub-label is displayed below the sub-field input. */
  Below = 'BELOW'
}

/** Gravity Forms submit button. */
export type FormSubmitButton = {
  __typename?: 'FormSubmitButton';
  /** Controls when the form button should be visible based on values selected on the form. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** Contains the URL for the image button. Only applicable when type is set to image. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** Where the submit button should be located. */
  location?: Maybe<FormSubmitButtonLocationEnum>;
  /** Contains the button text. Only applicable when type is set to text. */
  text?: Maybe<Scalars['String']['output']>;
  /** Specifies the type of button to be displayed. Defaults to TEXT. */
  type?: Maybe<FormButtonTypeEnum>;
  /** The width of the submit button element. */
  width?: Maybe<FormSubmitButtonWidthEnum>;
};

/** Where the submit button should be located. */
export enum FormSubmitButtonLocationEnum {
  /** The submit button will be placed in a new row after all fields of the form. */
  Bottom = 'BOTTOM',
  /** The submit button will be placed on the last row of the form where it will fill the remaining space left by field columns. */
  Inline = 'INLINE'
}

/** Submit button width. */
export enum FormSubmitButtonWidthEnum {
  /** The width is set to match that of the button text. */
  Auto = 'AUTO',
  /** The width is set to fill 100% of the container. */
  Full = 'FULL'
}

/** Type of button to be displayed. Default is TEXT. */
export enum FormsConnectionOrderByEnum {
  /** The date the form was created. */
  DateCreated = 'DATE_CREATED',
  /** The database ID of the form. */
  Id = 'ID',
  /** The Form's active status. */
  IsActive = 'IS_ACTIVE',
  /** The form's trash status . */
  IsTrash = 'IS_TRASH',
  /** The title of the form. */
  Title = 'TITLE'
}

/** Options for ordering the connection. */
export type FormsConnectionOrderbyInput = {
  /** The form column name used to sort the results. */
  column?: InputMaybe<FormsConnectionOrderByEnum>;
  /** The cardinality of the order of the connection. */
  order?: InputMaybe<OrderEnum>;
};

export type FrontEndConfiguration = AcfOptionsPage & Node & WithAcfFrontEndConfigurationBlock & {
  __typename?: 'FrontEndConfiguration';
  /** Fields of the FrontEndConfigurationBlock ACF Field Group */
  frontEndConfigurationBlock?: Maybe<FrontEndConfigurationBlock>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  menuTitle?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
};

/** The &quot;FrontEndConfigurationBlock&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type FrontEndConfigurationBlock = AcfFieldGroup & AcfFieldGroupFields & FrontEndConfigurationBlock_Fields & {
  __typename?: 'FrontEndConfigurationBlock';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** This is the complete URL for the client application, beginning with https:// */
  frontEndUrl?: Maybe<Scalars['String']['output']>;
  /** Allows the WordPress server to selectively revalidate individual pages &amp; posts after saving changes. This should be a secure, randomly-generated value like UUID */
  revalidationToken?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;FrontEndConfigurationBlock&quot; Field Group */
export type FrontEndConfigurationBlock_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** This is the complete URL for the client application, beginning with https:// */
  frontEndUrl?: Maybe<Scalars['String']['output']>;
  /** Allows the WordPress server to selectively revalidate individual pages &amp; posts after saving changes. This should be a secure, randomly-generated value like UUID */
  revalidationToken?: Maybe<Scalars['String']['output']>;
};

/** The &quot;FuelSavingsCalculator&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type FuelSavingsCalculator = AcfFieldGroup & AcfFieldGroupFields & FuelSavingsCalculator_Fields & {
  __typename?: 'FuelSavingsCalculator';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FuelSavingsCalculator&quot; Field Group */
  marketoFormId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;number&quot; Field Type added to the schema as part of the &quot;FuelSavingsCalculator&quot; Field Group */
  multiplier?: Maybe<Scalars['Float']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;FuelSavingsCalculator&quot; Field Group */
  outroCopy?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FuelSavingsCalculator&quot; Field Group */
  sectionTitle?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;FuelSavingsCalculator&quot; Field Group */
export type FuelSavingsCalculator_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FuelSavingsCalculator&quot; Field Group */
  marketoFormId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;number&quot; Field Type added to the schema as part of the &quot;FuelSavingsCalculator&quot; Field Group */
  multiplier?: Maybe<Scalars['Float']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;FuelSavingsCalculator&quot; Field Group */
  outroCopy?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;FuelSavingsCalculator&quot; Field Group */
  sectionTitle?: Maybe<Scalars['String']['output']>;
};

/** The general setting type */
export type GeneralSettings = {
  __typename?: 'GeneralSettings';
  /** A date format for all date strings. */
  dateFormat?: Maybe<Scalars['String']['output']>;
  /** Site tagline. */
  description?: Maybe<Scalars['String']['output']>;
  /** This address is used for admin purposes, like new user notification. */
  email?: Maybe<Scalars['String']['output']>;
  /** WordPress locale code. */
  language?: Maybe<Scalars['String']['output']>;
  /** A day number of the week that the week should start on. */
  startOfWeek?: Maybe<Scalars['Int']['output']>;
  /** A time format for all time strings. */
  timeFormat?: Maybe<Scalars['String']['output']>;
  /** A city in the same timezone as you. */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Site title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Site URL. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Input for the generateAuthorizationCode mutation. */
export type GenerateAuthorizationCodeInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email for WordPress user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Password for WordPress user */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Username for WordPress user */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the generateAuthorizationCode mutation. */
export type GenerateAuthorizationCodePayload = {
  __typename?: 'GenerateAuthorizationCodePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Authorization code used for requesting refresh/access tokens */
  code?: Maybe<Scalars['String']['output']>;
  /** Error encountered during user authentication, if any */
  error?: Maybe<Scalars['String']['output']>;
};

/** Currencies supported by Gravity Forms. */
export enum GfCurrencyEnum {
  /** Australian Dollar . */
  Aud = 'AUD',
  /** Brazilian Real . */
  Brl = 'BRL',
  /** Canadian Dollar . */
  Cad = 'CAD',
  /** Swiss Franc . */
  Chf = 'CHF',
  /** Czech Koruna . */
  Czk = 'CZK',
  /** Danish Krone . */
  Dkk = 'DKK',
  /** Euro . */
  Eur = 'EUR',
  /** Pound Sterling . */
  Gbp = 'GBP',
  /** Hong Kong Dollar . */
  Hkd = 'HKD',
  /** Hungarian Forint . */
  Huf = 'HUF',
  /** Israeli New Sheqel . */
  Ils = 'ILS',
  /** Japanese Yen . */
  Jpy = 'JPY',
  /** Mexican Peso . */
  Mxn = 'MXN',
  /** Malaysian Ringgit . */
  Myr = 'MYR',
  /** Norwegian Krone . */
  Nok = 'NOK',
  /** New Zealand Dollar . */
  Nzd = 'NZD',
  /** Philippine Peso . */
  Php = 'PHP',
  /** Polish Zloty . */
  Pln = 'PLN',
  /** Russian Ruble . */
  Rub = 'RUB',
  /** Swedish Krona . */
  Sek = 'SEK',
  /** Singapore Dollar . */
  Sgd = 'SGD',
  /** Thai Baht . */
  Thb = 'THB',
  /** Taiwan New Dollar . */
  Twd = 'TWD',
  /** U.S. Dollar . */
  Usd = 'USD',
  /** South African Rand . */
  Zar = 'ZAR'
}

/** A Gravity Forms draft entry. */
export type GfDraftEntry = GfEntry & Node & NodeWithForm & {
  __typename?: 'GfDraftEntry';
  /** The user who created the entry. */
  createdBy?: Maybe<User>;
  /** Database ID of the user that submitted of the form if a logged in user submitted the form. */
  createdByDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Global ID of the user that submitted of the form if a logged in user submitted the form. */
  createdById?: Maybe<Scalars['ID']['output']>;
  /** The date and time that the entry was created in local time. */
  dateCreated?: Maybe<Scalars['String']['output']>;
  /** The date and time that the entry was created in GMT. */
  dateCreatedGmt?: Maybe<Scalars['String']['output']>;
  /** The date and time that the entry was created in local time. */
  dateUpdated?: Maybe<Scalars['String']['output']>;
  /** The date and time that the entry was updated in GMT. */
  dateUpdatedGmt?: Maybe<Scalars['String']['output']>;
  /** The form object of the node. */
  form?: Maybe<GfForm>;
  /** The database identifier of the form of the node. */
  formDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The form fields associated with the entry. */
  formFields?: Maybe<GfEntryToFormFieldConnection>;
  /** The globally unique identifier of the form of the node. */
  formId?: Maybe<Scalars['ID']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Client IP of user who submitted the form. */
  ip?: Maybe<Scalars['String']['output']>;
  /** Whether the entry is a draft. */
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the entry has been submitted. */
  isSubmitted?: Maybe<Scalars['Boolean']['output']>;
  /** The entry order summary. Null if the entry has no pricing fields */
  orderSummary?: Maybe<GfOrderSummary>;
  /** The resume token. Only applies to draft entries. */
  resumeToken?: Maybe<Scalars['String']['output']>;
  /** Source URL of page that contained the form when it was submitted. */
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** Provides the name and version of both the browser and operating system from which the entry was submitted. */
  userAgent?: Maybe<Scalars['String']['output']>;
};


/** A Gravity Forms draft entry. */
export type GfDraftEntryFormFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GfEntryToFormFieldConnectionWhereArgs>;
};

/** Gravity Forms entry interface. */
export type GfEntry = {
  /** The user who created the entry. */
  createdBy?: Maybe<User>;
  /** Database ID of the user that submitted of the form if a logged in user submitted the form. */
  createdByDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Global ID of the user that submitted of the form if a logged in user submitted the form. */
  createdById?: Maybe<Scalars['ID']['output']>;
  /** The date and time that the entry was created in local time. */
  dateCreated?: Maybe<Scalars['String']['output']>;
  /** The date and time that the entry was created in GMT. */
  dateCreatedGmt?: Maybe<Scalars['String']['output']>;
  /** The date and time that the entry was created in local time. */
  dateUpdated?: Maybe<Scalars['String']['output']>;
  /** The date and time that the entry was updated in GMT. */
  dateUpdatedGmt?: Maybe<Scalars['String']['output']>;
  /** The form object of the node. */
  form?: Maybe<GfForm>;
  /** The database identifier of the form of the node. */
  formDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The form fields associated with the entry. */
  formFields?: Maybe<GfEntryToFormFieldConnection>;
  /** The globally unique identifier of the form of the node. */
  formId?: Maybe<Scalars['ID']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Client IP of user who submitted the form. */
  ip?: Maybe<Scalars['String']['output']>;
  /** Whether the entry is a draft. */
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the entry has been submitted. */
  isSubmitted?: Maybe<Scalars['Boolean']['output']>;
  /** The entry order summary. Null if the entry has no pricing fields */
  orderSummary?: Maybe<GfOrderSummary>;
  /** Source URL of page that contained the form when it was submitted. */
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** Provides the name and version of both the browser and operating system from which the entry was submitted. */
  userAgent?: Maybe<Scalars['String']['output']>;
};


/** Gravity Forms entry interface. */
export type GfEntryFormFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GfEntryToFormFieldConnectionWhereArgs>;
};

/** A paginated collection of GfEntry Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of GfEntry Nodes */
export type GfEntryConnection = {
  /** A list of edges (relational context) between RootQuery and connected GfEntry Nodes */
  edges: Array<GfEntryConnectionEdge>;
  /** A list of connected GfEntry Nodes */
  nodes: Array<GfEntry>;
  /** Information about pagination in a connection. */
  pageInfo: GfEntryConnectionPageInfo;
};

/** Represents a connection to a GfEntry. Contains both the GfEntry Node and metadata about the relationship. */
export type GfEntryConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected GfEntry Node */
  node: GfEntry;
};

/** Pagination metadata specific to &quot;GfEntryConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;GfEntryConnectionEdge&quot; Nodes. */
export type GfEntryConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Connection between the GfEntry type and the FormField type */
export type GfEntryToFormFieldConnection = Connection & FormFieldConnection & {
  __typename?: 'GfEntryToFormFieldConnection';
  /** Edges for the GfEntryToFormFieldConnection connection */
  edges: Array<GfEntryToFormFieldConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<FormField>;
  /** Information about pagination in a connection. */
  pageInfo: GfEntryToFormFieldConnectionPageInfo;
};

/** An edge in a connection */
export type GfEntryToFormFieldConnectionEdge = Edge & FormFieldConnectionEdge & {
  __typename?: 'GfEntryToFormFieldConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: FormField;
};

/** Pagination metadata specific to &quot;GfEntryToFormFieldConnection&quot; collections. Provides cursors and flags for navigating through sets of GfEntryToFormFieldConnection Nodes. */
export type GfEntryToFormFieldConnectionPageInfo = FormFieldConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'GfEntryToFormFieldConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the GfEntryToFormFieldConnection connection */
export type GfEntryToFormFieldConnectionWhereArgs = {
  /** Array of form field adminLabels to return. */
  adminLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of Gravity Forms Field types to return. */
  fieldTypes?: InputMaybe<Array<InputMaybe<FormFieldTypeEnum>>>;
  /** Array of form field IDs to return. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The form page number to return. */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** Gravity Forms field choice. */
export type GfFieldChoice = {
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Choice for a form field with the `choices_setting` setting. */
export type GfFieldChoiceWithChoicesSetting = {
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Choice for a form field with the `columns_setting` setting. */
export type GfFieldChoiceWithColumnsSetting = {
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Choice for a form field with the `name_setting` setting. */
export type GfFieldChoiceWithNameSetting = {
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Choice for a form field with the `other_choice_setting` setting. */
export type GfFieldChoiceWithOtherChoiceSetting = {
  /** Indicates the radio button item is the “Other” choice. */
  isOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Gravity Forms field input. */
export type GfFieldInput = {
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
};

/** An Input for a form field with the `address_setting` setting. */
export type GfFieldInputWithAddressSetting = {
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Whether or not this field should be hidden. */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Key used to identify this input. */
  key?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** An Input for a form field with the `date_format_setting` setting. */
export type GfFieldInputWithDateFormatSetting = {
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** An Input for a form field with the `email_confirm_setting` setting. */
export type GfFieldInputWithEmailConfirmationSetting = {
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** An Input for a form field with the `name_setting` setting. */
export type GfFieldInputWithNameSetting = {
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not this field should be hidden. */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Key used to identify this input. */
  key?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** An Input for a form field with the `password_setting` setting. */
export type GfFieldInputWithPasswordSetting = {
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Whether or not this field should be hidden. */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** An Input for a form field with the `select_all_choices_setting` setting. */
export type GfFieldInputWithSelectAllChoicesSetting = {
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
};

/** An Input for a form field with the `single_product_inputs` setting. */
export type GfFieldInputWithSingleProductInputs = {
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
};

/** An Input for a form field with the `time_format_setting` setting. */
export type GfFieldInputWithTimeFormatSetting = {
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** Gravity Forms field value with connected choice. */
export type GfFieldValueWithChoice = {
  /** The selected Gravity Forms field choice object. */
  connectedChoice?: Maybe<GfFieldChoice>;
};

/** Gravity Forms field value with connected input. */
export type GfFieldValueWithInput = {
  /** The selected Gravity Forms field input object. */
  connectedInput?: Maybe<GfFieldInput>;
};

/** A form field with the `add_icon_url_setting` setting. */
export type GfFieldWithAddIconUrlSetting = {
  /** The URL of the image to be used for the add row button. */
  addIconUrl?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `address_setting` setting. */
export type GfFieldWithAddressSetting = {
  /** Determines the type of address to be displayed. */
  addressType?: Maybe<AddressFieldTypeEnum>;
  /** Contains the country that will be selected by default. Only applicable when &quot;addressType&quot; is set to &quot;INTERATIONAL&quot;. */
  defaultCountry?: Maybe<AddressFieldCountryEnum>;
  /** Contains the province that will be selected by default. Only applicable when &quot;addressType&quot; is set to &quot;CANADA&quot;. */
  defaultProvince?: Maybe<AddressFieldProvinceEnum>;
  /** Contains the state that will be selected by default. Only applicable when &quot;addressType&quot; is set to &quot;US&quot;. */
  defaultState?: Maybe<AddressFieldProvinceEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
};

/** A form field with the `admin_label_setting` setting. */
export type GfFieldWithAdminLabelSetting = {
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `autocomplete_setting` setting. */
export type GfFieldWithAutocompleteSetting = {
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `base_price_setting` setting. */
export type GfFieldWithBasePriceSetting = {
  /** The price of the product, prefixed by the currency. */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** The price of the product. */
  price?: Maybe<Scalars['Float']['output']>;
};

/** A form field with the `calculation_setting` setting. */
export type GfFieldWithCalculationSetting = {
  /** The formula used for the number field. */
  calculationFormula?: Maybe<Scalars['String']['output']>;
  /** Specifies to how many decimal places the number should be rounded. This is available when `isCalculation` is true, but will return null if the number format is `CURRENCY` or if the calculation is set to `Do not round`. */
  calculationRounding?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the number field is a calculation. */
  isCalculation?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `captcha_bg_setting` setting. */
export type GfFieldWithCaptchaBackgroundSetting = {
  /** Determines the image’s background color, in HEX format (i.e. #CCCCCC). Only applicable to simple_captcha and math captcha types. */
  simpleCaptchaBackgroundColor?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `captcha_badge_setting` setting. */
export type GfFieldWithCaptchaBadgeSetting = {
  /** The language used when the captcha is displayed. This property is available when the captchaType is “captcha”, the default. The possible values are the language codes used by WordPress. */
  captchaBadgePosition?: Maybe<CaptchaFieldBadgePositionEnum>;
};

/** A form field with the `captcha_fg_setting` setting. */
export type GfFieldWithCaptchaForegroundSetting = {
  /** Determines the image’s font color, in HEX format (i.e. #CCCCCC). Only applicable to simple_captcha and math captcha types. */
  simpleCaptchaFontColor?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `captcha_language_setting` setting. */
export type GfFieldWithCaptchaLanguageSetting = {
  /** The language used when the captcha is displayed. This property is available when the captchaType is “captcha”, the default. The possible values are the language codes used by WordPress. */
  captchaLanguage?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `captcha_size_setting` setting. */
export type GfFieldWithCaptchaSizeSetting = {
  /** Determines the CAPTCHA image size. Only applicable to simple_captcha and math captcha types. */
  simpleCaptchaSize?: Maybe<FormFieldSizeEnum>;
};

/** A form field with the `captcha_theme_setting` setting. */
export type GfFieldWithCaptchaThemeSetting = {
  /** Determines the theme to be used for the reCAPTCHA field. Only applicable to the recaptcha captcha type. */
  captchaTheme?: Maybe<CaptchaFieldThemeEnum>;
};

/** A form field with the `captcha_type_setting` setting. */
export type GfFieldWithCaptchaTypeSetting = {
  /** Determines the type of CAPTCHA field to be used. */
  captchaType?: Maybe<CaptchaFieldTypeEnum>;
};

/** A form field with the `checkbox_label_setting` setting. */
export type GfFieldWithCheckboxLabelSetting = {
  /** Text of the consent checkbox. */
  checkboxLabel?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms field with possible field choices. */
export type GfFieldWithChoices = {
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<GfFieldChoice>>>;
};

/** A form field with the `choices_setting` setting. */
export type GfFieldWithChoicesSetting = {
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<GfFieldChoice>>>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
};

/** A form field with the `columns_setting` setting. */
export type GfFieldWithColumnsSetting = {
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<GfFieldChoice>>>;
  /** Determines if the field should use multiple columns. Default is false. */
  hasColumns?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `conditional_logic_setting` setting. */
export type GfFieldWithConditionalLogicSetting = {
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
};

/** A form field with the `content_setting` setting. */
export type GfFieldWithContentSetting = {
  /** Content of an HTML block field to be displayed on the form. */
  content?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `copy_values_option` setting. */
export type GfFieldWithCopyValuesOptionSetting = {
  /** The field id of the field being used as the copy source. */
  copyValuesOptionFieldId?: Maybe<Scalars['Int']['output']>;
  /** The label that appears next to the copy values option when the form is displayed. The default value is \“Same as previous\”. */
  copyValuesOptionLabel?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the copy values option can be used. This option allows users to skip filling out the field and use the same values as another. For example, if the mailing and billing address are the same. */
  shouldCopyValuesOption?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `css_class_setting` setting. */
export type GfFieldWithCssClassSetting = {
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `date_format_setting` setting. */
export type GfFieldWithDateFormatSetting = {
  /** Determines how the date is displayed. */
  dateFormat?: Maybe<DateFieldFormatEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
};

/** A form field with the `date_input_type_setting` setting. */
export type GfFieldWithDateInputTypeSetting = {
  /** Determines how the date field displays it’s calendar icon. */
  calendarIconType?: Maybe<FormFieldCalendarIconTypeEnum>;
  /** Contains the URL to the custom calendar icon. Only applicable when calendarIconType is set to custom. */
  calendarIconUrl?: Maybe<Scalars['String']['output']>;
  /** The type of date field to display. */
  dateType?: Maybe<DateFieldTypeEnum>;
};

/** A form field with the `default_value_setting` setting. */
export type GfFieldWithDefaultValueSetting = {
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `delete_icon_url_setting` setting. */
export type GfFieldWithDeleteIconUrlSetting = {
  /** The URL of the image to be used for the delete row button. */
  deleteIconUrl?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `description_setting` setting. */
export type GfFieldWithDescriptionSetting = {
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `disable_margins_setting` setting. */
export type GfFieldWithDisableMarginsSetting = {
  /** Indicates whether the default margins are turned on to align the HTML content with other fields. */
  hasMargins?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `disable_quantity_setting` setting. */
export type GfFieldWithDisableQuantitySetting = {
  /** Whether the field has the quantity property enabled. */
  hasQuantity?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `duplicate_setting` setting. */
export type GfFieldWithDuplicatesSetting = {
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `enable_enhanced_ui_setting` setting. */
export type GfFieldWithEnhancedUiSetting = {
  /** When set to true, the &quot;Chosen&quot; jQuery script will be applied to this field, enabling search capabilities to Drop Down fields and a more user-friendly interface for Multi Select fields. */
  hasEnhancedUI?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `error_message_setting` setting. */
export type GfFieldWithErrorMessageSetting = {
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `file_extensions_setting` setting. */
export type GfFieldWithFileExtensionsSetting = {
  /** A comma-delimited list of the file extensions which may be uploaded. */
  allowedExtensions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** A form field with the `file_size_setting` setting. */
export type GfFieldWithFileSizeSetting = {
  /** The maximum size (in MB) an uploaded file may be . */
  maxFileSize?: Maybe<Scalars['Int']['output']>;
};

/** A form field with the `input_mask_setting` setting. */
export type GfFieldWithInputMaskSetting = {
  /** Whether the field has an input mask. */
  hasInputMask?: Maybe<Scalars['Boolean']['output']>;
  /** The pattern used for the input mask. */
  inputMaskValue?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms field with possible field inputs. */
export type GfFieldWithInputs = {
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
};

/** A form field with the `label_placement_setting` setting. */
export type GfFieldWithLabelPlacementSetting = {
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
};

/** A form field with the `label_setting` setting. */
export type GfFieldWithLabelSetting = {
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `maxlen_setting` setting. */
export type GfFieldWithMaxLengthSetting = {
  /** Specifies the maximum number of characters allowed in a text or textarea (paragraph) field. */
  maxLength?: Maybe<Scalars['Int']['output']>;
};

/** A form field with the `maxrows_setting` setting. */
export type GfFieldWithMaxRowsSetting = {
  /** The maximum number of rows the user can add to the field. */
  maxRows?: Maybe<Scalars['Int']['output']>;
};

/** A form field with the `multiple_files_setting` setting. */
export type GfFieldWithMultipleFilesSetting = {
  /** Indicates whether multiple files may be uploaded. */
  canAcceptMultipleFiles?: Maybe<Scalars['Boolean']['output']>;
  /** When the field is set to allow multiple files to be uploaded, this property is available to set a limit on how many may be uploaded. */
  maxFiles?: Maybe<Scalars['Int']['output']>;
};

/** A form field with the `name_setting` setting. */
export type GfFieldWithNameSetting = {
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
};

/** A form field with the `next_button_setting` setting. */
export type GfFieldWithNextButtonSetting = {
  /** An array containing the the individual properties for the &quot;Next&quot; button. */
  nextButton?: Maybe<FormButton>;
};

/** A form field with the `number_format_setting` setting. */
export type GfFieldWithNumberFormatSetting = {
  /** Specifies the format allowed for the number field. */
  numberFormat?: Maybe<NumberFieldFormatEnum>;
};

/** A form field with the `other_choice_setting` setting. */
export type GfFieldWithOtherChoiceSetting = {
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<GfFieldChoice>>>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the &#039;Enable &quot;other&quot; choice&#039; option is checked in the editor. */
  hasOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
};

/** A form field with the `password_field_setting` setting. */
export type GfFieldWithPasswordFieldSetting = {
  /** Determines if a text field input tag should be created with a &quot;password&quot; type. */
  isPasswordInput?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `password_setting` setting. */
export type GfFieldWithPasswordSetting = {
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
};

/** A form field with the `password_strength_setting` setting. */
export type GfFieldWithPasswordStrengthSetting = {
  /** Indicates whether the field displays the password strength indicator. */
  hasPasswordStrengthIndicator?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates how strong the password should be. */
  minPasswordStrength?: Maybe<PasswordFieldMinStrengthEnum>;
};

/** A form field with the `password_visibility_setting` setting. */
export type GfFieldWithPasswordVisibilitySetting = {
  /** Whether the Password visibility toggle should be enabled for this field. */
  hasPasswordVisibilityToggle?: Maybe<Scalars['Boolean']['output']>;
};

/** The form field-specifc policies for exporting and erasing personal data. */
export type GfFieldWithPersonalData = {
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
};

/** A form field with the `phone_format_setting` setting. */
export type GfFieldWithPhoneFormatSetting = {
  /** Determines the allowed format for phones. If the phone value does not conform with the specified format, the field will fail validation. */
  phoneFormat?: Maybe<PhoneFieldFormatEnum>;
};

/** A form field with the `placeholder_setting` setting. */
export type GfFieldWithPlaceholderSetting = {
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `post_category_checkbox_setting` setting. */
export type GfFieldWithPostCategoryCheckboxSetting = {
  /** Determines if all categories should be displayed on the Post Category drop down. If this property is true (display all categories), the Post Category drop down will display the categories hierarchically. */
  hasAllCategories?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `post_category_initial_item_setting` setting. */
export type GfFieldWithPostCategoryInitialItemSetting = {
  /** The dropdown placeholder for the field. */
  dropdownPlaceholder?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `post_custom_field_setting` setting. */
export type GfFieldWithPostCustomFieldSetting = {
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
};

/** A form field with the `post_image_featured_image` setting. */
export type GfFieldWithPostImageFeaturedImageSetting = {
  /** Whether the image field should be used to set the post&#039;s Featured Image */
  isFeaturedImage?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `post_image_setting` setting. */
export type GfFieldWithPostImageSetting = {
  /** A comma-delimited list of the file extensions which may be uploaded. */
  allowedExtensions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Controls the visibility of the alt metadata for Post Image fields. */
  hasAlt?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the caption metadata for Post Image fields. */
  hasCaption?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the description metadata for Post Image fields. */
  hasDescription?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the title metadata for Post Image fields. */
  hasTitle?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `prepopulate_field_setting` setting. */
export type GfFieldWithPrepopulateFieldSetting = {
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `previous_button` setting. */
export type GfFieldWithPreviousButton = {
  /** An array containing the the individual properties for the &quot;Previous&quot; button. */
  previousButton?: Maybe<FormButton>;
};

/** A form field with the `product_field_setting` setting. */
export type GfFieldWithProductFieldSetting = {
  /** The product field to which the field is associated. */
  connectedProductField?: Maybe<ProductField>;
  /**
   * The id of the product field to which the field is associated.
   * @deprecated Use `connectedProductField` field instead.
   */
  productField?: Maybe<Scalars['Int']['output']>;
};

/** A form field with the `range_setting` setting. */
export type GfFieldWithRangeSetting = {
  /** Maximum allowed value for a number field. Values higher than the number specified by this property will cause the field to fail validation. */
  rangeMax?: Maybe<Scalars['Float']['output']>;
  /** Minimum allowed value for a number field. Values lower than the number specified by this property will cause the field to fail validation. */
  rangeMin?: Maybe<Scalars['Float']['output']>;
};

/** A form field with the `rich_text_editor_setting` setting. */
export type GfFieldWithRichTextEditorSetting = {
  /** Indicates whether the field uses the rich text editor interface. */
  hasRichTextEditor?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `rules_setting` setting. */
export type GfFieldWithRulesSetting = {
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
};

/** A form field with the `select_all_choices_setting` setting. */
export type GfFieldWithSelectAllChoicesSetting = {
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<GfFieldChoice>>>;
  /** Whether the \&quot;select all\&quot; choice should be displayed. */
  hasSelectAll?: Maybe<Scalars['Boolean']['output']>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
};

/** A form field with the `single_product_inputs` setting. */
export type GfFieldWithSingleProductInputs = {
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
};

/** A form field with the `size_setting` setting. */
export type GfFieldWithSizeSetting = {
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
};

/** A form field with the `sub_label_placement_setting` setting. */
export type GfFieldWithSubLabelPlacementSetting = {
  /** The placement of the labels for the subfields within the group. This setting controls all of the subfields, they cannot be set individually. They may be aligned above or below the inputs. If this property is not set, the “Sub-Label Placement” setting on the Form Settings-&gt;Form Layout page is used. If no setting is specified, the default is above inputs. */
  subLabelPlacement?: Maybe<FormFieldSubLabelPlacementEnum>;
};

/** A form field with the `time_format_setting` setting. */
export type GfFieldWithTimeFormatSetting = {
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines how the time is displayed. */
  timeFormat?: Maybe<TimeFieldFormatEnum>;
};

/** Gravity Forms form. */
export type GfForm = DatabaseIdentifier & Node & {
  __typename?: 'GfForm';
  /** Contains the form confirmation settings such as confirmation text or redirect URL. */
  confirmations?: Maybe<Array<Maybe<FormConfirmation>>>;
  /** String containing the custom CSS classes to be added to the &lt;form&gt; tag. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** The custom text to use to indicate a field is required. */
  customRequiredIndicator?: Maybe<Scalars['String']['output']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** The date and time that the entry was created in local time. */
  dateCreated?: Maybe<Scalars['String']['output']>;
  /** The date and time that the entry was created in GMT. */
  dateCreatedGmt?: Maybe<Scalars['String']['output']>;
  /** Form description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Determines if the field description is displayed above the field input (i.e. immediately after the field label) or below the field input. */
  descriptionPlacement?: Maybe<FormDescriptionPlacementEnum>;
  /** The entries submitted to the form. */
  entries?: Maybe<GfFormToGfEntryConnection>;
  /** The entry limit settings. */
  entryLimits?: Maybe<FormEntryLimits>;
  /** CSS class for the first page. */
  firstPageCssClass?: Maybe<Scalars['String']['output']>;
  /** The form fields associated with the form. */
  formFields?: Maybe<GfFormToFormFieldConnection>;
  /** When enabled, conditional logic hide/show operation will be performed with a jQuery slide animation. Only applicable to forms with conditional logic. */
  hasConditionalLogicAnimation?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies if the form has the Honeypot spam-protection feature. */
  hasHoneypot?: Maybe<Scalars['Boolean']['output']>;
  /** If enabled, will show a summary that lists form validation errors at the top of the form when a user attempts a failed submission. */
  hasValidationSummary?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Determines whether the form is active. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Determines whether the form is in the trash. */
  isTrash?: Maybe<Scalars['Boolean']['output']>;
  /** Determines where the field labels should be placed in relation to the field. */
  labelPlacement?: Maybe<FormLabelPlacementEnum>;
  /** Login requirements data. */
  login?: Maybe<FormLogin>;
  /** The Gravity Forms markup version. */
  markupVersion?: Maybe<Scalars['Int']['output']>;
  /** The ID to assign to the next field that is added to the form. */
  nextFieldId?: Maybe<Scalars['Int']['output']>;
  /** The properties for all the email notifications which exist for a form. */
  notifications?: Maybe<Array<Maybe<FormNotification>>>;
  /** Pagination data. */
  pagination?: Maybe<FormPagination>;
  /** Personal data settings. */
  personalData?: Maybe<FormPersonalData>;
  /** Post creation data. */
  postCreation?: Maybe<FormPostCreation>;
  /** Type of indicator to use when field is required. */
  requiredIndicator?: Maybe<FormFieldRequiredIndicatorEnum>;
  /** \&quot;Save and Continue\&quot; data. */
  saveAndContinue?: Maybe<FormSaveAndContinue>;
  /** Form scheduling data. */
  scheduling?: Maybe<FormSchedule>;
  /** How sub-labels are aligned. */
  subLabelPlacement?: Maybe<FormSubLabelPlacementEnum>;
  /** Contains the form button settings such as the button text or image button source. */
  submitButton?: Maybe<FormSubmitButton>;
  /** Form title. */
  title?: Maybe<Scalars['String']['output']>;
  /** The version of Gravity Forms used to create this form. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Gravity Forms form. */
export type GfFormEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GfFormToGfEntryConnectionWhereArgs>;
};


/** Gravity Forms form. */
export type GfFormFormFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GfFormToFormFieldConnectionWhereArgs>;
};

/** A paginated collection of GfForm Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of GfForm Nodes */
export type GfFormConnection = {
  /** A list of edges (relational context) between RootQuery and connected GfForm Nodes */
  edges: Array<GfFormConnectionEdge>;
  /** A list of connected GfForm Nodes */
  nodes: Array<GfForm>;
  /** Information about pagination in a connection. */
  pageInfo: GfFormConnectionPageInfo;
};

/** Represents a connection to a GfForm. Contains both the GfForm Node and metadata about the relationship. */
export type GfFormConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected GfForm Node */
  node: GfForm;
};

/** Pagination metadata specific to &quot;GfFormConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;GfFormConnectionEdge&quot; Nodes. */
export type GfFormConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Connection between the GfForm type and the FormField type */
export type GfFormToFormFieldConnection = Connection & FormFieldConnection & {
  __typename?: 'GfFormToFormFieldConnection';
  /** Edges for the GfFormToFormFieldConnection connection */
  edges: Array<GfFormToFormFieldConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<FormField>;
  /** Information about pagination in a connection. */
  pageInfo: GfFormToFormFieldConnectionPageInfo;
};

/** An edge in a connection */
export type GfFormToFormFieldConnectionEdge = Edge & FormFieldConnectionEdge & {
  __typename?: 'GfFormToFormFieldConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: FormField;
};

/** Pagination metadata specific to &quot;GfFormToFormFieldConnection&quot; collections. Provides cursors and flags for navigating through sets of GfFormToFormFieldConnection Nodes. */
export type GfFormToFormFieldConnectionPageInfo = FormFieldConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'GfFormToFormFieldConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the GfFormToFormFieldConnection connection */
export type GfFormToFormFieldConnectionWhereArgs = {
  /** Array of form field adminLabels to return. */
  adminLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of Gravity Forms Field types to return. */
  fieldTypes?: InputMaybe<Array<InputMaybe<FormFieldTypeEnum>>>;
  /** Array of form field IDs to return. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The form page number to return. */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** Connection between the GfForm type and the GfEntry type */
export type GfFormToGfEntryConnection = Connection & GfEntryConnection & {
  __typename?: 'GfFormToGfEntryConnection';
  /** The number of (filtered) entries submitted to the form. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Edges for the GfFormToGfEntryConnection connection */
  edges: Array<GfFormToGfEntryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<GfEntry>;
  /** Information about pagination in a connection. */
  pageInfo: GfFormToGfEntryConnectionPageInfo;
};

/** An edge in a connection */
export type GfFormToGfEntryConnectionEdge = Edge & GfEntryConnectionEdge & {
  __typename?: 'GfFormToGfEntryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: GfEntry;
};

/** Pagination metadata specific to &quot;GfFormToGfEntryConnection&quot; collections. Provides cursors and flags for navigating through sets of GfFormToGfEntryConnection Nodes. */
export type GfFormToGfEntryConnectionPageInfo = GfEntryConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'GfFormToGfEntryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the GfFormToGfEntryConnection connection */
export type GfFormToGfEntryConnectionWhereArgs = {
  /** Date filters to apply. */
  dateFilters?: InputMaybe<EntriesDateFiltersInput>;
  /** Field-specific filters to apply. */
  fieldFilters?: InputMaybe<Array<InputMaybe<EntriesFieldFiltersInput>>>;
  /** Whether to filter by ALL or ANY of the field filters. Default is ALL. */
  fieldFiltersMode?: InputMaybe<FieldFiltersModeEnum>;
  /** How to sort the entries. */
  orderby?: InputMaybe<EntriesConnectionOrderbyInput>;
  /** Entry status. Default is "ACTIVE". */
  status?: InputMaybe<EntryStatusEnum>;
};

/** A form field with the `email_confirm_setting` setting. */
export type GfGfFieldWithEmailConfirmationSetting = {
  /** Determines whether the Confirm Email field is active. */
  hasEmailConfirmation?: Maybe<Scalars['Boolean']['output']>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** The placement of the labels for the subfields within the group. This setting controls all of the subfields, they cannot be set individually. They may be aligned above or below the inputs. If this property is not set, the “Sub-Label Placement” setting on the Form Settings-&gt;Form Layout page is used. If no setting is specified, the default is above inputs. */
  subLabelPlacement?: Maybe<FormFieldSubLabelPlacementEnum>;
};

/** Gravity Forms Logging Settings. */
export type GfLogger = {
  __typename?: 'GfLogger';
  /** Whether the logger is enabled. */
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the Gravity Forms logger. */
  name?: Maybe<Scalars['String']['output']>;
};

/** The entry order item. */
export type GfOrderItem = {
  __typename?: 'GfOrderItem';
  /** The form field that the order item is connected to */
  connectedFormField?: Maybe<FormField>;
  /** The currency used for the order item */
  currency?: Maybe<GfCurrencyEnum>;
  /** The item description */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether this is a discount item */
  isDiscount?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is a line item */
  isLineItem?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is a recurring item */
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is a setup fee */
  isSetupFee?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is a shipping fee */
  isShipping?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is a trial item */
  isTrial?: Maybe<Scalars['Boolean']['output']>;
  /** The item name */
  name?: Maybe<Scalars['String']['output']>;
  /** The item options */
  options?: Maybe<Array<Maybe<GfOrderItemOption>>>;
  /** The item price */
  price?: Maybe<Scalars['Float']['output']>;
  /** The item quantity */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The section this order item belongs to. */
  section?: Maybe<Scalars['String']['output']>;
  /** The item subtotal */
  subtotal?: Maybe<Scalars['Float']['output']>;
};

/** An option on an Order item. */
export type GfOrderItemOption = {
  __typename?: 'GfOrderItemOption';
  /** The form field that the order item is connected to */
  connectedFormField?: Maybe<FormField>;
  /** The option&#039;s field label. */
  fieldLabel?: Maybe<Scalars['String']['output']>;
  /** The option name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The option label. */
  optionLabel?: Maybe<Scalars['String']['output']>;
  /** The option price. */
  price?: Maybe<Scalars['Float']['output']>;
};

/** The entry order information. */
export type GfOrderSummary = {
  __typename?: 'GfOrderSummary';
  /** The currency used for the order */
  currency?: Maybe<GfCurrencyEnum>;
  /** The order item details. */
  items?: Maybe<Array<Maybe<GfOrderItem>>>;
  /** The order subtotal. */
  subtotal?: Maybe<Scalars['Float']['output']>;
  /** The order total */
  total?: Maybe<Scalars['Float']['output']>;
};

/** Gravity Forms Settings. */
export type GfSettings = {
  __typename?: 'GfSettings';
  /** The default currency for your forms. Used for product, credit card, and other fields. */
  currency?: Maybe<GfCurrencyEnum>;
  /** Whether Gravity Forms to download and install bug fixes and security updates automatically in the background. Requires a valid license key. */
  hasBackgroundUpdates?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to output Gravity Forms&#039; default CSS. */
  hasDefaultCss?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to display the forms menu in the WordPress top toolbar. The forms menu will display the ten forms recently opened in the form editor. */
  hasToolbar?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the server-generated form markup uses HTML5. */
  isHtml5Enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Enable to prevent extraneous scripts and styles from being printed on a Gravity Forms admin pages, reducing conflicts with other plugins and themes. */
  isNoConflictModeEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Logging settings. */
  logging?: Maybe<GfSettingsLogging>;
  /** Recaptcha settings. */
  recaptcha?: Maybe<GfSettingsRecaptcha>;
};

/** Gravity Forms Logging Settings. */
export type GfSettingsLogging = {
  __typename?: 'GfSettingsLogging';
  /** Whether Gravity Forms internal logging is enabled. Logging allows you to easily debug the inner workings of Gravity Forms to solve any possible issues. */
  isLoggingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** A list of registered Gravity Forms loggers and their configurations. */
  loggers?: Maybe<Array<Maybe<GfLogger>>>;
};

/** Gravity Forms reCAPTCHA Settings. */
export type GfSettingsRecaptcha = {
  __typename?: 'GfSettingsRecaptcha';
  /** The public reCAPTCHA site key. */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** The type of of reCAPTCHA v2 to be used */
  type?: Maybe<RecaptchaTypeEnum>;
};

/** A Gravity Forms submitted entry. */
export type GfSubmittedEntry = DatabaseIdentifier & GfEntry & Node & NodeWithForm & {
  __typename?: 'GfSubmittedEntry';
  /** The user who created the entry. */
  createdBy?: Maybe<User>;
  /** Database ID of the user that submitted of the form if a logged in user submitted the form. */
  createdByDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Global ID of the user that submitted of the form if a logged in user submitted the form. */
  createdById?: Maybe<Scalars['ID']['output']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** The date and time that the entry was created in local time. */
  dateCreated?: Maybe<Scalars['String']['output']>;
  /** The date and time that the entry was created in GMT. */
  dateCreatedGmt?: Maybe<Scalars['String']['output']>;
  /** The date and time that the entry was created in local time. */
  dateUpdated?: Maybe<Scalars['String']['output']>;
  /** The date and time that the entry was updated in GMT. */
  dateUpdatedGmt?: Maybe<Scalars['String']['output']>;
  /** The form object of the node. */
  form?: Maybe<GfForm>;
  /** The database identifier of the form of the node. */
  formDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The form fields associated with the entry. */
  formFields?: Maybe<GfEntryToFormFieldConnection>;
  /** The globally unique identifier of the form of the node. */
  formId?: Maybe<Scalars['ID']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Client IP of user who submitted the form. */
  ip?: Maybe<Scalars['String']['output']>;
  /** Whether the entry is a draft. */
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the entry has been read. */
  isRead?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the entry has been starred (i.e marked with a star). */
  isStarred?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the entry has been submitted. */
  isSubmitted?: Maybe<Scalars['Boolean']['output']>;
  /** The entry order summary. Null if the entry has no pricing fields */
  orderSummary?: Maybe<GfOrderSummary>;
  /** For forms with Post fields, this is the post object that was created. */
  post?: Maybe<Post>;
  /** For forms with Post fields, this property contains the Id of the Post that was created. */
  postDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Source URL of page that contained the form when it was submitted. */
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** The current status of the entry. */
  status?: Maybe<EntryStatusEnum>;
  /** Provides the name and version of both the browser and operating system from which the entry was submitted. */
  userAgent?: Maybe<Scalars['String']['output']>;
};


/** A Gravity Forms submitted entry. */
export type GfSubmittedEntryFormFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GfEntryToFormFieldConnectionWhereArgs>;
};

/** A paginated collection of GfSubmittedEntry Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of GfSubmittedEntry Nodes */
export type GfSubmittedEntryConnection = {
  /** A list of edges (relational context) between RootQuery and connected GfSubmittedEntry Nodes */
  edges: Array<GfSubmittedEntryConnectionEdge>;
  /** A list of connected GfSubmittedEntry Nodes */
  nodes: Array<GfSubmittedEntry>;
  /** Information about pagination in a connection. */
  pageInfo: GfSubmittedEntryConnectionPageInfo;
};

/** Represents a connection to a GfSubmittedEntry. Contains both the GfSubmittedEntry Node and metadata about the relationship. */
export type GfSubmittedEntryConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected GfSubmittedEntry Node */
  node: GfSubmittedEntry;
};

/** Pagination metadata specific to &quot;GfSubmittedEntryConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;GfSubmittedEntryConnectionEdge&quot; Nodes. */
export type GfSubmittedEntryConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Types of styles to load */
export enum GlobalStylesheetTypesEnum {
  BaseLayoutStyles = 'BASE_LAYOUT_STYLES',
  Presets = 'PRESETS',
  Styles = 'STYLES',
  Variables = 'VARIABLES'
}

/** A block used for editing the site */
export type GravityformsForm = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'GravityformsForm';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the GravityformsForm Block Type */
  attributes?: Maybe<GravityformsFormAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the GravityformsForm Block Type */
export type GravityformsFormAttributes = {
  __typename?: 'GravityformsFormAttributes';
  /** The &quot;ajax&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  ajax?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;buttonPrimaryBackgroundColor&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  buttonPrimaryBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;buttonPrimaryColor&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  buttonPrimaryColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;description&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  description?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;descriptionColor&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  descriptionColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;descriptionFontSize&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  descriptionFontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;fieldValues&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  fieldValues?: Maybe<Scalars['String']['output']>;
  /** The form object associated with the block. */
  form?: Maybe<GfForm>;
  /** The &quot;formId&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  formId?: Maybe<Scalars['String']['output']>;
  /** The &quot;formPreview&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  formPreview?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;imgPreview&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  imgPreview?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;inputBackgroundColor&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  inputBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;inputBorderColor&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  inputBorderColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;inputBorderRadius&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  inputBorderRadius?: Maybe<Scalars['String']['output']>;
  /** The &quot;inputColor&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  inputColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;inputImageChoiceAppearance&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  inputImageChoiceAppearance?: Maybe<Scalars['String']['output']>;
  /** The &quot;inputImageChoiceSize&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  inputImageChoiceSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;inputImageChoiceStyle&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  inputImageChoiceStyle?: Maybe<Scalars['String']['output']>;
  /** The &quot;inputPrimaryColor&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  inputPrimaryColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;inputSize&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  inputSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;labelColor&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  labelColor?: Maybe<Scalars['String']['output']>;
  /** The &quot;labelFontSize&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  labelFontSize?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;tabindex&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  tabindex?: Maybe<Scalars['String']['output']>;
  /** The &quot;theme&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  theme?: Maybe<Scalars['String']['output']>;
  /** The &quot;title&quot; field on the &quot;GravityformsFormAttributes&quot; block or block attributes */
  title?: Maybe<Scalars['Boolean']['output']>;
};

/** The &quot;HeroBanner&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBanner = AcfFieldGroup & AcfFieldGroupFields & HeroBanner_Fields & {
  __typename?: 'HeroBanner';
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  content?: Maybe<Array<Maybe<HeroBannerContent>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  includeForm?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  pilllabel?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;select&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  rightContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;url&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  videoUrl?: Maybe<Scalars['String']['output']>;
};

/** The &quot;HeroBannerContent&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBannerContent = AcfFieldGroup & AcfFieldGroupFields & HeroBannerContent_Fields & {
  __typename?: 'HeroBannerContent';
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerContent&quot; Field Group */
  button?: Maybe<HeroBannerContentButton>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerContent&quot; Field Group */
  list?: Maybe<HeroBannerContentList>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerContent&quot; Field Group */
  paragraph?: Maybe<HeroBannerContentParagraph>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;HeroBannerContent&quot; Field Group */
  type?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerContent&quot; Field Group */
  wysiwyg?: Maybe<HeroBannerContentWysiwyg>;
};

/** The &quot;HeroBannerContentButton&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBannerContentButton = AcfFieldGroup & AcfFieldGroupFields & HeroBannerContentButton_Fields & {
  __typename?: 'HeroBannerContentButton';
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;HeroBannerContentButton&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;HeroBannerContentButton&quot; Field Group */
  buttonColor?: Maybe<Scalars['String']['output']>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBannerContentButton&quot; Field Group */
export type HeroBannerContentButton_Fields = {
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;HeroBannerContentButton&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;HeroBannerContentButton&quot; Field Group */
  buttonColor?: Maybe<Scalars['String']['output']>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** The &quot;HeroBannerContentList&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBannerContentList = AcfFieldGroup & AcfFieldGroupFields & HeroBannerContentList_Fields & {
  __typename?: 'HeroBannerContentList';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBannerContentList&quot; Field Group */
  heading?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;HeroBannerContentList&quot; Field Group */
  items?: Maybe<Array<Maybe<HeroBannerContentListItems>>>;
};

/** The &quot;HeroBannerContentListItems&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBannerContentListItems = AcfFieldGroup & AcfFieldGroupFields & HeroBannerContentListItems_Fields & {
  __typename?: 'HeroBannerContentListItems';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBannerContentListItems&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBannerContentListItems&quot; Field Group */
export type HeroBannerContentListItems_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBannerContentListItems&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBannerContentList&quot; Field Group */
export type HeroBannerContentList_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBannerContentList&quot; Field Group */
  heading?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;HeroBannerContentList&quot; Field Group */
  items?: Maybe<Array<Maybe<HeroBannerContentListItems>>>;
};

/** The &quot;HeroBannerContentParagraph&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBannerContentParagraph = AcfFieldGroup & AcfFieldGroupFields & HeroBannerContentParagraph_Fields & {
  __typename?: 'HeroBannerContentParagraph';
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;HeroBannerContentParagraph&quot; Field Group */
  bold?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;HeroBannerContentParagraph&quot; Field Group */
  removeTopMargin?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;HeroBannerContentParagraph&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBannerContentParagraph&quot; Field Group */
export type HeroBannerContentParagraph_Fields = {
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;HeroBannerContentParagraph&quot; Field Group */
  bold?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;HeroBannerContentParagraph&quot; Field Group */
  removeTopMargin?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;HeroBannerContentParagraph&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** The &quot;HeroBannerContentWysiwyg&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBannerContentWysiwyg = AcfFieldGroup & AcfFieldGroupFields & HeroBannerContentWysiwyg_Fields & {
  __typename?: 'HeroBannerContentWysiwyg';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;HeroBannerContentWysiwyg&quot; Field Group */
  wysiwyg?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBannerContentWysiwyg&quot; Field Group */
export type HeroBannerContentWysiwyg_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;HeroBannerContentWysiwyg&quot; Field Group */
  wysiwyg?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBannerContent&quot; Field Group */
export type HeroBannerContent_Fields = {
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerContent&quot; Field Group */
  button?: Maybe<HeroBannerContentButton>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerContent&quot; Field Group */
  list?: Maybe<HeroBannerContentList>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerContent&quot; Field Group */
  paragraph?: Maybe<HeroBannerContentParagraph>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;HeroBannerContent&quot; Field Group */
  type?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerContent&quot; Field Group */
  wysiwyg?: Maybe<HeroBannerContentWysiwyg>;
};

/** The &quot;HeroBannerWithForm&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBannerWithForm = AcfFieldGroup & AcfFieldGroupFields & HeroBannerWithForm_Fields & {
  __typename?: 'HeroBannerWithForm';
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;HeroBannerWithForm&quot; Field Group */
  content?: Maybe<Array<Maybe<HeroBannerWithFormContent>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerWithForm&quot; Field Group */
  form?: Maybe<HeroBannerWithFormForm>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;HeroBannerWithForm&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBannerWithForm&quot; Field Group */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBannerWithForm&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;HeroBannerWithFormContent&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBannerWithFormContent = AcfFieldGroup & AcfFieldGroupFields & HeroBannerWithFormContent_Fields & {
  __typename?: 'HeroBannerWithFormContent';
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContent&quot; Field Group */
  button?: Maybe<HeroBannerWithFormContentButton>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContent&quot; Field Group */
  list?: Maybe<HeroBannerWithFormContentList>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContent&quot; Field Group */
  paragraph?: Maybe<HeroBannerWithFormContentParagraph>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContent&quot; Field Group */
  type?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContent&quot; Field Group */
  wysiwyg?: Maybe<HeroBannerWithFormContentWysiwyg>;
};

/** The &quot;HeroBannerWithFormContentButton&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBannerWithFormContentButton = AcfFieldGroup & AcfFieldGroupFields & HeroBannerWithFormContentButton_Fields & {
  __typename?: 'HeroBannerWithFormContentButton';
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentButton&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentButton&quot; Field Group */
  buttonColor?: Maybe<Scalars['String']['output']>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBannerWithFormContentButton&quot; Field Group */
export type HeroBannerWithFormContentButton_Fields = {
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentButton&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentButton&quot; Field Group */
  buttonColor?: Maybe<Scalars['String']['output']>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** The &quot;HeroBannerWithFormContentList&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBannerWithFormContentList = AcfFieldGroup & AcfFieldGroupFields & HeroBannerWithFormContentList_Fields & {
  __typename?: 'HeroBannerWithFormContentList';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentList&quot; Field Group */
  heading?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentList&quot; Field Group */
  items?: Maybe<Array<Maybe<HeroBannerWithFormContentListItems>>>;
};

/** The &quot;HeroBannerWithFormContentListItems&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBannerWithFormContentListItems = AcfFieldGroup & AcfFieldGroupFields & HeroBannerWithFormContentListItems_Fields & {
  __typename?: 'HeroBannerWithFormContentListItems';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentListItems&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBannerWithFormContentListItems&quot; Field Group */
export type HeroBannerWithFormContentListItems_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentListItems&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBannerWithFormContentList&quot; Field Group */
export type HeroBannerWithFormContentList_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentList&quot; Field Group */
  heading?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentList&quot; Field Group */
  items?: Maybe<Array<Maybe<HeroBannerWithFormContentListItems>>>;
};

/** The &quot;HeroBannerWithFormContentParagraph&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBannerWithFormContentParagraph = AcfFieldGroup & AcfFieldGroupFields & HeroBannerWithFormContentParagraph_Fields & {
  __typename?: 'HeroBannerWithFormContentParagraph';
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentParagraph&quot; Field Group */
  bold?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentParagraph&quot; Field Group */
  removeTopMargin?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentParagraph&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBannerWithFormContentParagraph&quot; Field Group */
export type HeroBannerWithFormContentParagraph_Fields = {
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentParagraph&quot; Field Group */
  bold?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentParagraph&quot; Field Group */
  removeTopMargin?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentParagraph&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** The &quot;HeroBannerWithFormContentWysiwyg&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBannerWithFormContentWysiwyg = AcfFieldGroup & AcfFieldGroupFields & HeroBannerWithFormContentWysiwyg_Fields & {
  __typename?: 'HeroBannerWithFormContentWysiwyg';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentWysiwyg&quot; Field Group */
  wysiwyg?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBannerWithFormContentWysiwyg&quot; Field Group */
export type HeroBannerWithFormContentWysiwyg_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContentWysiwyg&quot; Field Group */
  wysiwyg?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBannerWithFormContent&quot; Field Group */
export type HeroBannerWithFormContent_Fields = {
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContent&quot; Field Group */
  button?: Maybe<HeroBannerWithFormContentButton>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContent&quot; Field Group */
  list?: Maybe<HeroBannerWithFormContentList>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContent&quot; Field Group */
  paragraph?: Maybe<HeroBannerWithFormContentParagraph>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContent&quot; Field Group */
  type?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormContent&quot; Field Group */
  wysiwyg?: Maybe<HeroBannerWithFormContentWysiwyg>;
};

/** The &quot;HeroBannerWithFormForm&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HeroBannerWithFormForm = AcfFieldGroup & AcfFieldGroupFields & FormContentBlock_Fields & HeroBannerWithFormForm_Fields & {
  __typename?: 'HeroBannerWithFormForm';
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormForm&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormForm&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormForm&quot; Field Group */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** The Gravity Form associated with the HeroBannerWithForm ACF block */
  gravityForm?: Maybe<GfForm>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormForm&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormForm&quot; Field Group */
  titlePlacement?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBannerWithFormForm&quot; Field Group */
export type HeroBannerWithFormForm_Fields = {
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormForm&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormForm&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormForm&quot; Field Group */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormForm&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;HeroBannerWithFormForm&quot; Field Group */
  titlePlacement?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBannerWithForm&quot; Field Group */
export type HeroBannerWithForm_Fields = {
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;HeroBannerWithForm&quot; Field Group */
  content?: Maybe<Array<Maybe<HeroBannerWithFormContent>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HeroBannerWithForm&quot; Field Group */
  form?: Maybe<HeroBannerWithFormForm>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;HeroBannerWithForm&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBannerWithForm&quot; Field Group */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBannerWithForm&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HeroBanner&quot; Field Group */
export type HeroBanner_Fields = {
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  content?: Maybe<Array<Maybe<HeroBannerContent>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  includeForm?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  pilllabel?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;select&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  rightContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;url&quot; Field Type added to the schema as part of the &quot;HeroBanner&quot; Field Group */
  videoUrl?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms hidden field. */
export type HiddenField = FormField & GfFieldWithDefaultValueSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & Node & {
  __typename?: 'HiddenField';
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** Content that can be organized in a parent-child structure. Provides fields for navigating up and down the hierarchy and maintaining structured relationships. */
export type HierarchicalContentNode = {
  /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
  /** Connection between the HierarchicalContentNode type and the ContentNode type */
  children?: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String']['output'];
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']['output']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']['output']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']['output']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']['output']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']['output']>;
  /** The parent of the node. The parent object can be of various types */
  parent?: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']['output']>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']['output']>;
  /** The Yoast SEO data of the ContentNode */
  seo?: Maybe<PostTypeSeo>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']['output']>;
  /** The template assigned to a node of content */
  template?: Maybe<ContentTemplate>;
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
};


/** Content that can be organized in a parent-child structure. Provides fields for navigating up and down the hierarchy and maintaining structured relationships. */
export type HierarchicalContentNodeAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};


/** Content that can be organized in a parent-child structure. Provides fields for navigating up and down the hierarchy and maintaining structured relationships. */
export type HierarchicalContentNodeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};


/** Content that can be organized in a parent-child structure. Provides fields for navigating up and down the hierarchy and maintaining structured relationships. */
export type HierarchicalContentNodeEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Content that can be organized in a parent-child structure. Provides fields for navigating up and down the hierarchy and maintaining structured relationships. */
export type HierarchicalContentNodeEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToContentNodeAncestorsConnection = Connection & ContentNodeConnection & {
  __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnection';
  /** Edges for the HierarchicalContentNodeToContentNodeAncestorsConnection connection */
  edges: Array<HierarchicalContentNodeToContentNodeAncestorsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: HierarchicalContentNodeToContentNodeAncestorsConnectionPageInfo;
};

/** An edge in a connection */
export type HierarchicalContentNodeToContentNodeAncestorsConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Pagination metadata specific to &quot;HierarchicalContentNodeToContentNodeAncestorsConnection&quot; collections. Provides cursors and flags for navigating through sets of HierarchicalContentNodeToContentNodeAncestorsConnection Nodes. */
export type HierarchicalContentNodeToContentNodeAncestorsConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the HierarchicalContentNodeToContentNodeAncestorsConnection connection */
export type HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToContentNodeChildrenConnection = Connection & ContentNodeConnection & {
  __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnection';
  /** Edges for the HierarchicalContentNodeToContentNodeChildrenConnection connection */
  edges: Array<HierarchicalContentNodeToContentNodeChildrenConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: HierarchicalContentNodeToContentNodeChildrenConnectionPageInfo;
};

/** An edge in a connection */
export type HierarchicalContentNodeToContentNodeChildrenConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Pagination metadata specific to &quot;HierarchicalContentNodeToContentNodeChildrenConnection&quot; collections. Provides cursors and flags for navigating through sets of HierarchicalContentNodeToContentNodeChildrenConnection Nodes. */
export type HierarchicalContentNodeToContentNodeChildrenConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the HierarchicalContentNodeToContentNodeChildrenConnection connection */
export type HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToParentContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & OneToOneConnection & {
  __typename?: 'HierarchicalContentNodeToParentContentNodeConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: ContentNode;
};

/** Content that can exist in a parent-child structure. Provides fields for navigating up (parent) and down (children) through the hierarchy. */
export type HierarchicalNode = {
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']['output']>;
};

/** Term node with hierarchical (parent/child) relationships */
export type HierarchicalTermNode = {
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** The description of the object */
  description?: Maybe<Scalars['String']['output']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  /** The link to the term */
  link?: Maybe<Scalars['String']['output']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']['output']>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']['output']>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']['output']>;
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']['output']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']['output']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
};


/** Term node with hierarchical (parent/child) relationships */
export type HierarchicalTermNodeEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Term node with hierarchical (parent/child) relationships */
export type HierarchicalTermNodeEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The &quot;Highlight&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type Highlight = AcfFieldGroup & AcfFieldGroupFields & Highlight_Fields & {
  __typename?: 'Highlight';
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;Highlight&quot; Field Group */
  content?: Maybe<Array<Maybe<HighlightContent>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;Highlight&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;Highlight&quot; Field Group */
  imagePlacement?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Highlight&quot; Field Group */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Highlight&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;HighlightContent&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HighlightContent = AcfFieldGroup & AcfFieldGroupFields & HighlightContent_Fields & {
  __typename?: 'HighlightContent';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HighlightContent&quot; Field Group */
  list?: Maybe<HighlightContentList>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HighlightContent&quot; Field Group */
  paragraph?: Maybe<HighlightContentParagraph>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;HighlightContent&quot; Field Group */
  type?: Maybe<Scalars['String']['output']>;
};

/** The &quot;HighlightContentList&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HighlightContentList = AcfFieldGroup & AcfFieldGroupFields & HighlightContentList_Fields & {
  __typename?: 'HighlightContentList';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HighlightContentList&quot; Field Group */
  heading?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;HighlightContentList&quot; Field Group */
  items?: Maybe<Array<Maybe<HighlightContentListItems>>>;
};

/** The &quot;HighlightContentListItems&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HighlightContentListItems = AcfFieldGroup & AcfFieldGroupFields & HighlightContentListItems_Fields & {
  __typename?: 'HighlightContentListItems';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HighlightContentListItems&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HighlightContentListItems&quot; Field Group */
export type HighlightContentListItems_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HighlightContentListItems&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HighlightContentList&quot; Field Group */
export type HighlightContentList_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;HighlightContentList&quot; Field Group */
  heading?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;HighlightContentList&quot; Field Group */
  items?: Maybe<Array<Maybe<HighlightContentListItems>>>;
};

/** The &quot;HighlightContentParagraph&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type HighlightContentParagraph = AcfFieldGroup & AcfFieldGroupFields & HighlightContentParagraph_Fields & {
  __typename?: 'HighlightContentParagraph';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;HighlightContentParagraph&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HighlightContentParagraph&quot; Field Group */
export type HighlightContentParagraph_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;HighlightContentParagraph&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;HighlightContent&quot; Field Group */
export type HighlightContent_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HighlightContent&quot; Field Group */
  list?: Maybe<HighlightContentList>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;HighlightContent&quot; Field Group */
  paragraph?: Maybe<HighlightContentParagraph>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;HighlightContent&quot; Field Group */
  type?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;Highlight&quot; Field Group */
export type Highlight_Fields = {
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;Highlight&quot; Field Group */
  content?: Maybe<Array<Maybe<HighlightContent>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;Highlight&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;Highlight&quot; Field Group */
  imagePlacement?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Highlight&quot; Field Group */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Highlight&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms html field. */
export type HtmlField = FormField & GfFieldWithConditionalLogicSetting & GfFieldWithContentSetting & GfFieldWithCssClassSetting & GfFieldWithDisableMarginsSetting & GfFieldWithLabelSetting & Node & {
  __typename?: 'HtmlField';
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** Content of an HTML block field to be displayed on the form. */
  content?: Maybe<Scalars['String']['output']>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the default margins are turned on to align the HTML content with other fields. */
  hasMargins?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms image_choice field. */
export type ImageChoiceField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & Node & {
  __typename?: 'ImageChoiceField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<ImageChoiceFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** ImageChoiceFieldChoice choice values. */
export type ImageChoiceFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & {
  __typename?: 'ImageChoiceFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** The individual properties for each element of the PostImage value field. */
export type ImageFieldValue = {
  __typename?: 'ImageFieldValue';
  /** The image alt text. */
  altText?: Maybe<Scalars['String']['output']>;
  /** The path to the parent directory of the file. */
  basePath?: Maybe<Scalars['String']['output']>;
  /** The base url to the parent directory of the file. */
  baseUrl?: Maybe<Scalars['String']['output']>;
  /** The image caption. */
  caption?: Maybe<Scalars['String']['output']>;
  /** The image description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The filename. */
  filename?: Maybe<Scalars['String']['output']>;
  /** The image title. */
  title?: Maybe<Scalars['String']['output']>;
  /** The url to the file. */
  url?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms list field. */
export type ListField = FormField & GfFieldWithAddIconUrlSetting & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithColumnsSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDeleteIconUrlSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithMaxRowsSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & Node & {
  __typename?: 'ListField';
  /** The URL of the image to be used for the add row button. */
  addIconUrl?: Maybe<Scalars['String']['output']>;
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<ListFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** The URL of the image to be used for the delete row button. */
  deleteIconUrl?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field should use multiple columns. Default is false. */
  hasColumns?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** List field value. */
  listValues?: Maybe<Array<Maybe<ListFieldValue>>>;
  /** The maximum number of rows the user can add to the field. */
  maxRows?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** ListFieldChoice choice values. */
export type ListFieldChoice = GfFieldChoice & GfFieldChoiceWithColumnsSetting & {
  __typename?: 'ListFieldChoice';
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Input fields for a single List field item. */
export type ListFieldInput = {
  /** Input values for the specific listField row. */
  rowValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The individual properties for each element of the List value field. */
export type ListFieldValue = {
  __typename?: 'ListFieldValue';
  /** Input values. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** The &quot;LogoRows&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type LogoRows = AcfFieldGroup & AcfFieldGroupFields & LogoRows_Fields & {
  __typename?: 'LogoRows';
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;LogoRows&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;LogoRows&quot; Field Group */
  logos?: Maybe<Array<Maybe<LogoRowsLogos>>>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;LogoRows&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;LogoRowsLogos&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type LogoRowsLogos = AcfFieldGroup & AcfFieldGroupFields & LogoRowsLogos_Fields & {
  __typename?: 'LogoRowsLogos';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;LogoRowsLogos&quot; Field Group */
  logo?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;number&quot; Field Type added to the schema as part of the &quot;LogoRowsLogos&quot; Field Group */
  maxWidth?: Maybe<Scalars['Float']['output']>;
};

/** Interface representing fields of the ACF &quot;LogoRowsLogos&quot; Field Group */
export type LogoRowsLogos_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;LogoRowsLogos&quot; Field Group */
  logo?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;number&quot; Field Type added to the schema as part of the &quot;LogoRowsLogos&quot; Field Group */
  maxWidth?: Maybe<Scalars['Float']['output']>;
};

/** Interface representing fields of the ACF &quot;LogoRows&quot; Field Group */
export type LogoRows_Fields = {
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;LogoRows&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;LogoRows&quot; Field Group */
  logos?: Maybe<Array<Maybe<LogoRowsLogos>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;LogoRows&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;LogoScroll&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type LogoScroll = AcfFieldGroup & AcfFieldGroupFields & LogoScroll_Fields & {
  __typename?: 'LogoScroll';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;LogoScroll&quot; Field Group */
  logoImages?: Maybe<Array<Maybe<LogoScrollLogoImages>>>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;LogoScroll&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;LogoScrollLogoImages&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type LogoScrollLogoImages = AcfFieldGroup & AcfFieldGroupFields & LogoScrollLogoImages_Fields & {
  __typename?: 'LogoScrollLogoImages';
  /** Field of the &quot;url&quot; Field Type added to the schema as part of the &quot;LogoScrollLogoImages&quot; Field Group */
  companyUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;LogoScrollLogoImages&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
};

/** Interface representing fields of the ACF &quot;LogoScrollLogoImages&quot; Field Group */
export type LogoScrollLogoImages_Fields = {
  /** Field of the &quot;url&quot; Field Type added to the schema as part of the &quot;LogoScrollLogoImages&quot; Field Group */
  companyUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;LogoScrollLogoImages&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
};

/** Interface representing fields of the ACF &quot;LogoScroll&quot; Field Group */
export type LogoScroll_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;LogoScroll&quot; Field Group */
  logoImages?: Maybe<Array<Maybe<LogoScrollLogoImages>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;LogoScroll&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;MainHero&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type MainHero = AcfFieldGroup & AcfFieldGroupFields & MainHero_Fields & {
  __typename?: 'MainHero';
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;MainHero&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;MainHero&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;MainHero&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;MainHero&quot; Field Group */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;MainHero&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;MainHero&quot; Field Group */
export type MainHero_Fields = {
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;MainHero&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;MainHero&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;MainHero&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;MainHero&quot; Field Group */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;MainHero&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

export type MarketoIntegration = AcfOptionsPage & Node & WithAcfMarketoIntegrationBlock & {
  __typename?: 'MarketoIntegration';
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Fields of the MarketoIntegrationBlock ACF Field Group */
  marketoIntegrationBlock?: Maybe<MarketoIntegrationBlock>;
  menuTitle?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
};

/** The &quot;MarketoIntegrationBlock&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type MarketoIntegrationBlock = AcfFieldGroup & AcfFieldGroupFields & MarketoIntegrationBlock_Fields & {
  __typename?: 'MarketoIntegrationBlock';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;MarketoIntegrationBlock&quot; Field Group */
  marketoClientId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;MarketoIntegrationBlock&quot; Field Group */
  marketoClientSecret?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;MarketoIntegrationBlock&quot; Field Group */
  munchkinId?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;MarketoIntegrationBlock&quot; Field Group */
export type MarketoIntegrationBlock_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;MarketoIntegrationBlock&quot; Field Group */
  marketoClientId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;MarketoIntegrationBlock&quot; Field Group */
  marketoClientSecret?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;MarketoIntegrationBlock&quot; Field Group */
  munchkinId?: Maybe<Scalars['String']['output']>;
};

/** File details for a Media Item */
export type MediaDetails = {
  __typename?: 'MediaDetails';
  /** The filename of the mediaItem */
  file?: Maybe<Scalars['String']['output']>;
  /** The path to the mediaItem relative to the uploads directory */
  filePath?: Maybe<Scalars['String']['output']>;
  /** The height of the mediaItem */
  height?: Maybe<Scalars['Int']['output']>;
  /** Meta information associated with the mediaItem */
  meta?: Maybe<MediaItemMeta>;
  /** The available sizes of the mediaItem */
  sizes?: Maybe<Array<Maybe<MediaSize>>>;
  /** The width of the mediaItem */
  width?: Maybe<Scalars['Int']['output']>;
};


/** File details for a Media Item */
export type MediaDetailsSizesArgs = {
  exclude?: InputMaybe<Array<InputMaybe<MediaItemSizeEnum>>>;
  include?: InputMaybe<Array<InputMaybe<MediaItemSizeEnum>>>;
};

/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItem = ContentNode & DatabaseIdentifier & HierarchicalContentNode & HierarchicalNode & Node & NodeWithAuthor & NodeWithComments & NodeWithTemplate & NodeWithTitle & UniformResourceIdentifiable & {
  __typename?: 'MediaItem';
  /** Alternative text to display when resource is not displayed */
  altText?: Maybe<Scalars['String']['output']>;
  /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
  /** Connection between the NodeWithAuthor type and the User type */
  author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the author of the node */
  authorId?: Maybe<Scalars['ID']['output']>;
  /** The caption for the resource */
  caption?: Maybe<Scalars['String']['output']>;
  /** Connection between the HierarchicalContentNode type and the ContentNode type */
  children?: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  commentCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the comments are open or closed for this particular post. */
  commentStatus?: Maybe<Scalars['String']['output']>;
  /** Connection between the MediaItem type and the Comment type */
  comments?: Maybe<MediaItemToCommentConnection>;
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String']['output'];
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']['output']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']['output']>;
  /** Description of the image (stored as post_content) */
  description?: Maybe<Scalars['String']['output']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']['output']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The filename of the mediaItem for the specified size (default size is full) */
  file?: Maybe<Scalars['String']['output']>;
  /** The path to the original file relative to the uploads directory */
  filePath?: Maybe<Scalars['String']['output']>;
  /** The filesize in bytes of the resource */
  fileSize?: Maybe<Scalars['Int']['output']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']['output']>;
  /** Whether the attachment object is password protected. */
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique identifier of the attachment object. */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']['output']>;
  /** Details about the mediaItem */
  mediaDetails?: Maybe<MediaDetails>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of the databaseId field
   */
  mediaItemId: Scalars['Int']['output'];
  /** Url of the mediaItem */
  mediaItemUrl?: Maybe<Scalars['String']['output']>;
  /** Type of resource */
  mediaType?: Maybe<Scalars['String']['output']>;
  /** The mime type of the mediaItem */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']['output']>;
  /** The parent of the node. The parent object can be of various types */
  parent?: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']['output']>;
  /** The password for the attachment object. */
  password?: Maybe<Scalars['String']['output']>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']['output']>;
  /** The Yoast SEO data of the ContentNode */
  seo?: Maybe<PostTypeSeo>;
  /** The sizes attribute value for an image. */
  sizes?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Url of the mediaItem */
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** The srcset attribute specifies the URL of the image to use in different situations. It is a comma separated string of urls and their widths. */
  srcSet?: Maybe<Scalars['String']['output']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']['output']>;
  /** The template assigned to a node of content */
  template?: Maybe<ContentTemplate>;
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemCaptionArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MediaItemToCommentConnectionWhereArgs>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemDescriptionArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemFileArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemFilePathArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemFileSizeArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemSizesArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemSourceUrlArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemSrcSetArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** Represents uploaded media, including images, videos, documents, and audio files. */
export type MediaItemTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A paginated collection of mediaItem Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of mediaItem Nodes */
export type MediaItemConnection = {
  /** A list of edges (relational context) between RootQuery and connected mediaItem Nodes */
  edges: Array<MediaItemConnectionEdge>;
  /** A list of connected mediaItem Nodes */
  nodes: Array<MediaItem>;
  /** Information about pagination in a connection. */
  pageInfo: MediaItemConnectionPageInfo;
};

/** Represents a connection to a mediaItem. Contains both the mediaItem Node and metadata about the relationship. */
export type MediaItemConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected mediaItem Node */
  node: MediaItem;
};

/** Pagination metadata specific to &quot;MediaItemConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;MediaItemConnectionEdge&quot; Nodes. */
export type MediaItemConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Identifier types for retrieving a specific MediaItem. Specifies which unique attribute is used to find an exact MediaItem. */
export enum MediaItemIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a media item by its source url */
  SourceUrl = 'SOURCE_URL',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Meta connected to a MediaItem */
export type MediaItemMeta = {
  __typename?: 'MediaItemMeta';
  /** Aperture measurement of the media item. */
  aperture?: Maybe<Scalars['Float']['output']>;
  /** Information about the camera used to create the media item. */
  camera?: Maybe<Scalars['String']['output']>;
  /** The text string description associated with the media item. */
  caption?: Maybe<Scalars['String']['output']>;
  /** Copyright information associated with the media item. */
  copyright?: Maybe<Scalars['String']['output']>;
  /** The date/time when the media was created. */
  createdTimestamp?: Maybe<Scalars['Int']['output']>;
  /** The original creator of the media item. */
  credit?: Maybe<Scalars['String']['output']>;
  /** The focal length value of the media item. */
  focalLength?: Maybe<Scalars['Float']['output']>;
  /** The ISO (International Organization for Standardization) value of the media item. */
  iso?: Maybe<Scalars['Int']['output']>;
  /** List of keywords used to describe or identfy the media item. */
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The vertical or horizontal aspect of the media item. */
  orientation?: Maybe<Scalars['String']['output']>;
  /** The shutter speed information of the media item. */
  shutterSpeed?: Maybe<Scalars['Float']['output']>;
  /** A useful title for the media item. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Predefined image size variations. Represents the standard image dimensions available for media assets. */
export enum MediaItemSizeEnum {
  /** Custom Image Size. (600x600) */
  GformImageChoiceLg = 'GFORM_IMAGE_CHOICE_LG',
  /** Custom Image Size. (400x400) */
  GformImageChoiceMd = 'GFORM_IMAGE_CHOICE_MD',
  /** Custom Image Size. (300x300) */
  GformImageChoiceSm = 'GFORM_IMAGE_CHOICE_SM',
  /** Large image preview suitable for detail views. (1024x1024) */
  Large = 'LARGE',
  /** Medium image preview typically suitable for listings and detail views. (300x300) */
  Medium = 'MEDIUM',
  /** Medium-to-large image preview suitable for listings and detail views. (768x0) */
  MediumLarge = 'MEDIUM_LARGE',
  /** Small image preview suitable for thumbnails and listings. (50x0) */
  Thumbnail = 'THUMBNAIL',
  /** Custom Image Size. (1536x1536) */
  '1536X1536' = '_1536X1536',
  /** Custom Image Size. (2048x2048) */
  '2048X2048' = '_2048X2048'
}

/** Publication status for media items. Controls whether media is publicly accessible, private, or in another state. */
export enum MediaItemStatusEnum {
  /** Automatically created media that has not been finalized */
  AutoDraft = 'AUTO_DRAFT',
  /** Media that inherits its publication status from the parent content */
  Inherit = 'INHERIT',
  /** Media visible only to users with appropriate permissions */
  Private = 'PRIVATE',
  /** Media marked for deletion but still recoverable */
  Trash = 'TRASH'
}

/** Connection between the MediaItem type and the Comment type */
export type MediaItemToCommentConnection = CommentConnection & Connection & {
  __typename?: 'MediaItemToCommentConnection';
  /** Edges for the MediaItemToCommentConnection connection */
  edges: Array<MediaItemToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: MediaItemToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type MediaItemToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  __typename?: 'MediaItemToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Comment;
};

/** Pagination metadata specific to &quot;MediaItemToCommentConnection&quot; collections. Provides cursors and flags for navigating through sets of MediaItemToCommentConnection Nodes. */
export type MediaItemToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'MediaItemToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the MediaItemToCommentConnection connection */
export type MediaItemToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']['input']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']['input']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']['input']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']['input']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** One or more Comment Statuses to limit results by */
  statusIn?: InputMaybe<Array<InputMaybe<CommentStatusEnum>>>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Details of an available size for a media item */
export type MediaSize = {
  __typename?: 'MediaSize';
  /** The filename of the referenced size */
  file?: Maybe<Scalars['String']['output']>;
  /** The path of the file for the referenced size (default size is full) */
  filePath?: Maybe<Scalars['String']['output']>;
  /** The filesize of the resource */
  fileSize?: Maybe<Scalars['Int']['output']>;
  /** The height of the referenced size */
  height?: Maybe<Scalars['String']['output']>;
  /** The mime type of the referenced size */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The referenced size name */
  name?: Maybe<Scalars['String']['output']>;
  /** The url of the referenced size */
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** The width of the referenced size */
  width?: Maybe<Scalars['String']['output']>;
};

/** Collections of navigation links. Menus can be assigned to designated locations and used to build site navigation structures. */
export type Menu = DatabaseIdentifier & Node & WithAcfBlockFooter & WithAcfMenuButton & WithAcfSystemAlert & {
  __typename?: 'Menu';
  /** Fields of the BlockFooter ACF Field Group */
  blockFooter?: Maybe<BlockFooter>;
  /** The number of items in the menu */
  count?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** The globally unique identifier of the nav menu object. */
  id: Scalars['ID']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** The locations a menu is assigned to */
  locations?: Maybe<Array<Maybe<MenuLocationEnum>>>;
  /** Fields of the MenuButton ACF Field Group */
  menuButton?: Maybe<MenuButton>;
  /**
   * WP ID of the nav menu.
   * @deprecated Deprecated in favor of the databaseId field
   */
  menuId?: Maybe<Scalars['Int']['output']>;
  /** Connection between the Menu type and the MenuItem type */
  menuItems?: Maybe<MenuToMenuItemConnection>;
  /** Display name of the menu. Equivalent to WP_Term-&gt;name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The url friendly name of the menu. Equivalent to WP_Term-&gt;slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Fields of the SystemAlert ACF Field Group */
  systemAlert?: Maybe<SystemAlert>;
};


/** Collections of navigation links. Menus can be assigned to designated locations and used to build site navigation structures. */
export type MenuMenuItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MenuToMenuItemConnectionWhereArgs>;
};

/** The &quot;MenuButton&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type MenuButton = AcfFieldGroup & AcfFieldGroupFields & MenuButton_Fields & {
  __typename?: 'MenuButton';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;MenuButton&quot; Field Group */
  menubutton?: Maybe<Array<Maybe<MenuButtonMenubutton>>>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** The &quot;MenuButtonMenubutton&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type MenuButtonMenubutton = AcfFieldGroup & AcfFieldGroupFields & MenuButtonMenubutton_Fields & {
  __typename?: 'MenuButtonMenubutton';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;MenuButtonMenubutton&quot; Field Group */
  menubuttonlink?: Maybe<AcfLink>;
};

/** Interface representing fields of the ACF &quot;MenuButtonMenubutton&quot; Field Group */
export type MenuButtonMenubutton_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;MenuButtonMenubutton&quot; Field Group */
  menubuttonlink?: Maybe<AcfLink>;
};

/** Interface representing fields of the ACF &quot;MenuButton&quot; Field Group */
export type MenuButton_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;MenuButton&quot; Field Group */
  menubutton?: Maybe<Array<Maybe<MenuButtonMenubutton>>>;
};

/** A paginated collection of Menu Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of Menu Nodes */
export type MenuConnection = {
  /** A list of edges (relational context) between RootQuery and connected Menu Nodes */
  edges: Array<MenuConnectionEdge>;
  /** A list of connected Menu Nodes */
  nodes: Array<Menu>;
  /** Information about pagination in a connection. */
  pageInfo: MenuConnectionPageInfo;
};

/** Represents a connection to a Menu. Contains both the Menu Node and metadata about the relationship. */
export type MenuConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Menu Node */
  node: Menu;
};

/** Pagination metadata specific to &quot;MenuConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;MenuConnectionEdge&quot; Nodes. */
export type MenuConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** The &quot;MenuContent&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type MenuContent = AcfFieldGroup & AcfFieldGroupFields & MenuContent_Fields & {
  __typename?: 'MenuContent';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;MenuContent&quot; Field Group */
  menuItems?: Maybe<Array<Maybe<MenuContentMenuItems>>>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** The &quot;MenuContentMenuItems&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type MenuContentMenuItems = AcfFieldGroup & AcfFieldGroupFields & MenuContentMenuItems_Fields & {
  __typename?: 'MenuContentMenuItems';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;MenuContentMenuItems&quot; Field Group */
  label?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;MenuContentMenuItems&quot; Field Group */
  link?: Maybe<AcfLink>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;MenuContentMenuItems&quot; Field Group */
  menuContent?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;MenuContentMenuItems&quot; Field Group */
export type MenuContentMenuItems_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;MenuContentMenuItems&quot; Field Group */
  label?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;MenuContentMenuItems&quot; Field Group */
  link?: Maybe<AcfLink>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;MenuContentMenuItems&quot; Field Group */
  menuContent?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;MenuContent&quot; Field Group */
export type MenuContent_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;MenuContent&quot; Field Group */
  menuItems?: Maybe<Array<Maybe<MenuContentMenuItems>>>;
};

/** Navigation menu items are the individual items assigned to a menu. These are rendered as the links in a navigation menu. */
export type MenuItem = DatabaseIdentifier & Node & WithAcfMenuContent & WithAcfNavDetails & WithAcfNavSegments & {
  __typename?: 'MenuItem';
  /** Connection between the MenuItem type and the MenuItem type */
  childItems?: Maybe<MenuItemToMenuItemConnection>;
  /** Connection from MenuItem to it&#039;s connected node */
  connectedNode?: Maybe<MenuItemToMenuItemLinkableConnectionEdge>;
  /**
   * The object connected to this menu item.
   * @deprecated Deprecated in favor of the connectedNode field
   */
  connectedObject?: Maybe<MenuItemObjectUnion>;
  /** Class attribute for the menu item link */
  cssClasses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** Description of the menu item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier of the nav menu item object. */
  id: Scalars['ID']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Label or title of the menu item. */
  label?: Maybe<Scalars['String']['output']>;
  /** Link relationship (XFN) of the menu item. */
  linkRelationship?: Maybe<Scalars['String']['output']>;
  /** The locations the menu item&#039;s Menu is assigned to */
  locations?: Maybe<Array<Maybe<MenuLocationEnum>>>;
  /** The Menu a MenuItem is part of */
  menu?: Maybe<MenuItemToMenuConnectionEdge>;
  /** Fields of the MenuContent ACF Field Group */
  menuContent?: Maybe<MenuContent>;
  /**
   * WP ID of the menu item.
   * @deprecated Deprecated in favor of the databaseId field
   */
  menuItemId?: Maybe<Scalars['Int']['output']>;
  /** Fields of the NavDetails ACF Field Group */
  navDetails?: Maybe<NavDetails>;
  /** Fields of the NavSegments ACF Field Group */
  navSegments?: Maybe<NavSegments>;
  /** Menu item order */
  order?: Maybe<Scalars['Int']['output']>;
  /** The database id of the parent menu item or null if it is the root */
  parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent nav menu item object. */
  parentId?: Maybe<Scalars['ID']['output']>;
  /** Path for the resource. Relative path for internal resources. Absolute path for external resources. */
  path?: Maybe<Scalars['String']['output']>;
  /** Target attribute for the menu item link. */
  target?: Maybe<Scalars['String']['output']>;
  /** Title attribute for the menu item link */
  title?: Maybe<Scalars['String']['output']>;
  /** The uri of the resource the menu item links to */
  uri?: Maybe<Scalars['String']['output']>;
  /** URL or destination of the menu item. */
  url?: Maybe<Scalars['String']['output']>;
};


/** Navigation menu items are the individual items assigned to a menu. These are rendered as the links in a navigation menu. */
export type MenuItemChildItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MenuItemToMenuItemConnectionWhereArgs>;
};

/** A paginated collection of MenuItem Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of MenuItem Nodes */
export type MenuItemConnection = {
  /** A list of edges (relational context) between RootQuery and connected MenuItem Nodes */
  edges: Array<MenuItemConnectionEdge>;
  /** A list of connected MenuItem Nodes */
  nodes: Array<MenuItem>;
  /** Information about pagination in a connection. */
  pageInfo: MenuItemConnectionPageInfo;
};

/** Represents a connection to a MenuItem. Contains both the MenuItem Node and metadata about the relationship. */
export type MenuItemConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected MenuItem Node */
  node: MenuItem;
};

/** Pagination metadata specific to &quot;MenuItemConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;MenuItemConnectionEdge&quot; Nodes. */
export type MenuItemConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Content that can be referenced by navigation menu items. Provides the essential fields needed to create links within navigation structures. */
export type MenuItemLinkable = {
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
};

/** Represents a connection to a MenuItemLinkable. Contains both the MenuItemLinkable Node and metadata about the relationship. */
export type MenuItemLinkableConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected MenuItemLinkable Node */
  node: MenuItemLinkable;
};

/** Identifier types for retrieving a specific menu item. Determines whether to look up menu items by global ID or database ID. */
export enum MenuItemNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID'
}

/** Deprecated in favor of MenuItemLinkeable Interface */
export type MenuItemObjectUnion = Category | Page | Post | Tag;

/** Connection between the MenuItem type and the Menu type */
export type MenuItemToMenuConnectionEdge = Edge & MenuConnectionEdge & OneToOneConnection & {
  __typename?: 'MenuItemToMenuConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: Menu;
};

/** Connection between the MenuItem type and the MenuItem type */
export type MenuItemToMenuItemConnection = Connection & MenuItemConnection & {
  __typename?: 'MenuItemToMenuItemConnection';
  /** Edges for the MenuItemToMenuItemConnection connection */
  edges: Array<MenuItemToMenuItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<MenuItem>;
  /** Information about pagination in a connection. */
  pageInfo: MenuItemToMenuItemConnectionPageInfo;
};

/** An edge in a connection */
export type MenuItemToMenuItemConnectionEdge = Edge & MenuItemConnectionEdge & {
  __typename?: 'MenuItemToMenuItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: MenuItem;
};

/** Pagination metadata specific to &quot;MenuItemToMenuItemConnection&quot; collections. Provides cursors and flags for navigating through sets of MenuItemToMenuItemConnection Nodes. */
export type MenuItemToMenuItemConnectionPageInfo = MenuItemConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'MenuItemToMenuItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the MenuItemToMenuItemConnection connection */
export type MenuItemToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The menu location for the menu being queried */
  location?: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  parentDatabaseId?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the parent menu object */
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection between the MenuItem type and the MenuItemLinkable type */
export type MenuItemToMenuItemLinkableConnectionEdge = Edge & MenuItemLinkableConnectionEdge & OneToOneConnection & {
  __typename?: 'MenuItemToMenuItemLinkableConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: MenuItemLinkable;
};

/** Designated areas where navigation menus can be displayed. Represents the named regions in the interface where menus can be assigned. */
export enum MenuLocationEnum {
  /** Put the menu in the footer location */
  Footer = 'FOOTER',
  /** Put the menu in the mobile-menu location */
  MobileMenu = 'MOBILE_MENU',
  /** Put the menu in the primary location */
  Primary = 'PRIMARY'
}

/** Identifier types for retrieving a specific navigation menu. Specifies which property (ID, name, location) is used to locate a particular menu. */
export enum MenuNodeIdTypeEnum {
  /** Identify a menu node by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a menu node by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a menu node by the slug of menu location to which it is assigned */
  Location = 'LOCATION',
  /** Identify a menu node by its name */
  Name = 'NAME',
  /** Identify a menu node by its slug */
  Slug = 'SLUG'
}

/** Connection between the Menu type and the MenuItem type */
export type MenuToMenuItemConnection = Connection & MenuItemConnection & {
  __typename?: 'MenuToMenuItemConnection';
  /** Edges for the MenuToMenuItemConnection connection */
  edges: Array<MenuToMenuItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<MenuItem>;
  /** Information about pagination in a connection. */
  pageInfo: MenuToMenuItemConnectionPageInfo;
};

/** An edge in a connection */
export type MenuToMenuItemConnectionEdge = Edge & MenuItemConnectionEdge & {
  __typename?: 'MenuToMenuItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: MenuItem;
};

/** Pagination metadata specific to &quot;MenuToMenuItemConnection&quot; collections. Provides cursors and flags for navigating through sets of MenuToMenuItemConnection Nodes. */
export type MenuToMenuItemConnectionPageInfo = MenuItemConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'MenuToMenuItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the MenuToMenuItemConnection connection */
export type MenuToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The menu location for the menu being queried */
  location?: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  parentDatabaseId?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the parent menu object */
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

/** Media file type classification based on MIME standards. Used to identify and filter media items by their format and content type. */
export enum MimeTypeEnum {
  /** application/java mime type. */
  ApplicationJava = 'APPLICATION_JAVA',
  /** application/msword mime type. */
  ApplicationMsword = 'APPLICATION_MSWORD',
  /** application/octet-stream mime type. */
  ApplicationOctetStream = 'APPLICATION_OCTET_STREAM',
  /** application/onenote mime type. */
  ApplicationOnenote = 'APPLICATION_ONENOTE',
  /** application/oxps mime type. */
  ApplicationOxps = 'APPLICATION_OXPS',
  /** application/pdf mime type. */
  ApplicationPdf = 'APPLICATION_PDF',
  /** application/rar mime type. */
  ApplicationRar = 'APPLICATION_RAR',
  /** application/rtf mime type. */
  ApplicationRtf = 'APPLICATION_RTF',
  /** application/ttaf+xml mime type. */
  ApplicationTtafXml = 'APPLICATION_TTAF_XML',
  /** application/vnd.apple.keynote mime type. */
  ApplicationVndAppleKeynote = 'APPLICATION_VND_APPLE_KEYNOTE',
  /** application/vnd.apple.numbers mime type. */
  ApplicationVndAppleNumbers = 'APPLICATION_VND_APPLE_NUMBERS',
  /** application/vnd.apple.pages mime type. */
  ApplicationVndApplePages = 'APPLICATION_VND_APPLE_PAGES',
  /** application/vnd.ms-access mime type. */
  ApplicationVndMsAccess = 'APPLICATION_VND_MS_ACCESS',
  /** application/vnd.ms-excel mime type. */
  ApplicationVndMsExcel = 'APPLICATION_VND_MS_EXCEL',
  /** application/vnd.ms-excel.addin.macroEnabled.12 mime type. */
  ApplicationVndMsExcelAddinMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_ADDIN_MACROENABLED_12',
  /** application/vnd.ms-excel.sheet.binary.macroEnabled.12 mime type. */
  ApplicationVndMsExcelSheetBinaryMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12',
  /** application/vnd.ms-excel.sheet.macroEnabled.12 mime type. */
  ApplicationVndMsExcelSheetMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12',
  /** application/vnd.ms-excel.template.macroEnabled.12 mime type. */
  ApplicationVndMsExcelTemplateMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_TEMPLATE_MACROENABLED_12',
  /** application/vnd.ms-powerpoint mime type. */
  ApplicationVndMsPowerpoint = 'APPLICATION_VND_MS_POWERPOINT',
  /** application/vnd.ms-powerpoint.addin.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointAddinMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_ADDIN_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.presentation.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointPresentationMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.slideshow.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointSlideshowMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.slide.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointSlideMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_SLIDE_MACROENABLED_12',
  /** application/vnd.ms-powerpoint.template.macroEnabled.12 mime type. */
  ApplicationVndMsPowerpointTemplateMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACROENABLED_12',
  /** application/vnd.ms-project mime type. */
  ApplicationVndMsProject = 'APPLICATION_VND_MS_PROJECT',
  /** application/vnd.ms-word.document.macroEnabled.12 mime type. */
  ApplicationVndMsWordDocumentMacroenabled_12 = 'APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12',
  /** application/vnd.ms-word.template.macroEnabled.12 mime type. */
  ApplicationVndMsWordTemplateMacroenabled_12 = 'APPLICATION_VND_MS_WORD_TEMPLATE_MACROENABLED_12',
  /** application/vnd.ms-write mime type. */
  ApplicationVndMsWrite = 'APPLICATION_VND_MS_WRITE',
  /** application/vnd.ms-xpsdocument mime type. */
  ApplicationVndMsXpsdocument = 'APPLICATION_VND_MS_XPSDOCUMENT',
  /** application/vnd.oasis.opendocument.chart mime type. */
  ApplicationVndOasisOpendocumentChart = 'APPLICATION_VND_OASIS_OPENDOCUMENT_CHART',
  /** application/vnd.oasis.opendocument.database mime type. */
  ApplicationVndOasisOpendocumentDatabase = 'APPLICATION_VND_OASIS_OPENDOCUMENT_DATABASE',
  /** application/vnd.oasis.opendocument.formula mime type. */
  ApplicationVndOasisOpendocumentFormula = 'APPLICATION_VND_OASIS_OPENDOCUMENT_FORMULA',
  /** application/vnd.oasis.opendocument.graphics mime type. */
  ApplicationVndOasisOpendocumentGraphics = 'APPLICATION_VND_OASIS_OPENDOCUMENT_GRAPHICS',
  /** application/vnd.oasis.opendocument.presentation mime type. */
  ApplicationVndOasisOpendocumentPresentation = 'APPLICATION_VND_OASIS_OPENDOCUMENT_PRESENTATION',
  /** application/vnd.oasis.opendocument.spreadsheet mime type. */
  ApplicationVndOasisOpendocumentSpreadsheet = 'APPLICATION_VND_OASIS_OPENDOCUMENT_SPREADSHEET',
  /** application/vnd.oasis.opendocument.text mime type. */
  ApplicationVndOasisOpendocumentText = 'APPLICATION_VND_OASIS_OPENDOCUMENT_TEXT',
  /** application/vnd.openxmlformats-officedocument.presentationml.presentation mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlPresentation = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION',
  /** application/vnd.openxmlformats-officedocument.presentationml.slide mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlSlide = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDE',
  /** application/vnd.openxmlformats-officedocument.presentationml.slideshow mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlSlideshow = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW',
  /** application/vnd.openxmlformats-officedocument.presentationml.template mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_TEMPLATE',
  /** application/vnd.openxmlformats-officedocument.spreadsheetml.sheet mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET',
  /** application/vnd.openxmlformats-officedocument.spreadsheetml.template mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_TEMPLATE',
  /** application/vnd.openxmlformats-officedocument.wordprocessingml.document mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlDocument = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT',
  /** application/vnd.openxmlformats-officedocument.wordprocessingml.template mime type. */
  ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_TEMPLATE',
  /** application/wordperfect mime type. */
  ApplicationWordperfect = 'APPLICATION_WORDPERFECT',
  /** application/x-7z-compressed mime type. */
  ApplicationX_7ZCompressed = 'APPLICATION_X_7Z_COMPRESSED',
  /** application/x-gzip mime type. */
  ApplicationXGzip = 'APPLICATION_X_GZIP',
  /** application/x-tar mime type. */
  ApplicationXTar = 'APPLICATION_X_TAR',
  /** application/zip mime type. */
  ApplicationZip = 'APPLICATION_ZIP',
  /** audio/aac mime type. */
  AudioAac = 'AUDIO_AAC',
  /** audio/flac mime type. */
  AudioFlac = 'AUDIO_FLAC',
  /** audio/midi mime type. */
  AudioMidi = 'AUDIO_MIDI',
  /** audio/mpeg mime type. */
  AudioMpeg = 'AUDIO_MPEG',
  /** audio/ogg mime type. */
  AudioOgg = 'AUDIO_OGG',
  /** audio/wav mime type. */
  AudioWav = 'AUDIO_WAV',
  /** audio/x-matroska mime type. */
  AudioXMatroska = 'AUDIO_X_MATROSKA',
  /** audio/x-ms-wax mime type. */
  AudioXMsWax = 'AUDIO_X_MS_WAX',
  /** audio/x-ms-wma mime type. */
  AudioXMsWma = 'AUDIO_X_MS_WMA',
  /** audio/x-realaudio mime type. */
  AudioXRealaudio = 'AUDIO_X_REALAUDIO',
  /** image/avif mime type. */
  ImageAvif = 'IMAGE_AVIF',
  /** image/bmp mime type. */
  ImageBmp = 'IMAGE_BMP',
  /** image/gif mime type. */
  ImageGif = 'IMAGE_GIF',
  /** image/heic mime type. */
  ImageHeic = 'IMAGE_HEIC',
  /** image/heic-sequence mime type. */
  ImageHeicSequence = 'IMAGE_HEIC_SEQUENCE',
  /** image/heif mime type. */
  ImageHeif = 'IMAGE_HEIF',
  /** image/heif-sequence mime type. */
  ImageHeifSequence = 'IMAGE_HEIF_SEQUENCE',
  /** image/jpeg mime type. */
  ImageJpeg = 'IMAGE_JPEG',
  /** image/png mime type. */
  ImagePng = 'IMAGE_PNG',
  /** image/svg+xml mime type. */
  ImageSvgXml = 'IMAGE_SVG_XML',
  /** image/tiff mime type. */
  ImageTiff = 'IMAGE_TIFF',
  /** image/webp mime type. */
  ImageWebp = 'IMAGE_WEBP',
  /** image/x-icon mime type. */
  ImageXIcon = 'IMAGE_X_ICON',
  /** text/calendar mime type. */
  TextCalendar = 'TEXT_CALENDAR',
  /** text/css mime type. */
  TextCss = 'TEXT_CSS',
  /** text/csv mime type. */
  TextCsv = 'TEXT_CSV',
  /** text/plain mime type. */
  TextPlain = 'TEXT_PLAIN',
  /** text/richtext mime type. */
  TextRichtext = 'TEXT_RICHTEXT',
  /** text/tab-separated-values mime type. */
  TextTabSeparatedValues = 'TEXT_TAB_SEPARATED_VALUES',
  /** text/vtt mime type. */
  TextVtt = 'TEXT_VTT',
  /** video/3gpp mime type. */
  Video_3Gpp = 'VIDEO_3GPP',
  /** video/3gpp2 mime type. */
  Video_3Gpp2 = 'VIDEO_3GPP2',
  /** video/avi mime type. */
  VideoAvi = 'VIDEO_AVI',
  /** video/divx mime type. */
  VideoDivx = 'VIDEO_DIVX',
  /** video/mp4 mime type. */
  VideoMp4 = 'VIDEO_MP4',
  /** video/mpeg mime type. */
  VideoMpeg = 'VIDEO_MPEG',
  /** video/ogg mime type. */
  VideoOgg = 'VIDEO_OGG',
  /** video/quicktime mime type. */
  VideoQuicktime = 'VIDEO_QUICKTIME',
  /** video/webm mime type. */
  VideoWebm = 'VIDEO_WEBM',
  /** video/x-flv mime type. */
  VideoXFlv = 'VIDEO_X_FLV',
  /** video/x-matroska mime type. */
  VideoXMatroska = 'VIDEO_X_MATROSKA',
  /** video/x-ms-asf mime type. */
  VideoXMsAsf = 'VIDEO_X_MS_ASF',
  /** video/x-ms-wm mime type. */
  VideoXMsWm = 'VIDEO_X_MS_WM',
  /** video/x-ms-wmv mime type. */
  VideoXMsWmv = 'VIDEO_X_MS_WMV',
  /** video/x-ms-wmx mime type. */
  VideoXMsWmx = 'VIDEO_X_MS_WMX'
}

/** A Gravity Forms multi_choice field. */
export type MultiChoiceField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & Node & {
  __typename?: 'MultiChoiceField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<MultiChoiceFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** MultiChoiceFieldChoice choice values. */
export type MultiChoiceFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & {
  __typename?: 'MultiChoiceFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms multiselect field. */
export type MultiSelectField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithEnhancedUiSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & {
  __typename?: 'MultiSelectField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<MultiSelectFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** When set to true, the &quot;Chosen&quot; jQuery script will be applied to this field, enabling search capabilities to Drop Down fields and a more user-friendly interface for Multi Select fields. */
  hasEnhancedUI?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** An array of field values. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** MultiSelectFieldChoice choice values. */
export type MultiSelectFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & {
  __typename?: 'MultiSelectFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms name field. */
export type NameField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithNameSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSubLabelPlacementSetting & Node & {
  __typename?: 'NameField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<NameInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** Name field value. */
  nameValues?: Maybe<NameFieldValue>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The placement of the labels for the subfields within the group. This setting controls all of the subfields, they cannot be set individually. They may be aligned above or below the inputs. If this property is not set, the “Sub-Label Placement” setting on the Form Settings-&gt;Form Layout page is used. If no setting is specified, the default is above inputs. */
  subLabelPlacement?: Maybe<FormFieldSubLabelPlacementEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** NameFieldChoice choice values. */
export type NameFieldChoice = GfFieldChoice & GfFieldChoiceWithNameSetting & {
  __typename?: 'NameFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Input fields for name field. */
export type NameFieldInput = {
  /** First name. */
  first?: InputMaybe<Scalars['String']['input']>;
  /** Last name. */
  last?: InputMaybe<Scalars['String']['input']>;
  /** Middle name. */
  middle?: InputMaybe<Scalars['String']['input']>;
  /** Prefix, such as Mr., Mrs. etc. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** Suffix, such as Sr., Jr. etc. */
  suffix?: InputMaybe<Scalars['String']['input']>;
};

/** The individual properties for each element of the Name value field. */
export type NameFieldValue = {
  __typename?: 'NameFieldValue';
  /** First name. */
  first?: Maybe<Scalars['String']['output']>;
  /** Last name. */
  last?: Maybe<Scalars['String']['output']>;
  /** Middle name. */
  middle?: Maybe<Scalars['String']['output']>;
  /** Prefix, such as Mr., Mrs. etc. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** Suffix, such as Sr., Jr. etc. */
  suffix?: Maybe<Scalars['String']['output']>;
};

/** NameInputProperty input values. */
export type NameInputProperty = GfFieldInput & GfFieldInputWithNameSetting & {
  __typename?: 'NameInputProperty';
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The nested NameFieldChoice choice. */
  choices?: Maybe<Array<Maybe<NameFieldChoice>>>;
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** Whether or not this field should be hidden. */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Key used to identify this input. */
  key?: Maybe<Scalars['String']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** The &quot;NavDetails&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type NavDetails = AcfFieldGroup & AcfFieldGroupFields & NavDetails_Fields & {
  __typename?: 'NavDetails';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;NavDetails&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;NavDetails&quot; Field Group */
  link?: Maybe<AcfLink>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;NavDetails&quot; Field Group */
export type NavDetails_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;NavDetails&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;NavDetails&quot; Field Group */
  link?: Maybe<AcfLink>;
};

/** The &quot;NavSegments&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type NavSegments = AcfFieldGroup & AcfFieldGroupFields & NavSegments_Fields & {
  __typename?: 'NavSegments';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;NavSegments&quot; Field Group */
  segments?: Maybe<Array<Maybe<NavSegmentsSegments>>>;
};

/** The &quot;NavSegmentsSegments&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type NavSegmentsSegments = AcfFieldGroup & AcfFieldGroupFields & NavSegmentsSegments_Fields & {
  __typename?: 'NavSegmentsSegments';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;NavSegmentsSegments&quot; Field Group */
  links?: Maybe<Array<Maybe<NavSegmentsSegmentsLinks>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;NavSegmentsSegments&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;NavSegmentsSegmentsLinks&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type NavSegmentsSegmentsLinks = AcfFieldGroup & AcfFieldGroupFields & NavSegmentsSegmentsLinks_Fields & {
  __typename?: 'NavSegmentsSegmentsLinks';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;NavSegmentsSegmentsLinks&quot; Field Group */
  link?: Maybe<AcfLink>;
};

/** Interface representing fields of the ACF &quot;NavSegmentsSegmentsLinks&quot; Field Group */
export type NavSegmentsSegmentsLinks_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;NavSegmentsSegmentsLinks&quot; Field Group */
  link?: Maybe<AcfLink>;
};

/** Interface representing fields of the ACF &quot;NavSegmentsSegments&quot; Field Group */
export type NavSegmentsSegments_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;NavSegmentsSegments&quot; Field Group */
  links?: Maybe<Array<Maybe<NavSegmentsSegmentsLinks>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;NavSegmentsSegments&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;NavSegments&quot; Field Group */
export type NavSegments_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;NavSegments&quot; Field Group */
  segments?: Maybe<Array<Maybe<NavSegmentsSegments>>>;
};

/** The &quot;NewsAndInsights&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type NewsAndInsights = AcfFieldGroup & AcfFieldGroupFields & NewsAndInsights_Fields & {
  __typename?: 'NewsAndInsights';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;NewsAndInsights&quot; Field Group */
  articleLinkText?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;NewsAndInsights&quot; Field Group */
  articles?: Maybe<Array<Maybe<NewsAndInsightsArticles>>>;
  /** Field of the &quot;taxonomy&quot; Field Type added to the schema as part of the &quot;NewsAndInsights&quot; Field Group */
  category?: Maybe<AcfTermNodeConnection>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;NewsAndInsights&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};


/** The &quot;NewsAndInsights&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type NewsAndInsightsCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The &quot;NewsAndInsightsArticles&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type NewsAndInsightsArticles = AcfFieldGroup & AcfFieldGroupFields & NewsAndInsightsArticles_Fields & {
  __typename?: 'NewsAndInsightsArticles';
  /** Field of the &quot;post_object&quot; Field Type added to the schema as part of the &quot;NewsAndInsightsArticles&quot; Field Group */
  articles?: Maybe<AcfContentNodeConnection>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};


/** The &quot;NewsAndInsightsArticles&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type NewsAndInsightsArticlesArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Interface representing fields of the ACF &quot;NewsAndInsightsArticles&quot; Field Group */
export type NewsAndInsightsArticles_Fields = {
  /** Field of the &quot;post_object&quot; Field Type added to the schema as part of the &quot;NewsAndInsightsArticles&quot; Field Group */
  articles?: Maybe<AcfContentNodeConnection>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};


/** Interface representing fields of the ACF &quot;NewsAndInsightsArticles&quot; Field Group */
export type NewsAndInsightsArticles_FieldsArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Interface representing fields of the ACF &quot;NewsAndInsights&quot; Field Group */
export type NewsAndInsights_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;NewsAndInsights&quot; Field Group */
  articleLinkText?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;NewsAndInsights&quot; Field Group */
  articles?: Maybe<Array<Maybe<NewsAndInsightsArticles>>>;
  /** Field of the &quot;taxonomy&quot; Field Type added to the schema as part of the &quot;NewsAndInsights&quot; Field Group */
  category?: Maybe<AcfTermNodeConnection>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;NewsAndInsights&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};


/** Interface representing fields of the ACF &quot;NewsAndInsights&quot; Field Group */
export type NewsAndInsights_FieldsCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The &quot;NewsletterSignup&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type NewsletterSignup = AcfFieldGroup & AcfFieldGroupFields & NewsletterSignup_Fields & {
  __typename?: 'NewsletterSignup';
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;NewsletterSignup&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;NewsletterSignup&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;NewsletterSignup&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;NewsletterSignup&quot; Field Group */
  marketoFormId?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;NewsletterSignup&quot; Field Group */
  successMessage?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;url&quot; Field Type added to the schema as part of the &quot;NewsletterSignup&quot; Field Group */
  successUrl?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;NewsletterSignup&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;NewsletterSignup&quot; Field Group */
export type NewsletterSignup_Fields = {
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;NewsletterSignup&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;NewsletterSignup&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;NewsletterSignup&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;NewsletterSignup&quot; Field Group */
  marketoFormId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;NewsletterSignup&quot; Field Group */
  successMessage?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;url&quot; Field Type added to the schema as part of the &quot;NewsletterSignup&quot; Field Group */
  successUrl?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;NewsletterSignup&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** An object with a globally unique identifier. All objects that can be identified by a unique ID implement this interface. */
export type Node = {
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
};

/** Content that can be attributed to a specific user. Provides fields for accessing the author&#039;s information and establishing content ownership. */
export type NodeWithAuthor = {
  /** Connection between the NodeWithAuthor type and the User type */
  author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the author of the node */
  authorId?: Maybe<Scalars['ID']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
};

/** Connection between the NodeWithAuthor type and the User type */
export type NodeWithAuthorToUserConnectionEdge = Edge & OneToOneConnection & UserConnectionEdge & {
  __typename?: 'NodeWithAuthorToUserConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: User;
};

/** Content that can receive and display user-submitted comments. Provides fields for accessing comment counts and managing comment status. */
export type NodeWithComments = {
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  commentCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the comments are open or closed for this particular post. */
  commentStatus?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
};

/** Content that has a main body field which can contain formatted text and media. Provides access to both raw (with appropriate permissions) and rendered versions of the content. */
export type NodeWithContentEditor = {
  /** The content of the post. */
  content?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
};


/** Content that has a main body field which can contain formatted text and media. Provides access to both raw (with appropriate permissions) and rendered versions of the content. */
export type NodeWithContentEditorContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Node that has content blocks associated with it */
export type NodeWithEditorBlocks = {
  /** List of editor blocks */
  editorBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
};


/** Node that has content blocks associated with it */
export type NodeWithEditorBlocksEditorBlocksArgs = {
  flat?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A node which provides an excerpt field, which is a condensed summary of the main content. Excerpts can be manually created or automatically generated and are often used in content listings and search results. */
export type NodeWithExcerpt = {
  /** The excerpt of the post. */
  excerpt?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
};


/** A node which provides an excerpt field, which is a condensed summary of the main content. Excerpts can be manually created or automatically generated and are often used in content listings and search results. */
export type NodeWithExcerptExcerptArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Content that can have a primary image attached. This image is typically used for thumbnails, social sharing, and prominent display in the presentation layer. */
export type NodeWithFeaturedImage = {
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId?: Maybe<Scalars['ID']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
};

/** Connection between the NodeWithFeaturedImage type and the MediaItem type */
export type NodeWithFeaturedImageToMediaItemConnectionEdge = Edge & MediaItemConnectionEdge & OneToOneConnection & {
  __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: MediaItem;
};

/** A node that can have a Gravity Forms form assigned to it. */
export type NodeWithForm = {
  /** The form object of the node. */
  form?: Maybe<GfForm>;
  /** The database identifier of the form of the node. */
  formDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the form of the node. */
  formId?: Maybe<Scalars['ID']['output']>;
};

/** Content that supports ordering metadata. Includes a menu order field which can be used for custom sorting in navigation menus and other ordered collections. */
export type NodeWithPageAttributes = {
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: Maybe<Scalars['Int']['output']>;
};

/** Node that has Page content blocks associated with it */
export type NodeWithPageEditorBlocks = {
  /** List of Page editor blocks */
  editorBlocks?: Maybe<Array<Maybe<PageEditorBlock>>>;
};


/** Node that has Page content blocks associated with it */
export type NodeWithPageEditorBlocksEditorBlocksArgs = {
  flat?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Node that has Post content blocks associated with it */
export type NodeWithPostEditorBlocks = {
  /** List of Post editor blocks */
  editorBlocks?: Maybe<Array<Maybe<PostEditorBlock>>>;
};


/** Node that has Post content blocks associated with it */
export type NodeWithPostEditorBlocksEditorBlocksArgs = {
  flat?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Content that maintains a history of changes. Provides access to previous versions of the content and the ability to restore earlier revisions. */
export type NodeWithRevisions = {
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** True if the node is a revision of another node */
  isRevision?: Maybe<Scalars['Boolean']['output']>;
  /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
  revisionOf?: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
};

/** Connection between the NodeWithRevisions type and the ContentNode type */
export type NodeWithRevisionsToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & OneToOneConnection & {
  __typename?: 'NodeWithRevisionsToContentNodeConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: ContentNode;
};

/** Content that provides template metadata. The template can help inform how the content is might be structured, styled, and presented to the user. */
export type NodeWithTemplate = {
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** The template assigned to the node */
  template?: Maybe<ContentTemplate>;
};

/** Content with a dedicated title field. The title typically serves as the main heading and identifier for the content. */
export type NodeWithTitle = {
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** The Yoast SEO data of the ContentNode */
  seo?: Maybe<PostTypeSeo>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']['output']>;
};


/** Content with a dedicated title field. The title typically serves as the main heading and identifier for the content. */
export type NodeWithTitleTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Content that supports cross-site notifications when linked to by other sites. Includes fields for pingback status and linked URLs. */
export type NodeWithTrackbacks = {
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Whether the pings are open or closed for this particular post. */
  pingStatus?: Maybe<Scalars['String']['output']>;
  /** URLs that have been pinged. */
  pinged?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** URLs queued to be pinged. */
  toPing?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** A Gravity Forms number field. */
export type NumberField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithCalculationSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithNumberFormatSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRangeSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & {
  __typename?: 'NumberField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The formula used for the number field. */
  calculationFormula?: Maybe<Scalars['String']['output']>;
  /** Specifies to how many decimal places the number should be rounded. This is available when `isCalculation` is true, but will return null if the number format is `CURRENCY` or if the calculation is set to `Do not round`. */
  calculationRounding?: Maybe<Scalars['Int']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Indicates whether the number field is a calculation. */
  isCalculation?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** Specifies the format allowed for the number field. */
  numberFormat?: Maybe<NumberFieldFormatEnum>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Maximum allowed value for a number field. Values higher than the number specified by this property will cause the field to fail validation. */
  rangeMax?: Maybe<Scalars['Float']['output']>;
  /** Minimum allowed value for a number field. Values lower than the number specified by this property will cause the field to fail validation. */
  rangeMin?: Maybe<Scalars['Float']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** The format allowed for the number field. . */
export enum NumberFieldFormatEnum {
  /** Currency format. */
  Currency = 'CURRENCY',
  /** Decimal-comma format (e.g. 9.999,99). */
  DecimalComma = 'DECIMAL_COMMA',
  /** Decimal-dot format (e.g. 9,999.99). */
  DecimalDot = 'DECIMAL_DOT'
}

/** A direct one-to-one relationship between objects. Unlike plural connections, this represents a single related object rather than a collection. */
export type OneToOneConnection = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected node */
  node: Node;
};

/** A Gravity Forms checkbox option field. */
export type OptionCheckboxField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithProductFieldSetting & GfFieldWithRulesSetting & GfFieldWithSelectAllChoicesSetting & Node & OptionField & {
  __typename?: 'OptionCheckboxField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Checkbox field value. */
  checkboxValues?: Maybe<Array<Maybe<CheckboxFieldValue>>>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<OptionCheckboxFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** The product field to which the field is associated. */
  connectedProductField?: Maybe<ProductField>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the \&quot;select all\&quot; choice should be displayed. */
  hasSelectAll?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<OptionCheckboxInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /**
   * The id of the product field to which the field is associated.
   * @deprecated Use `connectedProductField` field instead.
   */
  productField?: Maybe<Scalars['Int']['output']>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** OptionCheckboxFieldChoice choice values. */
export type OptionCheckboxFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & OptionFieldChoice & {
  __typename?: 'OptionCheckboxFieldChoice';
  /** The price associated with the choice. */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The price associated with the choice. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** OptionCheckboxInputProperty input values. */
export type OptionCheckboxInputProperty = GfFieldInput & GfFieldInputWithSelectAllChoicesSetting & {
  __typename?: 'OptionCheckboxInputProperty';
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms option field. */
export type OptionField = {
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<OptionFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** The product field to which the field is associated. */
  connectedProductField?: Maybe<ProductField>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /**
   * The id of the product field to which the field is associated.
   * @deprecated Use `connectedProductField` field instead.
   */
  productField?: Maybe<Scalars['Int']['output']>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** OptionFieldChoice choice values. */
export type OptionFieldChoice = {
  /** The price associated with the choice. */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The price associated with the choice. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms radio option field. */
export type OptionRadioField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithOtherChoiceSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithProductFieldSetting & GfFieldWithRulesSetting & Node & OptionField & {
  __typename?: 'OptionRadioField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<OptionRadioFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** The product field to which the field is associated. */
  connectedProductField?: Maybe<ProductField>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the &#039;Enable &quot;other&quot; choice&#039; option is checked in the editor. */
  hasOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /**
   * The id of the product field to which the field is associated.
   * @deprecated Use `connectedProductField` field instead.
   */
  productField?: Maybe<Scalars['Int']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** OptionRadioFieldChoice choice values. */
export type OptionRadioFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & GfFieldChoiceWithOtherChoiceSetting & OptionFieldChoice & {
  __typename?: 'OptionRadioFieldChoice';
  /** The price associated with the choice. */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** Indicates the radio button item is the “Other” choice. */
  isOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The price associated with the choice. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms select option field. */
export type OptionSelectField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithEnhancedUiSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithProductFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & OptionField & {
  __typename?: 'OptionSelectField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<OptionSelectFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** The product field to which the field is associated. */
  connectedProductField?: Maybe<ProductField>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** When set to true, the &quot;Chosen&quot; jQuery script will be applied to this field, enabling search capabilities to Drop Down fields and a more user-friendly interface for Multi Select fields. */
  hasEnhancedUI?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /**
   * The id of the product field to which the field is associated.
   * @deprecated Use `connectedProductField` field instead.
   */
  productField?: Maybe<Scalars['Int']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** OptionSelectFieldChoice choice values. */
export type OptionSelectFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & OptionFieldChoice & {
  __typename?: 'OptionSelectFieldChoice';
  /** The price associated with the choice. */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The price associated with the choice. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Sort direction for ordered results. Determines whether items are returned in ascending or descending order. */
export enum OrderEnum {
  /** Results ordered from lowest to highest values (i.e. A-Z, oldest-newest) */
  Asc = 'ASC',
  /** Results ordered from highest to lowest values (i.e. Z-A, newest-oldest) */
  Desc = 'DESC'
}

/** The &quot;OurHistory&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type OurHistory = AcfFieldGroup & AcfFieldGroupFields & OurHistory_Fields & {
  __typename?: 'OurHistory';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;OurHistory&quot; Field Group */
  timeline?: Maybe<Array<Maybe<OurHistoryTimeline>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;OurHistory&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;OurHistoryTimeline&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type OurHistoryTimeline = AcfFieldGroup & AcfFieldGroupFields & OurHistoryTimeline_Fields & {
  __typename?: 'OurHistoryTimeline';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;OurHistoryTimeline&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;OurHistoryTimeline&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;OurHistoryTimeline&quot; Field Group */
  keyPoints?: Maybe<Array<Maybe<OurHistoryTimelineKeyPoints>>>;
  /** Field of the &quot;number&quot; Field Type added to the schema as part of the &quot;OurHistoryTimeline&quot; Field Group */
  year?: Maybe<Scalars['Float']['output']>;
};

/** The &quot;OurHistoryTimelineKeyPoints&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type OurHistoryTimelineKeyPoints = AcfFieldGroup & AcfFieldGroupFields & OurHistoryTimelineKeyPoints_Fields & {
  __typename?: 'OurHistoryTimelineKeyPoints';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;OurHistoryTimelineKeyPoints&quot; Field Group */
  field?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;OurHistoryTimelineKeyPoints&quot; Field Group */
  value?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;OurHistoryTimelineKeyPoints&quot; Field Group */
export type OurHistoryTimelineKeyPoints_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;OurHistoryTimelineKeyPoints&quot; Field Group */
  field?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;OurHistoryTimelineKeyPoints&quot; Field Group */
  value?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;OurHistoryTimeline&quot; Field Group */
export type OurHistoryTimeline_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;OurHistoryTimeline&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;OurHistoryTimeline&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;OurHistoryTimeline&quot; Field Group */
  keyPoints?: Maybe<Array<Maybe<OurHistoryTimelineKeyPoints>>>;
  /** Field of the &quot;number&quot; Field Type added to the schema as part of the &quot;OurHistoryTimeline&quot; Field Group */
  year?: Maybe<Scalars['Float']['output']>;
};

/** Interface representing fields of the ACF &quot;OurHistory&quot; Field Group */
export type OurHistory_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;OurHistory&quot; Field Group */
  timeline?: Maybe<Array<Maybe<OurHistoryTimeline>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;OurHistory&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type Page = ContentNode & DatabaseIdentifier & HierarchicalContentNode & HierarchicalNode & MenuItemLinkable & Node & NodeWithAuthor & NodeWithComments & NodeWithContentEditor & NodeWithEditorBlocks & NodeWithFeaturedImage & NodeWithPageAttributes & NodeWithPageEditorBlocks & NodeWithRevisions & NodeWithTemplate & NodeWithTitle & Previewable & UniformResourceIdentifiable & WithAcfBlogIndexContent & {
  __typename?: 'Page';
  /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
  /** Connection between the NodeWithAuthor type and the User type */
  author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the author of the node */
  authorId?: Maybe<Scalars['ID']['output']>;
  /** Fields of the BlogIndexContent ACF Field Group */
  blogIndexContent?: Maybe<BlogIndexContent>;
  /** Connection between the HierarchicalContentNode type and the ContentNode type */
  children?: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  commentCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the comments are open or closed for this particular post. */
  commentStatus?: Maybe<Scalars['String']['output']>;
  /** Connection between the Page type and the Comment type */
  comments?: Maybe<PageToCommentConnection>;
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** The content of the post. */
  content?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String']['output'];
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']['output']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']['output']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']['output']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** List of Page editor blocks */
  editorBlocks?: Maybe<Array<Maybe<PageEditorBlock>>>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId?: Maybe<Scalars['ID']['output']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']['output']>;
  /** Whether the page object is password protected. */
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique identifier of the page object. */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether this page is set to the static front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether this page is set to the blog posts page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this page is set to the privacy page. */
  isPrivacyPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** True if the node is a revision of another node */
  isRevision?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']['output']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: Maybe<Scalars['Int']['output']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']['output']>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of the databaseId field
   */
  pageId: Scalars['Int']['output'];
  /** The parent of the node. The parent object can be of various types */
  parent?: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']['output']>;
  /** The password for the page object. */
  password?: Maybe<Scalars['String']['output']>;
  /** Connection between the Page type and the page type */
  preview?: Maybe<PageToPreviewConnectionEdge>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']['output']>;
  /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
  revisionOf?: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
  /** Connection between the Page type and the page type */
  revisions?: Maybe<PageToRevisionConnection>;
  /** The Yoast SEO data of the ContentNode */
  seo?: Maybe<PostTypeSeo>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']['output']>;
  /** The template assigned to a node of content */
  template?: Maybe<ContentTemplate>;
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageToCommentConnectionWhereArgs>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageEditorBlocksArgs = {
  flat?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageRevisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageToRevisionConnectionWhereArgs>;
};


/** A standalone content entry generally used for static, non-chronological content such as &quot;About Us&quot; or &quot;Contact&quot; pages. */
export type PageTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A paginated collection of page Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of page Nodes */
export type PageConnection = {
  /** A list of edges (relational context) between RootQuery and connected page Nodes */
  edges: Array<PageConnectionEdge>;
  /** A list of connected page Nodes */
  nodes: Array<Page>;
  /** Information about pagination in a connection. */
  pageInfo: PageConnectionPageInfo;
};

/** Represents a connection to a page. Contains both the page Node and metadata about the relationship. */
export type PageConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected page Node */
  node: Page;
};

/** Pagination metadata specific to &quot;PageConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;PageConnectionEdge&quot; Nodes. */
export type PageConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** EditorBlock Interface for Page Block Type */
export type PageEditorBlock = {
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the Block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms page field. */
export type PageField = FormField & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithNextButtonSetting & GfFieldWithPreviousButton & Node & {
  __typename?: 'PageField';
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** An array containing the the individual properties for the &quot;Next&quot; button. */
  nextButton?: Maybe<FormButton>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** An array containing the the individual properties for the &quot;Previous&quot; button. */
  previousButton?: Maybe<FormButton>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** Identifier types for retrieving a specific Page. Specifies which unique attribute is used to find an exact Page. */
export enum PageIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Metadata for cursor-based pagination. Provides cursors for continuing pagination and boolean flags indicating if more items exist in either direction. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Connection between the Page type and the Comment type */
export type PageToCommentConnection = CommentConnection & Connection & {
  __typename?: 'PageToCommentConnection';
  /** Edges for the PageToCommentConnection connection */
  edges: Array<PageToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: PageToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type PageToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  __typename?: 'PageToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Comment;
};

/** Pagination metadata specific to &quot;PageToCommentConnection&quot; collections. Provides cursors and flags for navigating through sets of PageToCommentConnection Nodes. */
export type PageToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'PageToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the PageToCommentConnection connection */
export type PageToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']['input']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']['input']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']['input']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']['input']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** One or more Comment Statuses to limit results by */
  statusIn?: InputMaybe<Array<InputMaybe<CommentStatusEnum>>>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection between the Page type and the page type */
export type PageToPreviewConnectionEdge = Edge & OneToOneConnection & PageConnectionEdge & {
  __typename?: 'PageToPreviewConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: Page;
};

/** Connection between the Page type and the page type */
export type PageToRevisionConnection = Connection & PageConnection & {
  __typename?: 'PageToRevisionConnection';
  /** Edges for the PageToRevisionConnection connection */
  edges: Array<PageToRevisionConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Page>;
  /** Information about pagination in a connection. */
  pageInfo: PageToRevisionConnectionPageInfo;
};

/** An edge in a connection */
export type PageToRevisionConnectionEdge = Edge & PageConnectionEdge & {
  __typename?: 'PageToRevisionConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Page;
};

/** Pagination metadata specific to &quot;PageToRevisionConnection&quot; collections. Provides cursors and flags for navigating through sets of PageToRevisionConnection Nodes. */
export type PageToRevisionConnectionPageInfo = PageConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'PageToRevisionConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the PageToRevisionConnection connection */
export type PageToRevisionConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The &quot;Partners&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type Partners = AcfFieldGroup & AcfFieldGroupFields & Partners_Fields & {
  __typename?: 'Partners';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Partners&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;Partners&quot; Field Group */
  partners?: Maybe<Array<Maybe<PartnersPartners>>>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Partners&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;PartnersPartners&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type PartnersPartners = AcfFieldGroup & AcfFieldGroupFields & PartnersPartners_Fields & {
  __typename?: 'PartnersPartners';
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;PartnersPartners&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PartnersPartners&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;PartnersPartners&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;PartnersPartners&quot; Field Group */
  logo?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PartnersPartners&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;PartnersPartners&quot; Field Group */
export type PartnersPartners_Fields = {
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;PartnersPartners&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PartnersPartners&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;PartnersPartners&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;PartnersPartners&quot; Field Group */
  logo?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PartnersPartners&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;Partners&quot; Field Group */
export type Partners_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Partners&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;Partners&quot; Field Group */
  partners?: Maybe<Array<Maybe<PartnersPartners>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Partners&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms password field. */
export type PasswordField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPasswordSetting & GfFieldWithPasswordStrengthSetting & GfFieldWithPasswordVisibilitySetting & GfFieldWithPersonalData & GfFieldWithRulesSetting & GfFieldWithSizeSetting & GfFieldWithSubLabelPlacementSetting & Node & {
  __typename?: 'PasswordField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the field displays the password strength indicator. */
  hasPasswordStrengthIndicator?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Password visibility toggle should be enabled for this field. */
  hasPasswordVisibilityToggle?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<PasswordInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** Indicates how strong the password should be. */
  minPasswordStrength?: Maybe<PasswordFieldMinStrengthEnum>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The placement of the labels for the subfields within the group. This setting controls all of the subfields, they cannot be set individually. They may be aligned above or below the inputs. If this property is not set, the “Sub-Label Placement” setting on the Form Settings-&gt;Form Layout page is used. If no setting is specified, the default is above inputs. */
  subLabelPlacement?: Maybe<FormFieldSubLabelPlacementEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** Indicates how strong the password should be. */
export enum PasswordFieldMinStrengthEnum {
  /** The password strength must be "bad" or better. */
  Bad = 'BAD',
  /** The password strength must be "good" or better. */
  Good = 'GOOD',
  /** The password strength must be "short" or better. */
  Short = 'SHORT',
  /** The password strength must be "strong". */
  Strong = 'STRONG'
}

/** PasswordInputProperty input values. */
export type PasswordInputProperty = GfFieldInput & GfFieldInputWithPasswordSetting & {
  __typename?: 'PasswordInputProperty';
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** Whether or not this field should be hidden. */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms phone field. */
export type PhoneField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPhoneFormatSetting & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & {
  __typename?: 'PhoneField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Determines the allowed format for phones. If the phone value does not conform with the specified format, the field will fail validation. */
  phoneFormat?: Maybe<PhoneFieldFormatEnum>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** Tthe allowed format for phone numbers. */
export enum PhoneFieldFormatEnum {
  /** International phone number format. */
  International = 'INTERNATIONAL',
  /** Standard phone number format. */
  Standard = 'STANDARD'
}

/** An plugin object */
export type Plugin = Node & {
  __typename?: 'Plugin';
  /** Name of the plugin author(s), may also be a company name. */
  author?: Maybe<Scalars['String']['output']>;
  /** URI for the related author(s)/company website. */
  authorUri?: Maybe<Scalars['String']['output']>;
  /** Description of the plugin. */
  description?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier of the plugin object. */
  id: Scalars['ID']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Display name of the plugin. */
  name?: Maybe<Scalars['String']['output']>;
  /** Plugin path. */
  path?: Maybe<Scalars['String']['output']>;
  /** URI for the plugin website. This is useful for directing users for support requests etc. */
  pluginUri?: Maybe<Scalars['String']['output']>;
  /** Current version of the plugin. */
  version?: Maybe<Scalars['String']['output']>;
};

/** A paginated collection of Plugin Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of Plugin Nodes */
export type PluginConnection = {
  /** A list of edges (relational context) between RootQuery and connected Plugin Nodes */
  edges: Array<PluginConnectionEdge>;
  /** A list of connected Plugin Nodes */
  nodes: Array<Plugin>;
  /** Information about pagination in a connection. */
  pageInfo: PluginConnectionPageInfo;
};

/** Represents a connection to a Plugin. Contains both the Plugin Node and metadata about the relationship. */
export type PluginConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Plugin Node */
  node: Plugin;
};

/** Pagination metadata specific to &quot;PluginConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;PluginConnectionEdge&quot; Nodes. */
export type PluginConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Operational status of a plugin. Indicates whether a plugin is active, inactive, or in another state that affects its functionality. */
export enum PluginStatusEnum {
  /** The plugin is currently active. */
  Active = 'ACTIVE',
  /** The plugin is a drop-in plugin. */
  DropIn = 'DROP_IN',
  /** The plugin is currently inactive. */
  Inactive = 'INACTIVE',
  /** The plugin is a must-use plugin. */
  MustUse = 'MUST_USE',
  /** The plugin is technically active but was paused while loading. */
  Paused = 'PAUSED',
  /** The plugin was active recently. */
  RecentlyActive = 'RECENTLY_ACTIVE',
  /** The plugin has an upgrade available. */
  Upgrade = 'UPGRADE'
}

/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type Post = ContentNode & DatabaseIdentifier & MenuItemLinkable & Node & NodeWithAuthor & NodeWithComments & NodeWithContentEditor & NodeWithEditorBlocks & NodeWithExcerpt & NodeWithFeaturedImage & NodeWithPostEditorBlocks & NodeWithRevisions & NodeWithTemplate & NodeWithTitle & NodeWithTrackbacks & Previewable & UniformResourceIdentifiable & WithAcfPostAsideContent & {
  __typename?: 'Post';
  /**
   * The ancestors of the content node.
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  ancestors?: Maybe<PostToPostConnection>;
  /** Connection between the NodeWithAuthor type and the User type */
  author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  authorDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** The globally unique identifier of the author of the node */
  authorId?: Maybe<Scalars['ID']['output']>;
  /** Connection between the Post type and the category type */
  categories?: Maybe<PostToCategoryConnection>;
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  commentCount?: Maybe<Scalars['Int']['output']>;
  /** Whether the comments are open or closed for this particular post. */
  commentStatus?: Maybe<Scalars['String']['output']>;
  /** Connection between the Post type and the Comment type */
  comments?: Maybe<PostToCommentConnection>;
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** The content of the post. */
  content?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String']['output'];
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']['output']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']['output']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']['output']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** List of Post editor blocks */
  editorBlocks?: Maybe<Array<Maybe<PostEditorBlock>>>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']['output']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The excerpt of the post. */
  excerpt?: Maybe<Scalars['String']['output']>;
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId?: Maybe<Scalars['ID']['output']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']['output']>;
  /** Whether the post object is password protected. */
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique identifier of the post object. */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** True if the node is a revision of another node */
  isRevision?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this page is sticky */
  isSticky: Scalars['Boolean']['output'];
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']['output']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']['output']>;
  /**
   * The parent of the content node.
   * @deprecated This content type is not hierarchical and typically will not have a parent
   */
  parent?: Maybe<PostToParentConnectionEdge>;
  /** The password for the post object. */
  password?: Maybe<Scalars['String']['output']>;
  /** Whether the pings are open or closed for this particular post. */
  pingStatus?: Maybe<Scalars['String']['output']>;
  /** URLs that have been pinged. */
  pinged?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fields of the PostAsideContent ACF Field Group */
  postAsideContent?: Maybe<PostAsideContent>;
  /** Connection between the Post type and the postFormat type */
  postFormats?: Maybe<PostToPostFormatConnection>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of the databaseId field
   */
  postId: Scalars['Int']['output'];
  /** Connection between the Post type and the post type */
  preview?: Maybe<PostToPreviewConnectionEdge>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']['output']>;
  /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
  revisionOf?: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
  /** Connection between the Post type and the post type */
  revisions?: Maybe<PostToRevisionConnection>;
  /** The Yoast SEO data of the ContentNode */
  seo?: Maybe<PostTypeSeo>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']['output']>;
  /** Connection between the Post type and the tag type */
  tags?: Maybe<PostToTagConnection>;
  /** The template assigned to the node */
  template?: Maybe<ContentTemplate>;
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Connection between the Post type and the TermNode type */
  terms?: Maybe<PostToTermNodeConnection>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']['output']>;
  /** URLs queued to be pinged. */
  toPing?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostToCategoryConnectionWhereArgs>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostToCommentConnectionWhereArgs>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostEditorBlocksArgs = {
  flat?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostExcerptArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostPostFormatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostToPostFormatConnectionWhereArgs>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostRevisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostToRevisionConnectionWhereArgs>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostToTagConnectionWhereArgs>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostToTermNodeConnectionWhereArgs>;
};


/** A chronological content entry typically used for blog posts, news articles, or similar date-based content. */
export type PostTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The &quot;PostAsideContent&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type PostAsideContent = AcfFieldGroup & AcfFieldGroupFields & PostAsideContent_Fields & {
  __typename?: 'PostAsideContent';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;PostAsideContent&quot; Field Group */
  newsletter?: Maybe<PostAsideContentNewsletter>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** The &quot;PostAsideContentNewsletter&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type PostAsideContentNewsletter = AcfFieldGroup & AcfFieldGroupFields & PostAsideContentNewsletter_Fields & {
  __typename?: 'PostAsideContentNewsletter';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PostAsideContentNewsletter&quot; Field Group */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PostAsideContentNewsletter&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PostAsideContentNewsletter&quot; Field Group */
  inputPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PostAsideContentNewsletter&quot; Field Group */
  marketoFormId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PostAsideContentNewsletter&quot; Field Group */
  successMessage?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PostAsideContentNewsletter&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;PostAsideContentNewsletter&quot; Field Group */
export type PostAsideContentNewsletter_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PostAsideContentNewsletter&quot; Field Group */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PostAsideContentNewsletter&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PostAsideContentNewsletter&quot; Field Group */
  inputPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PostAsideContentNewsletter&quot; Field Group */
  marketoFormId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PostAsideContentNewsletter&quot; Field Group */
  successMessage?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;PostAsideContentNewsletter&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;PostAsideContent&quot; Field Group */
export type PostAsideContent_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;PostAsideContent&quot; Field Group */
  newsletter?: Maybe<PostAsideContentNewsletter>;
};

/** Set relationships between the post to categories */
export type PostCategoriesInput = {
  /** If true, this will append the category to existing related categories. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<PostCategoriesNodeInput>>>;
};

/** List of categories to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostCategoriesNodeInput = {
  /** The description of the category. This field is used to set a description of the category if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the category. If present, this will be used to connect to the post. If no existing category exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the category. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the category. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** A Gravity Forms checkbox post_category field. */
export type PostCategoryCheckboxField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPostCategoryCheckboxSetting & GfFieldWithPostCategoryInitialItemSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSelectAllChoicesSetting & GfFieldWithSizeSetting & Node & PostCategoryField & {
  __typename?: 'PostCategoryCheckboxField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Checkbox field value. */
  checkboxValues?: Maybe<Array<Maybe<CheckboxFieldValue>>>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<PostCategoryCheckboxFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The dropdown placeholder for the field. */
  dropdownPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if all categories should be displayed on the Post Category drop down. If this property is true (display all categories), the Post Category drop down will display the categories hierarchically. */
  hasAllCategories?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the \&quot;select all\&quot; choice should be displayed. */
  hasSelectAll?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<PostCategoryCheckboxInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostCategoryCheckboxFieldChoice choice values. */
export type PostCategoryCheckboxFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & PostCategoryFieldChoice & {
  __typename?: 'PostCategoryCheckboxFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** PostCategoryCheckboxInputProperty input values. */
export type PostCategoryCheckboxInputProperty = GfFieldInput & GfFieldInputWithSelectAllChoicesSetting & {
  __typename?: 'PostCategoryCheckboxInputProperty';
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms post_category field. */
export type PostCategoryField = {
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<PostCategoryFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The dropdown placeholder for the field. */
  dropdownPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if all categories should be displayed on the Post Category drop down. If this property is true (display all categories), the Post Category drop down will display the categories hierarchically. */
  hasAllCategories?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostCategoryFieldChoice choice values. */
export type PostCategoryFieldChoice = {
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms multiselect post_category field. */
export type PostCategoryMultiSelectField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithEnhancedUiSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPostCategoryCheckboxSetting & GfFieldWithPostCategoryInitialItemSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostCategoryField & {
  __typename?: 'PostCategoryMultiSelectField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<PostCategoryMultiSelectFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The dropdown placeholder for the field. */
  dropdownPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if all categories should be displayed on the Post Category drop down. If this property is true (display all categories), the Post Category drop down will display the categories hierarchically. */
  hasAllCategories?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** When set to true, the &quot;Chosen&quot; jQuery script will be applied to this field, enabling search capabilities to Drop Down fields and a more user-friendly interface for Multi Select fields. */
  hasEnhancedUI?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** An array of field values. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostCategoryMultiSelectFieldChoice choice values. */
export type PostCategoryMultiSelectFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & PostCategoryFieldChoice & {
  __typename?: 'PostCategoryMultiSelectFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms radio post_category field. */
export type PostCategoryRadioField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithOtherChoiceSetting & GfFieldWithPersonalData & GfFieldWithPostCategoryCheckboxSetting & GfFieldWithPostCategoryInitialItemSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostCategoryField & {
  __typename?: 'PostCategoryRadioField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<PostCategoryRadioFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The dropdown placeholder for the field. */
  dropdownPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if all categories should be displayed on the Post Category drop down. If this property is true (display all categories), the Post Category drop down will display the categories hierarchically. */
  hasAllCategories?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the &#039;Enable &quot;other&quot; choice&#039; option is checked in the editor. */
  hasOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostCategoryRadioFieldChoice choice values. */
export type PostCategoryRadioFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & GfFieldChoiceWithOtherChoiceSetting & PostCategoryFieldChoice & {
  __typename?: 'PostCategoryRadioFieldChoice';
  /** Indicates the radio button item is the “Other” choice. */
  isOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms select post_category field. */
export type PostCategorySelectField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithEnhancedUiSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPostCategoryCheckboxSetting & GfFieldWithPostCategoryInitialItemSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostCategoryField & {
  __typename?: 'PostCategorySelectField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<PostCategorySelectFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The dropdown placeholder for the field. */
  dropdownPlaceholder?: Maybe<Scalars['String']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if all categories should be displayed on the Post Category drop down. If this property is true (display all categories), the Post Category drop down will display the categories hierarchically. */
  hasAllCategories?: Maybe<Scalars['Boolean']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** When set to true, the &quot;Chosen&quot; jQuery script will be applied to this field, enabling search capabilities to Drop Down fields and a more user-friendly interface for Multi Select fields. */
  hasEnhancedUI?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostCategorySelectFieldChoice choice values. */
export type PostCategorySelectFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & PostCategoryFieldChoice & {
  __typename?: 'PostCategorySelectFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A paginated collection of post Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of post Nodes */
export type PostConnection = {
  /** A list of edges (relational context) between RootQuery and connected post Nodes */
  edges: Array<PostConnectionEdge>;
  /** A list of connected post Nodes */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: PostConnectionPageInfo;
};

/** Represents a connection to a post. Contains both the post Node and metadata about the relationship. */
export type PostConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected post Node */
  node: Post;
};

/** Pagination metadata specific to &quot;PostConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;PostConnectionEdge&quot; Nodes. */
export type PostConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** A Gravity Forms post_content field. */
export type PostContentField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithMaxLengthSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRichTextEditorSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & {
  __typename?: 'PostContentField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the field uses the rich text editor interface. */
  hasRichTextEditor?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** Specifies the maximum number of characters allowed in a text or textarea (paragraph) field. */
  maxLength?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms checkbox post_custom_field field. */
export type PostCustomCheckboxField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSelectAllChoicesSetting & GfFieldWithSizeSetting & Node & PostCustomField & {
  __typename?: 'PostCustomCheckboxField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Checkbox field value. */
  checkboxValues?: Maybe<Array<Maybe<CheckboxFieldValue>>>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<PostCustomCheckboxFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the \&quot;select all\&quot; choice should be displayed. */
  hasSelectAll?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<PostCustomCheckboxInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostCustomCheckboxFieldChoice choice values. */
export type PostCustomCheckboxFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & {
  __typename?: 'PostCustomCheckboxFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** PostCustomCheckboxInputProperty input values. */
export type PostCustomCheckboxInputProperty = GfFieldInput & GfFieldInputWithSelectAllChoicesSetting & {
  __typename?: 'PostCustomCheckboxInputProperty';
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms date post_custom_field field. */
export type PostCustomDateField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDateFormatSetting & GfFieldWithDateInputTypeSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & GfFieldWithSubLabelPlacementSetting & Node & PostCustomField & {
  __typename?: 'PostCustomDateField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines how the date field displays it’s calendar icon. */
  calendarIconType?: Maybe<FormFieldCalendarIconTypeEnum>;
  /** Contains the URL to the custom calendar icon. Only applicable when calendarIconType is set to custom. */
  calendarIconUrl?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Determines how the date is displayed. */
  dateFormat?: Maybe<DateFieldFormatEnum>;
  /** The type of date field to display. */
  dateType?: Maybe<DateFieldTypeEnum>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<PostCustomDateInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The placement of the labels for the subfields within the group. This setting controls all of the subfields, they cannot be set individually. They may be aligned above or below the inputs. If this property is not set, the “Sub-Label Placement” setting on the Form Settings-&gt;Form Layout page is used. If no setting is specified, the default is above inputs. */
  subLabelPlacement?: Maybe<FormFieldSubLabelPlacementEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostCustomDateInputProperty input values. */
export type PostCustomDateInputProperty = GfFieldInput & GfFieldInputWithDateFormatSetting & {
  __typename?: 'PostCustomDateInputProperty';
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms email post_custom_field field. */
export type PostCustomEmailField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & GfFieldWithSubLabelPlacementSetting & GfGfFieldWithEmailConfirmationSetting & Node & PostCustomField & {
  __typename?: 'PostCustomEmailField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Determines whether the Confirm Email field is active. */
  hasEmailConfirmation?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<PostCustomEmailInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The placement of the labels for the subfields within the group. This setting controls all of the subfields, they cannot be set individually. They may be aligned above or below the inputs. If this property is not set, the “Sub-Label Placement” setting on the Form Settings-&gt;Form Layout page is used. If no setting is specified, the default is above inputs. */
  subLabelPlacement?: Maybe<FormFieldSubLabelPlacementEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostCustomEmailInputProperty input values. */
export type PostCustomEmailInputProperty = GfFieldInput & GfFieldInputWithEmailConfirmationSetting & {
  __typename?: 'PostCustomEmailInputProperty';
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms post_custom_field field. */
export type PostCustomField = {
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms fileupload post_custom_field field. */
export type PostCustomFileuploadField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithFileExtensionsSetting & GfFieldWithFileSizeSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithMultipleFilesSetting & GfFieldWithPersonalData & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostCustomField & {
  __typename?: 'PostCustomFileuploadField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** A comma-delimited list of the file extensions which may be uploaded. */
  allowedExtensions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Indicates whether multiple files may be uploaded. */
  canAcceptMultipleFiles?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** File upload value */
  fileUploadValues?: Maybe<Array<Maybe<FileUploadFieldValue>>>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The maximum size (in MB) an uploaded file may be . */
  maxFileSize?: Maybe<Scalars['Int']['output']>;
  /** When the field is set to allow multiple files to be uploaded, this property is available to set a limit on how many may be uploaded. */
  maxFiles?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms hidden post_custom_field field. */
export type PostCustomHiddenField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostCustomField & {
  __typename?: 'PostCustomHiddenField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms list post_custom_field field. */
export type PostCustomListField = FormField & GfFieldWithAddIconUrlSetting & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithColumnsSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDeleteIconUrlSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithMaxRowsSetting & GfFieldWithPersonalData & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostCustomField & {
  __typename?: 'PostCustomListField';
  /** The URL of the image to be used for the add row button. */
  addIconUrl?: Maybe<Scalars['String']['output']>;
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<PostCustomListFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** The URL of the image to be used for the delete row button. */
  deleteIconUrl?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field should use multiple columns. Default is false. */
  hasColumns?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** List field value. */
  listValues?: Maybe<Array<Maybe<ListFieldValue>>>;
  /** The maximum number of rows the user can add to the field. */
  maxRows?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostCustomListFieldChoice choice values. */
export type PostCustomListFieldChoice = GfFieldChoice & GfFieldChoiceWithColumnsSetting & {
  __typename?: 'PostCustomListFieldChoice';
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms multiselect post_custom_field field. */
export type PostCustomMultiSelectField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithEnhancedUiSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostCustomField & {
  __typename?: 'PostCustomMultiSelectField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<PostCustomMultiSelectFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** When set to true, the &quot;Chosen&quot; jQuery script will be applied to this field, enabling search capabilities to Drop Down fields and a more user-friendly interface for Multi Select fields. */
  hasEnhancedUI?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** An array of field values. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostCustomMultiSelectFieldChoice choice values. */
export type PostCustomMultiSelectFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & {
  __typename?: 'PostCustomMultiSelectFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms number post_custom_field field. */
export type PostCustomNumberField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithCalculationSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithNumberFormatSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRangeSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostCustomField & {
  __typename?: 'PostCustomNumberField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The formula used for the number field. */
  calculationFormula?: Maybe<Scalars['String']['output']>;
  /** Specifies to how many decimal places the number should be rounded. This is available when `isCalculation` is true, but will return null if the number format is `CURRENCY` or if the calculation is set to `Do not round`. */
  calculationRounding?: Maybe<Scalars['Int']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Indicates whether the number field is a calculation. */
  isCalculation?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** Specifies the format allowed for the number field. */
  numberFormat?: Maybe<NumberFieldFormatEnum>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Maximum allowed value for a number field. Values higher than the number specified by this property will cause the field to fail validation. */
  rangeMax?: Maybe<Scalars['Float']['output']>;
  /** Minimum allowed value for a number field. Values lower than the number specified by this property will cause the field to fail validation. */
  rangeMin?: Maybe<Scalars['Float']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms phone post_custom_field field. */
export type PostCustomPhoneField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPhoneFormatSetting & GfFieldWithPlaceholderSetting & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostCustomField & {
  __typename?: 'PostCustomPhoneField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Determines the allowed format for phones. If the phone value does not conform with the specified format, the field will fail validation. */
  phoneFormat?: Maybe<PhoneFieldFormatEnum>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms radio post_custom_field field. */
export type PostCustomRadioField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithOtherChoiceSetting & GfFieldWithPersonalData & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostCustomField & {
  __typename?: 'PostCustomRadioField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<PostCustomRadioFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the &#039;Enable &quot;other&quot; choice&#039; option is checked in the editor. */
  hasOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostCustomRadioFieldChoice choice values. */
export type PostCustomRadioFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & GfFieldChoiceWithOtherChoiceSetting & {
  __typename?: 'PostCustomRadioFieldChoice';
  /** Indicates the radio button item is the “Other” choice. */
  isOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms select post_custom_field field. */
export type PostCustomSelectField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithEnhancedUiSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostCustomField & {
  __typename?: 'PostCustomSelectField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<PostCustomSelectFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** When set to true, the &quot;Chosen&quot; jQuery script will be applied to this field, enabling search capabilities to Drop Down fields and a more user-friendly interface for Multi Select fields. */
  hasEnhancedUI?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostCustomSelectFieldChoice choice values. */
export type PostCustomSelectFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & {
  __typename?: 'PostCustomSelectFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms textarea post_custom_field field. */
export type PostCustomTextAreaField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithMaxLengthSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRichTextEditorSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostCustomField & {
  __typename?: 'PostCustomTextAreaField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the field uses the rich text editor interface. */
  hasRichTextEditor?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** Specifies the maximum number of characters allowed in a text or textarea (paragraph) field. */
  maxLength?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms text post_custom_field field. */
export type PostCustomTextField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputMaskSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithMaxLengthSetting & GfFieldWithPasswordFieldSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostCustomField & {
  __typename?: 'PostCustomTextField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has an input mask. */
  hasInputMask?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** The pattern used for the input mask. */
  inputMaskValue?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if a text field input tag should be created with a &quot;password&quot; type. */
  isPasswordInput?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** Specifies the maximum number of characters allowed in a text or textarea (paragraph) field. */
  maxLength?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms time post_custom_field field. */
export type PostCustomTimeField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & GfFieldWithSubLabelPlacementSetting & GfFieldWithTimeFormatSetting & Node & PostCustomField & {
  __typename?: 'PostCustomTimeField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<PostCustomTimeInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The placement of the labels for the subfields within the group. This setting controls all of the subfields, they cannot be set individually. They may be aligned above or below the inputs. If this property is not set, the “Sub-Label Placement” setting on the Form Settings-&gt;Form Layout page is used. If no setting is specified, the default is above inputs. */
  subLabelPlacement?: Maybe<FormFieldSubLabelPlacementEnum>;
  /** Determines how the time is displayed. */
  timeFormat?: Maybe<TimeFieldFormatEnum>;
  /** Time field value. */
  timeValues?: Maybe<TimeFieldValue>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostCustomTimeInputProperty input values. */
export type PostCustomTimeInputProperty = GfFieldInput & GfFieldInputWithTimeFormatSetting & {
  __typename?: 'PostCustomTimeInputProperty';
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms website post_custom_field field. */
export type PostCustomWebsiteField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPostCustomFieldSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostCustomField & {
  __typename?: 'PostCustomWebsiteField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The post meta key to which the value should be assigned. */
  postMetaFieldName?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** EditorBlock Interface for Post Block Type */
export type PostEditorBlock = {
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the Block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms post_excerpt field. */
export type PostExcerptField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithMaxLengthSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & {
  __typename?: 'PostExcerptField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** Specifies the maximum number of characters allowed in a text or textarea (paragraph) field. */
  maxLength?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A standardized classification system for content presentation styles. These formats can be used to display content differently based on type, such as &quot;standard&quot;, &quot;gallery&quot;, &quot;video&quot;, etc. */
export type PostFormat = DatabaseIdentifier & Node & TermNode & UniformResourceIdentifiable & {
  __typename?: 'PostFormat';
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** Connection between the PostFormat type and the ContentNode type */
  contentNodes?: Maybe<PostFormatToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** The description of the object */
  description?: Maybe<Scalars['String']['output']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  /** The link to the term */
  link?: Maybe<Scalars['String']['output']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of databaseId
   */
  postFormatId?: Maybe<Scalars['Int']['output']>;
  /** Connection between the PostFormat type and the post type */
  posts?: Maybe<PostFormatToPostConnection>;
  /** The Yoast SEO data of the Formats taxonomy. */
  seo?: Maybe<TaxonomySeo>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Connection between the PostFormat type and the Taxonomy type */
  taxonomy?: Maybe<PostFormatToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']['output']>;
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']['output']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']['output']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
};


/** A standardized classification system for content presentation styles. These formats can be used to display content differently based on type, such as &quot;standard&quot;, &quot;gallery&quot;, &quot;video&quot;, etc. */
export type PostFormatContentNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostFormatToContentNodeConnectionWhereArgs>;
};


/** A standardized classification system for content presentation styles. These formats can be used to display content differently based on type, such as &quot;standard&quot;, &quot;gallery&quot;, &quot;video&quot;, etc. */
export type PostFormatEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A standardized classification system for content presentation styles. These formats can be used to display content differently based on type, such as &quot;standard&quot;, &quot;gallery&quot;, &quot;video&quot;, etc. */
export type PostFormatEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A standardized classification system for content presentation styles. These formats can be used to display content differently based on type, such as &quot;standard&quot;, &quot;gallery&quot;, &quot;video&quot;, etc. */
export type PostFormatPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PostFormatToPostConnectionWhereArgs>;
};

/** A paginated collection of postFormat Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of postFormat Nodes */
export type PostFormatConnection = {
  /** A list of edges (relational context) between RootQuery and connected postFormat Nodes */
  edges: Array<PostFormatConnectionEdge>;
  /** A list of connected postFormat Nodes */
  nodes: Array<PostFormat>;
  /** Information about pagination in a connection. */
  pageInfo: PostFormatConnectionPageInfo;
};

/** Represents a connection to a postFormat. Contains both the postFormat Node and metadata about the relationship. */
export type PostFormatConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected postFormat Node */
  node: PostFormat;
};

/** Pagination metadata specific to &quot;PostFormatConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;PostFormatConnectionEdge&quot; Nodes. */
export type PostFormatConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Identifier types for retrieving a specific PostFormat. Determines which unique property (global ID, database ID, slug, etc.) is used to locate the PostFormat. */
export enum PostFormatIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the PostFormat type and the ContentNode type */
export type PostFormatToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'PostFormatToContentNodeConnection';
  /** Edges for the PostFormatToContentNodeConnection connection */
  edges: Array<PostFormatToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: PostFormatToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type PostFormatToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'PostFormatToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Pagination metadata specific to &quot;PostFormatToContentNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of PostFormatToContentNodeConnection Nodes. */
export type PostFormatToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'PostFormatToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the PostFormatToContentNodeConnection connection */
export type PostFormatToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfPostFormatEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the PostFormat type and the post type */
export type PostFormatToPostConnection = Connection & PostConnection & {
  __typename?: 'PostFormatToPostConnection';
  /** Edges for the PostFormatToPostConnection connection */
  edges: Array<PostFormatToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: PostFormatToPostConnectionPageInfo;
};

/** An edge in a connection */
export type PostFormatToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'PostFormatToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Pagination metadata specific to &quot;PostFormatToPostConnection&quot; collections. Provides cursors and flags for navigating through sets of PostFormatToPostConnection Nodes. */
export type PostFormatToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostFormatToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the PostFormatToPostConnection connection */
export type PostFormatToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the PostFormat type and the Taxonomy type */
export type PostFormatToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  __typename?: 'PostFormatToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: Taxonomy;
};

/** List of possible post formats. */
export enum PostFormatTypeEnum {
  /** A standard post format. */
  Standard = 'STANDARD'
}

/** Identifier types for retrieving a specific Post. Specifies which unique attribute is used to find an exact Post. */
export enum PostIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** A Gravity Forms post_image field. */
export type PostImageField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithFileExtensionsSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPostImageFeaturedImageSetting & GfFieldWithPostImageSetting & GfFieldWithRulesSetting & GfFieldWithSubLabelPlacementSetting & Node & {
  __typename?: 'PostImageField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** A comma-delimited list of the file extensions which may be uploaded. */
  allowedExtensions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Controls the visibility of the alt metadata for Post Image fields. */
  hasAlt?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the caption metadata for Post Image fields. */
  hasCaption?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the description metadata for Post Image fields. */
  hasDescription?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the title metadata for Post Image fields. */
  hasTitle?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Image field value. */
  imageValues?: Maybe<ImageFieldValue>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Whether the image field should be used to set the post&#039;s Featured Image */
  isFeaturedImage?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The placement of the labels for the subfields within the group. This setting controls all of the subfields, they cannot be set individually. They may be aligned above or below the inputs. If this property is not set, the “Sub-Label Placement” setting on the Form Settings-&gt;Form Layout page is used. If no setting is specified, the default is above inputs. */
  subLabelPlacement?: Maybe<FormFieldSubLabelPlacementEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** Content field rendering options. Determines whether content fields are returned as raw data or with applied formatting and transformations. Default is RENDERED. */
export enum PostObjectFieldFormatEnum {
  /** Unprocessed content exactly as stored in the database, requires appropriate permissions. */
  Raw = 'RAW',
  /** Content with all formatting and transformations applied, ready for display. */
  Rendered = 'RENDERED'
}

/** Date field selectors for content filtering. Specifies which date attribute (creation date, modification date) should be used for date-based queries. */
export enum PostObjectsConnectionDateColumnEnum {
  /** The date the comment was created in local time. */
  Date = 'DATE',
  /** The most recent modification date of the comment. */
  Modified = 'MODIFIED'
}

/** Content sorting attributes for post-type objects. Identifies which content property should be used to determine result order. */
export enum PostObjectsConnectionOrderbyEnum {
  /** Ordering by content author (typically by author name). */
  Author = 'AUTHOR',
  /** Ordering by popularity based on number of comments. */
  CommentCount = 'COMMENT_COUNT',
  /** Chronological ordering by publication date. */
  Date = 'DATE',
  /** Maintain custom order of IDs exactly as specified in the query with the IN field. */
  In = 'IN',
  /** Ordering by manually defined sort position. */
  MenuOrder = 'MENU_ORDER',
  /** Chronological ordering by modified date. */
  Modified = 'MODIFIED',
  /** Maintain custom order of IDs exactly as specified in the query with the NAME_IN field. */
  NameIn = 'NAME_IN',
  /** Ordering by parent-child relationship in hierarchical content. */
  Parent = 'PARENT',
  /** Alphabetical ordering by URL-friendly name. */
  Slug = 'SLUG',
  /** Alphabetical ordering by content title */
  Title = 'TITLE'
}

/** Options for ordering the connection */
export type PostObjectsConnectionOrderbyInput = {
  /** The field to order the connection by */
  field: PostObjectsConnectionOrderbyEnum;
  /** Possible directions in which to order a list of items */
  order: OrderEnum;
};

/** Set relationships between the post to postFormats */
export type PostPostFormatsInput = {
  /** If true, this will append the postFormat to existing related postFormats. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<PostPostFormatsNodeInput>>>;
};

/** List of postFormats to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostPostFormatsNodeInput = {
  /** The description of the postFormat. This field is used to set a description of the postFormat if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the postFormat. If present, this will be used to connect to the post. If no existing postFormat exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the postFormat. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the postFormat. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Publishing status that controls the visibility and editorial state of content. Determines whether content is published, pending review, in draft state, or private. */
export enum PostStatusEnum {
  /** Objects with the acf-disabled status */
  AcfDisabled = 'ACF_DISABLED',
  /** Automatically saved content that has not been manually saved */
  AutoDraft = 'AUTO_DRAFT',
  /** Content that is saved but not yet published or visible to the public */
  Draft = 'DRAFT',
  /** Objects with the future status */
  Future = 'FUTURE',
  /** Content that inherits its status from a parent object */
  Inherit = 'INHERIT',
  /** Content awaiting review before publication */
  Pending = 'PENDING',
  /** Content only visible to authorized users with appropriate permissions */
  Private = 'PRIVATE',
  /** Content that is publicly visible to all visitors */
  Publish = 'PUBLISH',
  /** Objects with the request-completed status */
  RequestCompleted = 'REQUEST_COMPLETED',
  /** Objects with the request-confirmed status */
  RequestConfirmed = 'REQUEST_CONFIRMED',
  /** Objects with the request-failed status */
  RequestFailed = 'REQUEST_FAILED',
  /** Objects with the request-pending status */
  RequestPending = 'REQUEST_PENDING',
  /** Content marked for deletion but still recoverable */
  Trash = 'TRASH'
}

/** A Gravity Forms checkbox post_tags field. */
export type PostTagsCheckboxField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSelectAllChoicesSetting & GfFieldWithSizeSetting & Node & PostTagsField & {
  __typename?: 'PostTagsCheckboxField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Checkbox field value. */
  checkboxValues?: Maybe<Array<Maybe<CheckboxFieldValue>>>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<PostTagsCheckboxFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the \&quot;select all\&quot; choice should be displayed. */
  hasSelectAll?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<PostTagsCheckboxInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostTagsCheckboxFieldChoice choice values. */
export type PostTagsCheckboxFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & {
  __typename?: 'PostTagsCheckboxFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** PostTagsCheckboxInputProperty input values. */
export type PostTagsCheckboxInputProperty = GfFieldInput & GfFieldInputWithSelectAllChoicesSetting & {
  __typename?: 'PostTagsCheckboxInputProperty';
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms post_tags field. */
export type PostTagsField = {
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** Set relationships between the post to tags */
export type PostTagsInput = {
  /** If true, this will append the tag to existing related tags. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<PostTagsNodeInput>>>;
};

/** A Gravity Forms multiselect post_tags field. */
export type PostTagsMultiSelectField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithEnhancedUiSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostTagsField & {
  __typename?: 'PostTagsMultiSelectField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<PostTagsMultiSelectFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** When set to true, the &quot;Chosen&quot; jQuery script will be applied to this field, enabling search capabilities to Drop Down fields and a more user-friendly interface for Multi Select fields. */
  hasEnhancedUI?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** An array of field values. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostTagsMultiSelectFieldChoice choice values. */
export type PostTagsMultiSelectFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & {
  __typename?: 'PostTagsMultiSelectFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** List of tags to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostTagsNodeInput = {
  /** The description of the tag. This field is used to set a description of the tag if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the tag. If present, this will be used to connect to the post. If no existing tag exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the tag. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the tag. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** A Gravity Forms radio post_tags field. */
export type PostTagsRadioField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithOtherChoiceSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostTagsField & {
  __typename?: 'PostTagsRadioField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<PostTagsRadioFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the &#039;Enable &quot;other&quot; choice&#039; option is checked in the editor. */
  hasOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostTagsRadioFieldChoice choice values. */
export type PostTagsRadioFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & GfFieldChoiceWithOtherChoiceSetting & {
  __typename?: 'PostTagsRadioFieldChoice';
  /** Indicates the radio button item is the “Other” choice. */
  isOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms select post_tags field. */
export type PostTagsSelectField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithEnhancedUiSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostTagsField & {
  __typename?: 'PostTagsSelectField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<PostTagsSelectFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** When set to true, the &quot;Chosen&quot; jQuery script will be applied to this field, enabling search capabilities to Drop Down fields and a more user-friendly interface for Multi Select fields. */
  hasEnhancedUI?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** PostTagsSelectFieldChoice choice values. */
export type PostTagsSelectFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & {
  __typename?: 'PostTagsSelectFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms text post_tags field. */
export type PostTagsTextField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputMaskSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithMaxLengthSetting & GfFieldWithPasswordFieldSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & PostTagsField & {
  __typename?: 'PostTagsTextField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has an input mask. */
  hasInputMask?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** The pattern used for the input mask. */
  inputMaskValue?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if a text field input tag should be created with a &quot;password&quot; type. */
  isPasswordInput?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** Specifies the maximum number of characters allowed in a text or textarea (paragraph) field. */
  maxLength?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms post_title field. */
export type PostTitleField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & {
  __typename?: 'PostTitleField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** Connection between the Post type and the category type */
export type PostToCategoryConnection = CategoryConnection & Connection & {
  __typename?: 'PostToCategoryConnection';
  /** Edges for the PostToCategoryConnection connection */
  edges: Array<PostToCategoryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Category>;
  /** Information about pagination in a connection. */
  pageInfo: PostToCategoryConnectionPageInfo;
};

/** An edge in a connection */
export type PostToCategoryConnectionEdge = CategoryConnectionEdge & Edge & {
  __typename?: 'PostToCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The Yoast SEO Primary category */
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  /** The item at the end of the edge */
  node: Category;
};

/** Pagination metadata specific to &quot;PostToCategoryConnection&quot; collections. Provides cursors and flags for navigating through sets of PostToCategoryConnection Nodes. */
export type PostToCategoryConnectionPageInfo = CategoryConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'PostToCategoryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the PostToCategoryConnection connection */
export type PostToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the Post type and the Comment type */
export type PostToCommentConnection = CommentConnection & Connection & {
  __typename?: 'PostToCommentConnection';
  /** Edges for the PostToCommentConnection connection */
  edges: Array<PostToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: PostToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type PostToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  __typename?: 'PostToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Comment;
};

/** Pagination metadata specific to &quot;PostToCommentConnection&quot; collections. Provides cursors and flags for navigating through sets of PostToCommentConnection Nodes. */
export type PostToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'PostToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the PostToCommentConnection connection */
export type PostToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']['input']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']['input']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']['input']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']['input']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** One or more Comment Statuses to limit results by */
  statusIn?: InputMaybe<Array<InputMaybe<CommentStatusEnum>>>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection between the Post type and the post type */
export type PostToParentConnectionEdge = Edge & OneToOneConnection & PostConnectionEdge & {
  __typename?: 'PostToParentConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /**
   * The node of the connection, without the edges
   * @deprecated This content type is not hierarchical and typically will not have a parent
   */
  node: Post;
};

/** Connection between the Post type and the post type */
export type PostToPostConnection = Connection & PostConnection & {
  __typename?: 'PostToPostConnection';
  /** Edges for the PostToPostConnection connection */
  edges: Array<PostToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: PostToPostConnectionPageInfo;
};

/** An edge in a connection */
export type PostToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'PostToPostConnectionEdge';
  /**
   * A cursor for use in pagination
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  cursor?: Maybe<Scalars['String']['output']>;
  /**
   * The item at the end of the edge
   * @deprecated This content type is not hierarchical and typically will not have ancestors
   */
  node: Post;
};

/** Pagination metadata specific to &quot;PostToPostConnection&quot; collections. Provides cursors and flags for navigating through sets of PostToPostConnection Nodes. */
export type PostToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Connection between the Post type and the postFormat type */
export type PostToPostFormatConnection = Connection & PostFormatConnection & {
  __typename?: 'PostToPostFormatConnection';
  /** Edges for the PostToPostFormatConnection connection */
  edges: Array<PostToPostFormatConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<PostFormat>;
  /** Information about pagination in a connection. */
  pageInfo: PostToPostFormatConnectionPageInfo;
};

/** An edge in a connection */
export type PostToPostFormatConnectionEdge = Edge & PostFormatConnectionEdge & {
  __typename?: 'PostToPostFormatConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The Yoast SEO Primary post_format */
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  /** The item at the end of the edge */
  node: PostFormat;
};

/** Pagination metadata specific to &quot;PostToPostFormatConnection&quot; collections. Provides cursors and flags for navigating through sets of PostToPostFormatConnection Nodes. */
export type PostToPostFormatConnectionPageInfo = PageInfo & PostFormatConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostToPostFormatConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the PostToPostFormatConnection connection */
export type PostToPostFormatConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the Post type and the post type */
export type PostToPreviewConnectionEdge = Edge & OneToOneConnection & PostConnectionEdge & {
  __typename?: 'PostToPreviewConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: Post;
};

/** Connection between the Post type and the post type */
export type PostToRevisionConnection = Connection & PostConnection & {
  __typename?: 'PostToRevisionConnection';
  /** Edges for the PostToRevisionConnection connection */
  edges: Array<PostToRevisionConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: PostToRevisionConnectionPageInfo;
};

/** An edge in a connection */
export type PostToRevisionConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'PostToRevisionConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Pagination metadata specific to &quot;PostToRevisionConnection&quot; collections. Provides cursors and flags for navigating through sets of PostToRevisionConnection Nodes. */
export type PostToRevisionConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostToRevisionConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the PostToRevisionConnection connection */
export type PostToRevisionConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the Post type and the tag type */
export type PostToTagConnection = Connection & TagConnection & {
  __typename?: 'PostToTagConnection';
  /** Edges for the PostToTagConnection connection */
  edges: Array<PostToTagConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Tag>;
  /** Information about pagination in a connection. */
  pageInfo: PostToTagConnectionPageInfo;
};

/** An edge in a connection */
export type PostToTagConnectionEdge = Edge & TagConnectionEdge & {
  __typename?: 'PostToTagConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The Yoast SEO Primary post_tag */
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  /** The item at the end of the edge */
  node: Tag;
};

/** Pagination metadata specific to &quot;PostToTagConnection&quot; collections. Provides cursors and flags for navigating through sets of PostToTagConnection Nodes. */
export type PostToTagConnectionPageInfo = PageInfo & TagConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostToTagConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the PostToTagConnection connection */
export type PostToTagConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the Post type and the TermNode type */
export type PostToTermNodeConnection = Connection & TermNodeConnection & {
  __typename?: 'PostToTermNodeConnection';
  /** Edges for the PostToTermNodeConnection connection */
  edges: Array<PostToTermNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<TermNode>;
  /** Information about pagination in a connection. */
  pageInfo: PostToTermNodeConnectionPageInfo;
};

/** An edge in a connection */
export type PostToTermNodeConnectionEdge = Edge & TermNodeConnectionEdge & {
  __typename?: 'PostToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: TermNode;
};

/** Pagination metadata specific to &quot;PostToTermNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of PostToTermNodeConnection Nodes. */
export type PostToTermNodeConnectionPageInfo = PageInfo & TermNodeConnectionPageInfo & WpPageInfo & {
  __typename?: 'PostToTermNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the PostToTermNodeConnection connection */
export type PostToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies?: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Details for labels of the PostType */
export type PostTypeLabelDetails = {
  __typename?: 'PostTypeLabelDetails';
  /** Default is ‘Add New’ for both hierarchical and non-hierarchical types. */
  addNew?: Maybe<Scalars['String']['output']>;
  /** Label for adding a new singular item. */
  addNewItem?: Maybe<Scalars['String']['output']>;
  /** Label to signify all items in a submenu link. */
  allItems?: Maybe<Scalars['String']['output']>;
  /** Label for archives in nav menus */
  archives?: Maybe<Scalars['String']['output']>;
  /** Label for the attributes meta box. */
  attributes?: Maybe<Scalars['String']['output']>;
  /** Label for editing a singular item. */
  editItem?: Maybe<Scalars['String']['output']>;
  /** Label for the Featured Image meta box title. */
  featuredImage?: Maybe<Scalars['String']['output']>;
  /** Label for the table views hidden heading. */
  filterItemsList?: Maybe<Scalars['String']['output']>;
  /** Label for the media frame button. */
  insertIntoItem?: Maybe<Scalars['String']['output']>;
  /** Label for the table hidden heading. */
  itemsList?: Maybe<Scalars['String']['output']>;
  /** Label for the table pagination hidden heading. */
  itemsListNavigation?: Maybe<Scalars['String']['output']>;
  /** Label for the menu name. */
  menuName?: Maybe<Scalars['String']['output']>;
  /** General name for the post type, usually plural. */
  name?: Maybe<Scalars['String']['output']>;
  /** Label for the new item page title. */
  newItem?: Maybe<Scalars['String']['output']>;
  /** Label used when no items are found. */
  notFound?: Maybe<Scalars['String']['output']>;
  /** Label used when no items are in the trash. */
  notFoundInTrash?: Maybe<Scalars['String']['output']>;
  /** Label used to prefix parents of hierarchical items. */
  parentItemColon?: Maybe<Scalars['String']['output']>;
  /** Label for removing the featured image. */
  removeFeaturedImage?: Maybe<Scalars['String']['output']>;
  /** Label for searching plural items. */
  searchItems?: Maybe<Scalars['String']['output']>;
  /** Label for setting the featured image. */
  setFeaturedImage?: Maybe<Scalars['String']['output']>;
  /** Name for one object of this post type. */
  singularName?: Maybe<Scalars['String']['output']>;
  /** Label for the media frame filter. */
  uploadedToThisItem?: Maybe<Scalars['String']['output']>;
  /** Label in the media frame for using a featured image. */
  useFeaturedImage?: Maybe<Scalars['String']['output']>;
  /** Label for viewing a singular item. */
  viewItem?: Maybe<Scalars['String']['output']>;
  /** Label for viewing post type archives. */
  viewItems?: Maybe<Scalars['String']['output']>;
};

export type PostTypeSeo = {
  __typename?: 'PostTypeSEO';
  breadcrumbs?: Maybe<Array<Maybe<SeoPostTypeBreadcrumbs>>>;
  canonical?: Maybe<Scalars['String']['output']>;
  cornerstone?: Maybe<Scalars['Boolean']['output']>;
  focuskw?: Maybe<Scalars['String']['output']>;
  fullHead?: Maybe<Scalars['String']['output']>;
  metaDesc?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Scalars['String']['output']>;
  metaRobotsNofollow?: Maybe<Scalars['String']['output']>;
  metaRobotsNoindex?: Maybe<Scalars['String']['output']>;
  opengraphAuthor?: Maybe<Scalars['String']['output']>;
  opengraphDescription?: Maybe<Scalars['String']['output']>;
  opengraphImage?: Maybe<MediaItem>;
  opengraphModifiedTime?: Maybe<Scalars['String']['output']>;
  opengraphPublishedTime?: Maybe<Scalars['String']['output']>;
  opengraphPublisher?: Maybe<Scalars['String']['output']>;
  opengraphSiteName?: Maybe<Scalars['String']['output']>;
  opengraphTitle?: Maybe<Scalars['String']['output']>;
  opengraphType?: Maybe<Scalars['String']['output']>;
  opengraphUrl?: Maybe<Scalars['String']['output']>;
  readingTime?: Maybe<Scalars['Float']['output']>;
  schema?: Maybe<SeoPostTypeSchema>;
  title?: Maybe<Scalars['String']['output']>;
  twitterDescription?: Maybe<Scalars['String']['output']>;
  twitterImage?: Maybe<MediaItem>;
  twitterTitle?: Maybe<Scalars['String']['output']>;
};

/** Content that supports a draft preview mode. Allows viewing unpublished changes before they are made publicly available. Previewing unpublished changes requires appropriate permissions. */
export type Previewable = {
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']['output']>;
};

/** A Gravity Forms calculation calculation field. */
export type ProductCalculationField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithCalculationSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDisableQuantitySetting & GfFieldWithDuplicatesSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & Node & ProductField & {
  __typename?: 'ProductCalculationField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The formula used for the number field. */
  calculationFormula?: Maybe<Scalars['String']['output']>;
  /** Specifies to how many decimal places the number should be rounded. This is available when `isCalculation` is true, but will return null if the number format is `CURRENCY` or if the calculation is set to `Do not round`. */
  calculationRounding?: Maybe<Scalars['Int']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has the quantity property enabled. */
  hasQuantity?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Indicates whether the number field is a calculation. */
  isCalculation?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Product field values. */
  productValues?: Maybe<ProductFieldValue>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms product field. */
export type ProductField = {
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Product field values. */
  productValues?: Maybe<ProductFieldValue>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** Input fields for Product field. */
export type ProductFieldInput = {
  /** Product price. */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Product quantity. */
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

/** The individual properties for each element of the Product value field. */
export type ProductFieldValue = {
  __typename?: 'ProductFieldValue';
  /** The product name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The product price. */
  price?: Maybe<Scalars['String']['output']>;
  /** The product quantity. */
  quantity?: Maybe<Scalars['Float']['output']>;
};

/** A Gravity Forms hiddenproduct hiddenproduct field. */
export type ProductHiddenField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithBasePriceSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & Node & ProductField & {
  __typename?: 'ProductHiddenField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The price of the product, prefixed by the currency. */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The price of the product. */
  price?: Maybe<Scalars['Float']['output']>;
  /** Product field values. */
  productValues?: Maybe<ProductFieldValue>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms price product field. */
export type ProductPriceField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & ProductField & {
  __typename?: 'ProductPriceField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Product field values. */
  productValues?: Maybe<ProductFieldValue>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms radio product field. */
export type ProductRadioField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithOtherChoiceSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & Node & ProductField & {
  __typename?: 'ProductRadioField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<ProductRadioFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the &#039;Enable &quot;other&quot; choice&#039; option is checked in the editor. */
  hasOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Product field values. */
  productValues?: Maybe<ProductFieldValue>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** ProductRadioFieldChoice choice values. */
export type ProductRadioFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & GfFieldChoiceWithOtherChoiceSetting & {
  __typename?: 'ProductRadioFieldChoice';
  /** The price associated with the choice. */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** Indicates the radio button item is the “Other” choice. */
  isOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The price associated with the choice. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms select product field. */
export type ProductSelectField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithEnhancedUiSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & ProductField & {
  __typename?: 'ProductSelectField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<ProductSelectFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** When set to true, the &quot;Chosen&quot; jQuery script will be applied to this field, enabling search capabilities to Drop Down fields and a more user-friendly interface for Multi Select fields. */
  hasEnhancedUI?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Product field values. */
  productValues?: Maybe<ProductFieldValue>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** ProductSelectFieldChoice choice values. */
export type ProductSelectFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & {
  __typename?: 'ProductSelectFieldChoice';
  /** The price associated with the choice. */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The price associated with the choice. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms singleproduct singleproduct field. */
export type ProductSingleField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithBasePriceSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDisableQuantitySetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSingleProductInputs & Node & ProductField & {
  __typename?: 'ProductSingleField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The price of the product, prefixed by the currency. */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** Whether the field has the quantity property enabled. */
  hasQuantity?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<ProductSingleInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The price of the product. */
  price?: Maybe<Scalars['Float']['output']>;
  /** Product field values. */
  productValues?: Maybe<ProductFieldValue>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** ProductSingleInputProperty input values. */
export type ProductSingleInputProperty = GfFieldInput & GfFieldInputWithSingleProductInputs & {
  __typename?: 'ProductSingleInputProperty';
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  name?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms quantity field. */
export type QuantityField = {
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** The product field to which the field is associated. */
  connectedProductField?: Maybe<ProductField>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /**
   * The id of the product field to which the field is associated.
   * @deprecated Use `connectedProductField` field instead.
   */
  productField?: Maybe<Scalars['Int']['output']>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms hidden quantity field. */
export type QuantityHiddenField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithProductFieldSetting & Node & QuantityField & {
  __typename?: 'QuantityHiddenField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** The product field to which the field is associated. */
  connectedProductField?: Maybe<ProductField>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /**
   * The id of the product field to which the field is associated.
   * @deprecated Use `connectedProductField` field instead.
   */
  productField?: Maybe<Scalars['Int']['output']>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms number quantity field. */
export type QuantityNumberField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithCalculationSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithNumberFormatSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithProductFieldSetting & GfFieldWithRangeSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & QuantityField & {
  __typename?: 'QuantityNumberField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The formula used for the number field. */
  calculationFormula?: Maybe<Scalars['String']['output']>;
  /** Specifies to how many decimal places the number should be rounded. This is available when `isCalculation` is true, but will return null if the number format is `CURRENCY` or if the calculation is set to `Do not round`. */
  calculationRounding?: Maybe<Scalars['Int']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** The product field to which the field is associated. */
  connectedProductField?: Maybe<ProductField>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Indicates whether the number field is a calculation. */
  isCalculation?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** Specifies the format allowed for the number field. */
  numberFormat?: Maybe<NumberFieldFormatEnum>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /**
   * The id of the product field to which the field is associated.
   * @deprecated Use `connectedProductField` field instead.
   */
  productField?: Maybe<Scalars['Int']['output']>;
  /** Maximum allowed value for a number field. Values higher than the number specified by this property will cause the field to fail validation. */
  rangeMax?: Maybe<Scalars['Float']['output']>;
  /** Minimum allowed value for a number field. Values lower than the number specified by this property will cause the field to fail validation. */
  rangeMin?: Maybe<Scalars['Float']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms select quantity field. */
export type QuantitySelectField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithEnhancedUiSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithProductFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & QuantityField & {
  __typename?: 'QuantitySelectField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<QuantitySelectFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** The product field to which the field is associated. */
  connectedProductField?: Maybe<ProductField>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** When set to true, the &quot;Chosen&quot; jQuery script will be applied to this field, enabling search capabilities to Drop Down fields and a more user-friendly interface for Multi Select fields. */
  hasEnhancedUI?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /**
   * The id of the product field to which the field is associated.
   * @deprecated Use `connectedProductField` field instead.
   */
  productField?: Maybe<Scalars['Int']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** QuantitySelectFieldChoice choice values. */
export type QuantitySelectFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & {
  __typename?: 'QuantitySelectFieldChoice';
  /** The price associated with the choice. */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The price associated with the choice. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms radio field. */
export type RadioField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithOtherChoiceSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & Node & {
  __typename?: 'RadioField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<RadioFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the &#039;Enable &quot;other&quot; choice&#039; option is checked in the editor. */
  hasOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** RadioFieldChoice choice values. */
export type RadioFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & GfFieldChoiceWithOtherChoiceSetting & {
  __typename?: 'RadioFieldChoice';
  /** Indicates the radio button item is the “Other” choice. */
  isOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** The reading setting type */
export type ReadingSettings = {
  __typename?: 'ReadingSettings';
  /** The ID of the page that should display the latest posts */
  pageForPosts?: Maybe<Scalars['Int']['output']>;
  /** The ID of the page that should be displayed on the front page */
  pageOnFront?: Maybe<Scalars['Int']['output']>;
  /** Blog pages show at most. */
  postsPerPage?: Maybe<Scalars['Int']['output']>;
  /** What to show on the front page */
  showOnFront?: Maybe<Scalars['String']['output']>;
};

/** Determines which version of reCAPTCHA v2 will be used.  */
export enum RecaptchaTypeEnum {
  /** A checkbox reCAPTCHA type. */
  Checkbox = 'CHECKBOX',
  /** An invisible reCAPTCHA type. */
  Invisible = 'INVISIBLE'
}

export type RedirectConfiguration = AcfOptionsPage & Node & WithAcfRedirectConfigurationBlock & {
  __typename?: 'RedirectConfiguration';
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  menuTitle?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  /** Fields of the RedirectConfigurationBlock ACF Field Group */
  redirectConfigurationBlock?: Maybe<RedirectConfigurationBlock>;
};

/** The &quot;RedirectConfigurationBlock&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type RedirectConfigurationBlock = AcfFieldGroup & AcfFieldGroupFields & RedirectConfigurationBlock_Fields & {
  __typename?: 'RedirectConfigurationBlock';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Setting this value will redirect all traffic from our site to the configured site */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;RedirectConfigurationBlock&quot; Field Group */
export type RedirectConfigurationBlock_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Setting this value will redirect all traffic from our site to the configured site */
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

/** Input for the registerUser mutation. */
export type RegisterUserInput = {
  /** User's AOL IM account. */
  aim?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A string containing content about the user. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** A string containing the user's email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The user's first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User's Jabber account. */
  jabber?: InputMaybe<Scalars['String']['input']>;
  /** The user's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User's locale. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  nicename?: InputMaybe<Scalars['String']['input']>;
  /** The user's nickname, defaults to the user's username. */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains the plain text password for the user. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  registered?: InputMaybe<Scalars['String']['input']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  richEditing?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains the user's username. */
  username: Scalars['String']['input'];
  /** A string containing the user's URL for the user's web site. */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  /** User's Yahoo IM account. */
  yim?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the registerUser mutation. */
export type RegisterUserPayload = {
  __typename?: 'RegisterUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The User object mutation type. */
  user?: Maybe<User>;
};

/** Logical operators for filter conditions. Determines whether multiple filtering criteria should be combined with AND (all must match) or OR (any can match). */
export enum RelationEnum {
  /** All conditions must match (more restrictive filtering) */
  And = 'AND',
  /** Any condition can match (more inclusive filtering) */
  Or = 'OR'
}

/** Input for the resetUserPassword mutation. */
export type ResetUserPasswordInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Password reset key */
  key?: InputMaybe<Scalars['String']['input']>;
  /** The user's login (username). */
  login?: InputMaybe<Scalars['String']['input']>;
  /** The new password. */
  password?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the resetUserPassword mutation. */
export type ResetUserPasswordPayload = {
  __typename?: 'ResetUserPasswordPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The User object mutation type. */
  user?: Maybe<User>;
};

/** Input for the restoreComment mutation. */
export type RestoreCommentInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the comment to be restored */
  id: Scalars['ID']['input'];
};

/** The payload for the restoreComment mutation. */
export type RestoreCommentPayload = {
  __typename?: 'RestoreCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The restored comment object */
  comment?: Maybe<Comment>;
  /** The ID of the restored comment */
  restoredId?: Maybe<Scalars['ID']['output']>;
};

/** The root mutation */
export type RootMutation = {
  __typename?: 'RootMutation';
  /** The createCategory mutation */
  createCategory?: Maybe<CreateCategoryPayload>;
  /** The createComment mutation */
  createComment?: Maybe<CreateCommentPayload>;
  /** The createMediaItem mutation */
  createMediaItem?: Maybe<CreateMediaItemPayload>;
  /** The createPage mutation */
  createPage?: Maybe<CreatePagePayload>;
  /** The createPost mutation */
  createPost?: Maybe<CreatePostPayload>;
  /** The createPostFormat mutation */
  createPostFormat?: Maybe<CreatePostFormatPayload>;
  /** The createTag mutation */
  createTag?: Maybe<CreateTagPayload>;
  /** The createUser mutation */
  createUser?: Maybe<CreateUserPayload>;
  /** The deleteCategory mutation */
  deleteCategory?: Maybe<DeleteCategoryPayload>;
  /** The deleteComment mutation */
  deleteComment?: Maybe<DeleteCommentPayload>;
  /** The deleteGfDraftEntry mutation */
  deleteGfDraftEntry?: Maybe<DeleteGfDraftEntryPayload>;
  /** The deleteGfEntry mutation */
  deleteGfEntry?: Maybe<DeleteGfEntryPayload>;
  /** The deleteMediaItem mutation */
  deleteMediaItem?: Maybe<DeleteMediaItemPayload>;
  /** The deletePage mutation */
  deletePage?: Maybe<DeletePagePayload>;
  /** The deletePost mutation */
  deletePost?: Maybe<DeletePostPayload>;
  /** The deletePostFormat mutation */
  deletePostFormat?: Maybe<DeletePostFormatPayload>;
  /** The deleteTag mutation */
  deleteTag?: Maybe<DeleteTagPayload>;
  /** The deleteUser mutation */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** The generateAuthorizationCode mutation */
  generateAuthorizationCode?: Maybe<GenerateAuthorizationCodePayload>;
  /** Increase the count. */
  increaseCount?: Maybe<Scalars['Int']['output']>;
  /** The registerUser mutation */
  registerUser?: Maybe<RegisterUserPayload>;
  /** The resetUserPassword mutation */
  resetUserPassword?: Maybe<ResetUserPasswordPayload>;
  /** The restoreComment mutation */
  restoreComment?: Maybe<RestoreCommentPayload>;
  /** Send password reset email to user */
  sendPasswordResetEmail?: Maybe<SendPasswordResetEmailPayload>;
  /** The submitGfDraftEntry mutation */
  submitGfDraftEntry?: Maybe<SubmitGfDraftEntryPayload>;
  /** The SubmitGfForm mutation */
  submitGfForm?: Maybe<SubmitGfFormPayload>;
  /** The updateCategory mutation */
  updateCategory?: Maybe<UpdateCategoryPayload>;
  /** The updateComment mutation */
  updateComment?: Maybe<UpdateCommentPayload>;
  /** The updateGfDraftEntry mutation */
  updateGfDraftEntry?: Maybe<UpdateGfDraftEntryPayload>;
  /** The updateGfEntry mutation */
  updateGfEntry?: Maybe<UpdateGfEntryPayload>;
  /** The updateMediaItem mutation */
  updateMediaItem?: Maybe<UpdateMediaItemPayload>;
  /** The updatePage mutation */
  updatePage?: Maybe<UpdatePagePayload>;
  /** The updatePost mutation */
  updatePost?: Maybe<UpdatePostPayload>;
  /** The updatePostFormat mutation */
  updatePostFormat?: Maybe<UpdatePostFormatPayload>;
  /** The updateSettings mutation */
  updateSettings?: Maybe<UpdateSettingsPayload>;
  /** The updateTag mutation */
  updateTag?: Maybe<UpdateTagPayload>;
  /** The updateUser mutation */
  updateUser?: Maybe<UpdateUserPayload>;
};


/** The root mutation */
export type RootMutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


/** The root mutation */
export type RootMutationCreateCommentArgs = {
  input: CreateCommentInput;
};


/** The root mutation */
export type RootMutationCreateMediaItemArgs = {
  input: CreateMediaItemInput;
};


/** The root mutation */
export type RootMutationCreatePageArgs = {
  input: CreatePageInput;
};


/** The root mutation */
export type RootMutationCreatePostArgs = {
  input: CreatePostInput;
};


/** The root mutation */
export type RootMutationCreatePostFormatArgs = {
  input: CreatePostFormatInput;
};


/** The root mutation */
export type RootMutationCreateTagArgs = {
  input: CreateTagInput;
};


/** The root mutation */
export type RootMutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation */
export type RootMutationDeleteCategoryArgs = {
  input: DeleteCategoryInput;
};


/** The root mutation */
export type RootMutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


/** The root mutation */
export type RootMutationDeleteGfDraftEntryArgs = {
  input: DeleteGfDraftEntryInput;
};


/** The root mutation */
export type RootMutationDeleteGfEntryArgs = {
  input: DeleteGfEntryInput;
};


/** The root mutation */
export type RootMutationDeleteMediaItemArgs = {
  input: DeleteMediaItemInput;
};


/** The root mutation */
export type RootMutationDeletePageArgs = {
  input: DeletePageInput;
};


/** The root mutation */
export type RootMutationDeletePostArgs = {
  input: DeletePostInput;
};


/** The root mutation */
export type RootMutationDeletePostFormatArgs = {
  input: DeletePostFormatInput;
};


/** The root mutation */
export type RootMutationDeleteTagArgs = {
  input: DeleteTagInput;
};


/** The root mutation */
export type RootMutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation */
export type RootMutationGenerateAuthorizationCodeArgs = {
  input: GenerateAuthorizationCodeInput;
};


/** The root mutation */
export type RootMutationIncreaseCountArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


/** The root mutation */
export type RootMutationRegisterUserArgs = {
  input: RegisterUserInput;
};


/** The root mutation */
export type RootMutationResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};


/** The root mutation */
export type RootMutationRestoreCommentArgs = {
  input: RestoreCommentInput;
};


/** The root mutation */
export type RootMutationSendPasswordResetEmailArgs = {
  input: SendPasswordResetEmailInput;
};


/** The root mutation */
export type RootMutationSubmitGfDraftEntryArgs = {
  input: SubmitGfDraftEntryInput;
};


/** The root mutation */
export type RootMutationSubmitGfFormArgs = {
  input: SubmitGfFormInput;
};


/** The root mutation */
export type RootMutationUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};


/** The root mutation */
export type RootMutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


/** The root mutation */
export type RootMutationUpdateGfDraftEntryArgs = {
  input: UpdateGfDraftEntryInput;
};


/** The root mutation */
export type RootMutationUpdateGfEntryArgs = {
  input: UpdateGfEntryInput;
};


/** The root mutation */
export type RootMutationUpdateMediaItemArgs = {
  input: UpdateMediaItemInput;
};


/** The root mutation */
export type RootMutationUpdatePageArgs = {
  input: UpdatePageInput;
};


/** The root mutation */
export type RootMutationUpdatePostArgs = {
  input: UpdatePostInput;
};


/** The root mutation */
export type RootMutationUpdatePostFormatArgs = {
  input: UpdatePostFormatInput;
};


/** The root mutation */
export type RootMutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};


/** The root mutation */
export type RootMutationUpdateTagArgs = {
  input: UpdateTagInput;
};


/** The root mutation */
export type RootMutationUpdateUserArgs = {
  input: UpdateUserInput;
};

/** The root entry point into the Graph */
export type RootQuery = WithAcfOptionsPageFrontEndConfiguration & WithAcfOptionsPageMarketoIntegration & WithAcfOptionsPageRedirectConfiguration & WithAcfOptionsPageSalesforceIntegration & WithAcfOptionsPageUtmConfiguration & {
  __typename?: 'RootQuery';
  /** Entry point to get all settings for the site */
  allSettings?: Maybe<Settings>;
  /** Connection between the RootQuery type and the category type */
  categories?: Maybe<RootQueryToCategoryConnection>;
  /** A 0bject */
  category?: Maybe<Category>;
  /** Returns a Comment */
  comment?: Maybe<Comment>;
  /** Connection between the RootQuery type and the Comment type */
  comments?: Maybe<RootQueryToCommentConnection>;
  /** A node used to manage content */
  contentNode?: Maybe<ContentNode>;
  /** Connection between the RootQuery type and the ContentNode type */
  contentNodes?: Maybe<RootQueryToContentNodeConnection>;
  /** Fetch a Content Type node by unique Identifier */
  contentType?: Maybe<ContentType>;
  /** Connection between the RootQuery type and the ContentType type */
  contentTypes?: Maybe<RootQueryToContentTypeConnection>;
  /** Fields of the &#039;DiscussionSettings&#039; settings group */
  discussionSettings?: Maybe<DiscussionSettings>;
  frontEndConfiguration?: Maybe<FrontEndConfiguration>;
  /** Fields of the &#039;GeneralSettings&#039; settings group */
  generalSettings?: Maybe<GeneralSettings>;
  /** Get a Gravity Forms entry. */
  gfDraftEntry?: Maybe<GfDraftEntry>;
  /** Connection between the RootQuery type and the GfEntry type */
  gfEntries?: Maybe<RootQueryToGfEntryConnection>;
  /** Get a Gravity Forms entry. */
  gfEntry?: Maybe<GfEntry>;
  /** Get a Gravity Forms form. */
  gfForm?: Maybe<GfForm>;
  /** Connection between the RootQuery type and the GfForm type */
  gfForms?: Maybe<RootQueryToGfFormConnection>;
  /** Gravity Forms settings. */
  gfSettings?: Maybe<GfSettings>;
  /** Connection between the RootQuery type and the GfSubmittedEntry type */
  gfSubmittedEntries?: Maybe<RootQueryToGfSubmittedEntryConnection>;
  /** Get a Gravity Forms entry. */
  gfSubmittedEntry?: Maybe<GfSubmittedEntry>;
  /** Returns the stylesheet resulting of merging core, theme, and user data. */
  globalStylesheet?: Maybe<Scalars['String']['output']>;
  marketoIntegration?: Maybe<MarketoIntegration>;
  /** An object of the mediaItem Type.  */
  mediaItem?: Maybe<MediaItem>;
  /**
   * A mediaItem object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  mediaItemBy?: Maybe<MediaItem>;
  /** Connection between the RootQuery type and the mediaItem type */
  mediaItems?: Maybe<RootQueryToMediaItemConnection>;
  /** A WordPress navigation menu */
  menu?: Maybe<Menu>;
  /** A WordPress navigation menu item */
  menuItem?: Maybe<MenuItem>;
  /** Connection between the RootQuery type and the MenuItem type */
  menuItems?: Maybe<RootQueryToMenuItemConnection>;
  /** Connection between the RootQuery type and the Menu type */
  menus?: Maybe<RootQueryToMenuConnection>;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Fetches an object given its Unique Resource Identifier */
  nodeByUri?: Maybe<UniformResourceIdentifiable>;
  /** An object of the page Type.  */
  page?: Maybe<Page>;
  /**
   * A page object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  pageBy?: Maybe<Page>;
  /** Connection between the RootQuery type and the page type */
  pages?: Maybe<RootQueryToPageConnection>;
  /** A WordPress plugin */
  plugin?: Maybe<Plugin>;
  /** Connection between the RootQuery type and the Plugin type */
  plugins?: Maybe<RootQueryToPluginConnection>;
  /** An object of the post Type.  */
  post?: Maybe<Post>;
  /**
   * A post object
   * @deprecated Deprecated in favor of using the single entry point for this type with ID and IDType fields. For example, instead of postBy( id: &quot;&quot; ), use post(id: &quot;&quot; idType: &quot;&quot;)
   */
  postBy?: Maybe<Post>;
  /** A 0bject */
  postFormat?: Maybe<PostFormat>;
  /** Connection between the RootQuery type and the postFormat type */
  postFormats?: Maybe<RootQueryToPostFormatConnection>;
  /** Connection between the RootQuery type and the post type */
  posts?: Maybe<RootQueryToPostConnection>;
  /** Fields of the &#039;ReadingSettings&#039; settings group */
  readingSettings?: Maybe<ReadingSettings>;
  redirectConfiguration?: Maybe<RedirectConfiguration>;
  /** Connection between the RootQuery type and the EnqueuedScript type */
  registeredScripts?: Maybe<RootQueryToEnqueuedScriptConnection>;
  /** Connection between the RootQuery type and the EnqueuedStylesheet type */
  registeredStylesheets?: Maybe<RootQueryToEnqueuedStylesheetConnection>;
  /** Connection between the RootQuery type and the ContentNode type */
  revisions?: Maybe<RootQueryToRevisionsConnection>;
  salesforceIntegration?: Maybe<SalesforceIntegration>;
  /** Returns seo site data */
  seo?: Maybe<SeoConfig>;
  /** A 0bject */
  tag?: Maybe<Tag>;
  /** Connection between the RootQuery type and the tag type */
  tags?: Maybe<RootQueryToTagConnection>;
  /** Connection between the RootQuery type and the Taxonomy type */
  taxonomies?: Maybe<RootQueryToTaxonomyConnection>;
  /** Fetch a Taxonomy node by unique Identifier */
  taxonomy?: Maybe<Taxonomy>;
  /** A node in a taxonomy used to group and relate content nodes */
  termNode?: Maybe<TermNode>;
  /** Connection between the RootQuery type and the TermNode type */
  terms?: Maybe<RootQueryToTermNodeConnection>;
  /** A Theme object */
  theme?: Maybe<Theme>;
  /** Connection between the RootQuery type and the Theme type */
  themes?: Maybe<RootQueryToThemeConnection>;
  uTMConfiguration?: Maybe<UtmConfiguration>;
  /** Returns a user */
  user?: Maybe<User>;
  /** Returns a user role */
  userRole?: Maybe<UserRole>;
  /** Connection between the RootQuery type and the UserRole type */
  userRoles?: Maybe<RootQueryToUserRoleConnection>;
  /** Connection between the RootQuery type and the User type */
  users?: Maybe<RootQueryToUserConnection>;
  /** Returns the current user */
  viewer?: Maybe<User>;
  /** Fields of the &#039;WritingSettings&#039; settings group */
  writingSettings?: Maybe<WritingSettings>;
};


/** The root entry point into the Graph */
export type RootQueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToCategoryConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryCategoryArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<CategoryIdType>;
};


/** The root entry point into the Graph */
export type RootQueryCommentArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<CommentNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToCommentConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryContentNodeArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']['input']>;
  contentType?: InputMaybe<ContentTypeEnum>;
  id: Scalars['ID']['input'];
  idType?: InputMaybe<ContentNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryContentNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToContentNodeConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryContentTypeArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<ContentTypeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryContentTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryGfDraftEntryArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<DraftEntryIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryGfEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToGfEntryConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryGfEntryArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<EntryIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryGfFormArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<FormIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryGfFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToGfFormConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryGfSubmittedEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToGfSubmittedEntryConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryGfSubmittedEntryArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<SubmittedEntryIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryGlobalStylesheetArgs = {
  types?: InputMaybe<Array<InputMaybe<GlobalStylesheetTypesEnum>>>;
};


/** The root entry point into the Graph */
export type RootQueryMediaItemArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  idType?: InputMaybe<MediaItemIdType>;
};


/** The root entry point into the Graph */
export type RootQueryMediaItemByArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  mediaItemId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryMediaItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToMediaItemConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryMenuArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<MenuNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryMenuItemArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<MenuItemNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryMenuItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToMenuItemConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryMenusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToMenuConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryNodeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryNodeByUriArgs = {
  uri: Scalars['String']['input'];
};


/** The root entry point into the Graph */
export type RootQueryPageArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  idType?: InputMaybe<PageIdType>;
};


/** The root entry point into the Graph */
export type RootQueryPageByArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  pageId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToPageConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryPluginArgs = {
  id: Scalars['ID']['input'];
};


/** The root entry point into the Graph */
export type RootQueryPluginsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToPluginConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryPostArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  idType?: InputMaybe<PostIdType>;
};


/** The root entry point into the Graph */
export type RootQueryPostByArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  postId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryPostFormatArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<PostFormatIdType>;
};


/** The root entry point into the Graph */
export type RootQueryPostFormatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToPostFormatConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToPostConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryRegisteredScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryRegisteredStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryRevisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToRevisionsConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryTagArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<TagIdType>;
};


/** The root entry point into the Graph */
export type RootQueryTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToTagConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryTaxonomiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryTaxonomyArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<TaxonomyIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryTermNodeArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<TermNodeIdTypeEnum>;
  taxonomy?: InputMaybe<TaxonomyEnum>;
};


/** The root entry point into the Graph */
export type RootQueryTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToTermNodeConnectionWhereArgs>;
};


/** The root entry point into the Graph */
export type RootQueryThemeArgs = {
  id: Scalars['ID']['input'];
};


/** The root entry point into the Graph */
export type RootQueryThemesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryUserArgs = {
  id: Scalars['ID']['input'];
  idType?: InputMaybe<UserNodeIdTypeEnum>;
};


/** The root entry point into the Graph */
export type RootQueryUserRoleArgs = {
  id: Scalars['ID']['input'];
};


/** The root entry point into the Graph */
export type RootQueryUserRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root entry point into the Graph */
export type RootQueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RootQueryToUserConnectionWhereArgs>;
};

/** Connection between the RootQuery type and the category type */
export type RootQueryToCategoryConnection = CategoryConnection & Connection & {
  __typename?: 'RootQueryToCategoryConnection';
  /** Edges for the RootQueryToCategoryConnection connection */
  edges: Array<RootQueryToCategoryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Category>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToCategoryConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToCategoryConnectionEdge = CategoryConnectionEdge & Edge & {
  __typename?: 'RootQueryToCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Category;
};

/** Pagination metadata specific to &quot;RootQueryToCategoryConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToCategoryConnection Nodes. */
export type RootQueryToCategoryConnectionPageInfo = CategoryConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToCategoryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToCategoryConnection connection */
export type RootQueryToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the RootQuery type and the Comment type */
export type RootQueryToCommentConnection = CommentConnection & Connection & {
  __typename?: 'RootQueryToCommentConnection';
  /** Edges for the RootQueryToCommentConnection connection */
  edges: Array<RootQueryToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  __typename?: 'RootQueryToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Comment;
};

/** Pagination metadata specific to &quot;RootQueryToCommentConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToCommentConnection Nodes. */
export type RootQueryToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToCommentConnection connection */
export type RootQueryToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']['input']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']['input']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']['input']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']['input']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** One or more Comment Statuses to limit results by */
  statusIn?: InputMaybe<Array<InputMaybe<CommentStatusEnum>>>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection between the RootQuery type and the ContentNode type */
export type RootQueryToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'RootQueryToContentNodeConnection';
  /** Edges for the RootQueryToContentNodeConnection connection */
  edges: Array<RootQueryToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'RootQueryToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Pagination metadata specific to &quot;RootQueryToContentNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToContentNodeConnection Nodes. */
export type RootQueryToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToContentNodeConnection connection */
export type RootQueryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the ContentType type */
export type RootQueryToContentTypeConnection = Connection & ContentTypeConnection & {
  __typename?: 'RootQueryToContentTypeConnection';
  /** Edges for the RootQueryToContentTypeConnection connection */
  edges: Array<RootQueryToContentTypeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentType>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToContentTypeConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToContentTypeConnectionEdge = ContentTypeConnectionEdge & Edge & {
  __typename?: 'RootQueryToContentTypeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: ContentType;
};

/** Pagination metadata specific to &quot;RootQueryToContentTypeConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToContentTypeConnection Nodes. */
export type RootQueryToContentTypeConnectionPageInfo = ContentTypeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToContentTypeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Connection between the RootQuery type and the EnqueuedScript type */
export type RootQueryToEnqueuedScriptConnection = Connection & EnqueuedScriptConnection & {
  __typename?: 'RootQueryToEnqueuedScriptConnection';
  /** Edges for the RootQueryToEnqueuedScriptConnection connection */
  edges: Array<RootQueryToEnqueuedScriptConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedScript>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToEnqueuedScriptConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToEnqueuedScriptConnectionEdge = Edge & EnqueuedScriptConnectionEdge & {
  __typename?: 'RootQueryToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: EnqueuedScript;
};

/** Pagination metadata specific to &quot;RootQueryToEnqueuedScriptConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToEnqueuedScriptConnection Nodes. */
export type RootQueryToEnqueuedScriptConnectionPageInfo = EnqueuedScriptConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToEnqueuedScriptConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Connection between the RootQuery type and the EnqueuedStylesheet type */
export type RootQueryToEnqueuedStylesheetConnection = Connection & EnqueuedStylesheetConnection & {
  __typename?: 'RootQueryToEnqueuedStylesheetConnection';
  /** Edges for the RootQueryToEnqueuedStylesheetConnection connection */
  edges: Array<RootQueryToEnqueuedStylesheetConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToEnqueuedStylesheetConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToEnqueuedStylesheetConnectionEdge = Edge & EnqueuedStylesheetConnectionEdge & {
  __typename?: 'RootQueryToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: EnqueuedStylesheet;
};

/** Pagination metadata specific to &quot;RootQueryToEnqueuedStylesheetConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToEnqueuedStylesheetConnection Nodes. */
export type RootQueryToEnqueuedStylesheetConnectionPageInfo = EnqueuedStylesheetConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToEnqueuedStylesheetConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Connection between the RootQuery type and the GfEntry type */
export type RootQueryToGfEntryConnection = Connection & GfEntryConnection & {
  __typename?: 'RootQueryToGfEntryConnection';
  /** Edges for the RootQueryToGfEntryConnection connection */
  edges: Array<RootQueryToGfEntryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<GfEntry>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToGfEntryConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToGfEntryConnectionEdge = Edge & GfEntryConnectionEdge & {
  __typename?: 'RootQueryToGfEntryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: GfEntry;
};

/** Pagination metadata specific to &quot;RootQueryToGfEntryConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToGfEntryConnection Nodes. */
export type RootQueryToGfEntryConnectionPageInfo = GfEntryConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToGfEntryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToGfEntryConnection connection */
export type RootQueryToGfEntryConnectionWhereArgs = {
  /** Date filters to apply. */
  dateFilters?: InputMaybe<EntriesDateFiltersInput>;
  /** Entry status. Default is `SUBMITTED`. Currently no other types are supported. */
  entryType?: InputMaybe<EntryTypeEnum>;
  /** Field-specific filters to apply. */
  fieldFilters?: InputMaybe<Array<InputMaybe<EntriesFieldFiltersInput>>>;
  /** Whether to filter by ALL or ANY of the field filters. Default is ALL. */
  fieldFiltersMode?: InputMaybe<FieldFiltersModeEnum>;
  /** Array of form IDs to limit the entries to. Exclude this argument to query all forms. */
  formIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** How to sort the entries. */
  orderby?: InputMaybe<EntriesConnectionOrderbyInput>;
  /** Entry status. Default is "ACTIVE". */
  status?: InputMaybe<EntryStatusEnum>;
};

/** Connection between the RootQuery type and the GfForm type */
export type RootQueryToGfFormConnection = Connection & GfFormConnection & {
  __typename?: 'RootQueryToGfFormConnection';
  /** Edges for the RootQueryToGfFormConnection connection */
  edges: Array<RootQueryToGfFormConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<GfForm>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToGfFormConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToGfFormConnectionEdge = Edge & GfFormConnectionEdge & {
  __typename?: 'RootQueryToGfFormConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: GfForm;
};

/** Pagination metadata specific to &quot;RootQueryToGfFormConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToGfFormConnection Nodes. */
export type RootQueryToGfFormConnectionPageInfo = GfFormConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToGfFormConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToGfFormConnection connection */
export type RootQueryToGfFormConnectionWhereArgs = {
  /** Array of form database IDs to return. Exclude this argument to query all forms. */
  formIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** How to sort the entries. */
  orderby?: InputMaybe<FormsConnectionOrderbyInput>;
  /** Status of the forms to get. */
  status?: InputMaybe<FormStatusEnum>;
};

/** Connection between the RootQuery type and the GfSubmittedEntry type */
export type RootQueryToGfSubmittedEntryConnection = Connection & GfSubmittedEntryConnection & {
  __typename?: 'RootQueryToGfSubmittedEntryConnection';
  /** Edges for the RootQueryToGfSubmittedEntryConnection connection */
  edges: Array<RootQueryToGfSubmittedEntryConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<GfSubmittedEntry>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToGfSubmittedEntryConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToGfSubmittedEntryConnectionEdge = Edge & GfSubmittedEntryConnectionEdge & {
  __typename?: 'RootQueryToGfSubmittedEntryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: GfSubmittedEntry;
};

/** Pagination metadata specific to &quot;RootQueryToGfSubmittedEntryConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToGfSubmittedEntryConnection Nodes. */
export type RootQueryToGfSubmittedEntryConnectionPageInfo = GfSubmittedEntryConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToGfSubmittedEntryConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToGfSubmittedEntryConnection connection */
export type RootQueryToGfSubmittedEntryConnectionWhereArgs = {
  /** Date filters to apply. */
  dateFilters?: InputMaybe<EntriesDateFiltersInput>;
  /** Field-specific filters to apply. */
  fieldFilters?: InputMaybe<Array<InputMaybe<EntriesFieldFiltersInput>>>;
  /** Whether to filter by ALL or ANY of the field filters. Default is ALL. */
  fieldFiltersMode?: InputMaybe<FieldFiltersModeEnum>;
  /** Array of form IDs to limit the entries to. Exclude this argument to query all forms. */
  formIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** How to sort the entries. */
  orderby?: InputMaybe<EntriesConnectionOrderbyInput>;
  /** Entry status. Default is "ACTIVE". */
  status?: InputMaybe<EntryStatusEnum>;
};

/** Connection between the RootQuery type and the mediaItem type */
export type RootQueryToMediaItemConnection = Connection & MediaItemConnection & {
  __typename?: 'RootQueryToMediaItemConnection';
  /** Edges for the RootQueryToMediaItemConnection connection */
  edges: Array<RootQueryToMediaItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<MediaItem>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToMediaItemConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToMediaItemConnectionEdge = Edge & MediaItemConnectionEdge & {
  __typename?: 'RootQueryToMediaItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: MediaItem;
};

/** Pagination metadata specific to &quot;RootQueryToMediaItemConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToMediaItemConnection Nodes. */
export type RootQueryToMediaItemConnectionPageInfo = MediaItemConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToMediaItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToMediaItemConnection connection */
export type RootQueryToMediaItemConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the Menu type */
export type RootQueryToMenuConnection = Connection & MenuConnection & {
  __typename?: 'RootQueryToMenuConnection';
  /** Edges for the RootQueryToMenuConnection connection */
  edges: Array<RootQueryToMenuConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Menu>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToMenuConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToMenuConnectionEdge = Edge & MenuConnectionEdge & {
  __typename?: 'RootQueryToMenuConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Menu;
};

/** Pagination metadata specific to &quot;RootQueryToMenuConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToMenuConnection Nodes. */
export type RootQueryToMenuConnectionPageInfo = MenuConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToMenuConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToMenuConnection connection */
export type RootQueryToMenuConnectionWhereArgs = {
  /** The database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The menu location for the menu being queried */
  location?: InputMaybe<MenuLocationEnum>;
  /** The slug of the menu to query items for */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the MenuItem type */
export type RootQueryToMenuItemConnection = Connection & MenuItemConnection & {
  __typename?: 'RootQueryToMenuItemConnection';
  /** Edges for the RootQueryToMenuItemConnection connection */
  edges: Array<RootQueryToMenuItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<MenuItem>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToMenuItemConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToMenuItemConnectionEdge = Edge & MenuItemConnectionEdge & {
  __typename?: 'RootQueryToMenuItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: MenuItem;
};

/** Pagination metadata specific to &quot;RootQueryToMenuItemConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToMenuItemConnection Nodes. */
export type RootQueryToMenuItemConnectionPageInfo = MenuItemConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToMenuItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToMenuItemConnection connection */
export type RootQueryToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The menu location for the menu being queried */
  location?: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  parentDatabaseId?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the parent menu object */
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection between the RootQuery type and the page type */
export type RootQueryToPageConnection = Connection & PageConnection & {
  __typename?: 'RootQueryToPageConnection';
  /** Edges for the RootQueryToPageConnection connection */
  edges: Array<RootQueryToPageConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Page>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToPageConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToPageConnectionEdge = Edge & PageConnectionEdge & {
  __typename?: 'RootQueryToPageConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Page;
};

/** Pagination metadata specific to &quot;RootQueryToPageConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToPageConnection Nodes. */
export type RootQueryToPageConnectionPageInfo = PageConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToPageConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToPageConnection connection */
export type RootQueryToPageConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the Plugin type */
export type RootQueryToPluginConnection = Connection & PluginConnection & {
  __typename?: 'RootQueryToPluginConnection';
  /** Edges for the RootQueryToPluginConnection connection */
  edges: Array<RootQueryToPluginConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Plugin>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToPluginConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToPluginConnectionEdge = Edge & PluginConnectionEdge & {
  __typename?: 'RootQueryToPluginConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Plugin;
};

/** Pagination metadata specific to &quot;RootQueryToPluginConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToPluginConnection Nodes. */
export type RootQueryToPluginConnectionPageInfo = PageInfo & PluginConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToPluginConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToPluginConnection connection */
export type RootQueryToPluginConnectionWhereArgs = {
  /** Show plugin based on a keyword search. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve plugins where plugin status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PluginStatusEnum>>>;
  /** Show plugins with a specific status. */
  status?: InputMaybe<PluginStatusEnum>;
};

/** Connection between the RootQuery type and the post type */
export type RootQueryToPostConnection = Connection & PostConnection & {
  __typename?: 'RootQueryToPostConnection';
  /** Edges for the RootQueryToPostConnection connection */
  edges: Array<RootQueryToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToPostConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'RootQueryToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Pagination metadata specific to &quot;RootQueryToPostConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToPostConnection Nodes. */
export type RootQueryToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToPostConnection connection */
export type RootQueryToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the postFormat type */
export type RootQueryToPostFormatConnection = Connection & PostFormatConnection & {
  __typename?: 'RootQueryToPostFormatConnection';
  /** Edges for the RootQueryToPostFormatConnection connection */
  edges: Array<RootQueryToPostFormatConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<PostFormat>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToPostFormatConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToPostFormatConnectionEdge = Edge & PostFormatConnectionEdge & {
  __typename?: 'RootQueryToPostFormatConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: PostFormat;
};

/** Pagination metadata specific to &quot;RootQueryToPostFormatConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToPostFormatConnection Nodes. */
export type RootQueryToPostFormatConnectionPageInfo = PageInfo & PostFormatConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToPostFormatConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToPostFormatConnection connection */
export type RootQueryToPostFormatConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the RootQuery type and the ContentNode type */
export type RootQueryToRevisionsConnection = Connection & ContentNodeConnection & {
  __typename?: 'RootQueryToRevisionsConnection';
  /** Edges for the RootQueryToRevisionsConnection connection */
  edges: Array<RootQueryToRevisionsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToRevisionsConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToRevisionsConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'RootQueryToRevisionsConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Pagination metadata specific to &quot;RootQueryToRevisionsConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToRevisionsConnection Nodes. */
export type RootQueryToRevisionsConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'RootQueryToRevisionsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToRevisionsConnection connection */
export type RootQueryToRevisionsConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the RootQuery type and the tag type */
export type RootQueryToTagConnection = Connection & TagConnection & {
  __typename?: 'RootQueryToTagConnection';
  /** Edges for the RootQueryToTagConnection connection */
  edges: Array<RootQueryToTagConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Tag>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToTagConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToTagConnectionEdge = Edge & TagConnectionEdge & {
  __typename?: 'RootQueryToTagConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Tag;
};

/** Pagination metadata specific to &quot;RootQueryToTagConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToTagConnection Nodes. */
export type RootQueryToTagConnectionPageInfo = PageInfo & TagConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToTagConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToTagConnection connection */
export type RootQueryToTagConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the RootQuery type and the Taxonomy type */
export type RootQueryToTaxonomyConnection = Connection & TaxonomyConnection & {
  __typename?: 'RootQueryToTaxonomyConnection';
  /** Edges for the RootQueryToTaxonomyConnection connection */
  edges: Array<RootQueryToTaxonomyConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Taxonomy>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToTaxonomyConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToTaxonomyConnectionEdge = Edge & TaxonomyConnectionEdge & {
  __typename?: 'RootQueryToTaxonomyConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Taxonomy;
};

/** Pagination metadata specific to &quot;RootQueryToTaxonomyConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToTaxonomyConnection Nodes. */
export type RootQueryToTaxonomyConnectionPageInfo = PageInfo & TaxonomyConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToTaxonomyConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Connection between the RootQuery type and the TermNode type */
export type RootQueryToTermNodeConnection = Connection & TermNodeConnection & {
  __typename?: 'RootQueryToTermNodeConnection';
  /** Edges for the RootQueryToTermNodeConnection connection */
  edges: Array<RootQueryToTermNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<TermNode>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToTermNodeConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToTermNodeConnectionEdge = Edge & TermNodeConnectionEdge & {
  __typename?: 'RootQueryToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: TermNode;
};

/** Pagination metadata specific to &quot;RootQueryToTermNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToTermNodeConnection Nodes. */
export type RootQueryToTermNodeConnectionPageInfo = PageInfo & TermNodeConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToTermNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToTermNodeConnection connection */
export type RootQueryToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']['input']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']['input']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']['input']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies?: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Connection between the RootQuery type and the Theme type */
export type RootQueryToThemeConnection = Connection & ThemeConnection & {
  __typename?: 'RootQueryToThemeConnection';
  /** Edges for the RootQueryToThemeConnection connection */
  edges: Array<RootQueryToThemeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Theme>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToThemeConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToThemeConnectionEdge = Edge & ThemeConnectionEdge & {
  __typename?: 'RootQueryToThemeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Theme;
};

/** Pagination metadata specific to &quot;RootQueryToThemeConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToThemeConnection Nodes. */
export type RootQueryToThemeConnectionPageInfo = PageInfo & ThemeConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToThemeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Connection between the RootQuery type and the User type */
export type RootQueryToUserConnection = Connection & UserConnection & {
  __typename?: 'RootQueryToUserConnection';
  /** Edges for the RootQueryToUserConnection connection */
  edges: Array<RootQueryToUserConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<User>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToUserConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToUserConnectionEdge = Edge & UserConnectionEdge & {
  __typename?: 'RootQueryToUserConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: User;
};

/** Pagination metadata specific to &quot;RootQueryToUserConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToUserConnection Nodes. */
export type RootQueryToUserConnectionPageInfo = PageInfo & UserConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToUserConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the RootQueryToUserConnection connection */
export type RootQueryToUserConnectionWhereArgs = {
  /** Array of userIds to exclude. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Pass an array of post types to filter results to users who have published posts in those post types. */
  hasPublishedPosts?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of userIds to include. */
  include?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** The user login. */
  login?: InputMaybe<Scalars['String']['input']>;
  /** An array of logins to include. Users matching one of these logins will be included in results. */
  loginIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of logins to exclude. Users matching one of these logins will not be included in results. */
  loginNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The user nicename. */
  nicename?: InputMaybe<Scalars['String']['input']>;
  /** An array of nicenames to include. Users matching one of these nicenames will be included in results. */
  nicenameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of nicenames to exclude. Users matching one of these nicenames will not be included in results. */
  nicenameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<UsersConnectionOrderbyInput>>>;
  /** An array of role names that users must match to be included in results. Note that this is an inclusive list: users must match *each* role. */
  role?: InputMaybe<UserRoleEnum>;
  /** An array of role names. Matched users must have at least one of these roles. */
  roleIn?: InputMaybe<Array<InputMaybe<UserRoleEnum>>>;
  /** An array of role names to exclude. Users matching one or more of these roles will not be included in results. */
  roleNotIn?: InputMaybe<Array<InputMaybe<UserRoleEnum>>>;
  /** Search keyword. Searches for possible string matches on columns. When "searchColumns" is left empty, it tries to determine which column to search in based on search string. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Array of column names to be searched. Accepts 'ID', 'login', 'nicename', 'email', 'url'. */
  searchColumns?: InputMaybe<Array<InputMaybe<UsersConnectionSearchColumnEnum>>>;
};

/** Connection between the RootQuery type and the UserRole type */
export type RootQueryToUserRoleConnection = Connection & UserRoleConnection & {
  __typename?: 'RootQueryToUserRoleConnection';
  /** Edges for the RootQueryToUserRoleConnection connection */
  edges: Array<RootQueryToUserRoleConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<UserRole>;
  /** Information about pagination in a connection. */
  pageInfo: RootQueryToUserRoleConnectionPageInfo;
};

/** An edge in a connection */
export type RootQueryToUserRoleConnectionEdge = Edge & UserRoleConnectionEdge & {
  __typename?: 'RootQueryToUserRoleConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: UserRole;
};

/** Pagination metadata specific to &quot;RootQueryToUserRoleConnection&quot; collections. Provides cursors and flags for navigating through sets of RootQueryToUserRoleConnection Nodes. */
export type RootQueryToUserRoleConnectionPageInfo = PageInfo & UserRoleConnectionPageInfo & WpPageInfo & {
  __typename?: 'RootQueryToUserRoleConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** The Yoast SEO breadcrumb config */
export type SeoBreadcrumbs = {
  __typename?: 'SEOBreadcrumbs';
  archivePrefix?: Maybe<Scalars['String']['output']>;
  boldLast?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  homeText?: Maybe<Scalars['String']['output']>;
  notFoundText?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  searchPrefix?: Maybe<Scalars['String']['output']>;
  separator?: Maybe<Scalars['String']['output']>;
  showBlogPage?: Maybe<Scalars['Boolean']['output']>;
};

/** Types of cards */
export enum SeoCardType {
  Summary = 'summary',
  SummaryLargeImage = 'summary_large_image'
}

/** The Yoast SEO site level configuration data */
export type SeoConfig = {
  __typename?: 'SEOConfig';
  breadcrumbs?: Maybe<SeoBreadcrumbs>;
  contentTypes?: Maybe<SeoContentTypes>;
  meta?: Maybe<SeoGlobalMeta>;
  openGraph?: Maybe<SeoOpenGraph>;
  redirects?: Maybe<Array<Maybe<SeoRedirect>>>;
  schema?: Maybe<SeoSchema>;
  social?: Maybe<SeoSocial>;
  taxonomyArchives?: Maybe<SeoTaxonomyTypes>;
  webmaster?: Maybe<SeoWebmaster>;
};

/** The Yoast SEO search appearance content types fields */
export type SeoContentType = {
  __typename?: 'SEOContentType';
  archive?: Maybe<SeoContentTypeArchive>;
  metaDesc?: Maybe<Scalars['String']['output']>;
  metaRobotsNoindex?: Maybe<Scalars['Boolean']['output']>;
  schema?: Maybe<SeoPageInfoSchema>;
  schemaType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** The Yoast SEO search appearance content types fields */
export type SeoContentTypeArchive = {
  __typename?: 'SEOContentTypeArchive';
  archiveLink?: Maybe<Scalars['String']['output']>;
  breadcrumbTitle?: Maybe<Scalars['String']['output']>;
  fullHead?: Maybe<Scalars['String']['output']>;
  hasArchive?: Maybe<Scalars['Boolean']['output']>;
  metaDesc?: Maybe<Scalars['String']['output']>;
  metaRobotsFollow?: Maybe<Scalars['String']['output']>;
  metaRobotsIndex?: Maybe<Scalars['String']['output']>;
  metaRobotsNofollow?: Maybe<Scalars['Boolean']['output']>;
  metaRobotsNoindex?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** The Yoast SEO search appearance content types */
export type SeoContentTypes = {
  __typename?: 'SEOContentTypes';
  mediaItem?: Maybe<SeoContentType>;
  page?: Maybe<SeoContentType>;
  post?: Maybe<SeoContentType>;
};

/** The Yoast SEO meta data */
export type SeoGlobalMeta = {
  __typename?: 'SEOGlobalMeta';
  author?: Maybe<SeoGlobalMetaAuthor>;
  config?: Maybe<SeoGlobalMetaConfig>;
  date?: Maybe<SeoGlobalMetaDate>;
  homepage?: Maybe<SeoGlobalMetaHome>;
  notFound?: Maybe<SeoGlobalMeta404>;
};

/** The Yoast SEO meta 404 data */
export type SeoGlobalMeta404 = {
  __typename?: 'SEOGlobalMeta404';
  breadcrumb?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** The Yoast SEO Author data */
export type SeoGlobalMetaAuthor = {
  __typename?: 'SEOGlobalMetaAuthor';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** The Yoast SEO meta config data */
export type SeoGlobalMetaConfig = {
  __typename?: 'SEOGlobalMetaConfig';
  separator?: Maybe<Scalars['String']['output']>;
};

/** The Yoast SEO Date data */
export type SeoGlobalMetaDate = {
  __typename?: 'SEOGlobalMetaDate';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** The Yoast SEO homepage data */
export type SeoGlobalMetaHome = {
  __typename?: 'SEOGlobalMetaHome';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** The Open Graph data */
export type SeoOpenGraph = {
  __typename?: 'SEOOpenGraph';
  defaultImage?: Maybe<MediaItem>;
  frontPage?: Maybe<SeoOpenGraphFrontPage>;
};

/** The Open Graph Front page data */
export type SeoOpenGraphFrontPage = {
  __typename?: 'SEOOpenGraphFrontPage';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<MediaItem>;
  title?: Maybe<Scalars['String']['output']>;
};

/** The Schema for post type */
export type SeoPageInfoSchema = {
  __typename?: 'SEOPageInfoSchema';
  raw?: Maybe<Scalars['String']['output']>;
};

export type SeoPostTypeBreadcrumbs = {
  __typename?: 'SEOPostTypeBreadcrumbs';
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** The page info SEO details */
export type SeoPostTypePageInfo = {
  __typename?: 'SEOPostTypePageInfo';
  schema?: Maybe<SeoPageInfoSchema>;
};

/** The Schema types */
export type SeoPostTypeSchema = {
  __typename?: 'SEOPostTypeSchema';
  articleType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pageType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  raw?: Maybe<Scalars['String']['output']>;
};

/** The Yoast redirect data  (Yoast Premium only) */
export type SeoRedirect = {
  __typename?: 'SEORedirect';
  format?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

/** The Yoast SEO schema data */
export type SeoSchema = {
  __typename?: 'SEOSchema';
  companyLogo?: Maybe<MediaItem>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyOrPerson?: Maybe<Scalars['String']['output']>;
  homeUrl?: Maybe<Scalars['String']['output']>;
  inLanguage?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<MediaItem>;
  personLogo?: Maybe<MediaItem>;
  personName?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  siteUrl?: Maybe<Scalars['String']['output']>;
  wordpressSiteName?: Maybe<Scalars['String']['output']>;
};

/** The Yoast SEO Social media links */
export type SeoSocial = {
  __typename?: 'SEOSocial';
  facebook?: Maybe<SeoSocialFacebook>;
  instagram?: Maybe<SeoSocialInstagram>;
  linkedIn?: Maybe<SeoSocialLinkedIn>;
  mySpace?: Maybe<SeoSocialMySpace>;
  otherSocials?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pinterest?: Maybe<SeoSocialPinterest>;
  twitter?: Maybe<SeoSocialTwitter>;
  wikipedia?: Maybe<SeoSocialWikipedia>;
  youTube?: Maybe<SeoSocialYoutube>;
};

export type SeoSocialFacebook = {
  __typename?: 'SEOSocialFacebook';
  defaultImage?: Maybe<MediaItem>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SeoSocialInstagram = {
  __typename?: 'SEOSocialInstagram';
  url?: Maybe<Scalars['String']['output']>;
};

export type SeoSocialLinkedIn = {
  __typename?: 'SEOSocialLinkedIn';
  url?: Maybe<Scalars['String']['output']>;
};

export type SeoSocialMySpace = {
  __typename?: 'SEOSocialMySpace';
  url?: Maybe<Scalars['String']['output']>;
};

export type SeoSocialPinterest = {
  __typename?: 'SEOSocialPinterest';
  metaTag?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SeoSocialTwitter = {
  __typename?: 'SEOSocialTwitter';
  cardType?: Maybe<SeoCardType>;
  username?: Maybe<Scalars['String']['output']>;
};

export type SeoSocialWikipedia = {
  __typename?: 'SEOSocialWikipedia';
  url?: Maybe<Scalars['String']['output']>;
};

export type SeoSocialYoutube = {
  __typename?: 'SEOSocialYoutube';
  url?: Maybe<Scalars['String']['output']>;
};

/** The Schema types for Taxonomy */
export type SeoTaxonomySchema = {
  __typename?: 'SEOTaxonomySchema';
  raw?: Maybe<Scalars['String']['output']>;
};

/** The Yoast SEO search appearance Taxonomy types fields */
export type SeoTaxonomyType = {
  __typename?: 'SEOTaxonomyType';
  archive?: Maybe<SeoTaxonomyTypeArchive>;
};

/** The Yoast SEO search appearance Taxonomy types fields */
export type SeoTaxonomyTypeArchive = {
  __typename?: 'SEOTaxonomyTypeArchive';
  metaDesc?: Maybe<Scalars['String']['output']>;
  metaRobotsNoindex?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** The Yoast SEO archive configuration data for taxonomies */
export type SeoTaxonomyTypes = {
  __typename?: 'SEOTaxonomyTypes';
  category?: Maybe<SeoTaxonomyType>;
  postFormat?: Maybe<SeoTaxonomyType>;
  tag?: Maybe<SeoTaxonomyType>;
};

export type SeoUser = {
  __typename?: 'SEOUser';
  breadcrumbTitle?: Maybe<Scalars['String']['output']>;
  canonical?: Maybe<Scalars['String']['output']>;
  fullHead?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  metaDesc?: Maybe<Scalars['String']['output']>;
  metaRobotsNofollow?: Maybe<Scalars['String']['output']>;
  metaRobotsNoindex?: Maybe<Scalars['String']['output']>;
  opengraphDescription?: Maybe<Scalars['String']['output']>;
  opengraphImage?: Maybe<MediaItem>;
  opengraphTitle?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<SeoUserSchema>;
  social?: Maybe<SeoUserSocial>;
  title?: Maybe<Scalars['String']['output']>;
  twitterDescription?: Maybe<Scalars['String']['output']>;
  twitterImage?: Maybe<MediaItem>;
  twitterTitle?: Maybe<Scalars['String']['output']>;
};

/** The Schema types for User */
export type SeoUserSchema = {
  __typename?: 'SEOUserSchema';
  articleType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pageType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  raw?: Maybe<Scalars['String']['output']>;
};

export type SeoUserSocial = {
  __typename?: 'SEOUserSocial';
  facebook?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  mySpace?: Maybe<Scalars['String']['output']>;
  pinterest?: Maybe<Scalars['String']['output']>;
  soundCloud?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  wikipedia?: Maybe<Scalars['String']['output']>;
  youTube?: Maybe<Scalars['String']['output']>;
};

/** The Yoast SEO  webmaster fields */
export type SeoWebmaster = {
  __typename?: 'SEOWebmaster';
  baiduVerify?: Maybe<Scalars['String']['output']>;
  googleVerify?: Maybe<Scalars['String']['output']>;
  msVerify?: Maybe<Scalars['String']['output']>;
  yandexVerify?: Maybe<Scalars['String']['output']>;
};

export type SalesforceIntegration = AcfOptionsPage & Node & WithAcfTriumphIntegration & {
  __typename?: 'SalesforceIntegration';
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  menuTitle?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  /** Fields of the TriumphIntegration ACF Field Group */
  triumphIntegration?: Maybe<TriumphIntegration>;
};

/** Script insertion positions in the document structure. Determines whether scripts are placed in the document head or before the closing body tag. */
export enum ScriptLoadingGroupLocationEnum {
  /** Delayed loading at end of document, right before the closing `<body>` tag. (allows content to render first) */
  Footer = 'FOOTER',
  /** Early loading in document `<head>` tag. (executes before page content renders) */
  Header = 'HEADER'
}

/** Script loading optimization attributes. Controls browser behavior for script loading to improve page performance (async or defer). */
export enum ScriptLoadingStrategyEnum {
  /** Load script in parallel with page rendering, executing as soon as downloaded */
  Async = 'ASYNC',
  /** Download script in parallel but defer execution until page is fully parsed */
  Defer = 'DEFER'
}

/** A Gravity Forms section field. */
export type SectionField = FormField & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithLabelSetting & Node & {
  __typename?: 'SectionField';
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** The &quot;SectionId&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type SectionId = AcfFieldGroup & AcfFieldGroupFields & SectionId_Fields & {
  __typename?: 'SectionId';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** This is the id that will be passed to the section element. It should be unique. */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;SectionId&quot; Field Group */
export type SectionId_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** This is the id that will be passed to the section element. It should be unique. */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms select field. */
export type SelectField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithEnhancedUiSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & {
  __typename?: 'SelectField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<SelectFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** When set to true, the &quot;Chosen&quot; jQuery script will be applied to this field, enabling search capabilities to Drop Down fields and a more user-friendly interface for Multi Select fields. */
  hasEnhancedUI?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** SelectFieldChoice choice values. */
export type SelectFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & {
  __typename?: 'SelectFieldChoice';
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Input for the sendPasswordResetEmail mutation. */
export type SendPasswordResetEmailInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains the user's username or email address. */
  username: Scalars['String']['input'];
};

/** The payload for the sendPasswordResetEmail mutation. */
export type SendPasswordResetEmailPayload = {
  __typename?: 'SendPasswordResetEmailPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the mutation completed successfully. This does NOT necessarily mean that an email was sent. */
  success?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The user that the password reset email was sent to
   * @deprecated This field will be removed in a future version of WPGraphQL
   */
  user?: Maybe<User>;
};

/** All of the registered settings */
export type Settings = {
  __typename?: 'Settings';
  /** Settings of the the string Settings Group */
  discussionSettingsDefaultCommentStatus?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  discussionSettingsDefaultPingStatus?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  generalSettingsDateFormat?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  generalSettingsDescription?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  generalSettingsEmail?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  generalSettingsLanguage?: Maybe<Scalars['String']['output']>;
  /** Settings of the the integer Settings Group */
  generalSettingsStartOfWeek?: Maybe<Scalars['Int']['output']>;
  /** Settings of the the string Settings Group */
  generalSettingsTimeFormat?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  generalSettingsTimezone?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  generalSettingsTitle?: Maybe<Scalars['String']['output']>;
  /** Settings of the the string Settings Group */
  generalSettingsUrl?: Maybe<Scalars['String']['output']>;
  /** Settings of the the integer Settings Group */
  readingSettingsPageForPosts?: Maybe<Scalars['Int']['output']>;
  /** Settings of the the integer Settings Group */
  readingSettingsPageOnFront?: Maybe<Scalars['Int']['output']>;
  /** Settings of the the integer Settings Group */
  readingSettingsPostsPerPage?: Maybe<Scalars['Int']['output']>;
  /** Settings of the the string Settings Group */
  readingSettingsShowOnFront?: Maybe<Scalars['String']['output']>;
  /** Settings of the the integer Settings Group */
  writingSettingsDefaultCategory?: Maybe<Scalars['Int']['output']>;
  /** Settings of the the string Settings Group */
  writingSettingsDefaultPostFormat?: Maybe<Scalars['String']['output']>;
  /** Settings of the the boolean Settings Group */
  writingSettingsUseSmilies?: Maybe<Scalars['Boolean']['output']>;
};

/** A Gravity Forms shipping field. */
export type ShippingField = {
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms radio shipping field. */
export type ShippingRadioField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithOtherChoiceSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & Node & ShippingField & {
  __typename?: 'ShippingRadioField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<ShippingRadioFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the &#039;Enable &quot;other&quot; choice&#039; option is checked in the editor. */
  hasOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** ShippingRadioFieldChoice choice values. */
export type ShippingRadioFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & GfFieldChoiceWithOtherChoiceSetting & {
  __typename?: 'ShippingRadioFieldChoice';
  /** The price associated with the choice. */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** Indicates the radio button item is the “Other” choice. */
  isOtherChoice?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The price associated with the choice. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms select shipping field. */
export type ShippingSelectField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithChoices & GfFieldWithChoicesSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithEnhancedUiSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & ShippingField & {
  __typename?: 'ShippingSelectField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** The choices for the field. */
  choices?: Maybe<Array<Maybe<ShippingSelectFieldChoice>>>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field (checkbox, select or radio) have choice values enabled, which allows the field to have choice values different from the labels that are displayed to the user. */
  hasChoiceValue?: Maybe<Scalars['Boolean']['output']>;
  /** When set to true, the &quot;Chosen&quot; jQuery script will be applied to this field, enabling search capabilities to Drop Down fields and a more user-friendly interface for Multi Select fields. */
  hasEnhancedUI?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<GfFieldInput>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** ShippingSelectFieldChoice choice values. */
export type ShippingSelectFieldChoice = GfFieldChoice & GfFieldChoiceWithChoicesSetting & {
  __typename?: 'ShippingSelectFieldChoice';
  /** The price associated with the choice. */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** Determines if this choice should be selected by default when displayed. The value true will select the choice, whereas false will display it unselected. */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The price associated with the choice. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The text to be displayed to the user when displaying this choice. */
  text?: Maybe<Scalars['String']['output']>;
  /** The value to be stored in the database when this choice is selected. Note: This property is only supported by the Drop Down and Post Category fields. Checkboxes and Radio fields will store the text property in the database regardless of the value property. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms singleshipping singleshipping field. */
export type ShippingSingleField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithBasePriceSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & Node & ShippingField & {
  __typename?: 'ShippingSingleField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The price of the product, prefixed by the currency. */
  formattedPrice?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The price of the product. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** The &quot;Solutions&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type Solutions = AcfFieldGroup & AcfFieldGroupFields & Solutions_Fields & {
  __typename?: 'Solutions';
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;Solutions&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;Solutions&quot; Field Group */
  solutions?: Maybe<Array<Maybe<SolutionsSolutions>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Solutions&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;SolutionsCards&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type SolutionsCards = AcfFieldGroup & AcfFieldGroupFields & SolutionsCards_Fields & {
  __typename?: 'SolutionsCards';
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;SolutionsCards&quot; Field Group */
  cards?: Maybe<Array<Maybe<SolutionsCardsCards>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;SolutionsCards&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;SolutionsCards&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;SolutionsCardsCards&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type SolutionsCardsCards = AcfFieldGroup & AcfFieldGroupFields & SolutionsCardsCards_Fields & {
  __typename?: 'SolutionsCardsCards';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;SolutionsCardsCards&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;SolutionsCardsCards&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
};

/** Interface representing fields of the ACF &quot;SolutionsCardsCards&quot; Field Group */
export type SolutionsCardsCards_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;SolutionsCardsCards&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;SolutionsCardsCards&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
};

/** Interface representing fields of the ACF &quot;SolutionsCards&quot; Field Group */
export type SolutionsCards_Fields = {
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;SolutionsCards&quot; Field Group */
  cards?: Maybe<Array<Maybe<SolutionsCardsCards>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;SolutionsCards&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;SolutionsCards&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;SolutionsSolutions&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type SolutionsSolutions = AcfFieldGroup & AcfFieldGroupFields & SolutionsSolutions_Fields & {
  __typename?: 'SolutionsSolutions';
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;SolutionsSolutions&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;SolutionsSolutions&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;SolutionsSolutions&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;SolutionsSolutions&quot; Field Group */
export type SolutionsSolutions_Fields = {
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;SolutionsSolutions&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;SolutionsSolutions&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;SolutionsSolutions&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;Solutions&quot; Field Group */
export type Solutions_Fields = {
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;Solutions&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;Solutions&quot; Field Group */
  solutions?: Maybe<Array<Maybe<SolutionsSolutions>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Solutions&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The Confirmation object returned on submission. Null if the submission was not successful. */
export type SubmissionConfirmation = {
  __typename?: 'SubmissionConfirmation';
  /** Contains the confirmation message HTML to display. Only applicable when type is set to `MESSAGE`. */
  message?: Maybe<Scalars['String']['output']>;
  /** The page that the browser will be redirected to. Only applicable when type is set to `PAGE`. */
  page?: Maybe<SubmissionConfirmationToPageConnectionEdge>;
  /** Contains the Id of the WordPress page that the browser will be redirected to. Only applicable when type is set to `PAGE`. */
  pageId?: Maybe<Scalars['Int']['output']>;
  /** Contains the query string to be appended to the redirection url. Only applicable when type is set to `REDIRECT` or `PAGE` . */
  queryString?: Maybe<Scalars['String']['output']>;
  /** Determines the type of confirmation to be used. */
  type?: Maybe<SubmissionConfirmationTypeEnum>;
  /** The URL the submission should redirect to. Only applicable when type is set to `REDIRECT`. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Connection between the SubmissionConfirmation type and the Page type */
export type SubmissionConfirmationToPageConnectionEdge = Edge & OneToOneConnection & PageConnectionEdge & {
  __typename?: 'SubmissionConfirmationToPageConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: Page;
};

/** Type of confirmation returned by the submission. */
export enum SubmissionConfirmationTypeEnum {
  /** A confirmation "message". */
  Message = 'MESSAGE',
  /** A "redirect" to a given URL. */
  Redirect = 'REDIRECT'
}

/** Entry meta input fields for submitting Gravity Forms forms. */
export type SubmitFormMetaInput = {
  /** ID of the user that submitted of the form if a logged in user submitted the form. */
  createdById?: InputMaybe<Scalars['Int']['input']>;
  /** The UTC date the entry was created, in `Y-m-d H:i:s` format. */
  dateCreatedGmt?: InputMaybe<Scalars['String']['input']>;
  /** Client IP of user who submitted the form. */
  ip?: InputMaybe<Scalars['String']['input']>;
  /** Used to overwrite the sourceUrl the form was submitted from. */
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** The name and version of both the browser and operating system from which the entry was submitted. */
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

/** Input for the submitGfDraftEntry mutation. */
export type SubmitGfDraftEntryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Either the global ID of the draft entry, or its resume token. */
  id: Scalars['ID']['input'];
  /** The ID type for the draft entry. Defaults to `ID` . */
  idType?: InputMaybe<DraftEntryIdTypeEnum>;
};

/** The payload for the submitGfDraftEntry mutation. */
export type SubmitGfDraftEntryPayload = {
  __typename?: 'SubmitGfDraftEntryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The form confirmation data. Null if the submission has `errors` */
  confirmation?: Maybe<SubmissionConfirmation>;
  /** The entry that was created. */
  entry?: Maybe<GfSubmittedEntry>;
  /** Field errors. */
  errors?: Maybe<Array<Maybe<FieldError>>>;
};

/** Input for the SubmitGfForm mutation. */
export type SubmitGfFormInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The entry meta associated with the submission. */
  entryMeta?: InputMaybe<SubmitFormMetaInput>;
  /** The field ids and their values. */
  fieldValues: Array<InputMaybe<FormFieldValuesInput>>;
  /** The form ID. Accepts either a global or Database ID. */
  id: Scalars['ID']['input'];
  /** Set to `true` if submitting a draft entry. Defaults to `false`. */
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Useful for multi-page forms to indicate which page of the form was just submitted. */
  sourcePage?: InputMaybe<Scalars['Int']['input']>;
  /** Useful for multi-page forms to indicate which page is to be loaded if the current page passes validation. */
  targetPage?: InputMaybe<Scalars['Int']['input']>;
};

/** The payload for the SubmitGfForm mutation. */
export type SubmitGfFormPayload = {
  __typename?: 'SubmitGfFormPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The form confirmation data. Null if the submission has `errors` */
  confirmation?: Maybe<SubmissionConfirmation>;
  /** The entry that was created. */
  entry?: Maybe<GfEntry>;
  /** Field errors. */
  errors?: Maybe<Array<Maybe<FieldError>>>;
  /** Draft resume URL. Null if submitting an entry. If the &quot;Referer&quot; header is not included in the request, this will be an empty string. */
  resumeUrl?: Maybe<Scalars['String']['output']>;
  /** Connection between the SubmitGfFormPayload type and the FormField type */
  targetPageFormFields?: Maybe<SubmitGfFormPayloadToFormFieldConnection>;
  /** The page number of the form that should be displayed after submission. This will be different than the `targetPage` provided to the mutation if a field on a previous field failed validation. */
  targetPageNumber?: Maybe<Scalars['Int']['output']>;
};


/** The payload for the SubmitGfForm mutation. */
export type SubmitGfFormPayloadTargetPageFormFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Connection between the SubmitGfFormPayload type and the FormField type */
export type SubmitGfFormPayloadToFormFieldConnection = Connection & FormFieldConnection & {
  __typename?: 'SubmitGfFormPayloadToFormFieldConnection';
  /** Edges for the SubmitGfFormPayloadToFormFieldConnection connection */
  edges: Array<SubmitGfFormPayloadToFormFieldConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<FormField>;
  /** Information about pagination in a connection. */
  pageInfo: SubmitGfFormPayloadToFormFieldConnectionPageInfo;
};

/** An edge in a connection */
export type SubmitGfFormPayloadToFormFieldConnectionEdge = Edge & FormFieldConnectionEdge & {
  __typename?: 'SubmitGfFormPayloadToFormFieldConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: FormField;
};

/** Pagination metadata specific to &quot;SubmitGfFormPayloadToFormFieldConnection&quot; collections. Provides cursors and flags for navigating through sets of SubmitGfFormPayloadToFormFieldConnection Nodes. */
export type SubmitGfFormPayloadToFormFieldConnectionPageInfo = FormFieldConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'SubmitGfFormPayloadToFormFieldConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** The Type of Identifier used to fetch a single resource. */
export enum SubmittedEntryIdTypeEnum {
  /** The database ID assigned by Gravity Forms. Used by submitted entries. */
  DatabaseId = 'DATABASE_ID',
  /** Unique global ID for the object. */
  Id = 'ID'
}

/** The &quot;SystemAlert&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type SystemAlert = AcfFieldGroup & AcfFieldGroupFields & SystemAlert_Fields & {
  __typename?: 'SystemAlert';
  /** Update this ID to guarantee every user sees the system alert. After a user dismisses an alert, they will not see it again unless this ID changes. */
  alertId?: Maybe<Scalars['String']['output']>;
  /** Set a UTC time. This is optional. If provided, the alert will show until this time. (ACF Fields of the &quot;date_time_picker&quot; type return a date string according to the RFC3339 spec: https://datatracker.ietf.org/doc/html/rfc3339.) */
  end?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;SystemAlert&quot; Field Group */
  message?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Set a UTC time. This is optional. If provided, the alert will not show until this time. (ACF Fields of the &quot;date_time_picker&quot; type return a date string according to the RFC3339 spec: https://datatracker.ietf.org/doc/html/rfc3339.) */
  start?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;SystemAlert&quot; Field Group */
export type SystemAlert_Fields = {
  /** Update this ID to guarantee every user sees the system alert. After a user dismisses an alert, they will not see it again unless this ID changes. */
  alertId?: Maybe<Scalars['String']['output']>;
  /** Set a UTC time. This is optional. If provided, the alert will show until this time. (ACF Fields of the &quot;date_time_picker&quot; type return a date string according to the RFC3339 spec: https://datatracker.ietf.org/doc/html/rfc3339.) */
  end?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;SystemAlert&quot; Field Group */
  message?: Maybe<Scalars['String']['output']>;
  /** Set a UTC time. This is optional. If provided, the alert will not show until this time. (ACF Fields of the &quot;date_time_picker&quot; type return a date string according to the RFC3339 spec: https://datatracker.ietf.org/doc/html/rfc3339.) */
  start?: Maybe<Scalars['String']['output']>;
};

/** A taxonomy term used to organize and classify content. Tags do not have a hierarchy and are generally used for more specific classifications. */
export type Tag = DatabaseIdentifier & MenuItemLinkable & Node & TermNode & UniformResourceIdentifiable & {
  __typename?: 'Tag';
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** Connection between the Tag type and the ContentNode type */
  contentNodes?: Maybe<TagToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int']['output'];
  /** The description of the object */
  description?: Maybe<Scalars['String']['output']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  /** The link to the term */
  link?: Maybe<Scalars['String']['output']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']['output']>;
  /** Connection between the Tag type and the post type */
  posts?: Maybe<TagToPostConnection>;
  /** The Yoast SEO data of the Tags taxonomy. */
  seo?: Maybe<TaxonomySeo>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * The id field matches the WP_Post-&gt;ID field.
   * @deprecated Deprecated in favor of databaseId
   */
  tagId?: Maybe<Scalars['Int']['output']>;
  /** Connection between the Tag type and the Taxonomy type */
  taxonomy?: Maybe<TagToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']['output']>;
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']['output']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']['output']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
};


/** A taxonomy term used to organize and classify content. Tags do not have a hierarchy and are generally used for more specific classifications. */
export type TagContentNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagToContentNodeConnectionWhereArgs>;
};


/** A taxonomy term used to organize and classify content. Tags do not have a hierarchy and are generally used for more specific classifications. */
export type TagEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A taxonomy term used to organize and classify content. Tags do not have a hierarchy and are generally used for more specific classifications. */
export type TagEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A taxonomy term used to organize and classify content. Tags do not have a hierarchy and are generally used for more specific classifications. */
export type TagPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagToPostConnectionWhereArgs>;
};

/** A paginated collection of tag Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of tag Nodes */
export type TagConnection = {
  /** A list of edges (relational context) between RootQuery and connected tag Nodes */
  edges: Array<TagConnectionEdge>;
  /** A list of connected tag Nodes */
  nodes: Array<Tag>;
  /** Information about pagination in a connection. */
  pageInfo: TagConnectionPageInfo;
};

/** Represents a connection to a tag. Contains both the tag Node and metadata about the relationship. */
export type TagConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected tag Node */
  node: Tag;
};

/** Pagination metadata specific to &quot;TagConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;TagConnectionEdge&quot; Nodes. */
export type TagConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Identifier types for retrieving a specific Tag. Determines which unique property (global ID, database ID, slug, etc.) is used to locate the Tag. */
export enum TagIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the Tag type and the ContentNode type */
export type TagToContentNodeConnection = Connection & ContentNodeConnection & {
  __typename?: 'TagToContentNodeConnection';
  /** Edges for the TagToContentNodeConnection connection */
  edges: Array<TagToContentNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: TagToContentNodeConnectionPageInfo;
};

/** An edge in a connection */
export type TagToContentNodeConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'TagToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Pagination metadata specific to &quot;TagToContentNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of TagToContentNodeConnection Nodes. */
export type TagToContentNodeConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'TagToContentNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the TagToContentNodeConnection connection */
export type TagToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfTagEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the Tag type and the post type */
export type TagToPostConnection = Connection & PostConnection & {
  __typename?: 'TagToPostConnection';
  /** Edges for the TagToPostConnection connection */
  edges: Array<TagToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: TagToPostConnectionPageInfo;
};

/** An edge in a connection */
export type TagToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'TagToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Pagination metadata specific to &quot;TagToPostConnection&quot; collections. Provides cursors and flags for navigating through sets of TagToPostConnection Nodes. */
export type TagToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'TagToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the TagToPostConnection connection */
export type TagToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the Tag type and the Taxonomy type */
export type TagToTaxonomyConnectionEdge = Edge & OneToOneConnection & TaxonomyConnectionEdge & {
  __typename?: 'TagToTaxonomyConnectionEdge';
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The node of the connection, without the edges */
  node: Taxonomy;
};

/** A taxonomy object */
export type Taxonomy = Node & {
  __typename?: 'Taxonomy';
  /** List of Content Types associated with the Taxonomy */
  connectedContentTypes?: Maybe<TaxonomyToContentTypeConnection>;
  /** List of Term Nodes associated with the Taxonomy */
  connectedTerms?: Maybe<TaxonomyToTermNodeConnection>;
  /** Description of the taxonomy. This field is equivalent to WP_Taxonomy-&gt;description */
  description?: Maybe<Scalars['String']['output']>;
  /** The plural name of the post type within the GraphQL Schema. */
  graphqlPluralName?: Maybe<Scalars['String']['output']>;
  /** The singular name of the post type within the GraphQL Schema. */
  graphqlSingleName?: Maybe<Scalars['String']['output']>;
  /** Whether the taxonomy is hierarchical */
  hierarchical?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique identifier of the taxonomy object. */
  id: Scalars['ID']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the taxonomy shown in the menu. Usually plural. */
  label?: Maybe<Scalars['String']['output']>;
  /** The display name of the taxonomy. This field is equivalent to WP_Taxonomy-&gt;label */
  name?: Maybe<Scalars['String']['output']>;
  /** Whether the taxonomy is publicly queryable */
  public?: Maybe<Scalars['Boolean']['output']>;
  /** Name of content type to display in REST API &quot;wp/v2&quot; namespace. */
  restBase?: Maybe<Scalars['String']['output']>;
  /** The REST Controller class assigned to handling this content type. */
  restControllerClass?: Maybe<Scalars['String']['output']>;
  /** Whether to show the taxonomy as part of a tag cloud widget. This field is equivalent to WP_Taxonomy-&gt;show_tagcloud */
  showCloud?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to display a column for the taxonomy on its post type listing screens. */
  showInAdminColumn?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to add the post type to the GraphQL Schema. */
  showInGraphql?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the taxonomy in the admin menu */
  showInMenu?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the taxonomy is available for selection in navigation menus. */
  showInNavMenus?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the taxonomy in the quick/bulk edit panel. */
  showInQuickEdit?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to add the post type route in the REST API &quot;wp/v2&quot; namespace. */
  showInRest?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to generate and allow a UI for managing terms in this taxonomy in the admin */
  showUi?: Maybe<Scalars['Boolean']['output']>;
};


/** A taxonomy object */
export type TaxonomyConnectedContentTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A taxonomy object */
export type TaxonomyConnectedTermsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated collection of Taxonomy Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of Taxonomy Nodes */
export type TaxonomyConnection = {
  /** A list of edges (relational context) between RootQuery and connected Taxonomy Nodes */
  edges: Array<TaxonomyConnectionEdge>;
  /** A list of connected Taxonomy Nodes */
  nodes: Array<Taxonomy>;
  /** Information about pagination in a connection. */
  pageInfo: TaxonomyConnectionPageInfo;
};

/** Represents a connection to a Taxonomy. Contains both the Taxonomy Node and metadata about the relationship. */
export type TaxonomyConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Taxonomy Node */
  node: Taxonomy;
};

/** Pagination metadata specific to &quot;TaxonomyConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;TaxonomyConnectionEdge&quot; Nodes. */
export type TaxonomyConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Available classification systems for organizing content. Identifies the different taxonomy types that can be used for content categorization. */
export enum TaxonomyEnum {
  /** Taxonomy enum category */
  Category = 'CATEGORY',
  /** Taxonomy enum post_format */
  Postformat = 'POSTFORMAT',
  /** Taxonomy enum post_tag */
  Tag = 'TAG'
}

/** Identifier types for retrieving a taxonomy definition. Determines whether to look up taxonomies by ID or name. */
export enum TaxonomyIdTypeEnum {
  /** The globally unique ID */
  Id = 'ID',
  /** The name of the taxonomy */
  Name = 'NAME'
}

export type TaxonomySeo = {
  __typename?: 'TaxonomySEO';
  breadcrumbs?: Maybe<Array<Maybe<SeoPostTypeBreadcrumbs>>>;
  canonical?: Maybe<Scalars['String']['output']>;
  cornerstone?: Maybe<Scalars['Boolean']['output']>;
  focuskw?: Maybe<Scalars['String']['output']>;
  fullHead?: Maybe<Scalars['String']['output']>;
  metaDesc?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Scalars['String']['output']>;
  metaRobotsNofollow?: Maybe<Scalars['String']['output']>;
  metaRobotsNoindex?: Maybe<Scalars['String']['output']>;
  opengraphAuthor?: Maybe<Scalars['String']['output']>;
  opengraphDescription?: Maybe<Scalars['String']['output']>;
  opengraphImage?: Maybe<MediaItem>;
  opengraphModifiedTime?: Maybe<Scalars['String']['output']>;
  opengraphPublishedTime?: Maybe<Scalars['String']['output']>;
  opengraphPublisher?: Maybe<Scalars['String']['output']>;
  opengraphSiteName?: Maybe<Scalars['String']['output']>;
  opengraphTitle?: Maybe<Scalars['String']['output']>;
  opengraphType?: Maybe<Scalars['String']['output']>;
  opengraphUrl?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<SeoTaxonomySchema>;
  title?: Maybe<Scalars['String']['output']>;
  twitterDescription?: Maybe<Scalars['String']['output']>;
  twitterImage?: Maybe<MediaItem>;
  twitterTitle?: Maybe<Scalars['String']['output']>;
};

/** Connection between the Taxonomy type and the ContentType type */
export type TaxonomyToContentTypeConnection = Connection & ContentTypeConnection & {
  __typename?: 'TaxonomyToContentTypeConnection';
  /** Edges for the TaxonomyToContentTypeConnection connection */
  edges: Array<TaxonomyToContentTypeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentType>;
  /** Information about pagination in a connection. */
  pageInfo: TaxonomyToContentTypeConnectionPageInfo;
};

/** An edge in a connection */
export type TaxonomyToContentTypeConnectionEdge = ContentTypeConnectionEdge & Edge & {
  __typename?: 'TaxonomyToContentTypeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: ContentType;
};

/** Pagination metadata specific to &quot;TaxonomyToContentTypeConnection&quot; collections. Provides cursors and flags for navigating through sets of TaxonomyToContentTypeConnection Nodes. */
export type TaxonomyToContentTypeConnectionPageInfo = ContentTypeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'TaxonomyToContentTypeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Connection between the Taxonomy type and the TermNode type */
export type TaxonomyToTermNodeConnection = Connection & TermNodeConnection & {
  __typename?: 'TaxonomyToTermNodeConnection';
  /** Edges for the TaxonomyToTermNodeConnection connection */
  edges: Array<TaxonomyToTermNodeConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<TermNode>;
  /** Information about pagination in a connection. */
  pageInfo: TaxonomyToTermNodeConnectionPageInfo;
};

/** An edge in a connection */
export type TaxonomyToTermNodeConnectionEdge = Edge & TermNodeConnectionEdge & {
  __typename?: 'TaxonomyToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: TermNode;
};

/** Pagination metadata specific to &quot;TaxonomyToTermNodeConnection&quot; collections. Provides cursors and flags for navigating through sets of TaxonomyToTermNodeConnection Nodes. */
export type TaxonomyToTermNodeConnectionPageInfo = PageInfo & TermNodeConnectionPageInfo & WpPageInfo & {
  __typename?: 'TaxonomyToTermNodeConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** The &quot;TeamMembers&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type TeamMembers = AcfFieldGroup & AcfFieldGroupFields & TeamMembers_Fields & {
  __typename?: 'TeamMembers';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;TeamMembers&quot; Field Group */
  members?: Maybe<Array<Maybe<TeamMembersMembers>>>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** The &quot;TeamMembersMembers&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type TeamMembersMembers = AcfFieldGroup & AcfFieldGroupFields & TeamMembersMembers_Fields & {
  __typename?: 'TeamMembersMembers';
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;TeamMembersMembers&quot; Field Group */
  bio?: Maybe<Scalars['String']['output']>;
  /** This is the id that will be passed to the Bio CTA Text element. It should be unique. */
  bioCtaText?: Maybe<Scalars['String']['output']>;
  /** This is the id that will be passed to the Bio CTA Text element. It should be unique. */
  ctaId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;TeamMembersMembers&quot; Field Group */
  headshot?: Maybe<AcfMediaItemConnectionEdge>;
  /** This job description will appear under the image when viewing the grid view of all team members */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** This job description will appear in the dialog that opens after the user clicks on the bio CTA */
  jobTitleInDialog?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TeamMembersMembers&quot; Field Group */
  name?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;TeamMembersMembers&quot; Field Group */
export type TeamMembersMembers_Fields = {
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;TeamMembersMembers&quot; Field Group */
  bio?: Maybe<Scalars['String']['output']>;
  /** This is the id that will be passed to the Bio CTA Text element. It should be unique. */
  bioCtaText?: Maybe<Scalars['String']['output']>;
  /** This is the id that will be passed to the Bio CTA Text element. It should be unique. */
  ctaId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;TeamMembersMembers&quot; Field Group */
  headshot?: Maybe<AcfMediaItemConnectionEdge>;
  /** This job description will appear under the image when viewing the grid view of all team members */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** This job description will appear in the dialog that opens after the user clicks on the bio CTA */
  jobTitleInDialog?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TeamMembersMembers&quot; Field Group */
  name?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;TeamMembers&quot; Field Group */
export type TeamMembers_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;TeamMembers&quot; Field Group */
  members?: Maybe<Array<Maybe<TeamMembersMembers>>>;
};

/** Base interface for taxonomy terms such as categories and tags. Terms are used to organize and classify content. */
export type TermNode = {
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']['output']>;
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** The description of the object */
  description?: Maybe<Scalars['String']['output']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  /** The link to the term */
  link?: Maybe<Scalars['String']['output']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']['output']>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']['output']>;
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']['output']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']['output']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
};


/** Base interface for taxonomy terms such as categories and tags. Terms are used to organize and classify content. */
export type TermNodeEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Base interface for taxonomy terms such as categories and tags. Terms are used to organize and classify content. */
export type TermNodeEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated collection of TermNode Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of TermNode Nodes */
export type TermNodeConnection = {
  /** A list of edges (relational context) between RootQuery and connected TermNode Nodes */
  edges: Array<TermNodeConnectionEdge>;
  /** A list of connected TermNode Nodes */
  nodes: Array<TermNode>;
  /** Information about pagination in a connection. */
  pageInfo: TermNodeConnectionPageInfo;
};

/** Represents a connection to a TermNode. Contains both the TermNode Node and metadata about the relationship. */
export type TermNodeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected TermNode Node */
  node: TermNode;
};

/** Pagination metadata specific to &quot;TermNodeConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;TermNodeConnectionEdge&quot; Nodes. */
export type TermNodeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** The Type of Identifier used to fetch a single resource. Default is "ID". To be used along with the "id" field. */
export enum TermNodeIdTypeEnum {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the TermNode type and the EnqueuedScript type */
export type TermNodeToEnqueuedScriptConnection = Connection & EnqueuedScriptConnection & {
  __typename?: 'TermNodeToEnqueuedScriptConnection';
  /** Edges for the TermNodeToEnqueuedScriptConnection connection */
  edges: Array<TermNodeToEnqueuedScriptConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedScript>;
  /** Information about pagination in a connection. */
  pageInfo: TermNodeToEnqueuedScriptConnectionPageInfo;
};

/** An edge in a connection */
export type TermNodeToEnqueuedScriptConnectionEdge = Edge & EnqueuedScriptConnectionEdge & {
  __typename?: 'TermNodeToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: EnqueuedScript;
};

/** Pagination metadata specific to &quot;TermNodeToEnqueuedScriptConnection&quot; collections. Provides cursors and flags for navigating through sets of TermNodeToEnqueuedScriptConnection Nodes. */
export type TermNodeToEnqueuedScriptConnectionPageInfo = EnqueuedScriptConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'TermNodeToEnqueuedScriptConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Connection between the TermNode type and the EnqueuedStylesheet type */
export type TermNodeToEnqueuedStylesheetConnection = Connection & EnqueuedStylesheetConnection & {
  __typename?: 'TermNodeToEnqueuedStylesheetConnection';
  /** Edges for the TermNodeToEnqueuedStylesheetConnection connection */
  edges: Array<TermNodeToEnqueuedStylesheetConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  pageInfo: TermNodeToEnqueuedStylesheetConnectionPageInfo;
};

/** An edge in a connection */
export type TermNodeToEnqueuedStylesheetConnectionEdge = Edge & EnqueuedStylesheetConnectionEdge & {
  __typename?: 'TermNodeToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: EnqueuedStylesheet;
};

/** Pagination metadata specific to &quot;TermNodeToEnqueuedStylesheetConnection&quot; collections. Provides cursors and flags for navigating through sets of TermNodeToEnqueuedStylesheetConnection Nodes. */
export type TermNodeToEnqueuedStylesheetConnectionPageInfo = EnqueuedStylesheetConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'TermNodeToEnqueuedStylesheetConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Sorting attributes for taxonomy term collections. Determines which property of taxonomy terms is used for ordering results. */
export enum TermObjectsConnectionOrderbyEnum {
  /** Ordering by number of associated content items. */
  Count = 'COUNT',
  /** Alphabetical ordering by term description text. */
  Description = 'DESCRIPTION',
  /** Alphabetical ordering by term name. */
  Name = 'NAME',
  /** Alphabetical ordering by URL-friendly name. */
  Slug = 'SLUG',
  /** Ordering by assigned term grouping value. */
  TermGroup = 'TERM_GROUP',
  /** Ordering by internal identifier. */
  TermId = 'TERM_ID',
  /** Ordering by manually defined sort position. */
  TermOrder = 'TERM_ORDER'
}

/** The &quot;Testimonials&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type Testimonials = AcfFieldGroup & AcfFieldGroupFields & Testimonials_Fields & {
  __typename?: 'Testimonials';
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;Testimonials&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;Testimonials&quot; Field Group */
  testimonials?: Maybe<Array<Maybe<TestimonialsTestimonials>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Testimonials&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;TestimonialsTestimonials&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type TestimonialsTestimonials = AcfFieldGroup & AcfFieldGroupFields & TestimonialsTestimonials_Fields & {
  __typename?: 'TestimonialsTestimonials';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TestimonialsTestimonials&quot; Field Group */
  author?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;TestimonialsTestimonials&quot; Field Group */
  authorImage?: Maybe<AcfMediaItemConnectionEdge>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TestimonialsTestimonials&quot; Field Group */
  quote?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;TestimonialsTestimonials&quot; Field Group */
export type TestimonialsTestimonials_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TestimonialsTestimonials&quot; Field Group */
  author?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;TestimonialsTestimonials&quot; Field Group */
  authorImage?: Maybe<AcfMediaItemConnectionEdge>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TestimonialsTestimonials&quot; Field Group */
  quote?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;Testimonials&quot; Field Group */
export type Testimonials_Fields = {
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;Testimonials&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;Testimonials&quot; Field Group */
  testimonials?: Maybe<Array<Maybe<TestimonialsTestimonials>>>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Testimonials&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms textarea field. */
export type TextAreaField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithMaxLengthSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRichTextEditorSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & {
  __typename?: 'TextAreaField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the field uses the rich text editor interface. */
  hasRichTextEditor?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** Specifies the maximum number of characters allowed in a text or textarea (paragraph) field. */
  maxLength?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** A Gravity Forms text field. */
export type TextField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputMaskSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithMaxLengthSetting & GfFieldWithPasswordFieldSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & {
  __typename?: 'TextField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has an input mask. */
  hasInputMask?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** The pattern used for the input mask. */
  inputMaskValue?: Maybe<Scalars['String']['output']>;
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if a text field input tag should be created with a &quot;password&quot; type. */
  isPasswordInput?: Maybe<Scalars['Boolean']['output']>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** Specifies the maximum number of characters allowed in a text or textarea (paragraph) field. */
  maxLength?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The pattern for the text field */
  pattern?: Maybe<Scalars['String']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** The &quot;TextHeader&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type TextHeader = AcfFieldGroup & AcfFieldGroupFields & TextHeader_Fields & {
  __typename?: 'TextHeader';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TextHeader&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TextHeader&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;TextHeader&quot; Field Group */
  withGradientText?: Maybe<Scalars['Boolean']['output']>;
};

/** Interface representing fields of the ACF &quot;TextHeader&quot; Field Group */
export type TextHeader_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TextHeader&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TextHeader&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;TextHeader&quot; Field Group */
  withGradientText?: Maybe<Scalars['Boolean']['output']>;
};

/** A theme object */
export type Theme = Node & {
  __typename?: 'Theme';
  /** Name of the theme author(s), could also be a company name. This field is equivalent to WP_Theme-&gt;get( &quot;Author&quot; ). */
  author?: Maybe<Scalars['String']['output']>;
  /** URI for the author/company website. This field is equivalent to WP_Theme-&gt;get( &quot;AuthorURI&quot; ). */
  authorUri?: Maybe<Scalars['String']['output']>;
  /** The description of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Description&quot; ). */
  description?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier of the theme object. */
  id: Scalars['ID']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Display name of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Name&quot; ). */
  name?: Maybe<Scalars['String']['output']>;
  /** The URL of the screenshot for the theme. The screenshot is intended to give an overview of what the theme looks like. This field is equivalent to WP_Theme-&gt;get_screenshot(). */
  screenshot?: Maybe<Scalars['String']['output']>;
  /** The theme slug is used to internally match themes. Theme slugs can have subdirectories like: my-theme/sub-theme. This field is equivalent to WP_Theme-&gt;get_stylesheet(). */
  slug?: Maybe<Scalars['String']['output']>;
  /** URI for the author/company website. This field is equivalent to WP_Theme-&gt;get( &quot;Tags&quot; ). */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A URI if the theme has a website associated with it. The Theme URI is handy for directing users to a theme site for support etc. This field is equivalent to WP_Theme-&gt;get( &quot;ThemeURI&quot; ). */
  themeUri?: Maybe<Scalars['String']['output']>;
  /** The current version of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Version&quot; ). */
  version?: Maybe<Scalars['String']['output']>;
};

/** A paginated collection of Theme Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of Theme Nodes */
export type ThemeConnection = {
  /** A list of edges (relational context) between RootQuery and connected Theme Nodes */
  edges: Array<ThemeConnectionEdge>;
  /** A list of connected Theme Nodes */
  nodes: Array<Theme>;
  /** Information about pagination in a connection. */
  pageInfo: ThemeConnectionPageInfo;
};

/** Represents a connection to a Theme. Contains both the Theme Node and metadata about the relationship. */
export type ThemeConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected Theme Node */
  node: Theme;
};

/** Pagination metadata specific to &quot;ThemeConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;ThemeConnectionEdge&quot; Nodes. */
export type ThemeConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** The &quot;Thrive&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type Thrive = AcfFieldGroup & AcfFieldGroupFields & Thrive_Fields & {
  __typename?: 'Thrive';
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;Thrive&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Thrive&quot; Field Group */
  descriptionFooter?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;Thrive&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Thrive&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;Thrive&quot; Field Group */
export type Thrive_Fields = {
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;Thrive&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Thrive&quot; Field Group */
  descriptionFooter?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;Thrive&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;Thrive&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms time field. */
export type TimeField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithInputs & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSubLabelPlacementSetting & GfFieldWithTimeFormatSetting & Node & {
  __typename?: 'TimeField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** The inputs for the field. */
  inputs?: Maybe<Array<Maybe<TimeInputProperty>>>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** The placement of the labels for the subfields within the group. This setting controls all of the subfields, they cannot be set individually. They may be aligned above or below the inputs. If this property is not set, the “Sub-Label Placement” setting on the Form Settings-&gt;Form Layout page is used. If no setting is specified, the default is above inputs. */
  subLabelPlacement?: Maybe<FormFieldSubLabelPlacementEnum>;
  /** Determines how the time is displayed. */
  timeFormat?: Maybe<TimeFieldFormatEnum>;
  /** Time field value. */
  timeValues?: Maybe<TimeFieldValue>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** How the time is displayed. */
export enum TimeFieldFormatEnum {
  /** 12-hour time format. */
  H12 = 'H12',
  /** 24-hour time format. */
  H24 = 'H24'
}

/** The individual properties for each element of the Time value field. */
export type TimeFieldValue = {
  __typename?: 'TimeFieldValue';
  /** AM or PM. */
  amPm?: Maybe<AmPmEnum>;
  /** The full display value in 12-hour format. Example: &quot;08:25 am&quot;. */
  displayValue?: Maybe<Scalars['String']['output']>;
  /** The hours, in this format: hh. */
  hours?: Maybe<Scalars['String']['output']>;
  /** The minutes, in this format: mm. */
  minutes?: Maybe<Scalars['String']['output']>;
};

/** TimeInputProperty input values. */
export type TimeInputProperty = GfFieldInput & GfFieldInputWithTimeFormatSetting & {
  __typename?: 'TimeInputProperty';
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** The custom label for the input. When set, this is used in place of the label. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The input ID. Input IDs follow the following naming convention: FIELDID.INPUTID (i.e. 5.1), where FIELDID is the id of the containing field and INPUTID specifies the input field. */
  id?: Maybe<Scalars['Float']['output']>;
  /** The label to be used for the input. */
  label?: Maybe<Scalars['String']['output']>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
};

/** A Gravity Forms total field. */
export type TotalField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDescriptionSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & Node & {
  __typename?: 'TotalField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** The &quot;TriumphIntegration&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type TriumphIntegration = AcfFieldGroup & AcfFieldGroupFields & TriumphIntegration_Fields & {
  __typename?: 'TriumphIntegration';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TriumphIntegration&quot; Field Group */
  salesforceAuthUrl?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TriumphIntegration&quot; Field Group */
  salesforceClientId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TriumphIntegration&quot; Field Group */
  salesforceClientSecret?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TriumphIntegration&quot; Field Group */
  salesforcePostUrl?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;TriumphIntegration&quot; Field Group */
export type TriumphIntegration_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TriumphIntegration&quot; Field Group */
  salesforceAuthUrl?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TriumphIntegration&quot; Field Group */
  salesforceClientId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TriumphIntegration&quot; Field Group */
  salesforceClientSecret?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TriumphIntegration&quot; Field Group */
  salesforcePostUrl?: Maybe<Scalars['String']['output']>;
};

/** The &quot;TwoColumnCta&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type TwoColumnCta = AcfFieldGroup & AcfFieldGroupFields & TwoColumnCta_Fields & {
  __typename?: 'TwoColumnCta';
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;TwoColumnCta&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;TwoColumnCta&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TwoColumnCta&quot; Field Group */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TwoColumnCta&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;TwoColumnCta&quot; Field Group */
export type TwoColumnCta_Fields = {
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;TwoColumnCta&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;TwoColumnCta&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TwoColumnCta&quot; Field Group */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TwoColumnCta&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;TwoColumnPromo&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type TwoColumnPromo = AcfFieldGroup & AcfFieldGroupFields & TwoColumnPromo_Fields & {
  __typename?: 'TwoColumnPromo';
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;TwoColumnPromo&quot; Field Group */
  columnWidths?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;TwoColumnPromo&quot; Field Group */
  content?: Maybe<Array<Maybe<TwoColumnPromoContent>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;TwoColumnPromo&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TwoColumnPromo&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** The &quot;TwoColumnPromoContent&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type TwoColumnPromoContent = AcfFieldGroup & AcfFieldGroupFields & TwoColumnPromoContent_Fields & {
  __typename?: 'TwoColumnPromoContent';
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContent&quot; Field Group */
  button?: Maybe<TwoColumnPromoContentButton>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContent&quot; Field Group */
  list?: Maybe<TwoColumnPromoContentList>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContent&quot; Field Group */
  paragraph?: Maybe<TwoColumnPromoContentParagraph>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContent&quot; Field Group */
  type?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContent&quot; Field Group */
  wysiwyg?: Maybe<TwoColumnPromoContentWysiwyg>;
};

/** The &quot;TwoColumnPromoContentButton&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type TwoColumnPromoContentButton = AcfFieldGroup & AcfFieldGroupFields & TwoColumnPromoContentButton_Fields & {
  __typename?: 'TwoColumnPromoContentButton';
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentButton&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentButton&quot; Field Group */
  buttonColor?: Maybe<Scalars['String']['output']>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;TwoColumnPromoContentButton&quot; Field Group */
export type TwoColumnPromoContentButton_Fields = {
  /** Field of the &quot;link&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentButton&quot; Field Group */
  button?: Maybe<AcfLink>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentButton&quot; Field Group */
  buttonColor?: Maybe<Scalars['String']['output']>;
  /** This is the id that will be passed to the button element. It should be unique. */
  buttonId?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
};

/** The &quot;TwoColumnPromoContentList&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type TwoColumnPromoContentList = AcfFieldGroup & AcfFieldGroupFields & TwoColumnPromoContentList_Fields & {
  __typename?: 'TwoColumnPromoContentList';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentList&quot; Field Group */
  heading?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentList&quot; Field Group */
  items?: Maybe<Array<Maybe<TwoColumnPromoContentListItems>>>;
};

/** The &quot;TwoColumnPromoContentListItems&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type TwoColumnPromoContentListItems = AcfFieldGroup & AcfFieldGroupFields & TwoColumnPromoContentListItems_Fields & {
  __typename?: 'TwoColumnPromoContentListItems';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentListItems&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;TwoColumnPromoContentListItems&quot; Field Group */
export type TwoColumnPromoContentListItems_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentListItems&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;TwoColumnPromoContentList&quot; Field Group */
export type TwoColumnPromoContentList_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentList&quot; Field Group */
  heading?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentList&quot; Field Group */
  items?: Maybe<Array<Maybe<TwoColumnPromoContentListItems>>>;
};

/** The &quot;TwoColumnPromoContentParagraph&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type TwoColumnPromoContentParagraph = AcfFieldGroup & AcfFieldGroupFields & TwoColumnPromoContentParagraph_Fields & {
  __typename?: 'TwoColumnPromoContentParagraph';
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentParagraph&quot; Field Group */
  bold?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentParagraph&quot; Field Group */
  largeFontSize?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentParagraph&quot; Field Group */
  removeTopMargin?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentParagraph&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;TwoColumnPromoContentParagraph&quot; Field Group */
export type TwoColumnPromoContentParagraph_Fields = {
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentParagraph&quot; Field Group */
  bold?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentParagraph&quot; Field Group */
  largeFontSize?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentParagraph&quot; Field Group */
  removeTopMargin?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentParagraph&quot; Field Group */
  text?: Maybe<Scalars['String']['output']>;
};

/** The &quot;TwoColumnPromoContentWysiwyg&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type TwoColumnPromoContentWysiwyg = AcfFieldGroup & AcfFieldGroupFields & TwoColumnPromoContentWysiwyg_Fields & {
  __typename?: 'TwoColumnPromoContentWysiwyg';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentWysiwyg&quot; Field Group */
  wysiwyg?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;TwoColumnPromoContentWysiwyg&quot; Field Group */
export type TwoColumnPromoContentWysiwyg_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;wysiwyg&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContentWysiwyg&quot; Field Group */
  wysiwyg?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;TwoColumnPromoContent&quot; Field Group */
export type TwoColumnPromoContent_Fields = {
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContent&quot; Field Group */
  button?: Maybe<TwoColumnPromoContentButton>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContent&quot; Field Group */
  list?: Maybe<TwoColumnPromoContentList>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContent&quot; Field Group */
  paragraph?: Maybe<TwoColumnPromoContentParagraph>;
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContent&quot; Field Group */
  type?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;TwoColumnPromoContent&quot; Field Group */
  wysiwyg?: Maybe<TwoColumnPromoContentWysiwyg>;
};

/** Interface representing fields of the ACF &quot;TwoColumnPromo&quot; Field Group */
export type TwoColumnPromo_Fields = {
  /** Field of the &quot;radio&quot; Field Type added to the schema as part of the &quot;TwoColumnPromo&quot; Field Group */
  columnWidths?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;TwoColumnPromo&quot; Field Group */
  content?: Maybe<Array<Maybe<TwoColumnPromoContent>>>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;image&quot; Field Type added to the schema as part of the &quot;TwoColumnPromo&quot; Field Group */
  image?: Maybe<AcfMediaItemConnectionEdge>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;TwoColumnPromo&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

export type UtmConfiguration = AcfOptionsPage & Node & WithAcfUtmConfigurationBlock & {
  __typename?: 'UTMConfiguration';
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  menuTitle?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  /** Fields of the UtmConfigurationBlock ACF Field Group */
  utmConfigurationBlock?: Maybe<UtmConfigurationBlock>;
};

/** An interface for content that can be accessed via a unique URI/URL path. Implemented by content types that have their own permalinks. */
export type UniformResourceIdentifiable = {
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
};

/** Input for the updateCategory mutation. */
export type UpdateCategoryInput = {
  /** The slug that the category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the category object */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the category object to update */
  id: Scalars['ID']['input'];
  /** The name of the category object to mutate */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The database ID of the category that should be set as the parent. This field cannot be used in conjunction with parentId */
  parentDatabaseId?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the category that should be set as the parent. This field cannot be used in conjunction with parentDatabaseId */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateCategory mutation. */
export type UpdateCategoryPayload = {
  __typename?: 'UpdateCategoryPayload';
  /** The created category */
  category?: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Input for the updateComment mutation. */
export type UpdateCommentInput = {
  /** The name of the comment's author. */
  author?: InputMaybe<Scalars['String']['input']>;
  /** The email of the comment's author. */
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** The url of the comment's author. */
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The database ID of the post object the comment belongs to. */
  commentOn?: InputMaybe<Scalars['Int']['input']>;
  /** Content of the comment. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day ( e.g. 01/31/2017 ) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the comment being updated. */
  id: Scalars['ID']['input'];
  /** Parent comment ID of current comment. */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** The approval status of the comment */
  status?: InputMaybe<CommentStatusEnum>;
  /** Type of comment. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateComment mutation. */
export type UpdateCommentPayload = {
  __typename?: 'UpdateCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The comment that was created */
  comment?: Maybe<Comment>;
  /** Whether the mutation succeeded. If the comment is not approved, the server will not return the comment to a non authenticated user, but a success message can be returned if the create succeeded, and the client can optimistically add the comment to the client cache */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Entry meta input fields for updating draft Gravity Forms entries. */
export type UpdateDraftEntryMetaInput = {
  /** ID of the user that submitted of the form if a logged in user submitted the form. */
  createdById?: InputMaybe<Scalars['Int']['input']>;
  /** The UTC date the entry was created, in `Y-m-d H:i:s` format. */
  dateCreatedGmt?: InputMaybe<Scalars['String']['input']>;
  /** Client IP of user who submitted the form. */
  ip?: InputMaybe<Scalars['String']['input']>;
  /** Used to overwrite the sourceUrl the form was submitted from. */
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** The name and version of both the browser and operating system from which the entry was submitted. */
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

/** Entry meta input fields for updating Gravity Forms entries. */
export type UpdateEntryMetaInput = {
  /** ID of the user that submitted of the form if a logged in user submitted the form. */
  createdById?: InputMaybe<Scalars['Int']['input']>;
  /** The UTC date the entry was created, in `Y-m-d H:i:s` format. */
  dateCreatedGmt?: InputMaybe<Scalars['String']['input']>;
  /** Client IP of user who submitted the form. */
  ip?: InputMaybe<Scalars['String']['input']>;
  /** Whether the entry has been read. */
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the entry has been starred (i.e marked with a star). */
  isStarred?: InputMaybe<Scalars['Boolean']['input']>;
  /** Used to overwrite the sourceUrl the form was submitted from. */
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** The current status of the entry. */
  status?: InputMaybe<EntryStatusEnum>;
  /** The name and version of both the browser and operating system from which the entry was submitted. */
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

/** Input for the updateGfDraftEntry mutation. */
export type UpdateGfDraftEntryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The entry meta values to update. */
  entryMeta?: InputMaybe<UpdateDraftEntryMetaInput>;
  /** The field ids and their values. */
  fieldValues?: InputMaybe<Array<InputMaybe<FormFieldValuesInput>>>;
  /** Either the global ID of the draft entry, or its resume token. */
  id: Scalars['ID']['input'];
  /** The ID type for the draft entry. Defaults to `ID` . */
  idType?: InputMaybe<DraftEntryIdTypeEnum>;
  /** Whether the field values should be validated on submission. Defaults to false. */
  shouldValidate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payload for the updateGfDraftEntry mutation. */
export type UpdateGfDraftEntryPayload = {
  __typename?: 'UpdateGfDraftEntryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The draft entry after the update mutation has been applied. If a validation error occurred, the draft entry will NOT have been updated with the invalid value provided. */
  draftEntry?: Maybe<GfDraftEntry>;
  /** Field validation errors. */
  errors?: Maybe<Array<Maybe<FieldError>>>;
  /** Draft resume URL. If the &quot;Referer&quot; header is not included in the request, this will be an empty string. */
  resumeUrl?: Maybe<Scalars['String']['output']>;
};

/** Input for the updateGfEntry mutation. */
export type UpdateGfEntryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The entry meta values to update. */
  entryMeta?: InputMaybe<UpdateEntryMetaInput>;
  /** The field ids and their values to update. */
  fieldValues?: InputMaybe<Array<InputMaybe<FormFieldValuesInput>>>;
  /** ID of the entry to update, either a global or database ID. */
  id: Scalars['ID']['input'];
  /** Whether the field values should be validated on submission. Defaults to false. */
  shouldValidate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payload for the updateGfEntry mutation. */
export type UpdateGfEntryPayload = {
  __typename?: 'UpdateGfEntryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The entry that was created. */
  entry?: Maybe<GfSubmittedEntry>;
  /** Field errors. */
  errors?: Maybe<Array<Maybe<FieldError>>>;
};

/** Input for the updateMediaItem mutation. */
export type UpdateMediaItemInput = {
  /** Alternative text to display when mediaItem is not displayed */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** The userId to assign as the author of the mediaItem */
  authorId?: InputMaybe<Scalars['ID']['input']>;
  /** The caption for the mediaItem */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment status for the mediaItem */
  commentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The date of the mediaItem */
  date?: InputMaybe<Scalars['String']['input']>;
  /** The date (in GMT zone) of the mediaItem */
  dateGmt?: InputMaybe<Scalars['String']['input']>;
  /** Description of the mediaItem */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The file name of the mediaItem */
  filePath?: InputMaybe<Scalars['String']['input']>;
  /** The file type of the mediaItem */
  fileType?: InputMaybe<MimeTypeEnum>;
  /** The ID of the mediaItem object */
  id: Scalars['ID']['input'];
  /** The ID of the parent object */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** The ping status for the mediaItem */
  pingStatus?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the mediaItem */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the mediaItem */
  status?: InputMaybe<MediaItemStatusEnum>;
  /** The title of the mediaItem */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateMediaItem mutation. */
export type UpdateMediaItemPayload = {
  __typename?: 'UpdateMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The MediaItem object mutation type. */
  mediaItem?: Maybe<MediaItem>;
};

/** Input for the updatePage mutation. */
export type UpdatePageInput = {
  /** The userId to assign as the author of the object */
  authorId?: InputMaybe<Scalars['ID']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment status for the object */
  commentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The content of the object */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the page object */
  id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the parent object */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updatePage mutation. */
export type UpdatePagePayload = {
  __typename?: 'UpdatePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  page?: Maybe<Page>;
};

/** Input for the updatePostFormat mutation. */
export type UpdatePostFormatInput = {
  /** The slug that the post_format will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the post_format object */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the postFormat object to update */
  id: Scalars['ID']['input'];
  /** The name of the post_format object to mutate */
  name?: InputMaybe<Scalars['String']['input']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updatePostFormat mutation. */
export type UpdatePostFormatPayload = {
  __typename?: 'UpdatePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created post_format */
  postFormat?: Maybe<PostFormat>;
};

/** Input for the updatePost mutation. */
export type UpdatePostInput = {
  /** The userId to assign as the author of the object */
  authorId?: InputMaybe<Scalars['ID']['input']>;
  /** Set connections between the post and categories */
  categories?: InputMaybe<PostCategoriesInput>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment status for the object */
  commentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The content of the object */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']['input']>;
  /** The excerpt of the object */
  excerpt?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the post object */
  id: Scalars['ID']['input'];
  /** Override the edit lock when another user is editing the post */
  ignoreEditLock?: InputMaybe<Scalars['Boolean']['input']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The ping status for the object */
  pingStatus?: InputMaybe<Scalars['String']['input']>;
  /** URLs that have been pinged. */
  pinged?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Set connections between the post and postFormats */
  postFormats?: InputMaybe<PostPostFormatsInput>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** Set connections between the post and tags */
  tags?: InputMaybe<PostTagsInput>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
  /** URLs queued to be pinged. */
  toPing?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The payload for the updatePost mutation. */
export type UpdatePostPayload = {
  __typename?: 'UpdatePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Post object mutation type. */
  post?: Maybe<Post>;
};

/** Input for the updateSettings mutation. */
export type UpdateSettingsInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Allow people to submit comments on new posts. */
  discussionSettingsDefaultCommentStatus?: InputMaybe<Scalars['String']['input']>;
  /** Allow link notifications from other blogs (pingbacks and trackbacks) on new articles. */
  discussionSettingsDefaultPingStatus?: InputMaybe<Scalars['String']['input']>;
  /** A date format for all date strings. */
  generalSettingsDateFormat?: InputMaybe<Scalars['String']['input']>;
  /** Site tagline. */
  generalSettingsDescription?: InputMaybe<Scalars['String']['input']>;
  /** This address is used for admin purposes, like new user notification. */
  generalSettingsEmail?: InputMaybe<Scalars['String']['input']>;
  /** WordPress locale code. */
  generalSettingsLanguage?: InputMaybe<Scalars['String']['input']>;
  /** A day number of the week that the week should start on. */
  generalSettingsStartOfWeek?: InputMaybe<Scalars['Int']['input']>;
  /** A time format for all time strings. */
  generalSettingsTimeFormat?: InputMaybe<Scalars['String']['input']>;
  /** A city in the same timezone as you. */
  generalSettingsTimezone?: InputMaybe<Scalars['String']['input']>;
  /** Site title. */
  generalSettingsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Site URL. */
  generalSettingsUrl?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the page that should display the latest posts */
  readingSettingsPageForPosts?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the page that should be displayed on the front page */
  readingSettingsPageOnFront?: InputMaybe<Scalars['Int']['input']>;
  /** Blog pages show at most. */
  readingSettingsPostsPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** What to show on the front page */
  readingSettingsShowOnFront?: InputMaybe<Scalars['String']['input']>;
  /** Default post category. */
  writingSettingsDefaultCategory?: InputMaybe<Scalars['Int']['input']>;
  /** Default post format. */
  writingSettingsDefaultPostFormat?: InputMaybe<Scalars['String']['input']>;
  /** Convert emoticons like :-) and :-P to graphics on display. */
  writingSettingsUseSmilies?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The payload for the updateSettings mutation. */
export type UpdateSettingsPayload = {
  __typename?: 'UpdateSettingsPayload';
  /** Update all settings. */
  allSettings?: Maybe<Settings>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Update the DiscussionSettings setting. */
  discussionSettings?: Maybe<DiscussionSettings>;
  /** Update the GeneralSettings setting. */
  generalSettings?: Maybe<GeneralSettings>;
  /** Update the ReadingSettings setting. */
  readingSettings?: Maybe<ReadingSettings>;
  /** Update the WritingSettings setting. */
  writingSettings?: Maybe<WritingSettings>;
};

/** Input for the updateTag mutation. */
export type UpdateTagInput = {
  /** The slug that the post_tag will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the post_tag object */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the tag object to update */
  id: Scalars['ID']['input'];
  /** The name of the post_tag object to mutate */
  name?: InputMaybe<Scalars['String']['input']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateTag mutation. */
export type UpdateTagPayload = {
  __typename?: 'UpdateTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created post_tag */
  tag?: Maybe<Tag>;
};

/** Input for the updateUser mutation. */
export type UpdateUserInput = {
  /** User's AOL IM account. */
  aim?: InputMaybe<Scalars['String']['input']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A string containing content about the user. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** A string containing the user's email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The user's first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user */
  id: Scalars['ID']['input'];
  /** User's Jabber account. */
  jabber?: InputMaybe<Scalars['String']['input']>;
  /** The user's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User's locale. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  nicename?: InputMaybe<Scalars['String']['input']>;
  /** The user's nickname, defaults to the user's username. */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** A string that contains the plain text password for the user. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  registered?: InputMaybe<Scalars['String']['input']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  richEditing?: InputMaybe<Scalars['String']['input']>;
  /** An array of roles to be assigned to the user. */
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A string containing the user's URL for the user's web site. */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  /** User's Yahoo IM account. */
  yim?: InputMaybe<Scalars['String']['input']>;
};

/** The payload for the updateUser mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The User object mutation type. */
  user?: Maybe<User>;
};

/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type User = Commenter & DatabaseIdentifier & Node & UniformResourceIdentifiable & {
  __typename?: 'User';
  /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
  avatar?: Maybe<Avatar>;
  /** User metadata option name. Usually it will be &quot;wp_capabilities&quot;. */
  capKey?: Maybe<Scalars['String']['output']>;
  /** A list of capabilities (permissions) granted to the user */
  capabilities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Connection between the User type and the Comment type */
  comments?: Maybe<UserToCommentConnection>;
  /** @deprecated Deprecated in favor of using Next.js pages */
  conditionalTags?: Maybe<ConditionalTags>;
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int']['output'];
  /** Description of the user. */
  description?: Maybe<Scalars['String']['output']>;
  /** Email address of the user. This is equivalent to the WP_User-&gt;user_email property. */
  email?: Maybe<Scalars['String']['output']>;
  /** Connection between the User type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<UserToEnqueuedScriptConnection>;
  /** Connection between the User type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<UserToEnqueuedStylesheetConnection>;
  /** A complete list of capabilities including capabilities inherited from a role. This is equivalent to the array keys of WP_User-&gt;allcaps. */
  extraCapabilities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** First name of the user. This is equivalent to the WP_User-&gt;user_first_name property. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier for the user object. */
  id: Scalars['ID']['output'];
  /** Whether the node is a Comment */
  isComment: Scalars['Boolean']['output'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean']['output'];
  /** Whether the node represents the front page. */
  isFrontPage: Scalars['Boolean']['output'];
  /** Whether  the node represents the blog page. */
  isPostsPage: Scalars['Boolean']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean']['output'];
  /** Last name of the user. This is equivalent to the WP_User-&gt;user_last_name property. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The preferred language locale set for the user. Value derived from get_user_locale(). */
  locale?: Maybe<Scalars['String']['output']>;
  /** Connection between the User type and the mediaItem type */
  mediaItems?: Maybe<UserToMediaItemConnection>;
  /** Display name of the user. This is equivalent to the WP_User-&gt;display_name property. */
  name?: Maybe<Scalars['String']['output']>;
  /** The nicename for the user. This field is equivalent to WP_User-&gt;user_nicename */
  nicename?: Maybe<Scalars['String']['output']>;
  /** Nickname of the user. */
  nickname?: Maybe<Scalars['String']['output']>;
  /** Connection between the User type and the page type */
  pages?: Maybe<UserToPageConnection>;
  /** Connection between the User type and the post type */
  posts?: Maybe<UserToPostConnection>;
  /** The date the user registered or was created. The field follows a full ISO8601 date string format. */
  registeredDate?: Maybe<Scalars['String']['output']>;
  /** Connection between the User and Revisions authored by the user */
  revisions?: Maybe<UserToRevisionsConnection>;
  /** Connection between the User type and the UserRole type */
  roles?: Maybe<UserToUserRoleConnection>;
  /** The Yoast SEO data of a user */
  seo?: Maybe<SeoUser>;
  /** Whether the Toolbar should be displayed when the user is viewing the site. */
  shouldShowAdminToolbar?: Maybe<Scalars['Boolean']['output']>;
  shouldShowFaustToolbar?: Maybe<Scalars['Boolean']['output']>;
  /** The slug for the user. This field is equivalent to WP_User-&gt;user_nicename */
  slug?: Maybe<Scalars['String']['output']>;
  templates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']['output']>;
  /** A website url that is associated with the user. */
  url?: Maybe<Scalars['String']['output']>;
  /**
   * The Id of the user. Equivalent to WP_User-&gt;ID
   * @deprecated Deprecated in favor of the databaseId field
   */
  userId?: Maybe<Scalars['Int']['output']>;
  /** Username for the user. This field is equivalent to WP_User-&gt;user_login. */
  username?: Maybe<Scalars['String']['output']>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserAvatarArgs = {
  forceDefault?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<AvatarRatingEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserToCommentConnectionWhereArgs>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserMediaItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserToMediaItemConnectionWhereArgs>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserToPageConnectionWhereArgs>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserToPostConnectionWhereArgs>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserRevisionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserToRevisionsConnectionWhereArgs>;
};


/** A registered user account. Users can be assigned roles, author content, and have various capabilities within the site. */
export type UserRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A paginated collection of User Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of User Nodes */
export type UserConnection = {
  /** A list of edges (relational context) between RootQuery and connected User Nodes */
  edges: Array<UserConnectionEdge>;
  /** A list of connected User Nodes */
  nodes: Array<User>;
  /** Information about pagination in a connection. */
  pageInfo: UserConnectionPageInfo;
};

/** Represents a connection to a User. Contains both the User Node and metadata about the relationship. */
export type UserConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected User Node */
  node: User;
};

/** Pagination metadata specific to &quot;UserConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;UserConnectionEdge&quot; Nodes. */
export type UserConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Identifier types for retrieving a specific user. Determines whether to look up users by ID, email, username, or other unique properties. */
export enum UserNodeIdTypeEnum {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The Email of the User */
  Email = 'EMAIL',
  /** The hashed Global ID */
  Id = 'ID',
  /** The slug of the User */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
  /** The username the User uses to login with */
  Username = 'USERNAME'
}

/** A user role object */
export type UserRole = Node & {
  __typename?: 'UserRole';
  /** The capabilities that belong to this role */
  capabilities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The display name of the role */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The globally unique identifier for the user role object. */
  id: Scalars['ID']['output'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  /** The registered name of the role */
  name?: Maybe<Scalars['String']['output']>;
};

/** A paginated collection of UserRole Nodes, Supports cursor-based pagination and filtering to efficiently retrieve sets of UserRole Nodes */
export type UserRoleConnection = {
  /** A list of edges (relational context) between RootQuery and connected UserRole Nodes */
  edges: Array<UserRoleConnectionEdge>;
  /** A list of connected UserRole Nodes */
  nodes: Array<UserRole>;
  /** Information about pagination in a connection. */
  pageInfo: UserRoleConnectionPageInfo;
};

/** Represents a connection to a UserRole. Contains both the UserRole Node and metadata about the relationship. */
export type UserRoleConnectionEdge = {
  /** Opaque reference to the nodes position in the connection. Value can be used with pagination args. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The connected UserRole Node */
  node: UserRole;
};

/** Pagination metadata specific to &quot;UserRoleConnectionEdge&quot; collections. Provides cursors and flags for navigating through sets of &quot;UserRoleConnectionEdge&quot; Nodes. */
export type UserRoleConnectionPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Permission levels for user accounts. Defines the standard access levels that control what actions users can perform within the system. */
export enum UserRoleEnum {
  /** User role with specific capabilities */
  Administrator = 'ADMINISTRATOR',
  /** User role with specific capabilities */
  Author = 'AUTHOR',
  /** User role with specific capabilities */
  Contributor = 'CONTRIBUTOR',
  /** User role with specific capabilities */
  Editor = 'EDITOR',
  /** User role with specific capabilities */
  SeoEditor = 'SEO_EDITOR',
  /** User role with specific capabilities */
  SeoManager = 'SEO_MANAGER',
  /** User role with specific capabilities */
  Subscriber = 'SUBSCRIBER'
}

/** Connection between the User type and the Comment type */
export type UserToCommentConnection = CommentConnection & Connection & {
  __typename?: 'UserToCommentConnection';
  /** Edges for the UserToCommentConnection connection */
  edges: Array<UserToCommentConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Comment>;
  /** Information about pagination in a connection. */
  pageInfo: UserToCommentConnectionPageInfo;
};

/** An edge in a connection */
export type UserToCommentConnectionEdge = CommentConnectionEdge & Edge & {
  __typename?: 'UserToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Comment;
};

/** Pagination metadata specific to &quot;UserToCommentConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToCommentConnection Nodes. */
export type UserToCommentConnectionPageInfo = CommentConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'UserToCommentConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the UserToCommentConnection connection */
export type UserToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']['input']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']['input']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']['input']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']['input']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** One or more Comment Statuses to limit results by */
  statusIn?: InputMaybe<Array<InputMaybe<CommentStatusEnum>>>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Connection between the User type and the EnqueuedScript type */
export type UserToEnqueuedScriptConnection = Connection & EnqueuedScriptConnection & {
  __typename?: 'UserToEnqueuedScriptConnection';
  /** Edges for the UserToEnqueuedScriptConnection connection */
  edges: Array<UserToEnqueuedScriptConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedScript>;
  /** Information about pagination in a connection. */
  pageInfo: UserToEnqueuedScriptConnectionPageInfo;
};

/** An edge in a connection */
export type UserToEnqueuedScriptConnectionEdge = Edge & EnqueuedScriptConnectionEdge & {
  __typename?: 'UserToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: EnqueuedScript;
};

/** Pagination metadata specific to &quot;UserToEnqueuedScriptConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToEnqueuedScriptConnection Nodes. */
export type UserToEnqueuedScriptConnectionPageInfo = EnqueuedScriptConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'UserToEnqueuedScriptConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Connection between the User type and the EnqueuedStylesheet type */
export type UserToEnqueuedStylesheetConnection = Connection & EnqueuedStylesheetConnection & {
  __typename?: 'UserToEnqueuedStylesheetConnection';
  /** Edges for the UserToEnqueuedStylesheetConnection connection */
  edges: Array<UserToEnqueuedStylesheetConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<EnqueuedStylesheet>;
  /** Information about pagination in a connection. */
  pageInfo: UserToEnqueuedStylesheetConnectionPageInfo;
};

/** An edge in a connection */
export type UserToEnqueuedStylesheetConnectionEdge = Edge & EnqueuedStylesheetConnectionEdge & {
  __typename?: 'UserToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: EnqueuedStylesheet;
};

/** Pagination metadata specific to &quot;UserToEnqueuedStylesheetConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToEnqueuedStylesheetConnection Nodes. */
export type UserToEnqueuedStylesheetConnectionPageInfo = EnqueuedStylesheetConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'UserToEnqueuedStylesheetConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Connection between the User type and the mediaItem type */
export type UserToMediaItemConnection = Connection & MediaItemConnection & {
  __typename?: 'UserToMediaItemConnection';
  /** Edges for the UserToMediaItemConnection connection */
  edges: Array<UserToMediaItemConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<MediaItem>;
  /** Information about pagination in a connection. */
  pageInfo: UserToMediaItemConnectionPageInfo;
};

/** An edge in a connection */
export type UserToMediaItemConnectionEdge = Edge & MediaItemConnectionEdge & {
  __typename?: 'UserToMediaItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: MediaItem;
};

/** Pagination metadata specific to &quot;UserToMediaItemConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToMediaItemConnection Nodes. */
export type UserToMediaItemConnectionPageInfo = MediaItemConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'UserToMediaItemConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the UserToMediaItemConnection connection */
export type UserToMediaItemConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the User type and the page type */
export type UserToPageConnection = Connection & PageConnection & {
  __typename?: 'UserToPageConnection';
  /** Edges for the UserToPageConnection connection */
  edges: Array<UserToPageConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Page>;
  /** Information about pagination in a connection. */
  pageInfo: UserToPageConnectionPageInfo;
};

/** An edge in a connection */
export type UserToPageConnectionEdge = Edge & PageConnectionEdge & {
  __typename?: 'UserToPageConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Page;
};

/** Pagination metadata specific to &quot;UserToPageConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToPageConnection Nodes. */
export type UserToPageConnectionPageInfo = PageConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'UserToPageConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the UserToPageConnection connection */
export type UserToPageConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the User type and the post type */
export type UserToPostConnection = Connection & PostConnection & {
  __typename?: 'UserToPostConnection';
  /** Edges for the UserToPostConnection connection */
  edges: Array<UserToPostConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<Post>;
  /** Information about pagination in a connection. */
  pageInfo: UserToPostConnectionPageInfo;
};

/** An edge in a connection */
export type UserToPostConnectionEdge = Edge & PostConnectionEdge & {
  __typename?: 'UserToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: Post;
};

/** Pagination metadata specific to &quot;UserToPostConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToPostConnection Nodes. */
export type UserToPostConnectionPageInfo = PageInfo & PostConnectionPageInfo & WpPageInfo & {
  __typename?: 'UserToPostConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the UserToPostConnection connection */
export type UserToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']['input']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']['input']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']['input']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the User type and the ContentNode type */
export type UserToRevisionsConnection = Connection & ContentNodeConnection & {
  __typename?: 'UserToRevisionsConnection';
  /** Edges for the UserToRevisionsConnection connection */
  edges: Array<UserToRevisionsConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<ContentNode>;
  /** Information about pagination in a connection. */
  pageInfo: UserToRevisionsConnectionPageInfo;
};

/** An edge in a connection */
export type UserToRevisionsConnectionEdge = ContentNodeConnectionEdge & Edge & {
  __typename?: 'UserToRevisionsConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: ContentNode;
};

/** Pagination metadata specific to &quot;UserToRevisionsConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToRevisionsConnection Nodes. */
export type UserToRevisionsConnectionPageInfo = ContentNodeConnectionPageInfo & PageInfo & WpPageInfo & {
  __typename?: 'UserToRevisionsConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** Arguments for filtering the UserToRevisionsConnection connection */
export type UserToRevisionsConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** What parameter to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Connection between the User type and the UserRole type */
export type UserToUserRoleConnection = Connection & UserRoleConnection & {
  __typename?: 'UserToUserRoleConnection';
  /** Edges for the UserToUserRoleConnection connection */
  edges: Array<UserToUserRoleConnectionEdge>;
  /** The nodes of the connection, without the edges */
  nodes: Array<UserRole>;
  /** Information about pagination in a connection. */
  pageInfo: UserToUserRoleConnectionPageInfo;
};

/** An edge in a connection */
export type UserToUserRoleConnectionEdge = Edge & UserRoleConnectionEdge & {
  __typename?: 'UserToUserRoleConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge */
  node: UserRole;
};

/** Pagination metadata specific to &quot;UserToUserRoleConnection&quot; collections. Provides cursors and flags for navigating through sets of UserToUserRoleConnection Nodes. */
export type UserToUserRoleConnectionPageInfo = PageInfo & UserRoleConnectionPageInfo & WpPageInfo & {
  __typename?: 'UserToUserRoleConnectionPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** User attribute sorting options. Determines which property of user accounts is used for ordering user listings. */
export enum UsersConnectionOrderbyEnum {
  /** Order by display name */
  DisplayName = 'DISPLAY_NAME',
  /** Order by email address */
  Email = 'EMAIL',
  /** Order by login */
  Login = 'LOGIN',
  /** Preserve the login order given in the LOGIN_IN array */
  LoginIn = 'LOGIN_IN',
  /** Order by nice name */
  NiceName = 'NICE_NAME',
  /** Preserve the nice name order given in the NICE_NAME_IN array */
  NiceNameIn = 'NICE_NAME_IN',
  /** Order by registration date */
  Registered = 'REGISTERED',
  /** Order by URL */
  Url = 'URL'
}

/** Options for ordering the connection */
export type UsersConnectionOrderbyInput = {
  /** The field name used to sort the results. */
  field: UsersConnectionOrderbyEnum;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
};

/** User properties that can be targeted in search operations. Defines which user attributes can be searched when looking for specific users. */
export enum UsersConnectionSearchColumnEnum {
  /** The user's email address. */
  Email = 'EMAIL',
  /** The globally unique ID. */
  Id = 'ID',
  /** The username the User uses to login with. */
  Login = 'LOGIN',
  /** A URL-friendly name for the user. The default is the user's username. */
  Nicename = 'NICENAME',
  /** The URL of the user's website. */
  Url = 'URL'
}

/** The &quot;UtmConfigurationBlock&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type UtmConfigurationBlock = AcfFieldGroup & AcfFieldGroupFields & UtmConfigurationBlock_Fields & {
  __typename?: 'UtmConfigurationBlock';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;UtmConfigurationBlock&quot; Field Group */
  utmQueryParams?: Maybe<Array<Maybe<UtmConfigurationBlockUtmQueryParams>>>;
};

/** The &quot;UtmConfigurationBlockUtmQueryParams&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type UtmConfigurationBlockUtmQueryParams = AcfFieldGroup & AcfFieldGroupFields & UtmConfigurationBlockUtmQueryParams_Fields & {
  __typename?: 'UtmConfigurationBlockUtmQueryParams';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;UtmConfigurationBlockUtmQueryParams&quot; Field Group */
  queryParam?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;UtmConfigurationBlockUtmQueryParams&quot; Field Group */
export type UtmConfigurationBlockUtmQueryParams_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;UtmConfigurationBlockUtmQueryParams&quot; Field Group */
  queryParam?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;UtmConfigurationBlock&quot; Field Group */
export type UtmConfigurationBlock_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;repeater&quot; Field Type added to the schema as part of the &quot;UtmConfigurationBlock&quot; Field Group */
  utmQueryParams?: Maybe<Array<Maybe<UtmConfigurationBlockUtmQueryParams>>>;
};

/** The &quot;Video&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type Video = AcfFieldGroup & AcfFieldGroupFields & Video_Fields & {
  __typename?: 'Video';
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;url&quot; Field Type added to the schema as part of the &quot;Video&quot; Field Group */
  url?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;Video&quot; Field Group */
export type Video_Fields = {
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;url&quot; Field Type added to the schema as part of the &quot;Video&quot; Field Group */
  url?: Maybe<Scalars['String']['output']>;
};

/** Metadata for cursor-based pagination. Provides cursors for continuing pagination and boolean flags indicating if more items exist in either direction. */
export type WpPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Raw schema for page */
  seo?: Maybe<SeoPostTypePageInfo>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** A Gravity Forms website field. */
export type WebsiteField = FormField & GfFieldWithAdminLabelSetting & GfFieldWithAutocompleteSetting & GfFieldWithConditionalLogicSetting & GfFieldWithCssClassSetting & GfFieldWithDefaultValueSetting & GfFieldWithDescriptionSetting & GfFieldWithDuplicatesSetting & GfFieldWithErrorMessageSetting & GfFieldWithLabelPlacementSetting & GfFieldWithLabelSetting & GfFieldWithPersonalData & GfFieldWithPlaceholderSetting & GfFieldWithPrepopulateFieldSetting & GfFieldWithRulesSetting & GfFieldWithSizeSetting & Node & {
  __typename?: 'WebsiteField';
  /** When specified, the value of this property will be used on the admin pages instead of the label. It is useful for fields with long labels. */
  adminLabel?: Maybe<Scalars['String']['output']>;
  /** The autocomplete attribute for the field. */
  autocompleteAttribute?: Maybe<Scalars['String']['output']>;
  /** Determines if the field’s value can be pre-populated dynamically. */
  canPrepopulate?: Maybe<Scalars['Boolean']['output']>;
  /** Controls the visibility of the field based on values selected by the user. */
  conditionalLogic?: Maybe<ConditionalLogic>;
  /** String containing the custom CSS classes to be added to the &lt;li&gt; tag that contains the field. Useful for applying custom formatting to specific fields. */
  cssClass?: Maybe<Scalars['String']['output']>;
  /** Field database ID. */
  databaseId: Scalars['Int']['output'];
  /** Contains the default value for the field. When specified, the field&#039;s value will be populated with the contents of this property when the form is displayed. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Field description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The placement of the field description. */
  descriptionPlacement?: Maybe<FormFieldDescriptionPlacementEnum>;
  /** Indicates the field is only displayed and its contents are not submitted with the form/saved with the entry. This is set to true. */
  displayOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the message that is displayed for fields that fail validation. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether autocomplete should be enabled for this field. */
  hasAutocomplete?: Maybe<Scalars['Boolean']['output']>;
  /** The globally unique ID for the object */
  id: Scalars['ID']['output'];
  /** Assigns a name to this field so that it can be populated dynamically via this input name. Only applicable when canPrepopulate is `true`. */
  inputName?: Maybe<Scalars['String']['output']>;
  /** The base form field type used to display the input. A good example is the Post Custom Field that can be displayed as various different types of fields. */
  inputType?: Maybe<FormFieldTypeEnum>;
  /** Determines if the field requires the user to enter a value. Fields marked as required will prevent the form from being submitted if the user has not entered a value in it. */
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Field label that will be displayed on the form and on the admin pages. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field label position. */
  labelPlacement?: Maybe<FormFieldLabelPlacementEnum>;
  /** The number of CSS grid columns the field should span. */
  layoutGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The number of CSS grid columns the spacer field following this one should span. */
  layoutSpacerGridColumnSpan?: Maybe<Scalars['Int']['output']>;
  /** The form page this field is located on. Default is 1. */
  pageNumber?: Maybe<Scalars['Int']['output']>;
  /** The form field-specifc policies for exporting and erasing personal data. */
  personalData?: Maybe<FormFieldDataPolicy>;
  /** Placeholder text to give the user a hint on how to fill out the field. This is not submitted with the form. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Determines if the field allows duplicate submissions. */
  shouldAllowDuplicates?: Maybe<Scalars['Boolean']['output']>;
  /** Determines the size of the field when displayed on the page. */
  size?: Maybe<FormFieldSizeEnum>;
  /** The type of field to be displayed. */
  type?: Maybe<FormFieldTypeEnum>;
  /** The string-formatted entry value for the `formField`. For complex fields this might be a JSON-encoded or serialized array. */
  value?: Maybe<Scalars['String']['output']>;
  /** Field visibility. */
  visibility?: Maybe<FormFieldVisibilityEnum>;
};

/** Provides access to fields of the &quot;Accordion&quot; ACF Field Group via the &quot;accordion&quot; field */
export type WithAcfAccordion = {
  /** Fields of the Accordion ACF Field Group */
  accordion?: Maybe<Accordion>;
};

/** Provides access to fields of the &quot;Benefits&quot; ACF Field Group via the &quot;benefits&quot; field */
export type WithAcfBenefits = {
  /** Fields of the Benefits ACF Field Group */
  benefits?: Maybe<Benefits>;
};

/** Provides access to fields of the &quot;BenefitsAccordion&quot; ACF Field Group via the &quot;benefitsAccordion&quot; field */
export type WithAcfBenefitsAccordion = {
  /** Fields of the BenefitsAccordion ACF Field Group */
  benefitsAccordion?: Maybe<BenefitsAccordion>;
};

/** Provides access to fields of the &quot;BenefitsList&quot; ACF Field Group via the &quot;benefitsList&quot; field */
export type WithAcfBenefitsList = {
  /** Fields of the BenefitsList ACF Field Group */
  benefitsList?: Maybe<BenefitsList>;
};

/** Provides access to fields of the &quot;Benefitscontent&quot; ACF Field Group via the &quot;benefitscontent&quot; field */
export type WithAcfBenefitscontent = {
  /** Fields of the Benefitscontent ACF Field Group */
  benefitscontent?: Maybe<Benefitscontent>;
};

/** Provides access to fields of the &quot;BlockFooter&quot; ACF Field Group via the &quot;blockFooter&quot; field */
export type WithAcfBlockFooter = {
  /** Fields of the BlockFooter ACF Field Group */
  blockFooter?: Maybe<BlockFooter>;
};

/** Provides access to fields of the &quot;BlockModal&quot; ACF Field Group via the &quot;blockModal&quot; field */
export type WithAcfBlockModal = {
  /** Fields of the BlockModal ACF Field Group */
  blockModal?: Maybe<BlockModal>;
};

/** Provides access to fields of the &quot;BlockVideo&quot; ACF Field Group via the &quot;blockVideo&quot; field */
export type WithAcfBlockVideo = {
  /** Fields of the BlockVideo ACF Field Group */
  blockVideo?: Maybe<BlockVideo>;
};

/** Provides access to fields of the &quot;BlogArticles&quot; ACF Field Group via the &quot;blogArticles&quot; field */
export type WithAcfBlogArticles = {
  /** Fields of the BlogArticles ACF Field Group */
  blogArticles?: Maybe<BlogArticles>;
};

/** Provides access to fields of the &quot;BlogCtaCard&quot; ACF Field Group via the &quot;blogCtaCard&quot; field */
export type WithAcfBlogCtaCard = {
  /** Fields of the BlogCtaCard ACF Field Group */
  blogCtaCard?: Maybe<BlogCtaCard>;
};

/** Provides access to fields of the &quot;BlogIndexContent&quot; ACF Field Group via the &quot;blogIndexContent&quot; field */
export type WithAcfBlogIndexContent = {
  /** Fields of the BlogIndexContent ACF Field Group */
  blogIndexContent?: Maybe<BlogIndexContent>;
};

/** Provides access to fields of the &quot;CalloutText&quot; ACF Field Group via the &quot;calloutText&quot; field */
export type WithAcfCalloutText = {
  /** Fields of the CalloutText ACF Field Group */
  calloutText?: Maybe<CalloutText>;
};

/** Provides access to fields of the &quot;CardGrid&quot; ACF Field Group via the &quot;cardGrid&quot; field */
export type WithAcfCardGrid = {
  /** Fields of the CardGrid ACF Field Group */
  cardGrid?: Maybe<CardGrid>;
};

/** Provides access to fields of the &quot;CaseStudies&quot; ACF Field Group via the &quot;caseStudies&quot; field */
export type WithAcfCaseStudies = {
  /** Fields of the CaseStudies ACF Field Group */
  caseStudies?: Maybe<CaseStudies>;
};

/** Provides access to fields of the &quot;CompanyList&quot; ACF Field Group via the &quot;companyList&quot; field */
export type WithAcfCompanyList = {
  /** Fields of the CompanyList ACF Field Group */
  companyList?: Maybe<CompanyList>;
};

/** Provides access to fields of the &quot;CtaCard&quot; ACF Field Group via the &quot;ctaCard&quot; field */
export type WithAcfCtaCard = {
  /** Fields of the CtaCard ACF Field Group */
  ctaCard?: Maybe<CtaCard>;
};

/** Provides access to fields of the &quot;Divider&quot; ACF Field Group via the &quot;divider&quot; field */
export type WithAcfDivider = {
  /** Fields of the Divider ACF Field Group */
  divider?: Maybe<Divider>;
};

/** Provides access to fields of the &quot;FactoringInfoGraphic&quot; ACF Field Group via the &quot;factoringInfoGraphic&quot; field */
export type WithAcfFactoringInfoGraphic = {
  /** Fields of the FactoringInfoGraphic ACF Field Group */
  factoringInfoGraphic?: Maybe<FactoringInfoGraphic>;
};

/** Provides access to fields of the &quot;FinancingCta&quot; ACF Field Group via the &quot;financingCta&quot; field */
export type WithAcfFinancingCta = {
  /** Fields of the FinancingCta ACF Field Group */
  financingCta?: Maybe<FinancingCta>;
};

/** Provides access to fields of the &quot;FormContentBlock&quot; ACF Field Group via the &quot;formContentBlock&quot; field */
export type WithAcfFormContentBlock = {
  /** Fields of the FormContentBlock ACF Field Group */
  formContentBlock?: Maybe<FormContentBlock>;
};

/** Provides access to fields of the &quot;FrontEndConfigurationBlock&quot; ACF Field Group via the &quot;frontEndConfigurationBlock&quot; field */
export type WithAcfFrontEndConfigurationBlock = {
  /** Fields of the FrontEndConfigurationBlock ACF Field Group */
  frontEndConfigurationBlock?: Maybe<FrontEndConfigurationBlock>;
};

/** Provides access to fields of the &quot;FuelSavingsCalculator&quot; ACF Field Group via the &quot;fuelSavingsCalculator&quot; field */
export type WithAcfFuelSavingsCalculator = {
  /** Fields of the FuelSavingsCalculator ACF Field Group */
  fuelSavingsCalculator?: Maybe<FuelSavingsCalculator>;
};

/** Provides access to fields of the &quot;HeroBanner&quot; ACF Field Group via the &quot;heroBanner&quot; field */
export type WithAcfHeroBanner = {
  /** Fields of the HeroBanner ACF Field Group */
  heroBanner?: Maybe<HeroBanner>;
};

/** Provides access to fields of the &quot;HeroBannerWithForm&quot; ACF Field Group via the &quot;heroBannerWithForm&quot; field */
export type WithAcfHeroBannerWithForm = {
  /** Fields of the HeroBannerWithForm ACF Field Group */
  heroBannerWithForm?: Maybe<HeroBannerWithForm>;
};

/** Provides access to fields of the &quot;Highlight&quot; ACF Field Group via the &quot;highlight&quot; field */
export type WithAcfHighlight = {
  /** Fields of the Highlight ACF Field Group */
  highlight?: Maybe<Highlight>;
};

/** Provides access to fields of the &quot;LogoRows&quot; ACF Field Group via the &quot;logoRows&quot; field */
export type WithAcfLogoRows = {
  /** Fields of the LogoRows ACF Field Group */
  logoRows?: Maybe<LogoRows>;
};

/** Provides access to fields of the &quot;LogoScroll&quot; ACF Field Group via the &quot;logoScroll&quot; field */
export type WithAcfLogoScroll = {
  /** Fields of the LogoScroll ACF Field Group */
  logoScroll?: Maybe<LogoScroll>;
};

/** Provides access to fields of the &quot;MainHero&quot; ACF Field Group via the &quot;mainHero&quot; field */
export type WithAcfMainHero = {
  /** Fields of the MainHero ACF Field Group */
  mainHero?: Maybe<MainHero>;
};

/** Provides access to fields of the &quot;MarketoIntegrationBlock&quot; ACF Field Group via the &quot;marketoIntegrationBlock&quot; field */
export type WithAcfMarketoIntegrationBlock = {
  /** Fields of the MarketoIntegrationBlock ACF Field Group */
  marketoIntegrationBlock?: Maybe<MarketoIntegrationBlock>;
};

/** Provides access to fields of the &quot;MenuButton&quot; ACF Field Group via the &quot;menuButton&quot; field */
export type WithAcfMenuButton = {
  /** Fields of the MenuButton ACF Field Group */
  menuButton?: Maybe<MenuButton>;
};

/** Provides access to fields of the &quot;MenuContent&quot; ACF Field Group via the &quot;menuContent&quot; field */
export type WithAcfMenuContent = {
  /** Fields of the MenuContent ACF Field Group */
  menuContent?: Maybe<MenuContent>;
};

/** Provides access to fields of the &quot;NavDetails&quot; ACF Field Group via the &quot;navDetails&quot; field */
export type WithAcfNavDetails = {
  /** Fields of the NavDetails ACF Field Group */
  navDetails?: Maybe<NavDetails>;
};

/** Provides access to fields of the &quot;NavSegments&quot; ACF Field Group via the &quot;navSegments&quot; field */
export type WithAcfNavSegments = {
  /** Fields of the NavSegments ACF Field Group */
  navSegments?: Maybe<NavSegments>;
};

/** Provides access to fields of the &quot;NewsAndInsights&quot; ACF Field Group via the &quot;newsAndInsights&quot; field */
export type WithAcfNewsAndInsights = {
  /** Fields of the NewsAndInsights ACF Field Group */
  newsAndInsights?: Maybe<NewsAndInsights>;
};

/** Provides access to fields of the &quot;NewsletterSignup&quot; ACF Field Group via the &quot;newsletterSignup&quot; field */
export type WithAcfNewsletterSignup = {
  /** Fields of the NewsletterSignup ACF Field Group */
  newsletterSignup?: Maybe<NewsletterSignup>;
};

/** Access point for the &quot;FrontEndConfiguration&quot; ACF Options Page */
export type WithAcfOptionsPageFrontEndConfiguration = {
  frontEndConfiguration?: Maybe<FrontEndConfiguration>;
};

/** Access point for the &quot;MarketoIntegration&quot; ACF Options Page */
export type WithAcfOptionsPageMarketoIntegration = {
  marketoIntegration?: Maybe<MarketoIntegration>;
};

/** Access point for the &quot;RedirectConfiguration&quot; ACF Options Page */
export type WithAcfOptionsPageRedirectConfiguration = {
  redirectConfiguration?: Maybe<RedirectConfiguration>;
};

/** Access point for the &quot;SalesforceIntegration&quot; ACF Options Page */
export type WithAcfOptionsPageSalesforceIntegration = {
  salesforceIntegration?: Maybe<SalesforceIntegration>;
};

/** Access point for the &quot;UTMConfiguration&quot; ACF Options Page */
export type WithAcfOptionsPageUtmConfiguration = {
  uTMConfiguration?: Maybe<UtmConfiguration>;
};

/** Provides access to fields of the &quot;OurHistory&quot; ACF Field Group via the &quot;ourHistory&quot; field */
export type WithAcfOurHistory = {
  /** Fields of the OurHistory ACF Field Group */
  ourHistory?: Maybe<OurHistory>;
};

/** Provides access to fields of the &quot;Partners&quot; ACF Field Group via the &quot;partners&quot; field */
export type WithAcfPartners = {
  /** Fields of the Partners ACF Field Group */
  partners?: Maybe<Partners>;
};

/** Provides access to fields of the &quot;PostAsideContent&quot; ACF Field Group via the &quot;postAsideContent&quot; field */
export type WithAcfPostAsideContent = {
  /** Fields of the PostAsideContent ACF Field Group */
  postAsideContent?: Maybe<PostAsideContent>;
};

/** Provides access to fields of the &quot;RedirectConfigurationBlock&quot; ACF Field Group via the &quot;redirectConfigurationBlock&quot; field */
export type WithAcfRedirectConfigurationBlock = {
  /** Fields of the RedirectConfigurationBlock ACF Field Group */
  redirectConfigurationBlock?: Maybe<RedirectConfigurationBlock>;
};

/** Provides access to fields of the &quot;Solutions&quot; ACF Field Group via the &quot;solutions&quot; field */
export type WithAcfSolutions = {
  /** Fields of the Solutions ACF Field Group */
  solutions?: Maybe<Solutions>;
};

/** Provides access to fields of the &quot;SolutionsCards&quot; ACF Field Group via the &quot;solutionsCards&quot; field */
export type WithAcfSolutionsCards = {
  /** Fields of the SolutionsCards ACF Field Group */
  solutionsCards?: Maybe<SolutionsCards>;
};

/** Provides access to fields of the &quot;SystemAlert&quot; ACF Field Group via the &quot;systemAlert&quot; field */
export type WithAcfSystemAlert = {
  /** Fields of the SystemAlert ACF Field Group */
  systemAlert?: Maybe<SystemAlert>;
};

/** Provides access to fields of the &quot;TeamMembers&quot; ACF Field Group via the &quot;teamMembers&quot; field */
export type WithAcfTeamMembers = {
  /** Fields of the TeamMembers ACF Field Group */
  teamMembers?: Maybe<TeamMembers>;
};

/** Provides access to fields of the &quot;Testimonials&quot; ACF Field Group via the &quot;testimonials&quot; field */
export type WithAcfTestimonials = {
  /** Fields of the Testimonials ACF Field Group */
  testimonials?: Maybe<Testimonials>;
};

/** Provides access to fields of the &quot;TextHeader&quot; ACF Field Group via the &quot;textHeader&quot; field */
export type WithAcfTextHeader = {
  /** Fields of the TextHeader ACF Field Group */
  textHeader?: Maybe<TextHeader>;
};

/** Provides access to fields of the &quot;Thrive&quot; ACF Field Group via the &quot;thrive&quot; field */
export type WithAcfThrive = {
  /** Fields of the Thrive ACF Field Group */
  thrive?: Maybe<Thrive>;
};

/** Provides access to fields of the &quot;TriumphIntegration&quot; ACF Field Group via the &quot;triumphIntegration&quot; field */
export type WithAcfTriumphIntegration = {
  /** Fields of the TriumphIntegration ACF Field Group */
  triumphIntegration?: Maybe<TriumphIntegration>;
};

/** Provides access to fields of the &quot;TwoColumnCta&quot; ACF Field Group via the &quot;twoColumnCta&quot; field */
export type WithAcfTwoColumnCta = {
  /** Fields of the TwoColumnCta ACF Field Group */
  twoColumnCta?: Maybe<TwoColumnCta>;
};

/** Provides access to fields of the &quot;TwoColumnPromo&quot; ACF Field Group via the &quot;twoColumnPromo&quot; field */
export type WithAcfTwoColumnPromo = {
  /** Fields of the TwoColumnPromo ACF Field Group */
  twoColumnPromo?: Maybe<TwoColumnPromo>;
};

/** Provides access to fields of the &quot;UtmConfigurationBlock&quot; ACF Field Group via the &quot;utmConfigurationBlock&quot; field */
export type WithAcfUtmConfigurationBlock = {
  /** Fields of the UtmConfigurationBlock ACF Field Group */
  utmConfigurationBlock?: Maybe<UtmConfigurationBlock>;
};

/** Provides access to fields of the &quot;Video&quot; ACF Field Group via the &quot;video&quot; field */
export type WithAcfVideo = {
  /** Fields of the Video ACF Field Group */
  video?: Maybe<Video>;
};

/** Provides access to fields of the &quot;Wsywig&quot; ACF Field Group via the &quot;wsywig&quot; field */
export type WithAcfWsywig = {
  /** Fields of the Wsywig ACF Field Group */
  wsywig?: Maybe<Wsywig>;
};

/** The writing setting type */
export type WritingSettings = {
  __typename?: 'WritingSettings';
  /** Default post category. */
  defaultCategory?: Maybe<Scalars['Int']['output']>;
  /** Default post format. */
  defaultPostFormat?: Maybe<Scalars['String']['output']>;
  /** Convert emoticons like :-) and :-P to graphics on display. */
  useSmilies?: Maybe<Scalars['Boolean']['output']>;
};

/** The &quot;Wsywig&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type Wsywig = AcfFieldGroup & AcfFieldGroupFields & Wsywig_Fields & {
  __typename?: 'Wsywig';
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;Wsywig&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;Wsywig&quot; Field Group */
  externalLinkModal?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;Wsywig&quot; Field Group */
  modal?: Maybe<WsywigModal>;
  /** ID applied to section element */
  sectionId?: Maybe<Scalars['String']['output']>;
  /** Textcontent */
  textContent?: Maybe<Scalars['String']['output']>;
};

/** The &quot;WsywigModal&quot; Field Group. Added to the Schema by &quot;WPGraphQL for ACF&quot;. */
export type WsywigModal = AcfFieldGroup & AcfFieldGroupFields & WsywigModal_Fields & {
  __typename?: 'WsywigModal';
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;WsywigModal&quot; Field Group */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;WsywigModal&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;WsywigModal&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;WsywigModal&quot; Field Group */
export type WsywigModal_Fields = {
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;WsywigModal&quot; Field Group */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;textarea&quot; Field Type added to the schema as part of the &quot;WsywigModal&quot; Field Group */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;text&quot; Field Type added to the schema as part of the &quot;WsywigModal&quot; Field Group */
  title?: Maybe<Scalars['String']['output']>;
};

/** Interface representing fields of the ACF &quot;Wsywig&quot; Field Group */
export type Wsywig_Fields = {
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;Wsywig&quot; Field Group */
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  /** Field of the &quot;true_false&quot; Field Type added to the schema as part of the &quot;Wsywig&quot; Field Group */
  externalLinkModal?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the field group
   * @deprecated Use __typename instead
   */
  fieldGroupName?: Maybe<Scalars['String']['output']>;
  /** Field of the &quot;group&quot; Field Type added to the schema as part of the &quot;Wsywig&quot; Field Group */
  modal?: Maybe<WsywigModal>;
  /** Textcontent */
  textContent?: Maybe<Scalars['String']['output']>;
};

/** A block used for editing the site */
export type YoastFaqBlock = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'YoastFaqBlock';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the YoastFaqBlock Block Type */
  attributes?: Maybe<YoastFaqBlockAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the YoastFaqBlock Block Type */
export type YoastFaqBlockAttributes = {
  __typename?: 'YoastFaqBlockAttributes';
  /** The &quot;additionalListCssClasses&quot; field on the &quot;YoastFaqBlockAttributes&quot; block or block attributes */
  additionalListCssClasses?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;YoastFaqBlockAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;YoastFaqBlockAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;YoastFaqBlockAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;questions&quot; field on the &quot;YoastFaqBlockAttributes&quot; block or block attributes */
  questions?: Maybe<Scalars['BlockAttributesArray']['output']>;
};

/** A block used for editing the site */
export type YoastHowToBlock = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'YoastHowToBlock';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the YoastHowToBlock Block Type */
  attributes?: Maybe<YoastHowToBlockAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the YoastHowToBlock Block Type */
export type YoastHowToBlockAttributes = {
  __typename?: 'YoastHowToBlockAttributes';
  /** The &quot;additionalListCssClasses&quot; field on the &quot;YoastHowToBlockAttributes&quot; block or block attributes */
  additionalListCssClasses?: Maybe<Scalars['String']['output']>;
  /** The &quot;className&quot; field on the &quot;YoastHowToBlockAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;days&quot; field on the &quot;YoastHowToBlockAttributes&quot; block or block attributes */
  days?: Maybe<Scalars['String']['output']>;
  /** The &quot;defaultDurationText&quot; field on the &quot;YoastHowToBlockAttributes&quot; block or block attributes */
  defaultDurationText?: Maybe<Scalars['String']['output']>;
  /** The &quot;description&quot; field on the &quot;YoastHowToBlockAttributes&quot; block or block attributes */
  description?: Maybe<Scalars['String']['output']>;
  /** The &quot;durationText&quot; field on the &quot;YoastHowToBlockAttributes&quot; block or block attributes */
  durationText?: Maybe<Scalars['String']['output']>;
  /** The &quot;hasDuration&quot; field on the &quot;YoastHowToBlockAttributes&quot; block or block attributes */
  hasDuration?: Maybe<Scalars['Boolean']['output']>;
  /** The &quot;hours&quot; field on the &quot;YoastHowToBlockAttributes&quot; block or block attributes */
  hours?: Maybe<Scalars['String']['output']>;
  /** The &quot;jsonDescription&quot; field on the &quot;YoastHowToBlockAttributes&quot; block or block attributes */
  jsonDescription?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;YoastHowToBlockAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;YoastHowToBlockAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;minutes&quot; field on the &quot;YoastHowToBlockAttributes&quot; block or block attributes */
  minutes?: Maybe<Scalars['String']['output']>;
  /** The &quot;steps&quot; field on the &quot;YoastHowToBlockAttributes&quot; block or block attributes */
  steps?: Maybe<Scalars['BlockAttributesArray']['output']>;
  /** The &quot;unorderedList&quot; field on the &quot;YoastHowToBlockAttributes&quot; block or block attributes */
  unorderedList?: Maybe<Scalars['Boolean']['output']>;
};

/** A block used for editing the site */
export type YoastSeoBreadcrumbs = EditorBlock & PageEditorBlock & PostEditorBlock & {
  __typename?: 'YoastSeoBreadcrumbs';
  /** The API version of the Gutenberg Block */
  apiVersion?: Maybe<Scalars['Int']['output']>;
  /** Attributes of the YoastSeoBreadcrumbs Block Type */
  attributes?: Maybe<YoastSeoBreadcrumbsAttributes>;
  /** The name of the category the Block belongs to */
  blockEditorCategoryName?: Maybe<Scalars['String']['output']>;
  /** The id of the Block */
  clientId?: Maybe<Scalars['String']['output']>;
  /** CSS Classnames to apply to the block */
  cssClassNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The inner blocks of the Block */
  innerBlocks?: Maybe<Array<Maybe<EditorBlock>>>;
  /** Whether the block is Dynamic (server rendered) */
  isDynamic: Scalars['Boolean']['output'];
  /** The name of the block */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent id of the Block */
  parentClientId?: Maybe<Scalars['String']['output']>;
  /** The rendered HTML for the block */
  renderedHtml?: Maybe<Scalars['String']['output']>;
  /** The (GraphQL) type of the block */
  type?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the YoastSeoBreadcrumbs Block Type */
export type YoastSeoBreadcrumbsAttributes = {
  __typename?: 'YoastSeoBreadcrumbsAttributes';
  /** The &quot;className&quot; field on the &quot;YoastSeoBreadcrumbsAttributes&quot; block or block attributes */
  className?: Maybe<Scalars['String']['output']>;
  /** The &quot;lock&quot; field on the &quot;YoastSeoBreadcrumbsAttributes&quot; block or block attributes */
  lock?: Maybe<Scalars['BlockAttributesObject']['output']>;
  /** The &quot;metadata&quot; field on the &quot;YoastSeoBreadcrumbsAttributes&quot; block or block attributes */
  metadata?: Maybe<Scalars['BlockAttributesObject']['output']>;
};

export type AccordionFragmentFragment = { __typename?: 'AcfAccordion', name?: string | null, accordion?: { __typename?: 'Accordion', sectionId?: string | null, darkBackground?: boolean | null, description?: string | null, iconType?: Array<string | null> | null, title?: string | null, withAbbreviations?: boolean | null, withLargeItemTitle?: boolean | null, items?: Array<{ __typename?: 'AccordionItems', title?: string | null, content?: string | null } | null> | null } | null };

export type BenefitsFragmentFragment = { __typename?: 'AcfBenefits', name?: string | null, benefits?: { __typename?: 'Benefits', sectionId?: string | null, sectionDescription?: string | null, benefitCards?: Array<{ __typename?: 'BenefitsBenefitCards', buttonId?: string | null, title?: string | null, description?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, cardImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null };

export type BenefitsAccordionFragmentFragment = { __typename?: 'AcfBenefitsaccordion', name?: string | null, benefitsAccordion?: { __typename?: 'BenefitsAccordion', sectionId?: string | null, title?: string | null, subtitle?: string | null, accordionItems?: Array<{ __typename?: 'BenefitsAccordionAccordionItems', description?: string | null, accordionImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, links?: Array<{ __typename?: 'BenefitsAccordionAccordionItemsLinks', linkId?: string | null, link?: { __typename?: 'AcfLink', url?: string | null, title?: string | null } | null } | null> | null } | null> | null } | null };

export type BenefitsAccordionItemLinkFragmentFragment = { __typename?: 'BenefitsAccordionAccordionItems', links?: Array<{ __typename?: 'BenefitsAccordionAccordionItemsLinks', linkId?: string | null, link?: { __typename?: 'AcfLink', url?: string | null, title?: string | null } | null } | null> | null };

export type BenefitsContentFragmentFragment = { __typename?: 'AcfBenefitscontent', name?: string | null, benefitscontent?: { __typename?: 'Benefitscontent', sectionId?: string | null, title?: string | null, textContent?: string | null, textContentVerticalAlignment?: Array<string | null> | null, media?: { __typename?: 'BenefitscontentMedia', type?: string | null, video?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | null };

export type BenefitsListFragmentFragment = { __typename?: 'AcfBenefitslist', name?: string | null, benefitsList?: { __typename?: 'BenefitsList', sectionId?: string | null, title?: string | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, benefits?: Array<{ __typename?: 'BenefitsListBenefits', title?: string | null, description?: string | null } | null> | null, disclaimers?: Array<{ __typename?: 'BenefitsListDisclaimers', text?: string | null } | null> | null } | null };

export type GetArticleTotalsQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetArticleTotalsQuery = { __typename?: 'RootQuery', posts?: { __typename?: 'RootQueryToPostConnection', pageInfo: { __typename?: 'RootQueryToPostConnectionPageInfo', total?: number | null } } | null };

export type GetArticlesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
  notIn?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetArticlesQuery = { __typename?: 'RootQuery', posts?: { __typename?: 'RootQueryToPostConnection', nodes: Array<{ __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null }>, pageInfo: { __typename?: 'RootQueryToPostConnectionPageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, total?: number | null } } | null };

export type FeaturedArticlesFragmentFragment = { __typename?: 'BlogArticlesFeaturedArticles', articles?: Array<{ __typename?: 'BlogArticlesFeaturedArticlesArticles', article?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null, category?: { __typename?: 'AcfTermNodeConnection', edges: Array<{ __typename?: 'AcfTermNodeConnectionEdge', node: { __typename?: 'Category', databaseId: number, name?: string | null } | { __typename?: 'PostFormat', databaseId: number, name?: string | null } | { __typename?: 'Tag', databaseId: number, name?: string | null } }> } | null };

export type BlogArticlesFragmentFragment = { __typename?: 'AcfBlogarticles', name?: string | null, blogArticles?: { __typename?: 'BlogArticles', sectionId?: string | null, featuredArticles?: Array<{ __typename?: 'BlogArticlesFeaturedArticles', articles?: Array<{ __typename?: 'BlogArticlesFeaturedArticlesArticles', article?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null, category?: { __typename?: 'AcfTermNodeConnection', edges: Array<{ __typename?: 'AcfTermNodeConnectionEdge', node: { __typename?: 'Category', databaseId: number, name?: string | null } | { __typename?: 'PostFormat', databaseId: number, name?: string | null } | { __typename?: 'Tag', databaseId: number, name?: string | null } }> } | null } | null> | null } | null };

export type BlogCtaCardFragmentFragment = { __typename?: 'AcfBlogctacard', name?: string | null, blogCtaCard?: { __typename?: 'BlogCtaCard', sectionId?: string | null, title?: string | null, buttonId?: string | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null };

export type CallOutTextFragmentFragment = { __typename?: 'AcfCallouttext', name?: string | null, calloutText?: { __typename?: 'CalloutText', sectionId?: string | null, title?: string | null, text?: string | null } | null };

export type CardContentFragmentFragment = { __typename?: 'CardGridCardsCard', elementType?: Array<string | null> | null, title?: string | null, buttonColor?: string | null, buttonId?: string | null, paragraph?: string | null, heading?: string | null, disclaimer?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, imageData?: { __typename?: 'CardGridCardsCardImageData', alignment?: string | null, caption?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null, list?: Array<{ __typename?: 'CardGridCardsCardList', item?: string | null } | null> | null };

export type CardGridFragmentFragment = { __typename?: 'AcfCardgrid', name?: string | null, cardGrid?: { __typename?: 'CardGrid', sectionId?: string | null, maxColumns?: number | null, sectionBackgroundColor?: string | null, sectionTitle?: string | null, description?: string | null, cardBackgroundColor?: string | null, cardBorder?: string | null, cards?: Array<{ __typename?: 'CardGridCards', card?: Array<{ __typename?: 'CardGridCardsCard', elementType?: Array<string | null> | null, title?: string | null, buttonColor?: string | null, buttonId?: string | null, paragraph?: string | null, heading?: string | null, disclaimer?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, imageData?: { __typename?: 'CardGridCardsCardImageData', alignment?: string | null, caption?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null, list?: Array<{ __typename?: 'CardGridCardsCardList', item?: string | null } | null> | null } | null> | null } | null> | null } | null };

export type CaseStudiesFragmentFragment = { __typename?: 'AcfCasestudies', name?: string | null, caseStudies?: { __typename?: 'CaseStudies', sectionId?: string | null, sectionTitle?: string | null, ctaText?: string | null, darkBackground?: boolean | null, items?: Array<{ __typename?: 'CaseStudiesItems', description?: string | null, post?: { __typename?: 'AcfContentNodeConnection', nodes: Array<{ __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null }> } | null } | null> | null } | null };

export type CompanyListFragmentFragment = { __typename?: 'AcfCompanylist', name?: string | null, companyList?: { __typename?: 'CompanyList', sectionId?: string | null, companies?: Array<{ __typename?: 'CompanyListCompanies', buttonId?: string | null, description?: string | null, title?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null };

export type CtaCardFragmentFragment = { __typename?: 'AcfCtacard', name?: string | null, ctaCard?: { __typename?: 'CtaCard', sectionId?: string | null, heading?: string | null, text?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, secondaryButton?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null };

export type DividerFragmentFragment = { __typename?: 'AcfDivider', name?: string | null, divider?: { __typename?: 'Divider', sectionId?: string | null, darkBackground?: boolean | null } | null };

export type FactoringInfoGraphicFragmentFragment = { __typename?: 'AcfFactoringinfographic', name?: string | null, factoringInfoGraphic?: { __typename?: 'FactoringInfoGraphic', sectionId?: string | null, title?: string | null, items?: Array<{ __typename?: 'FactoringInfoGraphicItems', description?: string | null } | null> | null } | null };

export type FinancingCtaFragmentFragment = { __typename?: 'AcfFinancingcta', name?: string | null, financingCta?: { __typename?: 'FinancingCta', sectionId?: string | null, buttonId?: string | null, title?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, keyPoints?: Array<{ __typename?: 'FinancingCtaKeyPoints', field?: string | null, value?: string | null } | null> | null } | null };

export type FormFragmentFragment = { __typename?: 'AcfForm', name?: string | null, formContentBlock?: { __typename?: 'FormContentBlock', sectionId?: string | null, title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null };

export type FuelSavingsCalculatorFragmentFragment = { __typename?: 'AcfFuelsavingscalculator', name?: string | null, fuelSavingsCalculator?: { __typename?: 'FuelSavingsCalculator', sectionId?: string | null, sectionTitle?: string | null, multiplier?: number | null, outroCopy?: string | null, marketoFormId?: string | null } | null };

export type CaptchaFieldFragmentFragment = { __typename?: 'CaptchaField', databaseId: number, pageNumber?: number | null, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null };

export type CheckboxFieldFragmentFragment = { __typename?: 'CheckboxField', description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null };

export type ConditionalLogicFragmentFragment = { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null };

export type EmailFieldFragmentFragment = { __typename?: 'EmailField', label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null };

export type HiddenFieldFragmentFragment = { __typename?: 'HiddenField', defaultValue?: string | null, databaseId: number, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

export type MultiSelectFieldFieldsFragment = { __typename?: 'MultiSelectField', label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null };

export type NumberFieldFragmentFragment = { __typename?: 'NumberField', label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null };

export type PhoneFieldFragmentFragment = { __typename?: 'PhoneField', label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null };

export type RadioFieldFragmentFragment = { __typename?: 'RadioField', isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null };

export type SelectFieldFragmentFragment = { __typename?: 'SelectField', label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null };

export type TextAreaFieldFragmentFragment = { __typename?: 'TextAreaField', label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null };

export type TextFieldFragmentFragment = { __typename?: 'TextField', autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null };

type FormFieldFragment_AddressField_Fragment = { __typename?: 'AddressField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_CaptchaField_Fragment = { __typename?: 'CaptchaField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_CheckboxField_Fragment = { __typename?: 'CheckboxField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_ConsentField_Fragment = { __typename?: 'ConsentField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_DateField_Fragment = { __typename?: 'DateField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_EmailField_Fragment = { __typename?: 'EmailField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_FileUploadField_Fragment = { __typename?: 'FileUploadField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_HiddenField_Fragment = { __typename?: 'HiddenField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_HtmlField_Fragment = { __typename?: 'HtmlField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_ImageChoiceField_Fragment = { __typename?: 'ImageChoiceField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_ListField_Fragment = { __typename?: 'ListField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_MultiChoiceField_Fragment = { __typename?: 'MultiChoiceField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_MultiSelectField_Fragment = { __typename?: 'MultiSelectField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_NameField_Fragment = { __typename?: 'NameField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_NumberField_Fragment = { __typename?: 'NumberField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_OptionCheckboxField_Fragment = { __typename?: 'OptionCheckboxField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_OptionRadioField_Fragment = { __typename?: 'OptionRadioField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_OptionSelectField_Fragment = { __typename?: 'OptionSelectField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PageField_Fragment = { __typename?: 'PageField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PasswordField_Fragment = { __typename?: 'PasswordField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PhoneField_Fragment = { __typename?: 'PhoneField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCategoryCheckboxField_Fragment = { __typename?: 'PostCategoryCheckboxField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCategoryMultiSelectField_Fragment = { __typename?: 'PostCategoryMultiSelectField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCategoryRadioField_Fragment = { __typename?: 'PostCategoryRadioField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCategorySelectField_Fragment = { __typename?: 'PostCategorySelectField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostContentField_Fragment = { __typename?: 'PostContentField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomCheckboxField_Fragment = { __typename?: 'PostCustomCheckboxField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomDateField_Fragment = { __typename?: 'PostCustomDateField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomEmailField_Fragment = { __typename?: 'PostCustomEmailField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomFileuploadField_Fragment = { __typename?: 'PostCustomFileuploadField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomHiddenField_Fragment = { __typename?: 'PostCustomHiddenField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomListField_Fragment = { __typename?: 'PostCustomListField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomMultiSelectField_Fragment = { __typename?: 'PostCustomMultiSelectField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomNumberField_Fragment = { __typename?: 'PostCustomNumberField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomPhoneField_Fragment = { __typename?: 'PostCustomPhoneField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomRadioField_Fragment = { __typename?: 'PostCustomRadioField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomSelectField_Fragment = { __typename?: 'PostCustomSelectField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomTextAreaField_Fragment = { __typename?: 'PostCustomTextAreaField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomTextField_Fragment = { __typename?: 'PostCustomTextField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomTimeField_Fragment = { __typename?: 'PostCustomTimeField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostCustomWebsiteField_Fragment = { __typename?: 'PostCustomWebsiteField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostExcerptField_Fragment = { __typename?: 'PostExcerptField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostImageField_Fragment = { __typename?: 'PostImageField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostTagsCheckboxField_Fragment = { __typename?: 'PostTagsCheckboxField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostTagsMultiSelectField_Fragment = { __typename?: 'PostTagsMultiSelectField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostTagsRadioField_Fragment = { __typename?: 'PostTagsRadioField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostTagsSelectField_Fragment = { __typename?: 'PostTagsSelectField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostTagsTextField_Fragment = { __typename?: 'PostTagsTextField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_PostTitleField_Fragment = { __typename?: 'PostTitleField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_ProductCalculationField_Fragment = { __typename?: 'ProductCalculationField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_ProductHiddenField_Fragment = { __typename?: 'ProductHiddenField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_ProductPriceField_Fragment = { __typename?: 'ProductPriceField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_ProductRadioField_Fragment = { __typename?: 'ProductRadioField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_ProductSelectField_Fragment = { __typename?: 'ProductSelectField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_ProductSingleField_Fragment = { __typename?: 'ProductSingleField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_QuantityHiddenField_Fragment = { __typename?: 'QuantityHiddenField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_QuantityNumberField_Fragment = { __typename?: 'QuantityNumberField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_QuantitySelectField_Fragment = { __typename?: 'QuantitySelectField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_RadioField_Fragment = { __typename?: 'RadioField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_SectionField_Fragment = { __typename?: 'SectionField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_SelectField_Fragment = { __typename?: 'SelectField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_ShippingRadioField_Fragment = { __typename?: 'ShippingRadioField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_ShippingSelectField_Fragment = { __typename?: 'ShippingSelectField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_ShippingSingleField_Fragment = { __typename?: 'ShippingSingleField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_TextAreaField_Fragment = { __typename?: 'TextAreaField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_TextField_Fragment = { __typename?: 'TextField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_TimeField_Fragment = { __typename?: 'TimeField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_TotalField_Fragment = { __typename?: 'TotalField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

type FormFieldFragment_WebsiteField_Fragment = { __typename?: 'WebsiteField', databaseId: number, id: string, layoutGridColumnSpan?: number | null, type?: FormFieldTypeEnum | null };

export type FormFieldFragmentFragment = FormFieldFragment_AddressField_Fragment | FormFieldFragment_CaptchaField_Fragment | FormFieldFragment_CheckboxField_Fragment | FormFieldFragment_ConsentField_Fragment | FormFieldFragment_DateField_Fragment | FormFieldFragment_EmailField_Fragment | FormFieldFragment_FileUploadField_Fragment | FormFieldFragment_HiddenField_Fragment | FormFieldFragment_HtmlField_Fragment | FormFieldFragment_ImageChoiceField_Fragment | FormFieldFragment_ListField_Fragment | FormFieldFragment_MultiChoiceField_Fragment | FormFieldFragment_MultiSelectField_Fragment | FormFieldFragment_NameField_Fragment | FormFieldFragment_NumberField_Fragment | FormFieldFragment_OptionCheckboxField_Fragment | FormFieldFragment_OptionRadioField_Fragment | FormFieldFragment_OptionSelectField_Fragment | FormFieldFragment_PageField_Fragment | FormFieldFragment_PasswordField_Fragment | FormFieldFragment_PhoneField_Fragment | FormFieldFragment_PostCategoryCheckboxField_Fragment | FormFieldFragment_PostCategoryMultiSelectField_Fragment | FormFieldFragment_PostCategoryRadioField_Fragment | FormFieldFragment_PostCategorySelectField_Fragment | FormFieldFragment_PostContentField_Fragment | FormFieldFragment_PostCustomCheckboxField_Fragment | FormFieldFragment_PostCustomDateField_Fragment | FormFieldFragment_PostCustomEmailField_Fragment | FormFieldFragment_PostCustomFileuploadField_Fragment | FormFieldFragment_PostCustomHiddenField_Fragment | FormFieldFragment_PostCustomListField_Fragment | FormFieldFragment_PostCustomMultiSelectField_Fragment | FormFieldFragment_PostCustomNumberField_Fragment | FormFieldFragment_PostCustomPhoneField_Fragment | FormFieldFragment_PostCustomRadioField_Fragment | FormFieldFragment_PostCustomSelectField_Fragment | FormFieldFragment_PostCustomTextAreaField_Fragment | FormFieldFragment_PostCustomTextField_Fragment | FormFieldFragment_PostCustomTimeField_Fragment | FormFieldFragment_PostCustomWebsiteField_Fragment | FormFieldFragment_PostExcerptField_Fragment | FormFieldFragment_PostImageField_Fragment | FormFieldFragment_PostTagsCheckboxField_Fragment | FormFieldFragment_PostTagsMultiSelectField_Fragment | FormFieldFragment_PostTagsRadioField_Fragment | FormFieldFragment_PostTagsSelectField_Fragment | FormFieldFragment_PostTagsTextField_Fragment | FormFieldFragment_PostTitleField_Fragment | FormFieldFragment_ProductCalculationField_Fragment | FormFieldFragment_ProductHiddenField_Fragment | FormFieldFragment_ProductPriceField_Fragment | FormFieldFragment_ProductRadioField_Fragment | FormFieldFragment_ProductSelectField_Fragment | FormFieldFragment_ProductSingleField_Fragment | FormFieldFragment_QuantityHiddenField_Fragment | FormFieldFragment_QuantityNumberField_Fragment | FormFieldFragment_QuantitySelectField_Fragment | FormFieldFragment_RadioField_Fragment | FormFieldFragment_SectionField_Fragment | FormFieldFragment_SelectField_Fragment | FormFieldFragment_ShippingRadioField_Fragment | FormFieldFragment_ShippingSelectField_Fragment | FormFieldFragment_ShippingSingleField_Fragment | FormFieldFragment_TextAreaField_Fragment | FormFieldFragment_TextField_Fragment | FormFieldFragment_TimeField_Fragment | FormFieldFragment_TotalField_Fragment | FormFieldFragment_WebsiteField_Fragment;

export type GravityFormsFragmentFragment = { __typename?: 'GravityformsForm', name?: string | null, attributes?: { __typename?: 'GravityformsFormAttributes', form?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null };

export type SubmitFormMutationVariables = Exact<{
  formId: Scalars['ID']['input'];
  fieldValues: Array<InputMaybe<FormFieldValuesInput>> | InputMaybe<FormFieldValuesInput>;
}>;


export type SubmitFormMutation = { __typename?: 'RootMutation', submitGfForm?: { __typename?: 'SubmitGfFormPayload', confirmation?: { __typename?: 'SubmissionConfirmation', message?: string | null, type?: SubmissionConfirmationTypeEnum | null, url?: string | null } | null, entry?: { __typename?: 'GfDraftEntry', id: string, isSubmitted?: boolean | null } | { __typename?: 'GfSubmittedEntry', id: string, isSubmitted?: boolean | null } | null, errors?: Array<{ __typename?: 'FieldError', id?: number | null, message?: string | null } | null> | null } | null };

export type HeroBannerContentFragmentFragment = { __typename?: 'HeroBannerContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerContentWysiwyg', wysiwyg?: string | null } | null };

export type HeroBannerFragmentFragment = { __typename?: 'AcfHerobanner', name?: string | null, heroBanner?: { __typename?: 'HeroBanner', sectionId?: string | null, title?: string | null, subtitle?: string | null, includeForm?: boolean | null, rightContentType?: Array<string | null> | null, videoUrl?: string | null, content?: Array<{ __typename?: 'HeroBannerContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerContentWysiwyg', wysiwyg?: string | null } | null } | null> | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null };

export type HeroBannerWithFormContentFragmentFragment = { __typename?: 'HeroBannerWithFormContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerWithFormContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerWithFormContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerWithFormContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerWithFormContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerWithFormContentWysiwyg', wysiwyg?: string | null } | null };

export type HeroBannerWithFormFormFragmentFragment = { __typename?: 'HeroBannerWithFormForm', title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null };

export type HeroBannerWithFormFragmentFragment = { __typename?: 'AcfHerobannerwithform', name?: string | null, heroBannerWithForm?: { __typename?: 'HeroBannerWithForm', sectionId?: string | null, title?: string | null, subtitle?: string | null, content?: Array<{ __typename?: 'HeroBannerWithFormContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerWithFormContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerWithFormContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerWithFormContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerWithFormContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerWithFormContentWysiwyg', wysiwyg?: string | null } | null } | null> | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, form?: { __typename?: 'HeroBannerWithFormForm', title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | null };

export type HighlightContentFragmentFragment = { __typename?: 'HighlightContent', type?: string | null, paragraph?: { __typename?: 'HighlightContentParagraph', text?: string | null } | null, list?: { __typename?: 'HighlightContentList', heading?: string | null, items?: Array<{ __typename?: 'HighlightContentListItems', text?: string | null } | null> | null } | null };

export type HighlightFragmentFragment = { __typename?: 'AcfHighlight', name?: string | null, highlight?: { __typename?: 'Highlight', sectionId?: string | null, title?: string | null, subtitle?: string | null, imagePlacement?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, content?: Array<{ __typename?: 'HighlightContent', type?: string | null, paragraph?: { __typename?: 'HighlightContentParagraph', text?: string | null } | null, list?: { __typename?: 'HighlightContentList', heading?: string | null, items?: Array<{ __typename?: 'HighlightContentListItems', text?: string | null } | null> | null } | null } | null> | null } | null };

export type LogoRowsFragmentFragment = { __typename?: 'AcfLogorows', name?: string | null, logoRows?: { __typename?: 'LogoRows', sectionId?: string | null, title?: string | null, darkBackground?: boolean | null, logos?: Array<{ __typename?: 'LogoRowsLogos', maxWidth?: number | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null };

export type LogoScrollFragmentFragment = { __typename?: 'AcfLogoscroll', name?: string | null, logoScroll?: { __typename?: 'LogoScroll', sectionId?: string | null, title?: string | null, logoImages?: Array<{ __typename?: 'LogoScrollLogoImages', companyUrl?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null };

export type MainHeroFragmentFragment = { __typename?: 'AcfMainhero', name?: string | null, mainHero?: { __typename?: 'MainHero', sectionId?: string | null, title?: string | null, subtitle?: string | null, description?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null };

export type NewsAndInsightsFragmentFragment = { __typename?: 'AcfNewsandinsights', name?: string | null, newsAndInsights?: { __typename?: 'NewsAndInsights', sectionId?: string | null, articleLinkText?: string | null, title?: string | null, articles?: Array<{ __typename?: 'NewsAndInsightsArticles', articles?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null } | null };

export type NewsletterSignupFragmentFragment = { __typename?: 'AcfNewslettersignup', name?: string | null, newsletterSignup?: { __typename?: 'NewsletterSignup', sectionId?: string | null, title?: string | null, description?: string | null, darkBackground?: boolean | null, marketoFormId?: string | null, successMessage?: string | null, successUrl?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null };

export type OurHistoryTimelineFragmentFragment = { __typename?: 'OurHistoryTimeline', year?: number | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, keyPoints?: Array<{ __typename?: 'OurHistoryTimelineKeyPoints', field?: string | null, value?: string | null } | null> | null };

export type OurHistoryFragmentFragment = { __typename?: 'AcfOurhistory', name?: string | null, ourHistory?: { __typename?: 'OurHistory', sectionId?: string | null, title?: string | null, timeline?: Array<{ __typename?: 'OurHistoryTimeline', year?: number | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, keyPoints?: Array<{ __typename?: 'OurHistoryTimelineKeyPoints', field?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type PartnersFragmentFragment = { __typename?: 'AcfPartners', name?: string | null, partners?: { __typename?: 'Partners', sectionId?: string | null, title?: string | null, description?: string | null, partners?: Array<{ __typename?: 'PartnersPartners', title?: string | null, description?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null };

export type SolutionsFragmentFragment = { __typename?: 'AcfSolutions', name?: string | null, solutions?: { __typename?: 'Solutions', sectionId?: string | null, title?: string | null, description?: string | null, solutions?: Array<{ __typename?: 'SolutionsSolutions', buttonId?: string | null, title?: string | null, description?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null };

export type SolutionsCardsFragmentFragment = { __typename?: 'AcfSolutionscards', name?: string | null, solutionsCards?: { __typename?: 'SolutionsCards', sectionId?: string | null, title?: string | null, description?: string | null, cards?: Array<{ __typename?: 'SolutionsCardsCards', description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null };

export type TeamMemberFragmentFragment = { __typename?: 'TeamMembersMembers', name?: string | null, bio?: string | null, bioCtaText?: string | null, ctaId?: string | null, jobTitle?: string | null, jobTitleInDialog?: string | null, headshot?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null };

export type TeamMembersFragmentFragment = { __typename?: 'AcfTeammembers', name?: string | null, teamMembers?: { __typename?: 'TeamMembers', sectionId?: string | null, members?: Array<{ __typename?: 'TeamMembersMembers', name?: string | null, bio?: string | null, bioCtaText?: string | null, ctaId?: string | null, jobTitle?: string | null, jobTitleInDialog?: string | null, headshot?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null };

export type TestimonialFragmentFragment = { __typename?: 'AcfTestimonials', name?: string | null, testimonials?: { __typename?: 'Testimonials', sectionId?: string | null, darkBackground?: boolean | null, title?: string | null, testimonials?: Array<{ __typename?: 'TestimonialsTestimonials', author?: string | null, quote?: string | null, authorImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null };

export type TextContentFragmentFragment = { __typename?: 'AcfTextcontent', name?: string | null, wsywig?: { __typename?: 'Wsywig', externalLinkModal?: boolean | null, darkBackground?: boolean | null, sectionId?: string | null, textContent?: string | null, modal?: { __typename?: 'WsywigModal', buttonText?: string | null, description?: string | null, title?: string | null } | null } | null };

export type TextHeaderFragmentFragment = { __typename?: 'AcfTextheader', name?: string | null, textHeader?: { __typename?: 'TextHeader', sectionId?: string | null, title?: string | null, description?: string | null, withGradientText?: boolean | null } | null };

export type ThriveFragmentFragment = { __typename?: 'AcfThrive', name?: string | null, thrive?: { __typename?: 'Thrive', sectionId?: string | null, title?: string | null, description?: string | null, descriptionFooter?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null };

export type TwoColumnCtaFragmentFragment = { __typename?: 'AcfTwocolumncta', name?: string | null, twoColumnCta?: { __typename?: 'TwoColumnCta', sectionId?: string | null, buttonId?: string | null, title?: string | null, subtitle?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null };

export type TwoColumnPromoContentFragmentFragment = { __typename?: 'TwoColumnPromoContent', type?: string | null, paragraph?: { __typename?: 'TwoColumnPromoContentParagraph', bold?: boolean | null, largeFontSize?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'TwoColumnPromoContentList', heading?: string | null, items?: Array<{ __typename?: 'TwoColumnPromoContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'TwoColumnPromoContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null };

export type TwoColumnPromoFragmentFragment = { __typename?: 'AcfTwocolumnpromo', name?: string | null, twoColumnPromo?: { __typename?: 'TwoColumnPromo', sectionId?: string | null, title?: string | null, columnWidths?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, content?: Array<{ __typename?: 'TwoColumnPromoContent', type?: string | null, paragraph?: { __typename?: 'TwoColumnPromoContentParagraph', bold?: boolean | null, largeFontSize?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'TwoColumnPromoContentList', heading?: string | null, items?: Array<{ __typename?: 'TwoColumnPromoContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'TwoColumnPromoContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | null> | null } | null };

export type VideoFragmentFragment = { __typename?: 'AcfVideo', name?: string | null, video?: { __typename?: 'Video', sectionId?: string | null, url?: string | null } | null };

export type FooterMenuFragmentFragment = { __typename?: 'Menu', blockFooter?: { __typename?: 'BlockFooter', phone?: number | null, footerDisclosure?: string | null, footerAddress?: string | null, footerLogo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } } | null, socialMediaIcons?: Array<{ __typename?: 'BlockFooterSocialMediaIcons', socialMediaUrl?: string | null, iconImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } } | null } | null> | null } | null, menuItems?: { __typename?: 'MenuToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, parentId?: string | null }> } | null };

export type FooterMenuItemFragmentFragment = { __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, parentId?: string | null };

export type HeaderLogoFragmentFragment = { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null };

export type HeaderMenuItemFragmentFragment = { __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, navDetails?: { __typename?: 'NavDetails', description?: string | null, link?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, navSegments?: { __typename?: 'NavSegments', segments?: Array<{ __typename?: 'NavSegmentsSegments', title?: string | null, links?: Array<{ __typename?: 'NavSegmentsSegmentsLinks', link?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null> | null } | null };

export type MenuButtonFragmentFragment = { __typename?: 'Menu', menuButton?: { __typename?: 'MenuButton', menubutton?: Array<{ __typename?: 'MenuButtonMenubutton', menubuttonlink?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null };

export type SystemAlertFragmentFragment = { __typename?: 'Menu', systemAlert?: { __typename?: 'SystemAlert', alertId?: string | null, message?: string | null, start?: string | null, end?: string | null } | null };

export type LayoutFragmentFragment = { __typename?: 'RootQuery', footerMenus?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', blockFooter?: { __typename?: 'BlockFooter', phone?: number | null, footerDisclosure?: string | null, footerAddress?: string | null, footerLogo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } } | null, socialMediaIcons?: Array<{ __typename?: 'BlockFooterSocialMediaIcons', socialMediaUrl?: string | null, iconImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } } | null } | null> | null } | null, menuItems?: { __typename?: 'MenuToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, parentId?: string | null }> } | null }> } | null, generalSettings?: { __typename?: 'GeneralSettings', title?: string | null } | null, headerLogo?: { __typename?: 'RootQueryToMediaItemConnection', nodes: Array<{ __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null }> } | null, headerMenuItems?: { __typename?: 'RootQueryToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, navDetails?: { __typename?: 'NavDetails', description?: string | null, link?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, navSegments?: { __typename?: 'NavSegments', segments?: Array<{ __typename?: 'NavSegmentsSegments', title?: string | null, links?: Array<{ __typename?: 'NavSegmentsSegmentsLinks', link?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null> | null } | null }> } | null, menuButton?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', menuButton?: { __typename?: 'MenuButton', menubutton?: Array<{ __typename?: 'MenuButtonMenubutton', menubuttonlink?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null }> } | null, systemAlert?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', systemAlert?: { __typename?: 'SystemAlert', alertId?: string | null, message?: string | null, start?: string | null, end?: string | null } | null }> } | null, uTMConfiguration?: { __typename?: 'UTMConfiguration', utmConfigurationBlock?: { __typename?: 'UtmConfigurationBlock', utmQueryParams?: Array<{ __typename?: 'UtmConfigurationBlockUtmQueryParams', queryParam?: string | null } | null> | null } | null } | null };

export type GetNotFoundQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotFoundQuery = { __typename?: 'RootQuery', nodeByUri?: { __typename: 'Category' } | { __typename: 'Comment' } | { __typename: 'ContentType' } | { __typename: 'MediaItem' } | { __typename: 'Page', title?: string | null, content?: string | null, id: string, seo?: { __typename?: 'PostTypeSEO', canonical?: string | null, focuskw?: string | null, metaDesc?: string | null, metaKeywords?: string | null, metaRobotsNofollow?: string | null, metaRobotsNoindex?: string | null, opengraphAuthor?: string | null, opengraphDescription?: string | null, opengraphModifiedTime?: string | null, opengraphPublishedTime?: string | null, opengraphPublisher?: string | null, opengraphSiteName?: string | null, opengraphTitle?: string | null, opengraphType?: string | null, opengraphUrl?: string | null, readingTime?: number | null, title?: string | null, twitterDescription?: string | null, twitterTitle?: string | null, opengraphImage?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null } | null } | null, twitterImage?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', width?: number | null, height?: number | null } | null } | null } | null, editorBlocks?: Array<{ __typename?: 'AcfAccordion', name?: string | null, accordion?: { __typename?: 'Accordion', sectionId?: string | null, darkBackground?: boolean | null, description?: string | null, iconType?: Array<string | null> | null, title?: string | null, withAbbreviations?: boolean | null, withLargeItemTitle?: boolean | null, items?: Array<{ __typename?: 'AccordionItems', title?: string | null, content?: string | null } | null> | null } | null } | { __typename?: 'AcfArticlecards', name?: string | null } | { __typename?: 'AcfBenefits', name?: string | null, benefits?: { __typename?: 'Benefits', sectionId?: string | null, sectionDescription?: string | null, benefitCards?: Array<{ __typename?: 'BenefitsBenefitCards', buttonId?: string | null, title?: string | null, description?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, cardImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfBenefitsaccordion', name?: string | null, benefitsAccordion?: { __typename?: 'BenefitsAccordion', sectionId?: string | null, title?: string | null, subtitle?: string | null, accordionItems?: Array<{ __typename?: 'BenefitsAccordionAccordionItems', description?: string | null, accordionImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, links?: Array<{ __typename?: 'BenefitsAccordionAccordionItemsLinks', linkId?: string | null, link?: { __typename?: 'AcfLink', url?: string | null, title?: string | null } | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfBenefitscontent', name?: string | null, benefitscontent?: { __typename?: 'Benefitscontent', sectionId?: string | null, title?: string | null, textContent?: string | null, textContentVerticalAlignment?: Array<string | null> | null, media?: { __typename?: 'BenefitscontentMedia', type?: string | null, video?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | null } | { __typename?: 'AcfBenefitslist', name?: string | null, benefitsList?: { __typename?: 'BenefitsList', sectionId?: string | null, title?: string | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, benefits?: Array<{ __typename?: 'BenefitsListBenefits', title?: string | null, description?: string | null } | null> | null, disclaimers?: Array<{ __typename?: 'BenefitsListDisclaimers', text?: string | null } | null> | null } | null } | { __typename?: 'AcfBlogarticles', name?: string | null, blogArticles?: { __typename?: 'BlogArticles', sectionId?: string | null, featuredArticles?: Array<{ __typename?: 'BlogArticlesFeaturedArticles', articles?: Array<{ __typename?: 'BlogArticlesFeaturedArticlesArticles', article?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null, category?: { __typename?: 'AcfTermNodeConnection', edges: Array<{ __typename?: 'AcfTermNodeConnectionEdge', node: { __typename?: 'Category', databaseId: number, name?: string | null } | { __typename?: 'PostFormat', databaseId: number, name?: string | null } | { __typename?: 'Tag', databaseId: number, name?: string | null } }> } | null } | null> | null } | null } | { __typename?: 'AcfBlogctacard', name?: string | null, blogCtaCard?: { __typename?: 'BlogCtaCard', sectionId?: string | null, title?: string | null, buttonId?: string | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | { __typename?: 'AcfCallouttext', name?: string | null, calloutText?: { __typename?: 'CalloutText', sectionId?: string | null, title?: string | null, text?: string | null } | null } | { __typename?: 'AcfCardgrid', name?: string | null, cardGrid?: { __typename?: 'CardGrid', sectionId?: string | null, maxColumns?: number | null, sectionBackgroundColor?: string | null, sectionTitle?: string | null, description?: string | null, cardBackgroundColor?: string | null, cardBorder?: string | null, cards?: Array<{ __typename?: 'CardGridCards', card?: Array<{ __typename?: 'CardGridCardsCard', elementType?: Array<string | null> | null, title?: string | null, buttonColor?: string | null, buttonId?: string | null, paragraph?: string | null, heading?: string | null, disclaimer?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, imageData?: { __typename?: 'CardGridCardsCardImageData', alignment?: string | null, caption?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null, list?: Array<{ __typename?: 'CardGridCardsCardList', item?: string | null } | null> | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfCasestudies', name?: string | null, caseStudies?: { __typename?: 'CaseStudies', sectionId?: string | null, sectionTitle?: string | null, ctaText?: string | null, darkBackground?: boolean | null, items?: Array<{ __typename?: 'CaseStudiesItems', description?: string | null, post?: { __typename?: 'AcfContentNodeConnection', nodes: Array<{ __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null }> } | null } | null> | null } | null } | { __typename?: 'AcfCompanylist', name?: string | null, companyList?: { __typename?: 'CompanyList', sectionId?: string | null, companies?: Array<{ __typename?: 'CompanyListCompanies', buttonId?: string | null, description?: string | null, title?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfCorevalues', name?: string | null } | { __typename?: 'AcfCtacard', name?: string | null, ctaCard?: { __typename?: 'CtaCard', sectionId?: string | null, heading?: string | null, text?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, secondaryButton?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | { __typename?: 'AcfDivider', name?: string | null, divider?: { __typename?: 'Divider', sectionId?: string | null, darkBackground?: boolean | null } | null } | { __typename?: 'AcfFactoringinfographic', name?: string | null, factoringInfoGraphic?: { __typename?: 'FactoringInfoGraphic', sectionId?: string | null, title?: string | null, items?: Array<{ __typename?: 'FactoringInfoGraphicItems', description?: string | null } | null> | null } | null } | { __typename?: 'AcfFinancingcta', name?: string | null, financingCta?: { __typename?: 'FinancingCta', sectionId?: string | null, buttonId?: string | null, title?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, keyPoints?: Array<{ __typename?: 'FinancingCtaKeyPoints', field?: string | null, value?: string | null } | null> | null } | null } | { __typename?: 'AcfForm', name?: string | null, formContentBlock?: { __typename?: 'FormContentBlock', sectionId?: string | null, title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | { __typename?: 'AcfFuelsavingscalculator', name?: string | null, fuelSavingsCalculator?: { __typename?: 'FuelSavingsCalculator', sectionId?: string | null, sectionTitle?: string | null, multiplier?: number | null, outroCopy?: string | null, marketoFormId?: string | null } | null } | { __typename?: 'AcfHerobanner', name?: string | null, heroBanner?: { __typename?: 'HeroBanner', sectionId?: string | null, title?: string | null, subtitle?: string | null, includeForm?: boolean | null, rightContentType?: Array<string | null> | null, videoUrl?: string | null, content?: Array<{ __typename?: 'HeroBannerContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerContentWysiwyg', wysiwyg?: string | null } | null } | null> | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfHerobannerwithform', name?: string | null, heroBannerWithForm?: { __typename?: 'HeroBannerWithForm', sectionId?: string | null, title?: string | null, subtitle?: string | null, content?: Array<{ __typename?: 'HeroBannerWithFormContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerWithFormContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerWithFormContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerWithFormContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerWithFormContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerWithFormContentWysiwyg', wysiwyg?: string | null } | null } | null> | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, form?: { __typename?: 'HeroBannerWithFormForm', title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | null } | { __typename?: 'AcfHighlight', name?: string | null, highlight?: { __typename?: 'Highlight', sectionId?: string | null, title?: string | null, subtitle?: string | null, imagePlacement?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, content?: Array<{ __typename?: 'HighlightContent', type?: string | null, paragraph?: { __typename?: 'HighlightContentParagraph', text?: string | null } | null, list?: { __typename?: 'HighlightContentList', heading?: string | null, items?: Array<{ __typename?: 'HighlightContentListItems', text?: string | null } | null> | null } | null } | null> | null } | null } | { __typename?: 'AcfLogorows', name?: string | null, logoRows?: { __typename?: 'LogoRows', sectionId?: string | null, title?: string | null, darkBackground?: boolean | null, logos?: Array<{ __typename?: 'LogoRowsLogos', maxWidth?: number | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfLogoscroll', name?: string | null, logoScroll?: { __typename?: 'LogoScroll', sectionId?: string | null, title?: string | null, logoImages?: Array<{ __typename?: 'LogoScrollLogoImages', companyUrl?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfMainhero', name?: string | null, mainHero?: { __typename?: 'MainHero', sectionId?: string | null, title?: string | null, subtitle?: string | null, description?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfModal', name?: string | null } | { __typename?: 'AcfNewsandinsights', name?: string | null, newsAndInsights?: { __typename?: 'NewsAndInsights', sectionId?: string | null, articleLinkText?: string | null, title?: string | null, articles?: Array<{ __typename?: 'NewsAndInsightsArticles', articles?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null } | null } | { __typename?: 'AcfNewslettersignup', name?: string | null, newsletterSignup?: { __typename?: 'NewsletterSignup', sectionId?: string | null, title?: string | null, description?: string | null, darkBackground?: boolean | null, marketoFormId?: string | null, successMessage?: string | null, successUrl?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfOurhistory', name?: string | null, ourHistory?: { __typename?: 'OurHistory', sectionId?: string | null, title?: string | null, timeline?: Array<{ __typename?: 'OurHistoryTimeline', year?: number | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, keyPoints?: Array<{ __typename?: 'OurHistoryTimelineKeyPoints', field?: string | null, value?: string | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfPartners', name?: string | null, partners?: { __typename?: 'Partners', sectionId?: string | null, title?: string | null, description?: string | null, partners?: Array<{ __typename?: 'PartnersPartners', title?: string | null, description?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfSolutions', name?: string | null, solutions?: { __typename?: 'Solutions', sectionId?: string | null, title?: string | null, description?: string | null, solutions?: Array<{ __typename?: 'SolutionsSolutions', buttonId?: string | null, title?: string | null, description?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null } | { __typename?: 'AcfSolutionscards', name?: string | null, solutionsCards?: { __typename?: 'SolutionsCards', sectionId?: string | null, title?: string | null, description?: string | null, cards?: Array<{ __typename?: 'SolutionsCardsCards', description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTeammembers', name?: string | null, teamMembers?: { __typename?: 'TeamMembers', sectionId?: string | null, members?: Array<{ __typename?: 'TeamMembersMembers', name?: string | null, bio?: string | null, bioCtaText?: string | null, ctaId?: string | null, jobTitle?: string | null, jobTitleInDialog?: string | null, headshot?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTestimonials', name?: string | null, testimonials?: { __typename?: 'Testimonials', sectionId?: string | null, darkBackground?: boolean | null, title?: string | null, testimonials?: Array<{ __typename?: 'TestimonialsTestimonials', author?: string | null, quote?: string | null, authorImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTextcontent', name?: string | null, wsywig?: { __typename?: 'Wsywig', externalLinkModal?: boolean | null, darkBackground?: boolean | null, sectionId?: string | null, textContent?: string | null, modal?: { __typename?: 'WsywigModal', buttonText?: string | null, description?: string | null, title?: string | null } | null } | null } | { __typename?: 'AcfTextheader', name?: string | null, textHeader?: { __typename?: 'TextHeader', sectionId?: string | null, title?: string | null, description?: string | null, withGradientText?: boolean | null } | null } | { __typename?: 'AcfThrive', name?: string | null, thrive?: { __typename?: 'Thrive', sectionId?: string | null, title?: string | null, description?: string | null, descriptionFooter?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfTwocolumncta', name?: string | null, twoColumnCta?: { __typename?: 'TwoColumnCta', sectionId?: string | null, buttonId?: string | null, title?: string | null, subtitle?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfTwocolumnpromo', name?: string | null, twoColumnPromo?: { __typename?: 'TwoColumnPromo', sectionId?: string | null, title?: string | null, columnWidths?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, content?: Array<{ __typename?: 'TwoColumnPromoContent', type?: string | null, paragraph?: { __typename?: 'TwoColumnPromoContentParagraph', bold?: boolean | null, largeFontSize?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'TwoColumnPromoContentList', heading?: string | null, items?: Array<{ __typename?: 'TwoColumnPromoContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'TwoColumnPromoContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | null> | null } | null } | { __typename?: 'AcfVideo', name?: string | null, video?: { __typename?: 'Video', sectionId?: string | null, url?: string | null } | null } | { __typename?: 'CoreArchives', name?: string | null } | { __typename?: 'CoreAudio', name?: string | null } | { __typename?: 'CoreAvatar', name?: string | null } | { __typename?: 'CoreBlock', name?: string | null } | { __typename?: 'CoreButton', name?: string | null } | { __typename?: 'CoreButtons', name?: string | null } | { __typename?: 'CoreCalendar', name?: string | null } | { __typename?: 'CoreCategories', name?: string | null } | { __typename?: 'CoreCode', name?: string | null } | { __typename?: 'CoreColumn', name?: string | null } | { __typename?: 'CoreColumns', name?: string | null } | { __typename?: 'CoreCommentAuthorName', name?: string | null } | { __typename?: 'CoreCommentContent', name?: string | null } | { __typename?: 'CoreCommentDate', name?: string | null } | { __typename?: 'CoreCommentEditLink', name?: string | null } | { __typename?: 'CoreCommentReplyLink', name?: string | null } | { __typename?: 'CoreCommentTemplate', name?: string | null } | { __typename?: 'CoreComments', name?: string | null } | { __typename?: 'CoreCommentsPagination', name?: string | null } | { __typename?: 'CoreCommentsPaginationNext', name?: string | null } | { __typename?: 'CoreCommentsPaginationNumbers', name?: string | null } | { __typename?: 'CoreCommentsPaginationPrevious', name?: string | null } | { __typename?: 'CoreCommentsTitle', name?: string | null } | { __typename?: 'CoreCover', name?: string | null } | { __typename?: 'CoreDetails', name?: string | null } | { __typename?: 'CoreEmbed', name?: string | null } | { __typename?: 'CoreFile', name?: string | null } | { __typename?: 'CoreFootnotes', name?: string | null } | { __typename?: 'CoreFreeform', name?: string | null } | { __typename?: 'CoreGallery', name?: string | null } | { __typename?: 'CoreGroup', name?: string | null } | { __typename?: 'CoreHeading', name?: string | null } | { __typename?: 'CoreHomeLink', name?: string | null } | { __typename?: 'CoreHtml', name?: string | null } | { __typename?: 'CoreImage', name?: string | null } | { __typename?: 'CoreLatestComments', name?: string | null } | { __typename?: 'CoreLatestPosts', name?: string | null } | { __typename?: 'CoreLegacyWidget', name?: string | null } | { __typename?: 'CoreList', name?: string | null } | { __typename?: 'CoreListItem', name?: string | null } | { __typename?: 'CoreLoginout', name?: string | null } | { __typename?: 'CoreMediaText', name?: string | null } | { __typename?: 'CoreMissing', name?: string | null } | { __typename?: 'CoreMore', name?: string | null } | { __typename?: 'CoreNavigation', name?: string | null } | { __typename?: 'CoreNavigationLink', name?: string | null } | { __typename?: 'CoreNavigationSubmenu', name?: string | null } | { __typename?: 'CoreNextpage', name?: string | null } | { __typename?: 'CorePageList', name?: string | null } | { __typename?: 'CorePageListItem', name?: string | null } | { __typename?: 'CoreParagraph', name?: string | null } | { __typename?: 'CorePattern', name?: string | null } | { __typename?: 'CorePostAuthor', name?: string | null } | { __typename?: 'CorePostAuthorBiography', name?: string | null } | { __typename?: 'CorePostAuthorName', name?: string | null } | { __typename?: 'CorePostComments', name?: string | null } | { __typename?: 'CorePostCommentsForm', name?: string | null } | { __typename?: 'CorePostContent', name?: string | null } | { __typename?: 'CorePostDate', name?: string | null } | { __typename?: 'CorePostExcerpt', name?: string | null } | { __typename?: 'CorePostFeaturedImage', name?: string | null } | { __typename?: 'CorePostNavigationLink', name?: string | null } | { __typename?: 'CorePostTemplate', name?: string | null } | { __typename?: 'CorePostTerms', name?: string | null } | { __typename?: 'CorePostTitle', name?: string | null } | { __typename?: 'CorePreformatted', name?: string | null } | { __typename?: 'CorePullquote', name?: string | null } | { __typename?: 'CoreQuery', name?: string | null } | { __typename?: 'CoreQueryNoResults', name?: string | null } | { __typename?: 'CoreQueryPagination', name?: string | null } | { __typename?: 'CoreQueryPaginationNext', name?: string | null } | { __typename?: 'CoreQueryPaginationNumbers', name?: string | null } | { __typename?: 'CoreQueryPaginationPrevious', name?: string | null } | { __typename?: 'CoreQueryTitle', name?: string | null } | { __typename?: 'CoreQueryTotal', name?: string | null } | { __typename?: 'CoreQuote', name?: string | null } | { __typename?: 'CoreReadMore', name?: string | null } | { __typename?: 'CoreRss', name?: string | null } | { __typename?: 'CoreSearch', name?: string | null } | { __typename?: 'CoreSeparator', name?: string | null } | { __typename?: 'CoreShortcode', name?: string | null } | { __typename?: 'CoreSiteLogo', name?: string | null } | { __typename?: 'CoreSiteTagline', name?: string | null } | { __typename?: 'CoreSiteTitle', name?: string | null } | { __typename?: 'CoreSocialLink', name?: string | null } | { __typename?: 'CoreSocialLinks', name?: string | null } | { __typename?: 'CoreSpacer', name?: string | null } | { __typename?: 'CoreTable', name?: string | null } | { __typename?: 'CoreTagCloud', name?: string | null } | { __typename?: 'CoreTemplatePart', name?: string | null } | { __typename?: 'CoreTermDescription', name?: string | null } | { __typename?: 'CoreTextColumns', name?: string | null } | { __typename?: 'CoreVerse', name?: string | null } | { __typename?: 'CoreVideo', name?: string | null } | { __typename?: 'CoreWidgetGroup', name?: string | null } | { __typename?: 'GravityformsForm', name?: string | null, attributes?: { __typename?: 'GravityformsFormAttributes', form?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | { __typename?: 'YoastFaqBlock', name?: string | null } | { __typename?: 'YoastHowToBlock', name?: string | null } | { __typename?: 'YoastSeoBreadcrumbs', name?: string | null } | null> | null } | { __typename: 'Post' } | { __typename: 'PostFormat' } | { __typename: 'Tag' } | { __typename: 'User' } | null, footerMenus?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', blockFooter?: { __typename?: 'BlockFooter', phone?: number | null, footerDisclosure?: string | null, footerAddress?: string | null, footerLogo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } } | null, socialMediaIcons?: Array<{ __typename?: 'BlockFooterSocialMediaIcons', socialMediaUrl?: string | null, iconImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } } | null } | null> | null } | null, menuItems?: { __typename?: 'MenuToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, parentId?: string | null }> } | null }> } | null, generalSettings?: { __typename?: 'GeneralSettings', title?: string | null } | null, headerLogo?: { __typename?: 'RootQueryToMediaItemConnection', nodes: Array<{ __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null }> } | null, headerMenuItems?: { __typename?: 'RootQueryToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, navDetails?: { __typename?: 'NavDetails', description?: string | null, link?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, navSegments?: { __typename?: 'NavSegments', segments?: Array<{ __typename?: 'NavSegmentsSegments', title?: string | null, links?: Array<{ __typename?: 'NavSegmentsSegmentsLinks', link?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null> | null } | null }> } | null, menuButton?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', menuButton?: { __typename?: 'MenuButton', menubutton?: Array<{ __typename?: 'MenuButtonMenubutton', menubuttonlink?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null }> } | null, systemAlert?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', systemAlert?: { __typename?: 'SystemAlert', alertId?: string | null, message?: string | null, start?: string | null, end?: string | null } | null }> } | null, uTMConfiguration?: { __typename?: 'UTMConfiguration', utmConfigurationBlock?: { __typename?: 'UtmConfigurationBlock', utmQueryParams?: Array<{ __typename?: 'UtmConfigurationBlockUtmQueryParams', queryParam?: string | null } | null> | null } | null } | null };

export type BlogIndexContentFragmentFragment = { __typename?: 'BlogIndexContent', newsletter?: { __typename?: 'BlogIndexContentNewsletter', title?: string | null, description?: string | null, marketoFormId?: string | null, successMessage?: string | null } | null };

export type GetBlogQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBlogQuery = { __typename?: 'RootQuery', nodeByUri?: { __typename: 'Category' } | { __typename: 'Comment' } | { __typename: 'ContentType' } | { __typename: 'MediaItem' } | { __typename: 'Page', title?: string | null, content?: string | null, id: string, blogIndexContent?: { __typename?: 'BlogIndexContent', newsletter?: { __typename?: 'BlogIndexContentNewsletter', title?: string | null, description?: string | null, marketoFormId?: string | null, successMessage?: string | null } | null } | null, seo?: { __typename?: 'PostTypeSEO', canonical?: string | null, focuskw?: string | null, metaDesc?: string | null, metaKeywords?: string | null, metaRobotsNofollow?: string | null, metaRobotsNoindex?: string | null, opengraphAuthor?: string | null, opengraphDescription?: string | null, opengraphModifiedTime?: string | null, opengraphPublishedTime?: string | null, opengraphPublisher?: string | null, opengraphSiteName?: string | null, opengraphTitle?: string | null, opengraphType?: string | null, opengraphUrl?: string | null, readingTime?: number | null, title?: string | null, twitterDescription?: string | null, twitterTitle?: string | null, opengraphImage?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null } | null } | null, twitterImage?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', width?: number | null, height?: number | null } | null } | null } | null, editorBlocks?: Array<{ __typename?: 'AcfAccordion', name?: string | null, accordion?: { __typename?: 'Accordion', sectionId?: string | null, darkBackground?: boolean | null, description?: string | null, iconType?: Array<string | null> | null, title?: string | null, withAbbreviations?: boolean | null, withLargeItemTitle?: boolean | null, items?: Array<{ __typename?: 'AccordionItems', title?: string | null, content?: string | null } | null> | null } | null } | { __typename?: 'AcfArticlecards', name?: string | null } | { __typename?: 'AcfBenefits', name?: string | null, benefits?: { __typename?: 'Benefits', sectionId?: string | null, sectionDescription?: string | null, benefitCards?: Array<{ __typename?: 'BenefitsBenefitCards', buttonId?: string | null, title?: string | null, description?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, cardImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfBenefitsaccordion', name?: string | null, benefitsAccordion?: { __typename?: 'BenefitsAccordion', sectionId?: string | null, title?: string | null, subtitle?: string | null, accordionItems?: Array<{ __typename?: 'BenefitsAccordionAccordionItems', description?: string | null, accordionImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, links?: Array<{ __typename?: 'BenefitsAccordionAccordionItemsLinks', linkId?: string | null, link?: { __typename?: 'AcfLink', url?: string | null, title?: string | null } | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfBenefitscontent', name?: string | null, benefitscontent?: { __typename?: 'Benefitscontent', sectionId?: string | null, title?: string | null, textContent?: string | null, textContentVerticalAlignment?: Array<string | null> | null, media?: { __typename?: 'BenefitscontentMedia', type?: string | null, video?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | null } | { __typename?: 'AcfBenefitslist', name?: string | null, benefitsList?: { __typename?: 'BenefitsList', sectionId?: string | null, title?: string | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, benefits?: Array<{ __typename?: 'BenefitsListBenefits', title?: string | null, description?: string | null } | null> | null, disclaimers?: Array<{ __typename?: 'BenefitsListDisclaimers', text?: string | null } | null> | null } | null } | { __typename?: 'AcfBlogarticles', name?: string | null, blogArticles?: { __typename?: 'BlogArticles', sectionId?: string | null, featuredArticles?: Array<{ __typename?: 'BlogArticlesFeaturedArticles', articles?: Array<{ __typename?: 'BlogArticlesFeaturedArticlesArticles', article?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null, category?: { __typename?: 'AcfTermNodeConnection', edges: Array<{ __typename?: 'AcfTermNodeConnectionEdge', node: { __typename?: 'Category', databaseId: number, name?: string | null } | { __typename?: 'PostFormat', databaseId: number, name?: string | null } | { __typename?: 'Tag', databaseId: number, name?: string | null } }> } | null } | null> | null } | null } | { __typename?: 'AcfBlogctacard', name?: string | null, blogCtaCard?: { __typename?: 'BlogCtaCard', sectionId?: string | null, title?: string | null, buttonId?: string | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | { __typename?: 'AcfCallouttext', name?: string | null, calloutText?: { __typename?: 'CalloutText', sectionId?: string | null, title?: string | null, text?: string | null } | null } | { __typename?: 'AcfCardgrid', name?: string | null, cardGrid?: { __typename?: 'CardGrid', sectionId?: string | null, maxColumns?: number | null, sectionBackgroundColor?: string | null, sectionTitle?: string | null, description?: string | null, cardBackgroundColor?: string | null, cardBorder?: string | null, cards?: Array<{ __typename?: 'CardGridCards', card?: Array<{ __typename?: 'CardGridCardsCard', elementType?: Array<string | null> | null, title?: string | null, buttonColor?: string | null, buttonId?: string | null, paragraph?: string | null, heading?: string | null, disclaimer?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, imageData?: { __typename?: 'CardGridCardsCardImageData', alignment?: string | null, caption?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null, list?: Array<{ __typename?: 'CardGridCardsCardList', item?: string | null } | null> | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfCasestudies', name?: string | null, caseStudies?: { __typename?: 'CaseStudies', sectionId?: string | null, sectionTitle?: string | null, ctaText?: string | null, darkBackground?: boolean | null, items?: Array<{ __typename?: 'CaseStudiesItems', description?: string | null, post?: { __typename?: 'AcfContentNodeConnection', nodes: Array<{ __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null }> } | null } | null> | null } | null } | { __typename?: 'AcfCompanylist', name?: string | null, companyList?: { __typename?: 'CompanyList', sectionId?: string | null, companies?: Array<{ __typename?: 'CompanyListCompanies', buttonId?: string | null, description?: string | null, title?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfCorevalues', name?: string | null } | { __typename?: 'AcfCtacard', name?: string | null, ctaCard?: { __typename?: 'CtaCard', sectionId?: string | null, heading?: string | null, text?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, secondaryButton?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | { __typename?: 'AcfDivider', name?: string | null, divider?: { __typename?: 'Divider', sectionId?: string | null, darkBackground?: boolean | null } | null } | { __typename?: 'AcfFactoringinfographic', name?: string | null, factoringInfoGraphic?: { __typename?: 'FactoringInfoGraphic', sectionId?: string | null, title?: string | null, items?: Array<{ __typename?: 'FactoringInfoGraphicItems', description?: string | null } | null> | null } | null } | { __typename?: 'AcfFinancingcta', name?: string | null, financingCta?: { __typename?: 'FinancingCta', sectionId?: string | null, buttonId?: string | null, title?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, keyPoints?: Array<{ __typename?: 'FinancingCtaKeyPoints', field?: string | null, value?: string | null } | null> | null } | null } | { __typename?: 'AcfForm', name?: string | null, formContentBlock?: { __typename?: 'FormContentBlock', sectionId?: string | null, title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | { __typename?: 'AcfFuelsavingscalculator', name?: string | null, fuelSavingsCalculator?: { __typename?: 'FuelSavingsCalculator', sectionId?: string | null, sectionTitle?: string | null, multiplier?: number | null, outroCopy?: string | null, marketoFormId?: string | null } | null } | { __typename?: 'AcfHerobanner', name?: string | null, heroBanner?: { __typename?: 'HeroBanner', sectionId?: string | null, title?: string | null, subtitle?: string | null, includeForm?: boolean | null, rightContentType?: Array<string | null> | null, videoUrl?: string | null, content?: Array<{ __typename?: 'HeroBannerContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerContentWysiwyg', wysiwyg?: string | null } | null } | null> | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfHerobannerwithform', name?: string | null, heroBannerWithForm?: { __typename?: 'HeroBannerWithForm', sectionId?: string | null, title?: string | null, subtitle?: string | null, content?: Array<{ __typename?: 'HeroBannerWithFormContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerWithFormContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerWithFormContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerWithFormContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerWithFormContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerWithFormContentWysiwyg', wysiwyg?: string | null } | null } | null> | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, form?: { __typename?: 'HeroBannerWithFormForm', title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | null } | { __typename?: 'AcfHighlight', name?: string | null, highlight?: { __typename?: 'Highlight', sectionId?: string | null, title?: string | null, subtitle?: string | null, imagePlacement?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, content?: Array<{ __typename?: 'HighlightContent', type?: string | null, paragraph?: { __typename?: 'HighlightContentParagraph', text?: string | null } | null, list?: { __typename?: 'HighlightContentList', heading?: string | null, items?: Array<{ __typename?: 'HighlightContentListItems', text?: string | null } | null> | null } | null } | null> | null } | null } | { __typename?: 'AcfLogorows', name?: string | null, logoRows?: { __typename?: 'LogoRows', sectionId?: string | null, title?: string | null, darkBackground?: boolean | null, logos?: Array<{ __typename?: 'LogoRowsLogos', maxWidth?: number | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfLogoscroll', name?: string | null, logoScroll?: { __typename?: 'LogoScroll', sectionId?: string | null, title?: string | null, logoImages?: Array<{ __typename?: 'LogoScrollLogoImages', companyUrl?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfMainhero', name?: string | null, mainHero?: { __typename?: 'MainHero', sectionId?: string | null, title?: string | null, subtitle?: string | null, description?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfModal', name?: string | null } | { __typename?: 'AcfNewsandinsights', name?: string | null, newsAndInsights?: { __typename?: 'NewsAndInsights', sectionId?: string | null, articleLinkText?: string | null, title?: string | null, articles?: Array<{ __typename?: 'NewsAndInsightsArticles', articles?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null } | null } | { __typename?: 'AcfNewslettersignup', name?: string | null, newsletterSignup?: { __typename?: 'NewsletterSignup', sectionId?: string | null, title?: string | null, description?: string | null, darkBackground?: boolean | null, marketoFormId?: string | null, successMessage?: string | null, successUrl?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfOurhistory', name?: string | null, ourHistory?: { __typename?: 'OurHistory', sectionId?: string | null, title?: string | null, timeline?: Array<{ __typename?: 'OurHistoryTimeline', year?: number | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, keyPoints?: Array<{ __typename?: 'OurHistoryTimelineKeyPoints', field?: string | null, value?: string | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfPartners', name?: string | null, partners?: { __typename?: 'Partners', sectionId?: string | null, title?: string | null, description?: string | null, partners?: Array<{ __typename?: 'PartnersPartners', title?: string | null, description?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfSolutions', name?: string | null, solutions?: { __typename?: 'Solutions', sectionId?: string | null, title?: string | null, description?: string | null, solutions?: Array<{ __typename?: 'SolutionsSolutions', buttonId?: string | null, title?: string | null, description?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null } | { __typename?: 'AcfSolutionscards', name?: string | null, solutionsCards?: { __typename?: 'SolutionsCards', sectionId?: string | null, title?: string | null, description?: string | null, cards?: Array<{ __typename?: 'SolutionsCardsCards', description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTeammembers', name?: string | null, teamMembers?: { __typename?: 'TeamMembers', sectionId?: string | null, members?: Array<{ __typename?: 'TeamMembersMembers', name?: string | null, bio?: string | null, bioCtaText?: string | null, ctaId?: string | null, jobTitle?: string | null, jobTitleInDialog?: string | null, headshot?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTestimonials', name?: string | null, testimonials?: { __typename?: 'Testimonials', sectionId?: string | null, darkBackground?: boolean | null, title?: string | null, testimonials?: Array<{ __typename?: 'TestimonialsTestimonials', author?: string | null, quote?: string | null, authorImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTextcontent', name?: string | null, wsywig?: { __typename?: 'Wsywig', externalLinkModal?: boolean | null, darkBackground?: boolean | null, sectionId?: string | null, textContent?: string | null, modal?: { __typename?: 'WsywigModal', buttonText?: string | null, description?: string | null, title?: string | null } | null } | null } | { __typename?: 'AcfTextheader', name?: string | null, textHeader?: { __typename?: 'TextHeader', sectionId?: string | null, title?: string | null, description?: string | null, withGradientText?: boolean | null } | null } | { __typename?: 'AcfThrive', name?: string | null, thrive?: { __typename?: 'Thrive', sectionId?: string | null, title?: string | null, description?: string | null, descriptionFooter?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfTwocolumncta', name?: string | null, twoColumnCta?: { __typename?: 'TwoColumnCta', sectionId?: string | null, buttonId?: string | null, title?: string | null, subtitle?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfTwocolumnpromo', name?: string | null, twoColumnPromo?: { __typename?: 'TwoColumnPromo', sectionId?: string | null, title?: string | null, columnWidths?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, content?: Array<{ __typename?: 'TwoColumnPromoContent', type?: string | null, paragraph?: { __typename?: 'TwoColumnPromoContentParagraph', bold?: boolean | null, largeFontSize?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'TwoColumnPromoContentList', heading?: string | null, items?: Array<{ __typename?: 'TwoColumnPromoContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'TwoColumnPromoContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | null> | null } | null } | { __typename?: 'AcfVideo', name?: string | null, video?: { __typename?: 'Video', sectionId?: string | null, url?: string | null } | null } | { __typename?: 'CoreArchives', name?: string | null } | { __typename?: 'CoreAudio', name?: string | null } | { __typename?: 'CoreAvatar', name?: string | null } | { __typename?: 'CoreBlock', name?: string | null } | { __typename?: 'CoreButton', name?: string | null } | { __typename?: 'CoreButtons', name?: string | null } | { __typename?: 'CoreCalendar', name?: string | null } | { __typename?: 'CoreCategories', name?: string | null } | { __typename?: 'CoreCode', name?: string | null } | { __typename?: 'CoreColumn', name?: string | null } | { __typename?: 'CoreColumns', name?: string | null } | { __typename?: 'CoreCommentAuthorName', name?: string | null } | { __typename?: 'CoreCommentContent', name?: string | null } | { __typename?: 'CoreCommentDate', name?: string | null } | { __typename?: 'CoreCommentEditLink', name?: string | null } | { __typename?: 'CoreCommentReplyLink', name?: string | null } | { __typename?: 'CoreCommentTemplate', name?: string | null } | { __typename?: 'CoreComments', name?: string | null } | { __typename?: 'CoreCommentsPagination', name?: string | null } | { __typename?: 'CoreCommentsPaginationNext', name?: string | null } | { __typename?: 'CoreCommentsPaginationNumbers', name?: string | null } | { __typename?: 'CoreCommentsPaginationPrevious', name?: string | null } | { __typename?: 'CoreCommentsTitle', name?: string | null } | { __typename?: 'CoreCover', name?: string | null } | { __typename?: 'CoreDetails', name?: string | null } | { __typename?: 'CoreEmbed', name?: string | null } | { __typename?: 'CoreFile', name?: string | null } | { __typename?: 'CoreFootnotes', name?: string | null } | { __typename?: 'CoreFreeform', name?: string | null } | { __typename?: 'CoreGallery', name?: string | null } | { __typename?: 'CoreGroup', name?: string | null } | { __typename?: 'CoreHeading', name?: string | null } | { __typename?: 'CoreHomeLink', name?: string | null } | { __typename?: 'CoreHtml', name?: string | null } | { __typename?: 'CoreImage', name?: string | null } | { __typename?: 'CoreLatestComments', name?: string | null } | { __typename?: 'CoreLatestPosts', name?: string | null } | { __typename?: 'CoreLegacyWidget', name?: string | null } | { __typename?: 'CoreList', name?: string | null } | { __typename?: 'CoreListItem', name?: string | null } | { __typename?: 'CoreLoginout', name?: string | null } | { __typename?: 'CoreMediaText', name?: string | null } | { __typename?: 'CoreMissing', name?: string | null } | { __typename?: 'CoreMore', name?: string | null } | { __typename?: 'CoreNavigation', name?: string | null } | { __typename?: 'CoreNavigationLink', name?: string | null } | { __typename?: 'CoreNavigationSubmenu', name?: string | null } | { __typename?: 'CoreNextpage', name?: string | null } | { __typename?: 'CorePageList', name?: string | null } | { __typename?: 'CorePageListItem', name?: string | null } | { __typename?: 'CoreParagraph', name?: string | null } | { __typename?: 'CorePattern', name?: string | null } | { __typename?: 'CorePostAuthor', name?: string | null } | { __typename?: 'CorePostAuthorBiography', name?: string | null } | { __typename?: 'CorePostAuthorName', name?: string | null } | { __typename?: 'CorePostComments', name?: string | null } | { __typename?: 'CorePostCommentsForm', name?: string | null } | { __typename?: 'CorePostContent', name?: string | null } | { __typename?: 'CorePostDate', name?: string | null } | { __typename?: 'CorePostExcerpt', name?: string | null } | { __typename?: 'CorePostFeaturedImage', name?: string | null } | { __typename?: 'CorePostNavigationLink', name?: string | null } | { __typename?: 'CorePostTemplate', name?: string | null } | { __typename?: 'CorePostTerms', name?: string | null } | { __typename?: 'CorePostTitle', name?: string | null } | { __typename?: 'CorePreformatted', name?: string | null } | { __typename?: 'CorePullquote', name?: string | null } | { __typename?: 'CoreQuery', name?: string | null } | { __typename?: 'CoreQueryNoResults', name?: string | null } | { __typename?: 'CoreQueryPagination', name?: string | null } | { __typename?: 'CoreQueryPaginationNext', name?: string | null } | { __typename?: 'CoreQueryPaginationNumbers', name?: string | null } | { __typename?: 'CoreQueryPaginationPrevious', name?: string | null } | { __typename?: 'CoreQueryTitle', name?: string | null } | { __typename?: 'CoreQueryTotal', name?: string | null } | { __typename?: 'CoreQuote', name?: string | null } | { __typename?: 'CoreReadMore', name?: string | null } | { __typename?: 'CoreRss', name?: string | null } | { __typename?: 'CoreSearch', name?: string | null } | { __typename?: 'CoreSeparator', name?: string | null } | { __typename?: 'CoreShortcode', name?: string | null } | { __typename?: 'CoreSiteLogo', name?: string | null } | { __typename?: 'CoreSiteTagline', name?: string | null } | { __typename?: 'CoreSiteTitle', name?: string | null } | { __typename?: 'CoreSocialLink', name?: string | null } | { __typename?: 'CoreSocialLinks', name?: string | null } | { __typename?: 'CoreSpacer', name?: string | null } | { __typename?: 'CoreTable', name?: string | null } | { __typename?: 'CoreTagCloud', name?: string | null } | { __typename?: 'CoreTemplatePart', name?: string | null } | { __typename?: 'CoreTermDescription', name?: string | null } | { __typename?: 'CoreTextColumns', name?: string | null } | { __typename?: 'CoreVerse', name?: string | null } | { __typename?: 'CoreVideo', name?: string | null } | { __typename?: 'CoreWidgetGroup', name?: string | null } | { __typename?: 'GravityformsForm', name?: string | null, attributes?: { __typename?: 'GravityformsFormAttributes', form?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | { __typename?: 'YoastFaqBlock', name?: string | null } | { __typename?: 'YoastHowToBlock', name?: string | null } | { __typename?: 'YoastSeoBreadcrumbs', name?: string | null } | null> | null } | { __typename: 'Post' } | { __typename: 'PostFormat' } | { __typename: 'Tag' } | { __typename: 'User' } | null, categories?: { __typename?: 'RootQueryToCategoryConnection', nodes: Array<{ __typename?: 'Category', count?: number | null, databaseId: number, name?: string | null }> } | null, tags?: { __typename?: 'RootQueryToTagConnection', nodes: Array<{ __typename?: 'Tag', databaseId: number, name?: string | null }> } | null, footerMenus?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', blockFooter?: { __typename?: 'BlockFooter', phone?: number | null, footerDisclosure?: string | null, footerAddress?: string | null, footerLogo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } } | null, socialMediaIcons?: Array<{ __typename?: 'BlockFooterSocialMediaIcons', socialMediaUrl?: string | null, iconImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } } | null } | null> | null } | null, menuItems?: { __typename?: 'MenuToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, parentId?: string | null }> } | null }> } | null, generalSettings?: { __typename?: 'GeneralSettings', title?: string | null } | null, headerLogo?: { __typename?: 'RootQueryToMediaItemConnection', nodes: Array<{ __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null }> } | null, headerMenuItems?: { __typename?: 'RootQueryToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, navDetails?: { __typename?: 'NavDetails', description?: string | null, link?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, navSegments?: { __typename?: 'NavSegments', segments?: Array<{ __typename?: 'NavSegmentsSegments', title?: string | null, links?: Array<{ __typename?: 'NavSegmentsSegmentsLinks', link?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null> | null } | null }> } | null, menuButton?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', menuButton?: { __typename?: 'MenuButton', menubutton?: Array<{ __typename?: 'MenuButtonMenubutton', menubuttonlink?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null }> } | null, systemAlert?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', systemAlert?: { __typename?: 'SystemAlert', alertId?: string | null, message?: string | null, start?: string | null, end?: string | null } | null }> } | null, uTMConfiguration?: { __typename?: 'UTMConfiguration', utmConfigurationBlock?: { __typename?: 'UtmConfigurationBlock', utmQueryParams?: Array<{ __typename?: 'UtmConfigurationBlockUtmQueryParams', queryParam?: string | null } | null> | null } | null } | null };

export type GetRedirectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRedirectQuery = { __typename?: 'RootQuery', redirectConfiguration?: { __typename?: 'RedirectConfiguration', redirectConfigurationBlock?: { __typename?: 'RedirectConfigurationBlock', redirectUrl?: string | null } | null } | null };

export type SeoFragmentFragment = { __typename?: 'PostTypeSEO', canonical?: string | null, focuskw?: string | null, metaDesc?: string | null, metaKeywords?: string | null, metaRobotsNofollow?: string | null, metaRobotsNoindex?: string | null, opengraphAuthor?: string | null, opengraphDescription?: string | null, opengraphModifiedTime?: string | null, opengraphPublishedTime?: string | null, opengraphPublisher?: string | null, opengraphSiteName?: string | null, opengraphTitle?: string | null, opengraphType?: string | null, opengraphUrl?: string | null, readingTime?: number | null, title?: string | null, twitterDescription?: string | null, twitterTitle?: string | null, opengraphImage?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null } | null } | null, twitterImage?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', width?: number | null, height?: number | null } | null } | null };

export type GetArchiveQueryVariables = Exact<{
  uri: Scalars['String']['input'];
}>;


export type GetArchiveQuery = { __typename?: 'RootQuery', nodeByUri?: { __typename?: 'Category', name?: string | null, archiveType: 'Category', posts?: { __typename?: 'CategoryToPostConnection', nodes: Array<{ __typename?: 'Post', id: string, title?: string | null, uri?: string | null }> } | null } | { __typename?: 'Comment', archiveType: 'Comment' } | { __typename?: 'ContentType', archiveType: 'ContentType' } | { __typename?: 'MediaItem', archiveType: 'MediaItem' } | { __typename?: 'Page', archiveType: 'Page' } | { __typename?: 'Post', archiveType: 'Post' } | { __typename?: 'PostFormat', archiveType: 'PostFormat' } | { __typename?: 'Tag', name?: string | null, archiveType: 'Tag', posts?: { __typename?: 'TagToPostConnection', nodes: Array<{ __typename?: 'Post', id: string, title?: string | null, uri?: string | null }> } | null } | { __typename?: 'User', archiveType: 'User' } | null, footerMenus?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', blockFooter?: { __typename?: 'BlockFooter', phone?: number | null, footerDisclosure?: string | null, footerAddress?: string | null, footerLogo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } } | null, socialMediaIcons?: Array<{ __typename?: 'BlockFooterSocialMediaIcons', socialMediaUrl?: string | null, iconImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } } | null } | null> | null } | null, menuItems?: { __typename?: 'MenuToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, parentId?: string | null }> } | null }> } | null, generalSettings?: { __typename?: 'GeneralSettings', title?: string | null } | null, headerLogo?: { __typename?: 'RootQueryToMediaItemConnection', nodes: Array<{ __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null }> } | null, headerMenuItems?: { __typename?: 'RootQueryToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, navDetails?: { __typename?: 'NavDetails', description?: string | null, link?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, navSegments?: { __typename?: 'NavSegments', segments?: Array<{ __typename?: 'NavSegmentsSegments', title?: string | null, links?: Array<{ __typename?: 'NavSegmentsSegmentsLinks', link?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null> | null } | null }> } | null, menuButton?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', menuButton?: { __typename?: 'MenuButton', menubutton?: Array<{ __typename?: 'MenuButtonMenubutton', menubuttonlink?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null }> } | null, systemAlert?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', systemAlert?: { __typename?: 'SystemAlert', alertId?: string | null, message?: string | null, start?: string | null, end?: string | null } | null }> } | null, uTMConfiguration?: { __typename?: 'UTMConfiguration', utmConfigurationBlock?: { __typename?: 'UtmConfigurationBlock', utmQueryParams?: Array<{ __typename?: 'UtmConfigurationBlockUtmQueryParams', queryParam?: string | null } | null> | null } | null } | null };

export type ArticleFragmentFragment = { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null };

export type ArticleImageFragmentFragment = { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } };

type EditorBlockFragment_AcfAccordion_Fragment = { __typename?: 'AcfAccordion', name?: string | null };

type EditorBlockFragment_AcfArticlecards_Fragment = { __typename?: 'AcfArticlecards', name?: string | null };

type EditorBlockFragment_AcfBenefits_Fragment = { __typename?: 'AcfBenefits', name?: string | null };

type EditorBlockFragment_AcfBenefitsaccordion_Fragment = { __typename?: 'AcfBenefitsaccordion', name?: string | null };

type EditorBlockFragment_AcfBenefitscontent_Fragment = { __typename?: 'AcfBenefitscontent', name?: string | null };

type EditorBlockFragment_AcfBenefitslist_Fragment = { __typename?: 'AcfBenefitslist', name?: string | null };

type EditorBlockFragment_AcfBlogarticles_Fragment = { __typename?: 'AcfBlogarticles', name?: string | null };

type EditorBlockFragment_AcfBlogctacard_Fragment = { __typename?: 'AcfBlogctacard', name?: string | null };

type EditorBlockFragment_AcfCallouttext_Fragment = { __typename?: 'AcfCallouttext', name?: string | null };

type EditorBlockFragment_AcfCardgrid_Fragment = { __typename?: 'AcfCardgrid', name?: string | null };

type EditorBlockFragment_AcfCasestudies_Fragment = { __typename?: 'AcfCasestudies', name?: string | null };

type EditorBlockFragment_AcfCompanylist_Fragment = { __typename?: 'AcfCompanylist', name?: string | null };

type EditorBlockFragment_AcfCorevalues_Fragment = { __typename?: 'AcfCorevalues', name?: string | null };

type EditorBlockFragment_AcfCtacard_Fragment = { __typename?: 'AcfCtacard', name?: string | null };

type EditorBlockFragment_AcfDivider_Fragment = { __typename?: 'AcfDivider', name?: string | null };

type EditorBlockFragment_AcfFactoringinfographic_Fragment = { __typename?: 'AcfFactoringinfographic', name?: string | null };

type EditorBlockFragment_AcfFinancingcta_Fragment = { __typename?: 'AcfFinancingcta', name?: string | null };

type EditorBlockFragment_AcfForm_Fragment = { __typename?: 'AcfForm', name?: string | null };

type EditorBlockFragment_AcfFuelsavingscalculator_Fragment = { __typename?: 'AcfFuelsavingscalculator', name?: string | null };

type EditorBlockFragment_AcfHerobanner_Fragment = { __typename?: 'AcfHerobanner', name?: string | null };

type EditorBlockFragment_AcfHerobannerwithform_Fragment = { __typename?: 'AcfHerobannerwithform', name?: string | null };

type EditorBlockFragment_AcfHighlight_Fragment = { __typename?: 'AcfHighlight', name?: string | null };

type EditorBlockFragment_AcfLogorows_Fragment = { __typename?: 'AcfLogorows', name?: string | null };

type EditorBlockFragment_AcfLogoscroll_Fragment = { __typename?: 'AcfLogoscroll', name?: string | null };

type EditorBlockFragment_AcfMainhero_Fragment = { __typename?: 'AcfMainhero', name?: string | null };

type EditorBlockFragment_AcfModal_Fragment = { __typename?: 'AcfModal', name?: string | null };

type EditorBlockFragment_AcfNewsandinsights_Fragment = { __typename?: 'AcfNewsandinsights', name?: string | null };

type EditorBlockFragment_AcfNewslettersignup_Fragment = { __typename?: 'AcfNewslettersignup', name?: string | null };

type EditorBlockFragment_AcfOurhistory_Fragment = { __typename?: 'AcfOurhistory', name?: string | null };

type EditorBlockFragment_AcfPartners_Fragment = { __typename?: 'AcfPartners', name?: string | null };

type EditorBlockFragment_AcfSolutions_Fragment = { __typename?: 'AcfSolutions', name?: string | null };

type EditorBlockFragment_AcfSolutionscards_Fragment = { __typename?: 'AcfSolutionscards', name?: string | null };

type EditorBlockFragment_AcfTeammembers_Fragment = { __typename?: 'AcfTeammembers', name?: string | null };

type EditorBlockFragment_AcfTestimonials_Fragment = { __typename?: 'AcfTestimonials', name?: string | null };

type EditorBlockFragment_AcfTextcontent_Fragment = { __typename?: 'AcfTextcontent', name?: string | null };

type EditorBlockFragment_AcfTextheader_Fragment = { __typename?: 'AcfTextheader', name?: string | null };

type EditorBlockFragment_AcfThrive_Fragment = { __typename?: 'AcfThrive', name?: string | null };

type EditorBlockFragment_AcfTwocolumncta_Fragment = { __typename?: 'AcfTwocolumncta', name?: string | null };

type EditorBlockFragment_AcfTwocolumnpromo_Fragment = { __typename?: 'AcfTwocolumnpromo', name?: string | null };

type EditorBlockFragment_AcfVideo_Fragment = { __typename?: 'AcfVideo', name?: string | null };

type EditorBlockFragment_CoreArchives_Fragment = { __typename?: 'CoreArchives', name?: string | null };

type EditorBlockFragment_CoreAudio_Fragment = { __typename?: 'CoreAudio', name?: string | null };

type EditorBlockFragment_CoreAvatar_Fragment = { __typename?: 'CoreAvatar', name?: string | null };

type EditorBlockFragment_CoreBlock_Fragment = { __typename?: 'CoreBlock', name?: string | null };

type EditorBlockFragment_CoreButton_Fragment = { __typename?: 'CoreButton', name?: string | null };

type EditorBlockFragment_CoreButtons_Fragment = { __typename?: 'CoreButtons', name?: string | null };

type EditorBlockFragment_CoreCalendar_Fragment = { __typename?: 'CoreCalendar', name?: string | null };

type EditorBlockFragment_CoreCategories_Fragment = { __typename?: 'CoreCategories', name?: string | null };

type EditorBlockFragment_CoreCode_Fragment = { __typename?: 'CoreCode', name?: string | null };

type EditorBlockFragment_CoreColumn_Fragment = { __typename?: 'CoreColumn', name?: string | null };

type EditorBlockFragment_CoreColumns_Fragment = { __typename?: 'CoreColumns', name?: string | null };

type EditorBlockFragment_CoreCommentAuthorName_Fragment = { __typename?: 'CoreCommentAuthorName', name?: string | null };

type EditorBlockFragment_CoreCommentContent_Fragment = { __typename?: 'CoreCommentContent', name?: string | null };

type EditorBlockFragment_CoreCommentDate_Fragment = { __typename?: 'CoreCommentDate', name?: string | null };

type EditorBlockFragment_CoreCommentEditLink_Fragment = { __typename?: 'CoreCommentEditLink', name?: string | null };

type EditorBlockFragment_CoreCommentReplyLink_Fragment = { __typename?: 'CoreCommentReplyLink', name?: string | null };

type EditorBlockFragment_CoreCommentTemplate_Fragment = { __typename?: 'CoreCommentTemplate', name?: string | null };

type EditorBlockFragment_CoreComments_Fragment = { __typename?: 'CoreComments', name?: string | null };

type EditorBlockFragment_CoreCommentsPagination_Fragment = { __typename?: 'CoreCommentsPagination', name?: string | null };

type EditorBlockFragment_CoreCommentsPaginationNext_Fragment = { __typename?: 'CoreCommentsPaginationNext', name?: string | null };

type EditorBlockFragment_CoreCommentsPaginationNumbers_Fragment = { __typename?: 'CoreCommentsPaginationNumbers', name?: string | null };

type EditorBlockFragment_CoreCommentsPaginationPrevious_Fragment = { __typename?: 'CoreCommentsPaginationPrevious', name?: string | null };

type EditorBlockFragment_CoreCommentsTitle_Fragment = { __typename?: 'CoreCommentsTitle', name?: string | null };

type EditorBlockFragment_CoreCover_Fragment = { __typename?: 'CoreCover', name?: string | null };

type EditorBlockFragment_CoreDetails_Fragment = { __typename?: 'CoreDetails', name?: string | null };

type EditorBlockFragment_CoreEmbed_Fragment = { __typename?: 'CoreEmbed', name?: string | null };

type EditorBlockFragment_CoreFile_Fragment = { __typename?: 'CoreFile', name?: string | null };

type EditorBlockFragment_CoreFootnotes_Fragment = { __typename?: 'CoreFootnotes', name?: string | null };

type EditorBlockFragment_CoreFreeform_Fragment = { __typename?: 'CoreFreeform', name?: string | null };

type EditorBlockFragment_CoreGallery_Fragment = { __typename?: 'CoreGallery', name?: string | null };

type EditorBlockFragment_CoreGroup_Fragment = { __typename?: 'CoreGroup', name?: string | null };

type EditorBlockFragment_CoreHeading_Fragment = { __typename?: 'CoreHeading', name?: string | null };

type EditorBlockFragment_CoreHomeLink_Fragment = { __typename?: 'CoreHomeLink', name?: string | null };

type EditorBlockFragment_CoreHtml_Fragment = { __typename?: 'CoreHtml', name?: string | null };

type EditorBlockFragment_CoreImage_Fragment = { __typename?: 'CoreImage', name?: string | null };

type EditorBlockFragment_CoreLatestComments_Fragment = { __typename?: 'CoreLatestComments', name?: string | null };

type EditorBlockFragment_CoreLatestPosts_Fragment = { __typename?: 'CoreLatestPosts', name?: string | null };

type EditorBlockFragment_CoreLegacyWidget_Fragment = { __typename?: 'CoreLegacyWidget', name?: string | null };

type EditorBlockFragment_CoreList_Fragment = { __typename?: 'CoreList', name?: string | null };

type EditorBlockFragment_CoreListItem_Fragment = { __typename?: 'CoreListItem', name?: string | null };

type EditorBlockFragment_CoreLoginout_Fragment = { __typename?: 'CoreLoginout', name?: string | null };

type EditorBlockFragment_CoreMediaText_Fragment = { __typename?: 'CoreMediaText', name?: string | null };

type EditorBlockFragment_CoreMissing_Fragment = { __typename?: 'CoreMissing', name?: string | null };

type EditorBlockFragment_CoreMore_Fragment = { __typename?: 'CoreMore', name?: string | null };

type EditorBlockFragment_CoreNavigation_Fragment = { __typename?: 'CoreNavigation', name?: string | null };

type EditorBlockFragment_CoreNavigationLink_Fragment = { __typename?: 'CoreNavigationLink', name?: string | null };

type EditorBlockFragment_CoreNavigationSubmenu_Fragment = { __typename?: 'CoreNavigationSubmenu', name?: string | null };

type EditorBlockFragment_CoreNextpage_Fragment = { __typename?: 'CoreNextpage', name?: string | null };

type EditorBlockFragment_CorePageList_Fragment = { __typename?: 'CorePageList', name?: string | null };

type EditorBlockFragment_CorePageListItem_Fragment = { __typename?: 'CorePageListItem', name?: string | null };

type EditorBlockFragment_CoreParagraph_Fragment = { __typename?: 'CoreParagraph', name?: string | null };

type EditorBlockFragment_CorePattern_Fragment = { __typename?: 'CorePattern', name?: string | null };

type EditorBlockFragment_CorePostAuthor_Fragment = { __typename?: 'CorePostAuthor', name?: string | null };

type EditorBlockFragment_CorePostAuthorBiography_Fragment = { __typename?: 'CorePostAuthorBiography', name?: string | null };

type EditorBlockFragment_CorePostAuthorName_Fragment = { __typename?: 'CorePostAuthorName', name?: string | null };

type EditorBlockFragment_CorePostComments_Fragment = { __typename?: 'CorePostComments', name?: string | null };

type EditorBlockFragment_CorePostCommentsForm_Fragment = { __typename?: 'CorePostCommentsForm', name?: string | null };

type EditorBlockFragment_CorePostContent_Fragment = { __typename?: 'CorePostContent', name?: string | null };

type EditorBlockFragment_CorePostDate_Fragment = { __typename?: 'CorePostDate', name?: string | null };

type EditorBlockFragment_CorePostExcerpt_Fragment = { __typename?: 'CorePostExcerpt', name?: string | null };

type EditorBlockFragment_CorePostFeaturedImage_Fragment = { __typename?: 'CorePostFeaturedImage', name?: string | null };

type EditorBlockFragment_CorePostNavigationLink_Fragment = { __typename?: 'CorePostNavigationLink', name?: string | null };

type EditorBlockFragment_CorePostTemplate_Fragment = { __typename?: 'CorePostTemplate', name?: string | null };

type EditorBlockFragment_CorePostTerms_Fragment = { __typename?: 'CorePostTerms', name?: string | null };

type EditorBlockFragment_CorePostTitle_Fragment = { __typename?: 'CorePostTitle', name?: string | null };

type EditorBlockFragment_CorePreformatted_Fragment = { __typename?: 'CorePreformatted', name?: string | null };

type EditorBlockFragment_CorePullquote_Fragment = { __typename?: 'CorePullquote', name?: string | null };

type EditorBlockFragment_CoreQuery_Fragment = { __typename?: 'CoreQuery', name?: string | null };

type EditorBlockFragment_CoreQueryNoResults_Fragment = { __typename?: 'CoreQueryNoResults', name?: string | null };

type EditorBlockFragment_CoreQueryPagination_Fragment = { __typename?: 'CoreQueryPagination', name?: string | null };

type EditorBlockFragment_CoreQueryPaginationNext_Fragment = { __typename?: 'CoreQueryPaginationNext', name?: string | null };

type EditorBlockFragment_CoreQueryPaginationNumbers_Fragment = { __typename?: 'CoreQueryPaginationNumbers', name?: string | null };

type EditorBlockFragment_CoreQueryPaginationPrevious_Fragment = { __typename?: 'CoreQueryPaginationPrevious', name?: string | null };

type EditorBlockFragment_CoreQueryTitle_Fragment = { __typename?: 'CoreQueryTitle', name?: string | null };

type EditorBlockFragment_CoreQueryTotal_Fragment = { __typename?: 'CoreQueryTotal', name?: string | null };

type EditorBlockFragment_CoreQuote_Fragment = { __typename?: 'CoreQuote', name?: string | null };

type EditorBlockFragment_CoreReadMore_Fragment = { __typename?: 'CoreReadMore', name?: string | null };

type EditorBlockFragment_CoreRss_Fragment = { __typename?: 'CoreRss', name?: string | null };

type EditorBlockFragment_CoreSearch_Fragment = { __typename?: 'CoreSearch', name?: string | null };

type EditorBlockFragment_CoreSeparator_Fragment = { __typename?: 'CoreSeparator', name?: string | null };

type EditorBlockFragment_CoreShortcode_Fragment = { __typename?: 'CoreShortcode', name?: string | null };

type EditorBlockFragment_CoreSiteLogo_Fragment = { __typename?: 'CoreSiteLogo', name?: string | null };

type EditorBlockFragment_CoreSiteTagline_Fragment = { __typename?: 'CoreSiteTagline', name?: string | null };

type EditorBlockFragment_CoreSiteTitle_Fragment = { __typename?: 'CoreSiteTitle', name?: string | null };

type EditorBlockFragment_CoreSocialLink_Fragment = { __typename?: 'CoreSocialLink', name?: string | null };

type EditorBlockFragment_CoreSocialLinks_Fragment = { __typename?: 'CoreSocialLinks', name?: string | null };

type EditorBlockFragment_CoreSpacer_Fragment = { __typename?: 'CoreSpacer', name?: string | null };

type EditorBlockFragment_CoreTable_Fragment = { __typename?: 'CoreTable', name?: string | null };

type EditorBlockFragment_CoreTagCloud_Fragment = { __typename?: 'CoreTagCloud', name?: string | null };

type EditorBlockFragment_CoreTemplatePart_Fragment = { __typename?: 'CoreTemplatePart', name?: string | null };

type EditorBlockFragment_CoreTermDescription_Fragment = { __typename?: 'CoreTermDescription', name?: string | null };

type EditorBlockFragment_CoreTextColumns_Fragment = { __typename?: 'CoreTextColumns', name?: string | null };

type EditorBlockFragment_CoreVerse_Fragment = { __typename?: 'CoreVerse', name?: string | null };

type EditorBlockFragment_CoreVideo_Fragment = { __typename?: 'CoreVideo', name?: string | null };

type EditorBlockFragment_CoreWidgetGroup_Fragment = { __typename?: 'CoreWidgetGroup', name?: string | null };

type EditorBlockFragment_GravityformsForm_Fragment = { __typename?: 'GravityformsForm', name?: string | null };

type EditorBlockFragment_YoastFaqBlock_Fragment = { __typename?: 'YoastFaqBlock', name?: string | null };

type EditorBlockFragment_YoastHowToBlock_Fragment = { __typename?: 'YoastHowToBlock', name?: string | null };

type EditorBlockFragment_YoastSeoBreadcrumbs_Fragment = { __typename?: 'YoastSeoBreadcrumbs', name?: string | null };

export type EditorBlockFragmentFragment = EditorBlockFragment_AcfAccordion_Fragment | EditorBlockFragment_AcfArticlecards_Fragment | EditorBlockFragment_AcfBenefits_Fragment | EditorBlockFragment_AcfBenefitsaccordion_Fragment | EditorBlockFragment_AcfBenefitscontent_Fragment | EditorBlockFragment_AcfBenefitslist_Fragment | EditorBlockFragment_AcfBlogarticles_Fragment | EditorBlockFragment_AcfBlogctacard_Fragment | EditorBlockFragment_AcfCallouttext_Fragment | EditorBlockFragment_AcfCardgrid_Fragment | EditorBlockFragment_AcfCasestudies_Fragment | EditorBlockFragment_AcfCompanylist_Fragment | EditorBlockFragment_AcfCorevalues_Fragment | EditorBlockFragment_AcfCtacard_Fragment | EditorBlockFragment_AcfDivider_Fragment | EditorBlockFragment_AcfFactoringinfographic_Fragment | EditorBlockFragment_AcfFinancingcta_Fragment | EditorBlockFragment_AcfForm_Fragment | EditorBlockFragment_AcfFuelsavingscalculator_Fragment | EditorBlockFragment_AcfHerobanner_Fragment | EditorBlockFragment_AcfHerobannerwithform_Fragment | EditorBlockFragment_AcfHighlight_Fragment | EditorBlockFragment_AcfLogorows_Fragment | EditorBlockFragment_AcfLogoscroll_Fragment | EditorBlockFragment_AcfMainhero_Fragment | EditorBlockFragment_AcfModal_Fragment | EditorBlockFragment_AcfNewsandinsights_Fragment | EditorBlockFragment_AcfNewslettersignup_Fragment | EditorBlockFragment_AcfOurhistory_Fragment | EditorBlockFragment_AcfPartners_Fragment | EditorBlockFragment_AcfSolutions_Fragment | EditorBlockFragment_AcfSolutionscards_Fragment | EditorBlockFragment_AcfTeammembers_Fragment | EditorBlockFragment_AcfTestimonials_Fragment | EditorBlockFragment_AcfTextcontent_Fragment | EditorBlockFragment_AcfTextheader_Fragment | EditorBlockFragment_AcfThrive_Fragment | EditorBlockFragment_AcfTwocolumncta_Fragment | EditorBlockFragment_AcfTwocolumnpromo_Fragment | EditorBlockFragment_AcfVideo_Fragment | EditorBlockFragment_CoreArchives_Fragment | EditorBlockFragment_CoreAudio_Fragment | EditorBlockFragment_CoreAvatar_Fragment | EditorBlockFragment_CoreBlock_Fragment | EditorBlockFragment_CoreButton_Fragment | EditorBlockFragment_CoreButtons_Fragment | EditorBlockFragment_CoreCalendar_Fragment | EditorBlockFragment_CoreCategories_Fragment | EditorBlockFragment_CoreCode_Fragment | EditorBlockFragment_CoreColumn_Fragment | EditorBlockFragment_CoreColumns_Fragment | EditorBlockFragment_CoreCommentAuthorName_Fragment | EditorBlockFragment_CoreCommentContent_Fragment | EditorBlockFragment_CoreCommentDate_Fragment | EditorBlockFragment_CoreCommentEditLink_Fragment | EditorBlockFragment_CoreCommentReplyLink_Fragment | EditorBlockFragment_CoreCommentTemplate_Fragment | EditorBlockFragment_CoreComments_Fragment | EditorBlockFragment_CoreCommentsPagination_Fragment | EditorBlockFragment_CoreCommentsPaginationNext_Fragment | EditorBlockFragment_CoreCommentsPaginationNumbers_Fragment | EditorBlockFragment_CoreCommentsPaginationPrevious_Fragment | EditorBlockFragment_CoreCommentsTitle_Fragment | EditorBlockFragment_CoreCover_Fragment | EditorBlockFragment_CoreDetails_Fragment | EditorBlockFragment_CoreEmbed_Fragment | EditorBlockFragment_CoreFile_Fragment | EditorBlockFragment_CoreFootnotes_Fragment | EditorBlockFragment_CoreFreeform_Fragment | EditorBlockFragment_CoreGallery_Fragment | EditorBlockFragment_CoreGroup_Fragment | EditorBlockFragment_CoreHeading_Fragment | EditorBlockFragment_CoreHomeLink_Fragment | EditorBlockFragment_CoreHtml_Fragment | EditorBlockFragment_CoreImage_Fragment | EditorBlockFragment_CoreLatestComments_Fragment | EditorBlockFragment_CoreLatestPosts_Fragment | EditorBlockFragment_CoreLegacyWidget_Fragment | EditorBlockFragment_CoreList_Fragment | EditorBlockFragment_CoreListItem_Fragment | EditorBlockFragment_CoreLoginout_Fragment | EditorBlockFragment_CoreMediaText_Fragment | EditorBlockFragment_CoreMissing_Fragment | EditorBlockFragment_CoreMore_Fragment | EditorBlockFragment_CoreNavigation_Fragment | EditorBlockFragment_CoreNavigationLink_Fragment | EditorBlockFragment_CoreNavigationSubmenu_Fragment | EditorBlockFragment_CoreNextpage_Fragment | EditorBlockFragment_CorePageList_Fragment | EditorBlockFragment_CorePageListItem_Fragment | EditorBlockFragment_CoreParagraph_Fragment | EditorBlockFragment_CorePattern_Fragment | EditorBlockFragment_CorePostAuthor_Fragment | EditorBlockFragment_CorePostAuthorBiography_Fragment | EditorBlockFragment_CorePostAuthorName_Fragment | EditorBlockFragment_CorePostComments_Fragment | EditorBlockFragment_CorePostCommentsForm_Fragment | EditorBlockFragment_CorePostContent_Fragment | EditorBlockFragment_CorePostDate_Fragment | EditorBlockFragment_CorePostExcerpt_Fragment | EditorBlockFragment_CorePostFeaturedImage_Fragment | EditorBlockFragment_CorePostNavigationLink_Fragment | EditorBlockFragment_CorePostTemplate_Fragment | EditorBlockFragment_CorePostTerms_Fragment | EditorBlockFragment_CorePostTitle_Fragment | EditorBlockFragment_CorePreformatted_Fragment | EditorBlockFragment_CorePullquote_Fragment | EditorBlockFragment_CoreQuery_Fragment | EditorBlockFragment_CoreQueryNoResults_Fragment | EditorBlockFragment_CoreQueryPagination_Fragment | EditorBlockFragment_CoreQueryPaginationNext_Fragment | EditorBlockFragment_CoreQueryPaginationNumbers_Fragment | EditorBlockFragment_CoreQueryPaginationPrevious_Fragment | EditorBlockFragment_CoreQueryTitle_Fragment | EditorBlockFragment_CoreQueryTotal_Fragment | EditorBlockFragment_CoreQuote_Fragment | EditorBlockFragment_CoreReadMore_Fragment | EditorBlockFragment_CoreRss_Fragment | EditorBlockFragment_CoreSearch_Fragment | EditorBlockFragment_CoreSeparator_Fragment | EditorBlockFragment_CoreShortcode_Fragment | EditorBlockFragment_CoreSiteLogo_Fragment | EditorBlockFragment_CoreSiteTagline_Fragment | EditorBlockFragment_CoreSiteTitle_Fragment | EditorBlockFragment_CoreSocialLink_Fragment | EditorBlockFragment_CoreSocialLinks_Fragment | EditorBlockFragment_CoreSpacer_Fragment | EditorBlockFragment_CoreTable_Fragment | EditorBlockFragment_CoreTagCloud_Fragment | EditorBlockFragment_CoreTemplatePart_Fragment | EditorBlockFragment_CoreTermDescription_Fragment | EditorBlockFragment_CoreTextColumns_Fragment | EditorBlockFragment_CoreVerse_Fragment | EditorBlockFragment_CoreVideo_Fragment | EditorBlockFragment_CoreWidgetGroup_Fragment | EditorBlockFragment_GravityformsForm_Fragment | EditorBlockFragment_YoastFaqBlock_Fragment | EditorBlockFragment_YoastHowToBlock_Fragment | EditorBlockFragment_YoastSeoBreadcrumbs_Fragment;

export type EditorBlocksFragmentFragment = { __typename?: 'Page', id: string, editorBlocks?: Array<{ __typename?: 'AcfAccordion', name?: string | null, accordion?: { __typename?: 'Accordion', sectionId?: string | null, darkBackground?: boolean | null, description?: string | null, iconType?: Array<string | null> | null, title?: string | null, withAbbreviations?: boolean | null, withLargeItemTitle?: boolean | null, items?: Array<{ __typename?: 'AccordionItems', title?: string | null, content?: string | null } | null> | null } | null } | { __typename?: 'AcfArticlecards', name?: string | null } | { __typename?: 'AcfBenefits', name?: string | null, benefits?: { __typename?: 'Benefits', sectionId?: string | null, sectionDescription?: string | null, benefitCards?: Array<{ __typename?: 'BenefitsBenefitCards', buttonId?: string | null, title?: string | null, description?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, cardImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfBenefitsaccordion', name?: string | null, benefitsAccordion?: { __typename?: 'BenefitsAccordion', sectionId?: string | null, title?: string | null, subtitle?: string | null, accordionItems?: Array<{ __typename?: 'BenefitsAccordionAccordionItems', description?: string | null, accordionImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, links?: Array<{ __typename?: 'BenefitsAccordionAccordionItemsLinks', linkId?: string | null, link?: { __typename?: 'AcfLink', url?: string | null, title?: string | null } | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfBenefitscontent', name?: string | null, benefitscontent?: { __typename?: 'Benefitscontent', sectionId?: string | null, title?: string | null, textContent?: string | null, textContentVerticalAlignment?: Array<string | null> | null, media?: { __typename?: 'BenefitscontentMedia', type?: string | null, video?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | null } | { __typename?: 'AcfBenefitslist', name?: string | null, benefitsList?: { __typename?: 'BenefitsList', sectionId?: string | null, title?: string | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, benefits?: Array<{ __typename?: 'BenefitsListBenefits', title?: string | null, description?: string | null } | null> | null, disclaimers?: Array<{ __typename?: 'BenefitsListDisclaimers', text?: string | null } | null> | null } | null } | { __typename?: 'AcfBlogarticles', name?: string | null, blogArticles?: { __typename?: 'BlogArticles', sectionId?: string | null, featuredArticles?: Array<{ __typename?: 'BlogArticlesFeaturedArticles', articles?: Array<{ __typename?: 'BlogArticlesFeaturedArticlesArticles', article?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null, category?: { __typename?: 'AcfTermNodeConnection', edges: Array<{ __typename?: 'AcfTermNodeConnectionEdge', node: { __typename?: 'Category', databaseId: number, name?: string | null } | { __typename?: 'PostFormat', databaseId: number, name?: string | null } | { __typename?: 'Tag', databaseId: number, name?: string | null } }> } | null } | null> | null } | null } | { __typename?: 'AcfBlogctacard', name?: string | null, blogCtaCard?: { __typename?: 'BlogCtaCard', sectionId?: string | null, title?: string | null, buttonId?: string | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | { __typename?: 'AcfCallouttext', name?: string | null, calloutText?: { __typename?: 'CalloutText', sectionId?: string | null, title?: string | null, text?: string | null } | null } | { __typename?: 'AcfCardgrid', name?: string | null, cardGrid?: { __typename?: 'CardGrid', sectionId?: string | null, maxColumns?: number | null, sectionBackgroundColor?: string | null, sectionTitle?: string | null, description?: string | null, cardBackgroundColor?: string | null, cardBorder?: string | null, cards?: Array<{ __typename?: 'CardGridCards', card?: Array<{ __typename?: 'CardGridCardsCard', elementType?: Array<string | null> | null, title?: string | null, buttonColor?: string | null, buttonId?: string | null, paragraph?: string | null, heading?: string | null, disclaimer?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, imageData?: { __typename?: 'CardGridCardsCardImageData', alignment?: string | null, caption?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null, list?: Array<{ __typename?: 'CardGridCardsCardList', item?: string | null } | null> | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfCasestudies', name?: string | null, caseStudies?: { __typename?: 'CaseStudies', sectionId?: string | null, sectionTitle?: string | null, ctaText?: string | null, darkBackground?: boolean | null, items?: Array<{ __typename?: 'CaseStudiesItems', description?: string | null, post?: { __typename?: 'AcfContentNodeConnection', nodes: Array<{ __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null }> } | null } | null> | null } | null } | { __typename?: 'AcfCompanylist', name?: string | null, companyList?: { __typename?: 'CompanyList', sectionId?: string | null, companies?: Array<{ __typename?: 'CompanyListCompanies', buttonId?: string | null, description?: string | null, title?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfCorevalues', name?: string | null } | { __typename?: 'AcfCtacard', name?: string | null, ctaCard?: { __typename?: 'CtaCard', sectionId?: string | null, heading?: string | null, text?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, secondaryButton?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | { __typename?: 'AcfDivider', name?: string | null, divider?: { __typename?: 'Divider', sectionId?: string | null, darkBackground?: boolean | null } | null } | { __typename?: 'AcfFactoringinfographic', name?: string | null, factoringInfoGraphic?: { __typename?: 'FactoringInfoGraphic', sectionId?: string | null, title?: string | null, items?: Array<{ __typename?: 'FactoringInfoGraphicItems', description?: string | null } | null> | null } | null } | { __typename?: 'AcfFinancingcta', name?: string | null, financingCta?: { __typename?: 'FinancingCta', sectionId?: string | null, buttonId?: string | null, title?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, keyPoints?: Array<{ __typename?: 'FinancingCtaKeyPoints', field?: string | null, value?: string | null } | null> | null } | null } | { __typename?: 'AcfForm', name?: string | null, formContentBlock?: { __typename?: 'FormContentBlock', sectionId?: string | null, title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | { __typename?: 'AcfFuelsavingscalculator', name?: string | null, fuelSavingsCalculator?: { __typename?: 'FuelSavingsCalculator', sectionId?: string | null, sectionTitle?: string | null, multiplier?: number | null, outroCopy?: string | null, marketoFormId?: string | null } | null } | { __typename?: 'AcfHerobanner', name?: string | null, heroBanner?: { __typename?: 'HeroBanner', sectionId?: string | null, title?: string | null, subtitle?: string | null, includeForm?: boolean | null, rightContentType?: Array<string | null> | null, videoUrl?: string | null, content?: Array<{ __typename?: 'HeroBannerContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerContentWysiwyg', wysiwyg?: string | null } | null } | null> | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfHerobannerwithform', name?: string | null, heroBannerWithForm?: { __typename?: 'HeroBannerWithForm', sectionId?: string | null, title?: string | null, subtitle?: string | null, content?: Array<{ __typename?: 'HeroBannerWithFormContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerWithFormContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerWithFormContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerWithFormContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerWithFormContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerWithFormContentWysiwyg', wysiwyg?: string | null } | null } | null> | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, form?: { __typename?: 'HeroBannerWithFormForm', title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | null } | { __typename?: 'AcfHighlight', name?: string | null, highlight?: { __typename?: 'Highlight', sectionId?: string | null, title?: string | null, subtitle?: string | null, imagePlacement?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, content?: Array<{ __typename?: 'HighlightContent', type?: string | null, paragraph?: { __typename?: 'HighlightContentParagraph', text?: string | null } | null, list?: { __typename?: 'HighlightContentList', heading?: string | null, items?: Array<{ __typename?: 'HighlightContentListItems', text?: string | null } | null> | null } | null } | null> | null } | null } | { __typename?: 'AcfLogorows', name?: string | null, logoRows?: { __typename?: 'LogoRows', sectionId?: string | null, title?: string | null, darkBackground?: boolean | null, logos?: Array<{ __typename?: 'LogoRowsLogos', maxWidth?: number | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfLogoscroll', name?: string | null, logoScroll?: { __typename?: 'LogoScroll', sectionId?: string | null, title?: string | null, logoImages?: Array<{ __typename?: 'LogoScrollLogoImages', companyUrl?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfMainhero', name?: string | null, mainHero?: { __typename?: 'MainHero', sectionId?: string | null, title?: string | null, subtitle?: string | null, description?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfModal', name?: string | null } | { __typename?: 'AcfNewsandinsights', name?: string | null, newsAndInsights?: { __typename?: 'NewsAndInsights', sectionId?: string | null, articleLinkText?: string | null, title?: string | null, articles?: Array<{ __typename?: 'NewsAndInsightsArticles', articles?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null } | null } | { __typename?: 'AcfNewslettersignup', name?: string | null, newsletterSignup?: { __typename?: 'NewsletterSignup', sectionId?: string | null, title?: string | null, description?: string | null, darkBackground?: boolean | null, marketoFormId?: string | null, successMessage?: string | null, successUrl?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfOurhistory', name?: string | null, ourHistory?: { __typename?: 'OurHistory', sectionId?: string | null, title?: string | null, timeline?: Array<{ __typename?: 'OurHistoryTimeline', year?: number | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, keyPoints?: Array<{ __typename?: 'OurHistoryTimelineKeyPoints', field?: string | null, value?: string | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfPartners', name?: string | null, partners?: { __typename?: 'Partners', sectionId?: string | null, title?: string | null, description?: string | null, partners?: Array<{ __typename?: 'PartnersPartners', title?: string | null, description?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfSolutions', name?: string | null, solutions?: { __typename?: 'Solutions', sectionId?: string | null, title?: string | null, description?: string | null, solutions?: Array<{ __typename?: 'SolutionsSolutions', buttonId?: string | null, title?: string | null, description?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null } | { __typename?: 'AcfSolutionscards', name?: string | null, solutionsCards?: { __typename?: 'SolutionsCards', sectionId?: string | null, title?: string | null, description?: string | null, cards?: Array<{ __typename?: 'SolutionsCardsCards', description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTeammembers', name?: string | null, teamMembers?: { __typename?: 'TeamMembers', sectionId?: string | null, members?: Array<{ __typename?: 'TeamMembersMembers', name?: string | null, bio?: string | null, bioCtaText?: string | null, ctaId?: string | null, jobTitle?: string | null, jobTitleInDialog?: string | null, headshot?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTestimonials', name?: string | null, testimonials?: { __typename?: 'Testimonials', sectionId?: string | null, darkBackground?: boolean | null, title?: string | null, testimonials?: Array<{ __typename?: 'TestimonialsTestimonials', author?: string | null, quote?: string | null, authorImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTextcontent', name?: string | null, wsywig?: { __typename?: 'Wsywig', externalLinkModal?: boolean | null, darkBackground?: boolean | null, sectionId?: string | null, textContent?: string | null, modal?: { __typename?: 'WsywigModal', buttonText?: string | null, description?: string | null, title?: string | null } | null } | null } | { __typename?: 'AcfTextheader', name?: string | null, textHeader?: { __typename?: 'TextHeader', sectionId?: string | null, title?: string | null, description?: string | null, withGradientText?: boolean | null } | null } | { __typename?: 'AcfThrive', name?: string | null, thrive?: { __typename?: 'Thrive', sectionId?: string | null, title?: string | null, description?: string | null, descriptionFooter?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfTwocolumncta', name?: string | null, twoColumnCta?: { __typename?: 'TwoColumnCta', sectionId?: string | null, buttonId?: string | null, title?: string | null, subtitle?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfTwocolumnpromo', name?: string | null, twoColumnPromo?: { __typename?: 'TwoColumnPromo', sectionId?: string | null, title?: string | null, columnWidths?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, content?: Array<{ __typename?: 'TwoColumnPromoContent', type?: string | null, paragraph?: { __typename?: 'TwoColumnPromoContentParagraph', bold?: boolean | null, largeFontSize?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'TwoColumnPromoContentList', heading?: string | null, items?: Array<{ __typename?: 'TwoColumnPromoContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'TwoColumnPromoContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | null> | null } | null } | { __typename?: 'AcfVideo', name?: string | null, video?: { __typename?: 'Video', sectionId?: string | null, url?: string | null } | null } | { __typename?: 'CoreArchives', name?: string | null } | { __typename?: 'CoreAudio', name?: string | null } | { __typename?: 'CoreAvatar', name?: string | null } | { __typename?: 'CoreBlock', name?: string | null } | { __typename?: 'CoreButton', name?: string | null } | { __typename?: 'CoreButtons', name?: string | null } | { __typename?: 'CoreCalendar', name?: string | null } | { __typename?: 'CoreCategories', name?: string | null } | { __typename?: 'CoreCode', name?: string | null } | { __typename?: 'CoreColumn', name?: string | null } | { __typename?: 'CoreColumns', name?: string | null } | { __typename?: 'CoreCommentAuthorName', name?: string | null } | { __typename?: 'CoreCommentContent', name?: string | null } | { __typename?: 'CoreCommentDate', name?: string | null } | { __typename?: 'CoreCommentEditLink', name?: string | null } | { __typename?: 'CoreCommentReplyLink', name?: string | null } | { __typename?: 'CoreCommentTemplate', name?: string | null } | { __typename?: 'CoreComments', name?: string | null } | { __typename?: 'CoreCommentsPagination', name?: string | null } | { __typename?: 'CoreCommentsPaginationNext', name?: string | null } | { __typename?: 'CoreCommentsPaginationNumbers', name?: string | null } | { __typename?: 'CoreCommentsPaginationPrevious', name?: string | null } | { __typename?: 'CoreCommentsTitle', name?: string | null } | { __typename?: 'CoreCover', name?: string | null } | { __typename?: 'CoreDetails', name?: string | null } | { __typename?: 'CoreEmbed', name?: string | null } | { __typename?: 'CoreFile', name?: string | null } | { __typename?: 'CoreFootnotes', name?: string | null } | { __typename?: 'CoreFreeform', name?: string | null } | { __typename?: 'CoreGallery', name?: string | null } | { __typename?: 'CoreGroup', name?: string | null } | { __typename?: 'CoreHeading', name?: string | null } | { __typename?: 'CoreHomeLink', name?: string | null } | { __typename?: 'CoreHtml', name?: string | null } | { __typename?: 'CoreImage', name?: string | null } | { __typename?: 'CoreLatestComments', name?: string | null } | { __typename?: 'CoreLatestPosts', name?: string | null } | { __typename?: 'CoreLegacyWidget', name?: string | null } | { __typename?: 'CoreList', name?: string | null } | { __typename?: 'CoreListItem', name?: string | null } | { __typename?: 'CoreLoginout', name?: string | null } | { __typename?: 'CoreMediaText', name?: string | null } | { __typename?: 'CoreMissing', name?: string | null } | { __typename?: 'CoreMore', name?: string | null } | { __typename?: 'CoreNavigation', name?: string | null } | { __typename?: 'CoreNavigationLink', name?: string | null } | { __typename?: 'CoreNavigationSubmenu', name?: string | null } | { __typename?: 'CoreNextpage', name?: string | null } | { __typename?: 'CorePageList', name?: string | null } | { __typename?: 'CorePageListItem', name?: string | null } | { __typename?: 'CoreParagraph', name?: string | null } | { __typename?: 'CorePattern', name?: string | null } | { __typename?: 'CorePostAuthor', name?: string | null } | { __typename?: 'CorePostAuthorBiography', name?: string | null } | { __typename?: 'CorePostAuthorName', name?: string | null } | { __typename?: 'CorePostComments', name?: string | null } | { __typename?: 'CorePostCommentsForm', name?: string | null } | { __typename?: 'CorePostContent', name?: string | null } | { __typename?: 'CorePostDate', name?: string | null } | { __typename?: 'CorePostExcerpt', name?: string | null } | { __typename?: 'CorePostFeaturedImage', name?: string | null } | { __typename?: 'CorePostNavigationLink', name?: string | null } | { __typename?: 'CorePostTemplate', name?: string | null } | { __typename?: 'CorePostTerms', name?: string | null } | { __typename?: 'CorePostTitle', name?: string | null } | { __typename?: 'CorePreformatted', name?: string | null } | { __typename?: 'CorePullquote', name?: string | null } | { __typename?: 'CoreQuery', name?: string | null } | { __typename?: 'CoreQueryNoResults', name?: string | null } | { __typename?: 'CoreQueryPagination', name?: string | null } | { __typename?: 'CoreQueryPaginationNext', name?: string | null } | { __typename?: 'CoreQueryPaginationNumbers', name?: string | null } | { __typename?: 'CoreQueryPaginationPrevious', name?: string | null } | { __typename?: 'CoreQueryTitle', name?: string | null } | { __typename?: 'CoreQueryTotal', name?: string | null } | { __typename?: 'CoreQuote', name?: string | null } | { __typename?: 'CoreReadMore', name?: string | null } | { __typename?: 'CoreRss', name?: string | null } | { __typename?: 'CoreSearch', name?: string | null } | { __typename?: 'CoreSeparator', name?: string | null } | { __typename?: 'CoreShortcode', name?: string | null } | { __typename?: 'CoreSiteLogo', name?: string | null } | { __typename?: 'CoreSiteTagline', name?: string | null } | { __typename?: 'CoreSiteTitle', name?: string | null } | { __typename?: 'CoreSocialLink', name?: string | null } | { __typename?: 'CoreSocialLinks', name?: string | null } | { __typename?: 'CoreSpacer', name?: string | null } | { __typename?: 'CoreTable', name?: string | null } | { __typename?: 'CoreTagCloud', name?: string | null } | { __typename?: 'CoreTemplatePart', name?: string | null } | { __typename?: 'CoreTermDescription', name?: string | null } | { __typename?: 'CoreTextColumns', name?: string | null } | { __typename?: 'CoreVerse', name?: string | null } | { __typename?: 'CoreVideo', name?: string | null } | { __typename?: 'CoreWidgetGroup', name?: string | null } | { __typename?: 'GravityformsForm', name?: string | null, attributes?: { __typename?: 'GravityformsFormAttributes', form?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | { __typename?: 'YoastFaqBlock', name?: string | null } | { __typename?: 'YoastHowToBlock', name?: string | null } | { __typename?: 'YoastSeoBreadcrumbs', name?: string | null } | null> | null };

export type ImageFragmentFragment = { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } };

export type ImageWithoutMediaDetailsFragmentFragment = { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } };

export type GetLayoutQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLayoutQuery = { __typename?: 'RootQuery', footerMenus?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', blockFooter?: { __typename?: 'BlockFooter', phone?: number | null, footerDisclosure?: string | null, footerAddress?: string | null, footerLogo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } } | null, socialMediaIcons?: Array<{ __typename?: 'BlockFooterSocialMediaIcons', socialMediaUrl?: string | null, iconImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } } | null } | null> | null } | null, menuItems?: { __typename?: 'MenuToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, parentId?: string | null }> } | null }> } | null, generalSettings?: { __typename?: 'GeneralSettings', title?: string | null } | null, headerLogo?: { __typename?: 'RootQueryToMediaItemConnection', nodes: Array<{ __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null }> } | null, headerMenuItems?: { __typename?: 'RootQueryToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, navDetails?: { __typename?: 'NavDetails', description?: string | null, link?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, navSegments?: { __typename?: 'NavSegments', segments?: Array<{ __typename?: 'NavSegmentsSegments', title?: string | null, links?: Array<{ __typename?: 'NavSegmentsSegmentsLinks', link?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null> | null } | null }> } | null, menuButton?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', menuButton?: { __typename?: 'MenuButton', menubutton?: Array<{ __typename?: 'MenuButtonMenubutton', menubuttonlink?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null }> } | null, systemAlert?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', systemAlert?: { __typename?: 'SystemAlert', alertId?: string | null, message?: string | null, start?: string | null, end?: string | null } | null }> } | null, uTMConfiguration?: { __typename?: 'UTMConfiguration', utmConfigurationBlock?: { __typename?: 'UtmConfigurationBlock', utmQueryParams?: Array<{ __typename?: 'UtmConfigurationBlockUtmQueryParams', queryParam?: string | null } | null> | null } | null } | null };

export type LinkFragmentFragment = { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null };

export type GetPageQueryVariables = Exact<{
  pageId: Scalars['ID']['input'];
  asPreview: Scalars['Boolean']['input'];
}>;


export type GetPageQuery = { __typename?: 'RootQuery', page?: { __typename?: 'Page', uri?: string | null, id: string, seo?: { __typename?: 'PostTypeSEO', canonical?: string | null, focuskw?: string | null, metaDesc?: string | null, metaKeywords?: string | null, metaRobotsNofollow?: string | null, metaRobotsNoindex?: string | null, opengraphAuthor?: string | null, opengraphDescription?: string | null, opengraphModifiedTime?: string | null, opengraphPublishedTime?: string | null, opengraphPublisher?: string | null, opengraphSiteName?: string | null, opengraphTitle?: string | null, opengraphType?: string | null, opengraphUrl?: string | null, readingTime?: number | null, title?: string | null, twitterDescription?: string | null, twitterTitle?: string | null, opengraphImage?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null } | null } | null, twitterImage?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', width?: number | null, height?: number | null } | null } | null } | null, editorBlocks?: Array<{ __typename?: 'AcfAccordion', name?: string | null, accordion?: { __typename?: 'Accordion', sectionId?: string | null, darkBackground?: boolean | null, description?: string | null, iconType?: Array<string | null> | null, title?: string | null, withAbbreviations?: boolean | null, withLargeItemTitle?: boolean | null, items?: Array<{ __typename?: 'AccordionItems', title?: string | null, content?: string | null } | null> | null } | null } | { __typename?: 'AcfArticlecards', name?: string | null } | { __typename?: 'AcfBenefits', name?: string | null, benefits?: { __typename?: 'Benefits', sectionId?: string | null, sectionDescription?: string | null, benefitCards?: Array<{ __typename?: 'BenefitsBenefitCards', buttonId?: string | null, title?: string | null, description?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, cardImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfBenefitsaccordion', name?: string | null, benefitsAccordion?: { __typename?: 'BenefitsAccordion', sectionId?: string | null, title?: string | null, subtitle?: string | null, accordionItems?: Array<{ __typename?: 'BenefitsAccordionAccordionItems', description?: string | null, accordionImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, links?: Array<{ __typename?: 'BenefitsAccordionAccordionItemsLinks', linkId?: string | null, link?: { __typename?: 'AcfLink', url?: string | null, title?: string | null } | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfBenefitscontent', name?: string | null, benefitscontent?: { __typename?: 'Benefitscontent', sectionId?: string | null, title?: string | null, textContent?: string | null, textContentVerticalAlignment?: Array<string | null> | null, media?: { __typename?: 'BenefitscontentMedia', type?: string | null, video?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | null } | { __typename?: 'AcfBenefitslist', name?: string | null, benefitsList?: { __typename?: 'BenefitsList', sectionId?: string | null, title?: string | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, benefits?: Array<{ __typename?: 'BenefitsListBenefits', title?: string | null, description?: string | null } | null> | null, disclaimers?: Array<{ __typename?: 'BenefitsListDisclaimers', text?: string | null } | null> | null } | null } | { __typename?: 'AcfBlogarticles', name?: string | null, blogArticles?: { __typename?: 'BlogArticles', sectionId?: string | null, featuredArticles?: Array<{ __typename?: 'BlogArticlesFeaturedArticles', articles?: Array<{ __typename?: 'BlogArticlesFeaturedArticlesArticles', article?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null, category?: { __typename?: 'AcfTermNodeConnection', edges: Array<{ __typename?: 'AcfTermNodeConnectionEdge', node: { __typename?: 'Category', databaseId: number, name?: string | null } | { __typename?: 'PostFormat', databaseId: number, name?: string | null } | { __typename?: 'Tag', databaseId: number, name?: string | null } }> } | null } | null> | null } | null } | { __typename?: 'AcfBlogctacard', name?: string | null, blogCtaCard?: { __typename?: 'BlogCtaCard', sectionId?: string | null, title?: string | null, buttonId?: string | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | { __typename?: 'AcfCallouttext', name?: string | null, calloutText?: { __typename?: 'CalloutText', sectionId?: string | null, title?: string | null, text?: string | null } | null } | { __typename?: 'AcfCardgrid', name?: string | null, cardGrid?: { __typename?: 'CardGrid', sectionId?: string | null, maxColumns?: number | null, sectionBackgroundColor?: string | null, sectionTitle?: string | null, description?: string | null, cardBackgroundColor?: string | null, cardBorder?: string | null, cards?: Array<{ __typename?: 'CardGridCards', card?: Array<{ __typename?: 'CardGridCardsCard', elementType?: Array<string | null> | null, title?: string | null, buttonColor?: string | null, buttonId?: string | null, paragraph?: string | null, heading?: string | null, disclaimer?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, imageData?: { __typename?: 'CardGridCardsCardImageData', alignment?: string | null, caption?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null, list?: Array<{ __typename?: 'CardGridCardsCardList', item?: string | null } | null> | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfCasestudies', name?: string | null, caseStudies?: { __typename?: 'CaseStudies', sectionId?: string | null, sectionTitle?: string | null, ctaText?: string | null, darkBackground?: boolean | null, items?: Array<{ __typename?: 'CaseStudiesItems', description?: string | null, post?: { __typename?: 'AcfContentNodeConnection', nodes: Array<{ __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null }> } | null } | null> | null } | null } | { __typename?: 'AcfCompanylist', name?: string | null, companyList?: { __typename?: 'CompanyList', sectionId?: string | null, companies?: Array<{ __typename?: 'CompanyListCompanies', buttonId?: string | null, description?: string | null, title?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfCorevalues', name?: string | null } | { __typename?: 'AcfCtacard', name?: string | null, ctaCard?: { __typename?: 'CtaCard', sectionId?: string | null, heading?: string | null, text?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, secondaryButton?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | { __typename?: 'AcfDivider', name?: string | null, divider?: { __typename?: 'Divider', sectionId?: string | null, darkBackground?: boolean | null } | null } | { __typename?: 'AcfFactoringinfographic', name?: string | null, factoringInfoGraphic?: { __typename?: 'FactoringInfoGraphic', sectionId?: string | null, title?: string | null, items?: Array<{ __typename?: 'FactoringInfoGraphicItems', description?: string | null } | null> | null } | null } | { __typename?: 'AcfFinancingcta', name?: string | null, financingCta?: { __typename?: 'FinancingCta', sectionId?: string | null, buttonId?: string | null, title?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, keyPoints?: Array<{ __typename?: 'FinancingCtaKeyPoints', field?: string | null, value?: string | null } | null> | null } | null } | { __typename?: 'AcfForm', name?: string | null, formContentBlock?: { __typename?: 'FormContentBlock', sectionId?: string | null, title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | { __typename?: 'AcfFuelsavingscalculator', name?: string | null, fuelSavingsCalculator?: { __typename?: 'FuelSavingsCalculator', sectionId?: string | null, sectionTitle?: string | null, multiplier?: number | null, outroCopy?: string | null, marketoFormId?: string | null } | null } | { __typename?: 'AcfHerobanner', name?: string | null, heroBanner?: { __typename?: 'HeroBanner', sectionId?: string | null, title?: string | null, subtitle?: string | null, includeForm?: boolean | null, rightContentType?: Array<string | null> | null, videoUrl?: string | null, content?: Array<{ __typename?: 'HeroBannerContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerContentWysiwyg', wysiwyg?: string | null } | null } | null> | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfHerobannerwithform', name?: string | null, heroBannerWithForm?: { __typename?: 'HeroBannerWithForm', sectionId?: string | null, title?: string | null, subtitle?: string | null, content?: Array<{ __typename?: 'HeroBannerWithFormContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerWithFormContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerWithFormContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerWithFormContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerWithFormContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerWithFormContentWysiwyg', wysiwyg?: string | null } | null } | null> | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, form?: { __typename?: 'HeroBannerWithFormForm', title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | null } | { __typename?: 'AcfHighlight', name?: string | null, highlight?: { __typename?: 'Highlight', sectionId?: string | null, title?: string | null, subtitle?: string | null, imagePlacement?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, content?: Array<{ __typename?: 'HighlightContent', type?: string | null, paragraph?: { __typename?: 'HighlightContentParagraph', text?: string | null } | null, list?: { __typename?: 'HighlightContentList', heading?: string | null, items?: Array<{ __typename?: 'HighlightContentListItems', text?: string | null } | null> | null } | null } | null> | null } | null } | { __typename?: 'AcfLogorows', name?: string | null, logoRows?: { __typename?: 'LogoRows', sectionId?: string | null, title?: string | null, darkBackground?: boolean | null, logos?: Array<{ __typename?: 'LogoRowsLogos', maxWidth?: number | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfLogoscroll', name?: string | null, logoScroll?: { __typename?: 'LogoScroll', sectionId?: string | null, title?: string | null, logoImages?: Array<{ __typename?: 'LogoScrollLogoImages', companyUrl?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfMainhero', name?: string | null, mainHero?: { __typename?: 'MainHero', sectionId?: string | null, title?: string | null, subtitle?: string | null, description?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfModal', name?: string | null } | { __typename?: 'AcfNewsandinsights', name?: string | null, newsAndInsights?: { __typename?: 'NewsAndInsights', sectionId?: string | null, articleLinkText?: string | null, title?: string | null, articles?: Array<{ __typename?: 'NewsAndInsightsArticles', articles?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null } | null } | { __typename?: 'AcfNewslettersignup', name?: string | null, newsletterSignup?: { __typename?: 'NewsletterSignup', sectionId?: string | null, title?: string | null, description?: string | null, darkBackground?: boolean | null, marketoFormId?: string | null, successMessage?: string | null, successUrl?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfOurhistory', name?: string | null, ourHistory?: { __typename?: 'OurHistory', sectionId?: string | null, title?: string | null, timeline?: Array<{ __typename?: 'OurHistoryTimeline', year?: number | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, keyPoints?: Array<{ __typename?: 'OurHistoryTimelineKeyPoints', field?: string | null, value?: string | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfPartners', name?: string | null, partners?: { __typename?: 'Partners', sectionId?: string | null, title?: string | null, description?: string | null, partners?: Array<{ __typename?: 'PartnersPartners', title?: string | null, description?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfSolutions', name?: string | null, solutions?: { __typename?: 'Solutions', sectionId?: string | null, title?: string | null, description?: string | null, solutions?: Array<{ __typename?: 'SolutionsSolutions', buttonId?: string | null, title?: string | null, description?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null } | { __typename?: 'AcfSolutionscards', name?: string | null, solutionsCards?: { __typename?: 'SolutionsCards', sectionId?: string | null, title?: string | null, description?: string | null, cards?: Array<{ __typename?: 'SolutionsCardsCards', description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTeammembers', name?: string | null, teamMembers?: { __typename?: 'TeamMembers', sectionId?: string | null, members?: Array<{ __typename?: 'TeamMembersMembers', name?: string | null, bio?: string | null, bioCtaText?: string | null, ctaId?: string | null, jobTitle?: string | null, jobTitleInDialog?: string | null, headshot?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTestimonials', name?: string | null, testimonials?: { __typename?: 'Testimonials', sectionId?: string | null, darkBackground?: boolean | null, title?: string | null, testimonials?: Array<{ __typename?: 'TestimonialsTestimonials', author?: string | null, quote?: string | null, authorImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTextcontent', name?: string | null, wsywig?: { __typename?: 'Wsywig', externalLinkModal?: boolean | null, darkBackground?: boolean | null, sectionId?: string | null, textContent?: string | null, modal?: { __typename?: 'WsywigModal', buttonText?: string | null, description?: string | null, title?: string | null } | null } | null } | { __typename?: 'AcfTextheader', name?: string | null, textHeader?: { __typename?: 'TextHeader', sectionId?: string | null, title?: string | null, description?: string | null, withGradientText?: boolean | null } | null } | { __typename?: 'AcfThrive', name?: string | null, thrive?: { __typename?: 'Thrive', sectionId?: string | null, title?: string | null, description?: string | null, descriptionFooter?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfTwocolumncta', name?: string | null, twoColumnCta?: { __typename?: 'TwoColumnCta', sectionId?: string | null, buttonId?: string | null, title?: string | null, subtitle?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfTwocolumnpromo', name?: string | null, twoColumnPromo?: { __typename?: 'TwoColumnPromo', sectionId?: string | null, title?: string | null, columnWidths?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, content?: Array<{ __typename?: 'TwoColumnPromoContent', type?: string | null, paragraph?: { __typename?: 'TwoColumnPromoContentParagraph', bold?: boolean | null, largeFontSize?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'TwoColumnPromoContentList', heading?: string | null, items?: Array<{ __typename?: 'TwoColumnPromoContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'TwoColumnPromoContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | null> | null } | null } | { __typename?: 'AcfVideo', name?: string | null, video?: { __typename?: 'Video', sectionId?: string | null, url?: string | null } | null } | { __typename?: 'CoreArchives', name?: string | null } | { __typename?: 'CoreAudio', name?: string | null } | { __typename?: 'CoreAvatar', name?: string | null } | { __typename?: 'CoreBlock', name?: string | null } | { __typename?: 'CoreButton', name?: string | null } | { __typename?: 'CoreButtons', name?: string | null } | { __typename?: 'CoreCalendar', name?: string | null } | { __typename?: 'CoreCategories', name?: string | null } | { __typename?: 'CoreCode', name?: string | null } | { __typename?: 'CoreColumn', name?: string | null } | { __typename?: 'CoreColumns', name?: string | null } | { __typename?: 'CoreCommentAuthorName', name?: string | null } | { __typename?: 'CoreCommentContent', name?: string | null } | { __typename?: 'CoreCommentDate', name?: string | null } | { __typename?: 'CoreCommentEditLink', name?: string | null } | { __typename?: 'CoreCommentReplyLink', name?: string | null } | { __typename?: 'CoreCommentTemplate', name?: string | null } | { __typename?: 'CoreComments', name?: string | null } | { __typename?: 'CoreCommentsPagination', name?: string | null } | { __typename?: 'CoreCommentsPaginationNext', name?: string | null } | { __typename?: 'CoreCommentsPaginationNumbers', name?: string | null } | { __typename?: 'CoreCommentsPaginationPrevious', name?: string | null } | { __typename?: 'CoreCommentsTitle', name?: string | null } | { __typename?: 'CoreCover', name?: string | null } | { __typename?: 'CoreDetails', name?: string | null } | { __typename?: 'CoreEmbed', name?: string | null } | { __typename?: 'CoreFile', name?: string | null } | { __typename?: 'CoreFootnotes', name?: string | null } | { __typename?: 'CoreFreeform', name?: string | null } | { __typename?: 'CoreGallery', name?: string | null } | { __typename?: 'CoreGroup', name?: string | null } | { __typename?: 'CoreHeading', name?: string | null } | { __typename?: 'CoreHomeLink', name?: string | null } | { __typename?: 'CoreHtml', name?: string | null } | { __typename?: 'CoreImage', name?: string | null } | { __typename?: 'CoreLatestComments', name?: string | null } | { __typename?: 'CoreLatestPosts', name?: string | null } | { __typename?: 'CoreLegacyWidget', name?: string | null } | { __typename?: 'CoreList', name?: string | null } | { __typename?: 'CoreListItem', name?: string | null } | { __typename?: 'CoreLoginout', name?: string | null } | { __typename?: 'CoreMediaText', name?: string | null } | { __typename?: 'CoreMissing', name?: string | null } | { __typename?: 'CoreMore', name?: string | null } | { __typename?: 'CoreNavigation', name?: string | null } | { __typename?: 'CoreNavigationLink', name?: string | null } | { __typename?: 'CoreNavigationSubmenu', name?: string | null } | { __typename?: 'CoreNextpage', name?: string | null } | { __typename?: 'CorePageList', name?: string | null } | { __typename?: 'CorePageListItem', name?: string | null } | { __typename?: 'CoreParagraph', name?: string | null } | { __typename?: 'CorePattern', name?: string | null } | { __typename?: 'CorePostAuthor', name?: string | null } | { __typename?: 'CorePostAuthorBiography', name?: string | null } | { __typename?: 'CorePostAuthorName', name?: string | null } | { __typename?: 'CorePostComments', name?: string | null } | { __typename?: 'CorePostCommentsForm', name?: string | null } | { __typename?: 'CorePostContent', name?: string | null } | { __typename?: 'CorePostDate', name?: string | null } | { __typename?: 'CorePostExcerpt', name?: string | null } | { __typename?: 'CorePostFeaturedImage', name?: string | null } | { __typename?: 'CorePostNavigationLink', name?: string | null } | { __typename?: 'CorePostTemplate', name?: string | null } | { __typename?: 'CorePostTerms', name?: string | null } | { __typename?: 'CorePostTitle', name?: string | null } | { __typename?: 'CorePreformatted', name?: string | null } | { __typename?: 'CorePullquote', name?: string | null } | { __typename?: 'CoreQuery', name?: string | null } | { __typename?: 'CoreQueryNoResults', name?: string | null } | { __typename?: 'CoreQueryPagination', name?: string | null } | { __typename?: 'CoreQueryPaginationNext', name?: string | null } | { __typename?: 'CoreQueryPaginationNumbers', name?: string | null } | { __typename?: 'CoreQueryPaginationPrevious', name?: string | null } | { __typename?: 'CoreQueryTitle', name?: string | null } | { __typename?: 'CoreQueryTotal', name?: string | null } | { __typename?: 'CoreQuote', name?: string | null } | { __typename?: 'CoreReadMore', name?: string | null } | { __typename?: 'CoreRss', name?: string | null } | { __typename?: 'CoreSearch', name?: string | null } | { __typename?: 'CoreSeparator', name?: string | null } | { __typename?: 'CoreShortcode', name?: string | null } | { __typename?: 'CoreSiteLogo', name?: string | null } | { __typename?: 'CoreSiteTagline', name?: string | null } | { __typename?: 'CoreSiteTitle', name?: string | null } | { __typename?: 'CoreSocialLink', name?: string | null } | { __typename?: 'CoreSocialLinks', name?: string | null } | { __typename?: 'CoreSpacer', name?: string | null } | { __typename?: 'CoreTable', name?: string | null } | { __typename?: 'CoreTagCloud', name?: string | null } | { __typename?: 'CoreTemplatePart', name?: string | null } | { __typename?: 'CoreTermDescription', name?: string | null } | { __typename?: 'CoreTextColumns', name?: string | null } | { __typename?: 'CoreVerse', name?: string | null } | { __typename?: 'CoreVideo', name?: string | null } | { __typename?: 'CoreWidgetGroup', name?: string | null } | { __typename?: 'GravityformsForm', name?: string | null, attributes?: { __typename?: 'GravityformsFormAttributes', form?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | { __typename?: 'YoastFaqBlock', name?: string | null } | { __typename?: 'YoastHowToBlock', name?: string | null } | { __typename?: 'YoastSeoBreadcrumbs', name?: string | null } | null> | null } | null };

export type PostAsideContentFragmentFragment = { __typename?: 'PostAsideContent', newsletter?: { __typename?: 'PostAsideContentNewsletter', title?: string | null, description?: string | null, marketoFormId?: string | null, successMessage?: string | null } | null };

type PostEditorBlockFragment_AcfAccordion_Fragment = { __typename?: 'AcfAccordion', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfArticlecards_Fragment = { __typename?: 'AcfArticlecards', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfBenefits_Fragment = { __typename?: 'AcfBenefits', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfBenefitsaccordion_Fragment = { __typename?: 'AcfBenefitsaccordion', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfBenefitscontent_Fragment = { __typename?: 'AcfBenefitscontent', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfBenefitslist_Fragment = { __typename?: 'AcfBenefitslist', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfBlogarticles_Fragment = { __typename?: 'AcfBlogarticles', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfBlogctacard_Fragment = { __typename?: 'AcfBlogctacard', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfCallouttext_Fragment = { __typename?: 'AcfCallouttext', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfCardgrid_Fragment = { __typename?: 'AcfCardgrid', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfCasestudies_Fragment = { __typename?: 'AcfCasestudies', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfCompanylist_Fragment = { __typename?: 'AcfCompanylist', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfCorevalues_Fragment = { __typename?: 'AcfCorevalues', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfCtacard_Fragment = { __typename?: 'AcfCtacard', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfDivider_Fragment = { __typename?: 'AcfDivider', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfFactoringinfographic_Fragment = { __typename?: 'AcfFactoringinfographic', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfFinancingcta_Fragment = { __typename?: 'AcfFinancingcta', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfForm_Fragment = { __typename?: 'AcfForm', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfFuelsavingscalculator_Fragment = { __typename?: 'AcfFuelsavingscalculator', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfHerobanner_Fragment = { __typename?: 'AcfHerobanner', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfHerobannerwithform_Fragment = { __typename?: 'AcfHerobannerwithform', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfHighlight_Fragment = { __typename?: 'AcfHighlight', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfLogorows_Fragment = { __typename?: 'AcfLogorows', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfLogoscroll_Fragment = { __typename?: 'AcfLogoscroll', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfMainhero_Fragment = { __typename?: 'AcfMainhero', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfModal_Fragment = { __typename?: 'AcfModal', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfNewsandinsights_Fragment = { __typename?: 'AcfNewsandinsights', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfNewslettersignup_Fragment = { __typename?: 'AcfNewslettersignup', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfOurhistory_Fragment = { __typename?: 'AcfOurhistory', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfPartners_Fragment = { __typename?: 'AcfPartners', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfSolutions_Fragment = { __typename?: 'AcfSolutions', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfSolutionscards_Fragment = { __typename?: 'AcfSolutionscards', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfTeammembers_Fragment = { __typename?: 'AcfTeammembers', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfTestimonials_Fragment = { __typename?: 'AcfTestimonials', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfTextcontent_Fragment = { __typename?: 'AcfTextcontent', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfTextheader_Fragment = { __typename?: 'AcfTextheader', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfThrive_Fragment = { __typename?: 'AcfThrive', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfTwocolumncta_Fragment = { __typename?: 'AcfTwocolumncta', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfTwocolumnpromo_Fragment = { __typename?: 'AcfTwocolumnpromo', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_AcfVideo_Fragment = { __typename?: 'AcfVideo', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreArchives_Fragment = { __typename?: 'CoreArchives', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreAudio_Fragment = { __typename?: 'CoreAudio', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreAvatar_Fragment = { __typename?: 'CoreAvatar', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreBlock_Fragment = { __typename?: 'CoreBlock', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreButton_Fragment = { __typename?: 'CoreButton', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreButtons_Fragment = { __typename?: 'CoreButtons', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCalendar_Fragment = { __typename?: 'CoreCalendar', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCategories_Fragment = { __typename?: 'CoreCategories', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCode_Fragment = { __typename?: 'CoreCode', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreColumn_Fragment = { __typename?: 'CoreColumn', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreColumns_Fragment = { __typename?: 'CoreColumns', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCommentAuthorName_Fragment = { __typename?: 'CoreCommentAuthorName', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCommentContent_Fragment = { __typename?: 'CoreCommentContent', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCommentDate_Fragment = { __typename?: 'CoreCommentDate', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCommentEditLink_Fragment = { __typename?: 'CoreCommentEditLink', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCommentReplyLink_Fragment = { __typename?: 'CoreCommentReplyLink', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCommentTemplate_Fragment = { __typename?: 'CoreCommentTemplate', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreComments_Fragment = { __typename?: 'CoreComments', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCommentsPagination_Fragment = { __typename?: 'CoreCommentsPagination', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCommentsPaginationNext_Fragment = { __typename?: 'CoreCommentsPaginationNext', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCommentsPaginationNumbers_Fragment = { __typename?: 'CoreCommentsPaginationNumbers', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCommentsPaginationPrevious_Fragment = { __typename?: 'CoreCommentsPaginationPrevious', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCommentsTitle_Fragment = { __typename?: 'CoreCommentsTitle', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreCover_Fragment = { __typename?: 'CoreCover', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreDetails_Fragment = { __typename?: 'CoreDetails', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreEmbed_Fragment = { __typename?: 'CoreEmbed', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreFile_Fragment = { __typename?: 'CoreFile', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreFootnotes_Fragment = { __typename?: 'CoreFootnotes', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreFreeform_Fragment = { __typename?: 'CoreFreeform', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreGallery_Fragment = { __typename?: 'CoreGallery', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreGroup_Fragment = { __typename?: 'CoreGroup', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreHeading_Fragment = { __typename?: 'CoreHeading', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreHomeLink_Fragment = { __typename?: 'CoreHomeLink', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreHtml_Fragment = { __typename?: 'CoreHtml', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreImage_Fragment = { __typename?: 'CoreImage', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreLatestComments_Fragment = { __typename?: 'CoreLatestComments', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreLatestPosts_Fragment = { __typename?: 'CoreLatestPosts', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreLegacyWidget_Fragment = { __typename?: 'CoreLegacyWidget', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreList_Fragment = { __typename?: 'CoreList', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreListItem_Fragment = { __typename?: 'CoreListItem', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreLoginout_Fragment = { __typename?: 'CoreLoginout', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreMediaText_Fragment = { __typename?: 'CoreMediaText', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreMissing_Fragment = { __typename?: 'CoreMissing', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreMore_Fragment = { __typename?: 'CoreMore', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreNavigation_Fragment = { __typename?: 'CoreNavigation', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreNavigationLink_Fragment = { __typename?: 'CoreNavigationLink', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreNavigationSubmenu_Fragment = { __typename?: 'CoreNavigationSubmenu', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreNextpage_Fragment = { __typename?: 'CoreNextpage', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePageList_Fragment = { __typename?: 'CorePageList', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePageListItem_Fragment = { __typename?: 'CorePageListItem', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreParagraph_Fragment = { __typename?: 'CoreParagraph', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePattern_Fragment = { __typename?: 'CorePattern', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePostAuthor_Fragment = { __typename?: 'CorePostAuthor', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePostAuthorBiography_Fragment = { __typename?: 'CorePostAuthorBiography', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePostAuthorName_Fragment = { __typename?: 'CorePostAuthorName', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePostComments_Fragment = { __typename?: 'CorePostComments', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePostCommentsForm_Fragment = { __typename?: 'CorePostCommentsForm', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePostContent_Fragment = { __typename?: 'CorePostContent', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePostDate_Fragment = { __typename?: 'CorePostDate', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePostExcerpt_Fragment = { __typename?: 'CorePostExcerpt', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePostFeaturedImage_Fragment = { __typename?: 'CorePostFeaturedImage', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePostNavigationLink_Fragment = { __typename?: 'CorePostNavigationLink', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePostTemplate_Fragment = { __typename?: 'CorePostTemplate', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePostTerms_Fragment = { __typename?: 'CorePostTerms', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePostTitle_Fragment = { __typename?: 'CorePostTitle', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePreformatted_Fragment = { __typename?: 'CorePreformatted', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CorePullquote_Fragment = { __typename?: 'CorePullquote', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreQuery_Fragment = { __typename?: 'CoreQuery', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreQueryNoResults_Fragment = { __typename?: 'CoreQueryNoResults', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreQueryPagination_Fragment = { __typename?: 'CoreQueryPagination', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreQueryPaginationNext_Fragment = { __typename?: 'CoreQueryPaginationNext', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreQueryPaginationNumbers_Fragment = { __typename?: 'CoreQueryPaginationNumbers', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreQueryPaginationPrevious_Fragment = { __typename?: 'CoreQueryPaginationPrevious', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreQueryTitle_Fragment = { __typename?: 'CoreQueryTitle', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreQueryTotal_Fragment = { __typename?: 'CoreQueryTotal', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreQuote_Fragment = { __typename?: 'CoreQuote', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreReadMore_Fragment = { __typename?: 'CoreReadMore', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreRss_Fragment = { __typename?: 'CoreRss', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreSearch_Fragment = { __typename?: 'CoreSearch', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreSeparator_Fragment = { __typename?: 'CoreSeparator', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreShortcode_Fragment = { __typename?: 'CoreShortcode', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreSiteLogo_Fragment = { __typename?: 'CoreSiteLogo', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreSiteTagline_Fragment = { __typename?: 'CoreSiteTagline', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreSiteTitle_Fragment = { __typename?: 'CoreSiteTitle', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreSocialLink_Fragment = { __typename?: 'CoreSocialLink', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreSocialLinks_Fragment = { __typename?: 'CoreSocialLinks', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreSpacer_Fragment = { __typename?: 'CoreSpacer', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreTable_Fragment = { __typename?: 'CoreTable', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreTagCloud_Fragment = { __typename?: 'CoreTagCloud', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreTemplatePart_Fragment = { __typename?: 'CoreTemplatePart', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreTermDescription_Fragment = { __typename?: 'CoreTermDescription', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreTextColumns_Fragment = { __typename?: 'CoreTextColumns', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreVerse_Fragment = { __typename?: 'CoreVerse', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreVideo_Fragment = { __typename?: 'CoreVideo', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_CoreWidgetGroup_Fragment = { __typename?: 'CoreWidgetGroup', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_GravityformsForm_Fragment = { __typename?: 'GravityformsForm', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_YoastFaqBlock_Fragment = { __typename?: 'YoastFaqBlock', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_YoastHowToBlock_Fragment = { __typename?: 'YoastHowToBlock', name?: string | null, renderedHtml?: string | null };

type PostEditorBlockFragment_YoastSeoBreadcrumbs_Fragment = { __typename?: 'YoastSeoBreadcrumbs', name?: string | null, renderedHtml?: string | null };

export type PostEditorBlockFragmentFragment = PostEditorBlockFragment_AcfAccordion_Fragment | PostEditorBlockFragment_AcfArticlecards_Fragment | PostEditorBlockFragment_AcfBenefits_Fragment | PostEditorBlockFragment_AcfBenefitsaccordion_Fragment | PostEditorBlockFragment_AcfBenefitscontent_Fragment | PostEditorBlockFragment_AcfBenefitslist_Fragment | PostEditorBlockFragment_AcfBlogarticles_Fragment | PostEditorBlockFragment_AcfBlogctacard_Fragment | PostEditorBlockFragment_AcfCallouttext_Fragment | PostEditorBlockFragment_AcfCardgrid_Fragment | PostEditorBlockFragment_AcfCasestudies_Fragment | PostEditorBlockFragment_AcfCompanylist_Fragment | PostEditorBlockFragment_AcfCorevalues_Fragment | PostEditorBlockFragment_AcfCtacard_Fragment | PostEditorBlockFragment_AcfDivider_Fragment | PostEditorBlockFragment_AcfFactoringinfographic_Fragment | PostEditorBlockFragment_AcfFinancingcta_Fragment | PostEditorBlockFragment_AcfForm_Fragment | PostEditorBlockFragment_AcfFuelsavingscalculator_Fragment | PostEditorBlockFragment_AcfHerobanner_Fragment | PostEditorBlockFragment_AcfHerobannerwithform_Fragment | PostEditorBlockFragment_AcfHighlight_Fragment | PostEditorBlockFragment_AcfLogorows_Fragment | PostEditorBlockFragment_AcfLogoscroll_Fragment | PostEditorBlockFragment_AcfMainhero_Fragment | PostEditorBlockFragment_AcfModal_Fragment | PostEditorBlockFragment_AcfNewsandinsights_Fragment | PostEditorBlockFragment_AcfNewslettersignup_Fragment | PostEditorBlockFragment_AcfOurhistory_Fragment | PostEditorBlockFragment_AcfPartners_Fragment | PostEditorBlockFragment_AcfSolutions_Fragment | PostEditorBlockFragment_AcfSolutionscards_Fragment | PostEditorBlockFragment_AcfTeammembers_Fragment | PostEditorBlockFragment_AcfTestimonials_Fragment | PostEditorBlockFragment_AcfTextcontent_Fragment | PostEditorBlockFragment_AcfTextheader_Fragment | PostEditorBlockFragment_AcfThrive_Fragment | PostEditorBlockFragment_AcfTwocolumncta_Fragment | PostEditorBlockFragment_AcfTwocolumnpromo_Fragment | PostEditorBlockFragment_AcfVideo_Fragment | PostEditorBlockFragment_CoreArchives_Fragment | PostEditorBlockFragment_CoreAudio_Fragment | PostEditorBlockFragment_CoreAvatar_Fragment | PostEditorBlockFragment_CoreBlock_Fragment | PostEditorBlockFragment_CoreButton_Fragment | PostEditorBlockFragment_CoreButtons_Fragment | PostEditorBlockFragment_CoreCalendar_Fragment | PostEditorBlockFragment_CoreCategories_Fragment | PostEditorBlockFragment_CoreCode_Fragment | PostEditorBlockFragment_CoreColumn_Fragment | PostEditorBlockFragment_CoreColumns_Fragment | PostEditorBlockFragment_CoreCommentAuthorName_Fragment | PostEditorBlockFragment_CoreCommentContent_Fragment | PostEditorBlockFragment_CoreCommentDate_Fragment | PostEditorBlockFragment_CoreCommentEditLink_Fragment | PostEditorBlockFragment_CoreCommentReplyLink_Fragment | PostEditorBlockFragment_CoreCommentTemplate_Fragment | PostEditorBlockFragment_CoreComments_Fragment | PostEditorBlockFragment_CoreCommentsPagination_Fragment | PostEditorBlockFragment_CoreCommentsPaginationNext_Fragment | PostEditorBlockFragment_CoreCommentsPaginationNumbers_Fragment | PostEditorBlockFragment_CoreCommentsPaginationPrevious_Fragment | PostEditorBlockFragment_CoreCommentsTitle_Fragment | PostEditorBlockFragment_CoreCover_Fragment | PostEditorBlockFragment_CoreDetails_Fragment | PostEditorBlockFragment_CoreEmbed_Fragment | PostEditorBlockFragment_CoreFile_Fragment | PostEditorBlockFragment_CoreFootnotes_Fragment | PostEditorBlockFragment_CoreFreeform_Fragment | PostEditorBlockFragment_CoreGallery_Fragment | PostEditorBlockFragment_CoreGroup_Fragment | PostEditorBlockFragment_CoreHeading_Fragment | PostEditorBlockFragment_CoreHomeLink_Fragment | PostEditorBlockFragment_CoreHtml_Fragment | PostEditorBlockFragment_CoreImage_Fragment | PostEditorBlockFragment_CoreLatestComments_Fragment | PostEditorBlockFragment_CoreLatestPosts_Fragment | PostEditorBlockFragment_CoreLegacyWidget_Fragment | PostEditorBlockFragment_CoreList_Fragment | PostEditorBlockFragment_CoreListItem_Fragment | PostEditorBlockFragment_CoreLoginout_Fragment | PostEditorBlockFragment_CoreMediaText_Fragment | PostEditorBlockFragment_CoreMissing_Fragment | PostEditorBlockFragment_CoreMore_Fragment | PostEditorBlockFragment_CoreNavigation_Fragment | PostEditorBlockFragment_CoreNavigationLink_Fragment | PostEditorBlockFragment_CoreNavigationSubmenu_Fragment | PostEditorBlockFragment_CoreNextpage_Fragment | PostEditorBlockFragment_CorePageList_Fragment | PostEditorBlockFragment_CorePageListItem_Fragment | PostEditorBlockFragment_CoreParagraph_Fragment | PostEditorBlockFragment_CorePattern_Fragment | PostEditorBlockFragment_CorePostAuthor_Fragment | PostEditorBlockFragment_CorePostAuthorBiography_Fragment | PostEditorBlockFragment_CorePostAuthorName_Fragment | PostEditorBlockFragment_CorePostComments_Fragment | PostEditorBlockFragment_CorePostCommentsForm_Fragment | PostEditorBlockFragment_CorePostContent_Fragment | PostEditorBlockFragment_CorePostDate_Fragment | PostEditorBlockFragment_CorePostExcerpt_Fragment | PostEditorBlockFragment_CorePostFeaturedImage_Fragment | PostEditorBlockFragment_CorePostNavigationLink_Fragment | PostEditorBlockFragment_CorePostTemplate_Fragment | PostEditorBlockFragment_CorePostTerms_Fragment | PostEditorBlockFragment_CorePostTitle_Fragment | PostEditorBlockFragment_CorePreformatted_Fragment | PostEditorBlockFragment_CorePullquote_Fragment | PostEditorBlockFragment_CoreQuery_Fragment | PostEditorBlockFragment_CoreQueryNoResults_Fragment | PostEditorBlockFragment_CoreQueryPagination_Fragment | PostEditorBlockFragment_CoreQueryPaginationNext_Fragment | PostEditorBlockFragment_CoreQueryPaginationNumbers_Fragment | PostEditorBlockFragment_CoreQueryPaginationPrevious_Fragment | PostEditorBlockFragment_CoreQueryTitle_Fragment | PostEditorBlockFragment_CoreQueryTotal_Fragment | PostEditorBlockFragment_CoreQuote_Fragment | PostEditorBlockFragment_CoreReadMore_Fragment | PostEditorBlockFragment_CoreRss_Fragment | PostEditorBlockFragment_CoreSearch_Fragment | PostEditorBlockFragment_CoreSeparator_Fragment | PostEditorBlockFragment_CoreShortcode_Fragment | PostEditorBlockFragment_CoreSiteLogo_Fragment | PostEditorBlockFragment_CoreSiteTagline_Fragment | PostEditorBlockFragment_CoreSiteTitle_Fragment | PostEditorBlockFragment_CoreSocialLink_Fragment | PostEditorBlockFragment_CoreSocialLinks_Fragment | PostEditorBlockFragment_CoreSpacer_Fragment | PostEditorBlockFragment_CoreTable_Fragment | PostEditorBlockFragment_CoreTagCloud_Fragment | PostEditorBlockFragment_CoreTemplatePart_Fragment | PostEditorBlockFragment_CoreTermDescription_Fragment | PostEditorBlockFragment_CoreTextColumns_Fragment | PostEditorBlockFragment_CoreVerse_Fragment | PostEditorBlockFragment_CoreVideo_Fragment | PostEditorBlockFragment_CoreWidgetGroup_Fragment | PostEditorBlockFragment_GravityformsForm_Fragment | PostEditorBlockFragment_YoastFaqBlock_Fragment | PostEditorBlockFragment_YoastHowToBlock_Fragment | PostEditorBlockFragment_YoastSeoBreadcrumbs_Fragment;

export type PostEditorBlocksFragmentFragment = { __typename?: 'Post', id: string, editorBlocks?: Array<{ __typename?: 'AcfAccordion', name?: string | null, renderedHtml?: string | null, accordion?: { __typename?: 'Accordion', sectionId?: string | null, darkBackground?: boolean | null, description?: string | null, iconType?: Array<string | null> | null, title?: string | null, withAbbreviations?: boolean | null, withLargeItemTitle?: boolean | null, items?: Array<{ __typename?: 'AccordionItems', title?: string | null, content?: string | null } | null> | null } | null } | { __typename?: 'AcfArticlecards', name?: string | null, renderedHtml?: string | null } | { __typename?: 'AcfBenefits', name?: string | null, renderedHtml?: string | null, benefits?: { __typename?: 'Benefits', sectionId?: string | null, sectionDescription?: string | null, benefitCards?: Array<{ __typename?: 'BenefitsBenefitCards', buttonId?: string | null, title?: string | null, description?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, cardImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfBenefitsaccordion', name?: string | null, renderedHtml?: string | null, benefitsAccordion?: { __typename?: 'BenefitsAccordion', sectionId?: string | null, title?: string | null, subtitle?: string | null, accordionItems?: Array<{ __typename?: 'BenefitsAccordionAccordionItems', description?: string | null, accordionImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, links?: Array<{ __typename?: 'BenefitsAccordionAccordionItemsLinks', linkId?: string | null, link?: { __typename?: 'AcfLink', url?: string | null, title?: string | null } | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfBenefitscontent', name?: string | null, renderedHtml?: string | null, benefitscontent?: { __typename?: 'Benefitscontent', sectionId?: string | null, title?: string | null, textContent?: string | null, textContentVerticalAlignment?: Array<string | null> | null, media?: { __typename?: 'BenefitscontentMedia', type?: string | null, video?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | null } | { __typename?: 'AcfBenefitslist', name?: string | null, renderedHtml?: string | null, benefitsList?: { __typename?: 'BenefitsList', sectionId?: string | null, title?: string | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, benefits?: Array<{ __typename?: 'BenefitsListBenefits', title?: string | null, description?: string | null } | null> | null, disclaimers?: Array<{ __typename?: 'BenefitsListDisclaimers', text?: string | null } | null> | null } | null } | { __typename?: 'AcfBlogarticles', name?: string | null, renderedHtml?: string | null, blogArticles?: { __typename?: 'BlogArticles', sectionId?: string | null, featuredArticles?: Array<{ __typename?: 'BlogArticlesFeaturedArticles', articles?: Array<{ __typename?: 'BlogArticlesFeaturedArticlesArticles', article?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null, category?: { __typename?: 'AcfTermNodeConnection', edges: Array<{ __typename?: 'AcfTermNodeConnectionEdge', node: { __typename?: 'Category', databaseId: number, name?: string | null } | { __typename?: 'PostFormat', databaseId: number, name?: string | null } | { __typename?: 'Tag', databaseId: number, name?: string | null } }> } | null } | null> | null } | null } | { __typename?: 'AcfBlogctacard', name?: string | null, renderedHtml?: string | null, blogCtaCard?: { __typename?: 'BlogCtaCard', sectionId?: string | null, title?: string | null, buttonId?: string | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | { __typename?: 'AcfCallouttext', name?: string | null, renderedHtml?: string | null, calloutText?: { __typename?: 'CalloutText', sectionId?: string | null, title?: string | null, text?: string | null } | null } | { __typename?: 'AcfCardgrid', name?: string | null, renderedHtml?: string | null, cardGrid?: { __typename?: 'CardGrid', sectionId?: string | null, maxColumns?: number | null, sectionBackgroundColor?: string | null, sectionTitle?: string | null, description?: string | null, cardBackgroundColor?: string | null, cardBorder?: string | null, cards?: Array<{ __typename?: 'CardGridCards', card?: Array<{ __typename?: 'CardGridCardsCard', elementType?: Array<string | null> | null, title?: string | null, buttonColor?: string | null, buttonId?: string | null, paragraph?: string | null, heading?: string | null, disclaimer?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, imageData?: { __typename?: 'CardGridCardsCardImageData', alignment?: string | null, caption?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null, list?: Array<{ __typename?: 'CardGridCardsCardList', item?: string | null } | null> | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfCasestudies', name?: string | null, renderedHtml?: string | null, caseStudies?: { __typename?: 'CaseStudies', sectionId?: string | null, sectionTitle?: string | null, ctaText?: string | null, darkBackground?: boolean | null, items?: Array<{ __typename?: 'CaseStudiesItems', description?: string | null, post?: { __typename?: 'AcfContentNodeConnection', nodes: Array<{ __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null }> } | null } | null> | null } | null } | { __typename?: 'AcfCompanylist', name?: string | null, renderedHtml?: string | null, companyList?: { __typename?: 'CompanyList', sectionId?: string | null, companies?: Array<{ __typename?: 'CompanyListCompanies', buttonId?: string | null, description?: string | null, title?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfCorevalues', name?: string | null, renderedHtml?: string | null } | { __typename?: 'AcfCtacard', name?: string | null, renderedHtml?: string | null, ctaCard?: { __typename?: 'CtaCard', sectionId?: string | null, heading?: string | null, text?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, secondaryButton?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | { __typename?: 'AcfDivider', name?: string | null, renderedHtml?: string | null, divider?: { __typename?: 'Divider', sectionId?: string | null, darkBackground?: boolean | null } | null } | { __typename?: 'AcfFactoringinfographic', name?: string | null, renderedHtml?: string | null, factoringInfoGraphic?: { __typename?: 'FactoringInfoGraphic', sectionId?: string | null, title?: string | null, items?: Array<{ __typename?: 'FactoringInfoGraphicItems', description?: string | null } | null> | null } | null } | { __typename?: 'AcfFinancingcta', name?: string | null, renderedHtml?: string | null, financingCta?: { __typename?: 'FinancingCta', sectionId?: string | null, buttonId?: string | null, title?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, keyPoints?: Array<{ __typename?: 'FinancingCtaKeyPoints', field?: string | null, value?: string | null } | null> | null } | null } | { __typename?: 'AcfForm', name?: string | null, renderedHtml?: string | null, formContentBlock?: { __typename?: 'FormContentBlock', sectionId?: string | null, title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | { __typename?: 'AcfFuelsavingscalculator', name?: string | null, renderedHtml?: string | null, fuelSavingsCalculator?: { __typename?: 'FuelSavingsCalculator', sectionId?: string | null, sectionTitle?: string | null, multiplier?: number | null, outroCopy?: string | null, marketoFormId?: string | null } | null } | { __typename?: 'AcfHerobanner', name?: string | null, renderedHtml?: string | null, heroBanner?: { __typename?: 'HeroBanner', sectionId?: string | null, title?: string | null, subtitle?: string | null, includeForm?: boolean | null, rightContentType?: Array<string | null> | null, videoUrl?: string | null, content?: Array<{ __typename?: 'HeroBannerContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerContentWysiwyg', wysiwyg?: string | null } | null } | null> | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfHerobannerwithform', name?: string | null, renderedHtml?: string | null, heroBannerWithForm?: { __typename?: 'HeroBannerWithForm', sectionId?: string | null, title?: string | null, subtitle?: string | null, content?: Array<{ __typename?: 'HeroBannerWithFormContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerWithFormContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerWithFormContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerWithFormContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerWithFormContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerWithFormContentWysiwyg', wysiwyg?: string | null } | null } | null> | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, form?: { __typename?: 'HeroBannerWithFormForm', title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | null } | { __typename?: 'AcfHighlight', name?: string | null, renderedHtml?: string | null, highlight?: { __typename?: 'Highlight', sectionId?: string | null, title?: string | null, subtitle?: string | null, imagePlacement?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, content?: Array<{ __typename?: 'HighlightContent', type?: string | null, paragraph?: { __typename?: 'HighlightContentParagraph', text?: string | null } | null, list?: { __typename?: 'HighlightContentList', heading?: string | null, items?: Array<{ __typename?: 'HighlightContentListItems', text?: string | null } | null> | null } | null } | null> | null } | null } | { __typename?: 'AcfLogorows', name?: string | null, renderedHtml?: string | null, logoRows?: { __typename?: 'LogoRows', sectionId?: string | null, title?: string | null, darkBackground?: boolean | null, logos?: Array<{ __typename?: 'LogoRowsLogos', maxWidth?: number | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfLogoscroll', name?: string | null, renderedHtml?: string | null, logoScroll?: { __typename?: 'LogoScroll', sectionId?: string | null, title?: string | null, logoImages?: Array<{ __typename?: 'LogoScrollLogoImages', companyUrl?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfMainhero', name?: string | null, renderedHtml?: string | null, mainHero?: { __typename?: 'MainHero', sectionId?: string | null, title?: string | null, subtitle?: string | null, description?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfModal', name?: string | null, renderedHtml?: string | null } | { __typename?: 'AcfNewsandinsights', name?: string | null, renderedHtml?: string | null, newsAndInsights?: { __typename?: 'NewsAndInsights', sectionId?: string | null, articleLinkText?: string | null, title?: string | null, articles?: Array<{ __typename?: 'NewsAndInsightsArticles', articles?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null } | null } | { __typename?: 'AcfNewslettersignup', name?: string | null, renderedHtml?: string | null, newsletterSignup?: { __typename?: 'NewsletterSignup', sectionId?: string | null, title?: string | null, description?: string | null, darkBackground?: boolean | null, marketoFormId?: string | null, successMessage?: string | null, successUrl?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfOurhistory', name?: string | null, renderedHtml?: string | null, ourHistory?: { __typename?: 'OurHistory', sectionId?: string | null, title?: string | null, timeline?: Array<{ __typename?: 'OurHistoryTimeline', year?: number | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, keyPoints?: Array<{ __typename?: 'OurHistoryTimelineKeyPoints', field?: string | null, value?: string | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfPartners', name?: string | null, renderedHtml?: string | null, partners?: { __typename?: 'Partners', sectionId?: string | null, title?: string | null, description?: string | null, partners?: Array<{ __typename?: 'PartnersPartners', title?: string | null, description?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfSolutions', name?: string | null, renderedHtml?: string | null, solutions?: { __typename?: 'Solutions', sectionId?: string | null, title?: string | null, description?: string | null, solutions?: Array<{ __typename?: 'SolutionsSolutions', buttonId?: string | null, title?: string | null, description?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null } | { __typename?: 'AcfSolutionscards', name?: string | null, renderedHtml?: string | null, solutionsCards?: { __typename?: 'SolutionsCards', sectionId?: string | null, title?: string | null, description?: string | null, cards?: Array<{ __typename?: 'SolutionsCardsCards', description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTeammembers', name?: string | null, renderedHtml?: string | null, teamMembers?: { __typename?: 'TeamMembers', sectionId?: string | null, members?: Array<{ __typename?: 'TeamMembersMembers', name?: string | null, bio?: string | null, bioCtaText?: string | null, ctaId?: string | null, jobTitle?: string | null, jobTitleInDialog?: string | null, headshot?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTestimonials', name?: string | null, renderedHtml?: string | null, testimonials?: { __typename?: 'Testimonials', sectionId?: string | null, darkBackground?: boolean | null, title?: string | null, testimonials?: Array<{ __typename?: 'TestimonialsTestimonials', author?: string | null, quote?: string | null, authorImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTextcontent', name?: string | null, renderedHtml?: string | null, wsywig?: { __typename?: 'Wsywig', externalLinkModal?: boolean | null, darkBackground?: boolean | null, sectionId?: string | null, textContent?: string | null, modal?: { __typename?: 'WsywigModal', buttonText?: string | null, description?: string | null, title?: string | null } | null } | null } | { __typename?: 'AcfTextheader', name?: string | null, renderedHtml?: string | null, textHeader?: { __typename?: 'TextHeader', sectionId?: string | null, title?: string | null, description?: string | null, withGradientText?: boolean | null } | null } | { __typename?: 'AcfThrive', name?: string | null, renderedHtml?: string | null, thrive?: { __typename?: 'Thrive', sectionId?: string | null, title?: string | null, description?: string | null, descriptionFooter?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfTwocolumncta', name?: string | null, renderedHtml?: string | null, twoColumnCta?: { __typename?: 'TwoColumnCta', sectionId?: string | null, buttonId?: string | null, title?: string | null, subtitle?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfTwocolumnpromo', name?: string | null, renderedHtml?: string | null, twoColumnPromo?: { __typename?: 'TwoColumnPromo', sectionId?: string | null, title?: string | null, columnWidths?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, content?: Array<{ __typename?: 'TwoColumnPromoContent', type?: string | null, paragraph?: { __typename?: 'TwoColumnPromoContentParagraph', bold?: boolean | null, largeFontSize?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'TwoColumnPromoContentList', heading?: string | null, items?: Array<{ __typename?: 'TwoColumnPromoContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'TwoColumnPromoContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | null> | null } | null } | { __typename?: 'AcfVideo', name?: string | null, renderedHtml?: string | null, video?: { __typename?: 'Video', sectionId?: string | null, url?: string | null } | null } | { __typename?: 'CoreArchives', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreAudio', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreAvatar', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreBlock', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreButton', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreButtons', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCalendar', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCategories', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCode', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreColumn', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreColumns', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentAuthorName', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentContent', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentDate', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentEditLink', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentReplyLink', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentTemplate', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreComments', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentsPagination', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentsPaginationNext', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentsPaginationNumbers', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentsPaginationPrevious', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentsTitle', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCover', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreDetails', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreEmbed', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreFile', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreFootnotes', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreFreeform', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreGallery', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreGroup', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreHeading', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreHomeLink', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreHtml', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreImage', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreLatestComments', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreLatestPosts', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreLegacyWidget', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreList', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreListItem', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreLoginout', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreMediaText', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreMissing', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreMore', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreNavigation', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreNavigationLink', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreNavigationSubmenu', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreNextpage', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePageList', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePageListItem', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreParagraph', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePattern', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostAuthor', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostAuthorBiography', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostAuthorName', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostComments', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostCommentsForm', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostContent', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostDate', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostExcerpt', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostFeaturedImage', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostNavigationLink', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostTemplate', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostTerms', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostTitle', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePreformatted', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePullquote', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQuery', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQueryNoResults', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQueryPagination', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQueryPaginationNext', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQueryPaginationNumbers', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQueryPaginationPrevious', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQueryTitle', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQueryTotal', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQuote', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreReadMore', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreRss', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSearch', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSeparator', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreShortcode', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSiteLogo', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSiteTagline', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSiteTitle', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSocialLink', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSocialLinks', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSpacer', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreTable', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreTagCloud', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreTemplatePart', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreTermDescription', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreTextColumns', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreVerse', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreVideo', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreWidgetGroup', name?: string | null, renderedHtml?: string | null } | { __typename?: 'GravityformsForm', name?: string | null, renderedHtml?: string | null, attributes?: { __typename?: 'GravityformsFormAttributes', form?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | { __typename?: 'YoastFaqBlock', name?: string | null, renderedHtml?: string | null } | { __typename?: 'YoastHowToBlock', name?: string | null, renderedHtml?: string | null } | { __typename?: 'YoastSeoBreadcrumbs', name?: string | null, renderedHtml?: string | null } | null> | null };

export type GetReCaptchaKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReCaptchaKeyQuery = { __typename?: 'RootQuery', gfSettings?: { __typename?: 'GfSettings', recaptcha?: { __typename?: 'GfSettingsRecaptcha', publicKey?: string | null, type?: RecaptchaTypeEnum | null } | null } | null };

export type AuthorFragmentFragment = { __typename?: 'User', name?: string | null, description?: string | null, avatar?: { __typename?: 'Avatar', height?: number | null, width?: number | null, url?: string | null } | null };

export type CategoryFragmentFragment = { __typename?: 'Category', databaseId: number, name?: string | null };

export type FeaturedImageFragmentFragment = { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null };

export type GetPostQueryVariables = Exact<{
  databaseId: Scalars['ID']['input'];
  asPreview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPostQuery = { __typename?: 'RootQuery', categories?: { __typename?: 'RootQueryToCategoryConnection', nodes: Array<{ __typename?: 'Category', count?: number | null, databaseId: number, name?: string | null }> } | null, post?: { __typename?: 'Post', title?: string | null, date?: string | null, id: string, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', posts?: { __typename?: 'CategoryToPostConnection', nodes: Array<{ __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null }> } | null }> } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node: { __typename?: 'User', name?: string | null, description?: string | null, avatar?: { __typename?: 'Avatar', height?: number | null, width?: number | null, url?: string | null } | null } } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, seo?: { __typename?: 'PostTypeSEO', canonical?: string | null, focuskw?: string | null, metaDesc?: string | null, metaKeywords?: string | null, metaRobotsNofollow?: string | null, metaRobotsNoindex?: string | null, opengraphAuthor?: string | null, opengraphDescription?: string | null, opengraphModifiedTime?: string | null, opengraphPublishedTime?: string | null, opengraphPublisher?: string | null, opengraphSiteName?: string | null, opengraphTitle?: string | null, opengraphType?: string | null, opengraphUrl?: string | null, readingTime?: number | null, title?: string | null, twitterDescription?: string | null, twitterTitle?: string | null, opengraphImage?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null } | null } | null, twitterImage?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: string | null, mediaDetails?: { __typename?: 'MediaDetails', width?: number | null, height?: number | null } | null } | null } | null, postAsideContent?: { __typename?: 'PostAsideContent', newsletter?: { __typename?: 'PostAsideContentNewsletter', title?: string | null, description?: string | null, marketoFormId?: string | null, successMessage?: string | null } | null } | null, editorBlocks?: Array<{ __typename?: 'AcfAccordion', name?: string | null, renderedHtml?: string | null, accordion?: { __typename?: 'Accordion', sectionId?: string | null, darkBackground?: boolean | null, description?: string | null, iconType?: Array<string | null> | null, title?: string | null, withAbbreviations?: boolean | null, withLargeItemTitle?: boolean | null, items?: Array<{ __typename?: 'AccordionItems', title?: string | null, content?: string | null } | null> | null } | null } | { __typename?: 'AcfArticlecards', name?: string | null, renderedHtml?: string | null } | { __typename?: 'AcfBenefits', name?: string | null, renderedHtml?: string | null, benefits?: { __typename?: 'Benefits', sectionId?: string | null, sectionDescription?: string | null, benefitCards?: Array<{ __typename?: 'BenefitsBenefitCards', buttonId?: string | null, title?: string | null, description?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, cardImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfBenefitsaccordion', name?: string | null, renderedHtml?: string | null, benefitsAccordion?: { __typename?: 'BenefitsAccordion', sectionId?: string | null, title?: string | null, subtitle?: string | null, accordionItems?: Array<{ __typename?: 'BenefitsAccordionAccordionItems', description?: string | null, accordionImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, links?: Array<{ __typename?: 'BenefitsAccordionAccordionItemsLinks', linkId?: string | null, link?: { __typename?: 'AcfLink', url?: string | null, title?: string | null } | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfBenefitscontent', name?: string | null, renderedHtml?: string | null, benefitscontent?: { __typename?: 'Benefitscontent', sectionId?: string | null, title?: string | null, textContent?: string | null, textContentVerticalAlignment?: Array<string | null> | null, media?: { __typename?: 'BenefitscontentMedia', type?: string | null, video?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | null } | { __typename?: 'AcfBenefitslist', name?: string | null, renderedHtml?: string | null, benefitsList?: { __typename?: 'BenefitsList', sectionId?: string | null, title?: string | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, benefits?: Array<{ __typename?: 'BenefitsListBenefits', title?: string | null, description?: string | null } | null> | null, disclaimers?: Array<{ __typename?: 'BenefitsListDisclaimers', text?: string | null } | null> | null } | null } | { __typename?: 'AcfBlogarticles', name?: string | null, renderedHtml?: string | null, blogArticles?: { __typename?: 'BlogArticles', sectionId?: string | null, featuredArticles?: Array<{ __typename?: 'BlogArticlesFeaturedArticles', articles?: Array<{ __typename?: 'BlogArticlesFeaturedArticlesArticles', article?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null, category?: { __typename?: 'AcfTermNodeConnection', edges: Array<{ __typename?: 'AcfTermNodeConnectionEdge', node: { __typename?: 'Category', databaseId: number, name?: string | null } | { __typename?: 'PostFormat', databaseId: number, name?: string | null } | { __typename?: 'Tag', databaseId: number, name?: string | null } }> } | null } | null> | null } | null } | { __typename?: 'AcfBlogctacard', name?: string | null, renderedHtml?: string | null, blogCtaCard?: { __typename?: 'BlogCtaCard', sectionId?: string | null, title?: string | null, buttonId?: string | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | { __typename?: 'AcfCallouttext', name?: string | null, renderedHtml?: string | null, calloutText?: { __typename?: 'CalloutText', sectionId?: string | null, title?: string | null, text?: string | null } | null } | { __typename?: 'AcfCardgrid', name?: string | null, renderedHtml?: string | null, cardGrid?: { __typename?: 'CardGrid', sectionId?: string | null, maxColumns?: number | null, sectionBackgroundColor?: string | null, sectionTitle?: string | null, description?: string | null, cardBackgroundColor?: string | null, cardBorder?: string | null, cards?: Array<{ __typename?: 'CardGridCards', card?: Array<{ __typename?: 'CardGridCardsCard', elementType?: Array<string | null> | null, title?: string | null, buttonColor?: string | null, buttonId?: string | null, paragraph?: string | null, heading?: string | null, disclaimer?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, imageData?: { __typename?: 'CardGridCardsCardImageData', alignment?: string | null, caption?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null, list?: Array<{ __typename?: 'CardGridCardsCardList', item?: string | null } | null> | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfCasestudies', name?: string | null, renderedHtml?: string | null, caseStudies?: { __typename?: 'CaseStudies', sectionId?: string | null, sectionTitle?: string | null, ctaText?: string | null, darkBackground?: boolean | null, items?: Array<{ __typename?: 'CaseStudiesItems', description?: string | null, post?: { __typename?: 'AcfContentNodeConnection', nodes: Array<{ __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null }> } | null } | null> | null } | null } | { __typename?: 'AcfCompanylist', name?: string | null, renderedHtml?: string | null, companyList?: { __typename?: 'CompanyList', sectionId?: string | null, companies?: Array<{ __typename?: 'CompanyListCompanies', buttonId?: string | null, description?: string | null, title?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfCorevalues', name?: string | null, renderedHtml?: string | null } | { __typename?: 'AcfCtacard', name?: string | null, renderedHtml?: string | null, ctaCard?: { __typename?: 'CtaCard', sectionId?: string | null, heading?: string | null, text?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, secondaryButton?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | { __typename?: 'AcfDivider', name?: string | null, renderedHtml?: string | null, divider?: { __typename?: 'Divider', sectionId?: string | null, darkBackground?: boolean | null } | null } | { __typename?: 'AcfFactoringinfographic', name?: string | null, renderedHtml?: string | null, factoringInfoGraphic?: { __typename?: 'FactoringInfoGraphic', sectionId?: string | null, title?: string | null, items?: Array<{ __typename?: 'FactoringInfoGraphicItems', description?: string | null } | null> | null } | null } | { __typename?: 'AcfFinancingcta', name?: string | null, renderedHtml?: string | null, financingCta?: { __typename?: 'FinancingCta', sectionId?: string | null, buttonId?: string | null, title?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, keyPoints?: Array<{ __typename?: 'FinancingCtaKeyPoints', field?: string | null, value?: string | null } | null> | null } | null } | { __typename?: 'AcfForm', name?: string | null, renderedHtml?: string | null, formContentBlock?: { __typename?: 'FormContentBlock', sectionId?: string | null, title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | { __typename?: 'AcfFuelsavingscalculator', name?: string | null, renderedHtml?: string | null, fuelSavingsCalculator?: { __typename?: 'FuelSavingsCalculator', sectionId?: string | null, sectionTitle?: string | null, multiplier?: number | null, outroCopy?: string | null, marketoFormId?: string | null } | null } | { __typename?: 'AcfHerobanner', name?: string | null, renderedHtml?: string | null, heroBanner?: { __typename?: 'HeroBanner', sectionId?: string | null, title?: string | null, subtitle?: string | null, includeForm?: boolean | null, rightContentType?: Array<string | null> | null, videoUrl?: string | null, content?: Array<{ __typename?: 'HeroBannerContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerContentWysiwyg', wysiwyg?: string | null } | null } | null> | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfHerobannerwithform', name?: string | null, renderedHtml?: string | null, heroBannerWithForm?: { __typename?: 'HeroBannerWithForm', sectionId?: string | null, title?: string | null, subtitle?: string | null, content?: Array<{ __typename?: 'HeroBannerWithFormContent', type?: string | null, paragraph?: { __typename?: 'HeroBannerWithFormContentParagraph', bold?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'HeroBannerWithFormContentList', heading?: string | null, items?: Array<{ __typename?: 'HeroBannerWithFormContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'HeroBannerWithFormContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, wysiwyg?: { __typename?: 'HeroBannerWithFormContentWysiwyg', wysiwyg?: string | null } | null } | null> | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, form?: { __typename?: 'HeroBannerWithFormForm', title?: string | null, description?: string | null, disclaimer?: string | null, gravityForm?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | null } | { __typename?: 'AcfHighlight', name?: string | null, renderedHtml?: string | null, highlight?: { __typename?: 'Highlight', sectionId?: string | null, title?: string | null, subtitle?: string | null, imagePlacement?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, content?: Array<{ __typename?: 'HighlightContent', type?: string | null, paragraph?: { __typename?: 'HighlightContentParagraph', text?: string | null } | null, list?: { __typename?: 'HighlightContentList', heading?: string | null, items?: Array<{ __typename?: 'HighlightContentListItems', text?: string | null } | null> | null } | null } | null> | null } | null } | { __typename?: 'AcfLogorows', name?: string | null, renderedHtml?: string | null, logoRows?: { __typename?: 'LogoRows', sectionId?: string | null, title?: string | null, darkBackground?: boolean | null, logos?: Array<{ __typename?: 'LogoRowsLogos', maxWidth?: number | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfLogoscroll', name?: string | null, renderedHtml?: string | null, logoScroll?: { __typename?: 'LogoScroll', sectionId?: string | null, title?: string | null, logoImages?: Array<{ __typename?: 'LogoScrollLogoImages', companyUrl?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfMainhero', name?: string | null, renderedHtml?: string | null, mainHero?: { __typename?: 'MainHero', sectionId?: string | null, title?: string | null, subtitle?: string | null, description?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfModal', name?: string | null, renderedHtml?: string | null } | { __typename?: 'AcfNewsandinsights', name?: string | null, renderedHtml?: string | null, newsAndInsights?: { __typename?: 'NewsAndInsights', sectionId?: string | null, articleLinkText?: string | null, title?: string | null, articles?: Array<{ __typename?: 'NewsAndInsightsArticles', articles?: { __typename?: 'AcfContentNodeConnection', edges: Array<{ __typename?: 'AcfContentNodeConnectionEdge', node: { __typename?: 'MediaItem' } | { __typename?: 'Page' } | { __typename?: 'Post', id: string, title?: string | null, uri?: string | null, categories?: { __typename?: 'PostToCategoryConnection', nodes: Array<{ __typename?: 'Category', name?: string | null }> } | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } }> } | null } | null> | null } | null } | { __typename?: 'AcfNewslettersignup', name?: string | null, renderedHtml?: string | null, newsletterSignup?: { __typename?: 'NewsletterSignup', sectionId?: string | null, title?: string | null, description?: string | null, darkBackground?: boolean | null, marketoFormId?: string | null, successMessage?: string | null, successUrl?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfOurhistory', name?: string | null, renderedHtml?: string | null, ourHistory?: { __typename?: 'OurHistory', sectionId?: string | null, title?: string | null, timeline?: Array<{ __typename?: 'OurHistoryTimeline', year?: number | null, description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, keyPoints?: Array<{ __typename?: 'OurHistoryTimelineKeyPoints', field?: string | null, value?: string | null } | null> | null } | null> | null } | null } | { __typename?: 'AcfPartners', name?: string | null, renderedHtml?: string | null, partners?: { __typename?: 'Partners', sectionId?: string | null, title?: string | null, description?: string | null, partners?: Array<{ __typename?: 'PartnersPartners', title?: string | null, description?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, logo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfSolutions', name?: string | null, renderedHtml?: string | null, solutions?: { __typename?: 'Solutions', sectionId?: string | null, title?: string | null, description?: string | null, solutions?: Array<{ __typename?: 'SolutionsSolutions', buttonId?: string | null, title?: string | null, description?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null } | { __typename?: 'AcfSolutionscards', name?: string | null, renderedHtml?: string | null, solutionsCards?: { __typename?: 'SolutionsCards', sectionId?: string | null, title?: string | null, description?: string | null, cards?: Array<{ __typename?: 'SolutionsCardsCards', description?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTeammembers', name?: string | null, renderedHtml?: string | null, teamMembers?: { __typename?: 'TeamMembers', sectionId?: string | null, members?: Array<{ __typename?: 'TeamMembersMembers', name?: string | null, bio?: string | null, bioCtaText?: string | null, ctaId?: string | null, jobTitle?: string | null, jobTitleInDialog?: string | null, headshot?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTestimonials', name?: string | null, renderedHtml?: string | null, testimonials?: { __typename?: 'Testimonials', sectionId?: string | null, darkBackground?: boolean | null, title?: string | null, testimonials?: Array<{ __typename?: 'TestimonialsTestimonials', author?: string | null, quote?: string | null, authorImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null> | null } | null } | { __typename?: 'AcfTextcontent', name?: string | null, renderedHtml?: string | null, wsywig?: { __typename?: 'Wsywig', externalLinkModal?: boolean | null, darkBackground?: boolean | null, sectionId?: string | null, textContent?: string | null, modal?: { __typename?: 'WsywigModal', buttonText?: string | null, description?: string | null, title?: string | null } | null } | null } | { __typename?: 'AcfTextheader', name?: string | null, renderedHtml?: string | null, textHeader?: { __typename?: 'TextHeader', sectionId?: string | null, title?: string | null, description?: string | null, withGradientText?: boolean | null } | null } | { __typename?: 'AcfThrive', name?: string | null, renderedHtml?: string | null, thrive?: { __typename?: 'Thrive', sectionId?: string | null, title?: string | null, description?: string | null, descriptionFooter?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfTwocolumncta', name?: string | null, renderedHtml?: string | null, twoColumnCta?: { __typename?: 'TwoColumnCta', sectionId?: string | null, buttonId?: string | null, title?: string | null, subtitle?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null } | null } | { __typename?: 'AcfTwocolumnpromo', name?: string | null, renderedHtml?: string | null, twoColumnPromo?: { __typename?: 'TwoColumnPromo', sectionId?: string | null, title?: string | null, columnWidths?: string | null, image?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null, mediaDetails?: { __typename?: 'MediaDetails', height?: number | null, width?: number | null, sizes?: Array<{ __typename?: 'MediaSize', name?: string | null, sourceUrl?: string | null } | null> | null } | null } } | null, content?: Array<{ __typename?: 'TwoColumnPromoContent', type?: string | null, paragraph?: { __typename?: 'TwoColumnPromoContentParagraph', bold?: boolean | null, largeFontSize?: boolean | null, removeTopMargin?: boolean | null, text?: string | null } | null, list?: { __typename?: 'TwoColumnPromoContentList', heading?: string | null, items?: Array<{ __typename?: 'TwoColumnPromoContentListItems', text?: string | null } | null> | null } | null, button?: { __typename?: 'TwoColumnPromoContentButton', buttonColor?: string | null, buttonId?: string | null, button?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null } | null> | null } | null } | { __typename?: 'AcfVideo', name?: string | null, renderedHtml?: string | null, video?: { __typename?: 'Video', sectionId?: string | null, url?: string | null } | null } | { __typename?: 'CoreArchives', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreAudio', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreAvatar', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreBlock', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreButton', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreButtons', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCalendar', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCategories', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCode', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreColumn', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreColumns', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentAuthorName', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentContent', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentDate', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentEditLink', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentReplyLink', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentTemplate', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreComments', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentsPagination', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentsPaginationNext', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentsPaginationNumbers', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentsPaginationPrevious', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCommentsTitle', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreCover', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreDetails', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreEmbed', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreFile', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreFootnotes', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreFreeform', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreGallery', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreGroup', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreHeading', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreHomeLink', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreHtml', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreImage', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreLatestComments', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreLatestPosts', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreLegacyWidget', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreList', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreListItem', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreLoginout', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreMediaText', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreMissing', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreMore', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreNavigation', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreNavigationLink', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreNavigationSubmenu', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreNextpage', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePageList', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePageListItem', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreParagraph', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePattern', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostAuthor', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostAuthorBiography', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostAuthorName', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostComments', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostCommentsForm', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostContent', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostDate', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostExcerpt', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostFeaturedImage', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostNavigationLink', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostTemplate', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostTerms', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePostTitle', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePreformatted', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CorePullquote', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQuery', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQueryNoResults', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQueryPagination', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQueryPaginationNext', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQueryPaginationNumbers', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQueryPaginationPrevious', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQueryTitle', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQueryTotal', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreQuote', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreReadMore', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreRss', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSearch', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSeparator', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreShortcode', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSiteLogo', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSiteTagline', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSiteTitle', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSocialLink', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSocialLinks', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreSpacer', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreTable', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreTagCloud', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreTemplatePart', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreTermDescription', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreTextColumns', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreVerse', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreVideo', name?: string | null, renderedHtml?: string | null } | { __typename?: 'CoreWidgetGroup', name?: string | null, renderedHtml?: string | null } | { __typename?: 'GravityformsForm', name?: string | null, renderedHtml?: string | null, attributes?: { __typename?: 'GravityformsFormAttributes', form?: { __typename?: 'GfForm', id: string, databaseId: number, title?: string | null, description?: string | null, submitButton?: { __typename?: 'FormSubmitButton', text?: string | null } | null, pagination?: { __typename?: 'FormPagination', pageNames?: Array<string | null> | null } | null, confirmations?: Array<{ __typename?: 'FormConfirmation', isDefault?: boolean | null, isActive?: boolean | null, message?: string | null, type?: FormConfirmationTypeEnum | null, url?: string | null, page?: { __typename?: 'FormConfirmationToPageConnectionEdge', node: { __typename?: 'Page', uri?: string | null } } | null } | null> | null, formFields?: { __typename?: 'GfFormToFormFieldConnection', nodes: Array<{ __typename?: 'AddressField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'CaptchaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'CheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, description?: string | null, label?: string | null, pageNumber?: number | null, isRequired?: boolean | null, inputs?: Array<{ __typename?: 'CheckboxInputProperty', id?: number | null, label?: string | null, name?: string | null } | null> | null, choices?: Array<{ __typename?: 'CheckboxFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ConsentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'DateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'EmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'FileUploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'HiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, defaultValue?: string | null, inputName?: string | null, label?: string | null, pageNumber?: number | null, value?: string | null } | { __typename?: 'HtmlField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ImageChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiChoiceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'MultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'MultiSelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'NameField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'NumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, rangeMax?: number | null, rangeMin?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'OptionCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'OptionSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PageField', id: string, pageNumber?: number | null, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PasswordField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, phoneFormat?: PhoneFieldFormatEnum | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'PostCategoryCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategoryRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCategorySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostContentField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomDateField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomEmailField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomFileuploadField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomListField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomPhoneField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomTimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostCustomWebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostExcerptField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostImageField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsCheckboxField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsMultiSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTagsTextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'PostTitleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductCalculationField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductPriceField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ProductSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityHiddenField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantityNumberField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'QuantitySelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'RadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, isRequired?: boolean | null, label?: string | null, description?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'RadioFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'SectionField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'SelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, defaultValue?: string | null, pageNumber?: number | null, choices?: Array<{ __typename?: 'SelectFieldChoice', text?: string | null, value?: string | null } | null> | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'ShippingRadioField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSelectField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'ShippingSingleField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TextAreaField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, label?: string | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TextField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number, autocompleteAttribute?: string | null, label?: string | null, maxLength?: number | null, description?: string | null, isRequired?: boolean | null, placeholder?: string | null, pageNumber?: number | null, pattern?: string | null, conditionalLogic?: { __typename?: 'ConditionalLogic', actionType?: ConditionalLogicActionTypeEnum | null, logicType?: ConditionalLogicLogicTypeEnum | null, rules?: Array<{ __typename?: 'ConditionalLogicRule', fieldId?: number | null, operator?: FormRuleOperatorEnum | null, value?: string | null } | null> | null } | null } | { __typename?: 'TimeField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'TotalField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number } | { __typename?: 'WebsiteField', id: string, type?: FormFieldTypeEnum | null, layoutGridColumnSpan?: number | null, layoutSpacerGridColumnSpan?: number | null, databaseId: number }>, edges: Array<{ __typename?: 'GfFormToFormFieldConnectionEdge', node: { __typename?: 'AddressField', id: string } | { __typename?: 'CaptchaField', id: string } | { __typename?: 'CheckboxField', id: string } | { __typename?: 'ConsentField', id: string } | { __typename?: 'DateField', id: string } | { __typename?: 'EmailField', id: string } | { __typename?: 'FileUploadField', id: string } | { __typename?: 'HiddenField', id: string } | { __typename?: 'HtmlField', id: string } | { __typename?: 'ImageChoiceField', id: string } | { __typename?: 'ListField', id: string } | { __typename?: 'MultiChoiceField', id: string } | { __typename?: 'MultiSelectField', id: string } | { __typename?: 'NameField', id: string } | { __typename?: 'NumberField', id: string } | { __typename?: 'OptionCheckboxField', id: string } | { __typename?: 'OptionRadioField', id: string } | { __typename?: 'OptionSelectField', id: string } | { __typename?: 'PageField', id: string } | { __typename?: 'PasswordField', id: string } | { __typename?: 'PhoneField', id: string } | { __typename?: 'PostCategoryCheckboxField', id: string } | { __typename?: 'PostCategoryMultiSelectField', id: string } | { __typename?: 'PostCategoryRadioField', id: string } | { __typename?: 'PostCategorySelectField', id: string } | { __typename?: 'PostContentField', id: string } | { __typename?: 'PostCustomCheckboxField', id: string } | { __typename?: 'PostCustomDateField', id: string } | { __typename?: 'PostCustomEmailField', id: string } | { __typename?: 'PostCustomFileuploadField', id: string } | { __typename?: 'PostCustomHiddenField', id: string } | { __typename?: 'PostCustomListField', id: string } | { __typename?: 'PostCustomMultiSelectField', id: string } | { __typename?: 'PostCustomNumberField', id: string } | { __typename?: 'PostCustomPhoneField', id: string } | { __typename?: 'PostCustomRadioField', id: string } | { __typename?: 'PostCustomSelectField', id: string } | { __typename?: 'PostCustomTextAreaField', id: string } | { __typename?: 'PostCustomTextField', id: string } | { __typename?: 'PostCustomTimeField', id: string } | { __typename?: 'PostCustomWebsiteField', id: string } | { __typename?: 'PostExcerptField', id: string } | { __typename?: 'PostImageField', id: string } | { __typename?: 'PostTagsCheckboxField', id: string } | { __typename?: 'PostTagsMultiSelectField', id: string } | { __typename?: 'PostTagsRadioField', id: string } | { __typename?: 'PostTagsSelectField', id: string } | { __typename?: 'PostTagsTextField', id: string } | { __typename?: 'PostTitleField', id: string } | { __typename?: 'ProductCalculationField', id: string } | { __typename?: 'ProductHiddenField', id: string } | { __typename?: 'ProductPriceField', id: string } | { __typename?: 'ProductRadioField', id: string } | { __typename?: 'ProductSelectField', id: string } | { __typename?: 'ProductSingleField', id: string } | { __typename?: 'QuantityHiddenField', id: string } | { __typename?: 'QuantityNumberField', id: string } | { __typename?: 'QuantitySelectField', id: string } | { __typename?: 'RadioField', id: string } | { __typename?: 'SectionField', id: string } | { __typename?: 'SelectField', id: string } | { __typename?: 'ShippingRadioField', id: string } | { __typename?: 'ShippingSelectField', id: string } | { __typename?: 'ShippingSingleField', id: string } | { __typename?: 'TextAreaField', id: string } | { __typename?: 'TextField', id: string } | { __typename?: 'TimeField', id: string } | { __typename?: 'TotalField', id: string } | { __typename?: 'WebsiteField', id: string } }>, pageInfo: { __typename?: 'GfFormToFormFieldConnectionPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null } | null } | { __typename?: 'YoastFaqBlock', name?: string | null, renderedHtml?: string | null } | { __typename?: 'YoastHowToBlock', name?: string | null, renderedHtml?: string | null } | { __typename?: 'YoastSeoBreadcrumbs', name?: string | null, renderedHtml?: string | null } | null> | null } | null, footerMenus?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', blockFooter?: { __typename?: 'BlockFooter', phone?: number | null, footerDisclosure?: string | null, footerAddress?: string | null, footerLogo?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } } | null, socialMediaIcons?: Array<{ __typename?: 'BlockFooterSocialMediaIcons', socialMediaUrl?: string | null, iconImage?: { __typename?: 'AcfMediaItemConnectionEdge', node: { __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null, sourceUrl?: string | null, mimeType?: string | null } } | null } | null> | null } | null, menuItems?: { __typename?: 'MenuToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, parentId?: string | null }> } | null }> } | null, generalSettings?: { __typename?: 'GeneralSettings', title?: string | null } | null, headerLogo?: { __typename?: 'RootQueryToMediaItemConnection', nodes: Array<{ __typename?: 'MediaItem', altText?: string | null, id: string, link?: string | null }> } | null, headerMenuItems?: { __typename?: 'RootQueryToMenuItemConnection', nodes: Array<{ __typename?: 'MenuItem', id: string, uri?: string | null, label?: string | null, navDetails?: { __typename?: 'NavDetails', description?: string | null, link?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null, navSegments?: { __typename?: 'NavSegments', segments?: Array<{ __typename?: 'NavSegmentsSegments', title?: string | null, links?: Array<{ __typename?: 'NavSegmentsSegmentsLinks', link?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null> | null } | null }> } | null, menuButton?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', menuButton?: { __typename?: 'MenuButton', menubutton?: Array<{ __typename?: 'MenuButtonMenubutton', menubuttonlink?: { __typename?: 'AcfLink', target?: string | null, title?: string | null, url?: string | null } | null } | null> | null } | null }> } | null, systemAlert?: { __typename?: 'RootQueryToMenuConnection', nodes: Array<{ __typename?: 'Menu', systemAlert?: { __typename?: 'SystemAlert', alertId?: string | null, message?: string | null, start?: string | null, end?: string | null } | null }> } | null, uTMConfiguration?: { __typename?: 'UTMConfiguration', utmConfigurationBlock?: { __typename?: 'UtmConfigurationBlock', utmQueryParams?: Array<{ __typename?: 'UtmConfigurationBlockUtmQueryParams', queryParam?: string | null } | null> | null } | null } | null };
